webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(332);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularAnimate = __webpack_require__(335);var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	var _angularAria = __webpack_require__(337);var _angularAria2 = _interopRequireDefault(_angularAria);
	var _angularMaterial = __webpack_require__(339);var _angularMaterial2 = _interopRequireDefault(_angularMaterial);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _common = __webpack_require__(416);var _common2 = _interopRequireDefault(_common);
	var _components = __webpack_require__(462);var _components2 = _interopRequireDefault(_components);
	var _app = __webpack_require__(843);var _app2 = _interopRequireDefault(_app);
	
	
	var _config = __webpack_require__(847);var _config2 = _interopRequireDefault(_config);
	var _mdDateLocaleProviderConfig = __webpack_require__(848);var _mdDateLocaleProviderConfig2 = _interopRequireDefault(_mdDateLocaleProviderConfig);
	var _mdThemingProviderConfig = __webpack_require__(849);var _mdThemingProviderConfig2 = _interopRequireDefault(_mdThemingProviderConfig);
	var _translateProviderConfig = __webpack_require__(850);var _translateProviderConfig2 = _interopRequireDefault(_translateProviderConfig);
	var _restangularConfig = __webpack_require__(852);var _restangularConfig2 = _interopRequireDefault(_restangularConfig);
	var _textangularConfig = __webpack_require__(854);var _textangularConfig2 = _interopRequireDefault(_textangularConfig);
	
	var _angularInputMasks = __webpack_require__(855);var _angularInputMasks2 = _interopRequireDefault(_angularInputMasks);
	var _angularTranslate = __webpack_require__(884);var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	__webpack_require__(885);
	__webpack_require__(886);
	__webpack_require__(887);
	__webpack_require__(889);
	var _angularMessages = __webpack_require__(890);var _angularMessages2 = _interopRequireDefault(_angularMessages);
	var _ngMaterialDatetimepicker = __webpack_require__(892);var _ngMaterialDatetimepicker2 = _interopRequireDefault(_ngMaterialDatetimepicker);
	var _angularMaterialDataTable = __webpack_require__(893);var _angularMaterialDataTable2 = _interopRequireDefault(_angularMaterialDataTable);
	__webpack_require__(895);
	var _textangular = __webpack_require__(896);var _textangular2 = _interopRequireDefault(_textangular);
	__webpack_require__(899);
	__webpack_require__(900);
	__webpack_require__(902);
	
	__webpack_require__(948);
	__webpack_require__(950);
	__webpack_require__(958);
	__webpack_require__(960);
	__webpack_require__(962);
	__webpack_require__(964);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	_angular2.default.module('app', [
	_angularAnimate2.default,
	_angularAria2.default,
	_angularMaterial2.default,
	_angularTranslate2.default,
	_common2.default,
	_components2.default,
	_angularMaterialDataTable2.default,
	'ngAvatar',
	'ngMap',
	_ngMaterialDatetimepicker2.default,
	_angularMessages2.default,
	'ngStorage',
	'restangular',
	_textangular2.default,
	'uiCropper',
	_angularUiRouter2.default,
	_angularInputMasks2.default,
	'chart.js']).
	
	config(_config2.default).
	config(_mdDateLocaleProviderConfig2.default).
	config(_mdThemingProviderConfig2.default).
	config(_translateProviderConfig2.default).
	config(_restangularConfig2.default).
	config(_textangularConfig2.default).
	
	run(["$rootScope", function ($rootScope) {
	  "ngInject";
	
	  // Because we have difficulties accessing the asssets folder with AWS s3 web hosting
	  //$rootScope.baseAssetsUrl = 'https://s3-sa-east-1.amazonaws.com/sabin-backoffice-prod/assets';
	  $rootScope.baseAssetsUrl = 'assets';
	}]).
	
	component('app', _app2.default);

/***/ }),
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _directives = __webpack_require__(417);var _directives2 = _interopRequireDefault(_directives);
	var _fieldValidators = __webpack_require__(419);var _fieldValidators2 = _interopRequireDefault(_fieldValidators);
	var _filters = __webpack_require__(429);var _filters2 = _interopRequireDefault(_filters);
	var _services = __webpack_require__(434);var _services2 = _interopRequireDefault(_services);
	var _shell = __webpack_require__(439);var _shell2 = _interopRequireDefault(_shell);
	var _sidenav = __webpack_require__(448);var _sidenav2 = _interopRequireDefault(_sidenav);
	var _toolbar = __webpack_require__(454);var _toolbar2 = _interopRequireDefault(_toolbar);
	var _user = __webpack_require__(460);var _user2 = _interopRequireDefault(_user);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var commonModule = _angular2.default.module('app.common', [
	_directives2.default,
	_fieldValidators2.default,
	_filters2.default,
	_services2.default,
	_shell2.default,
	_sidenav2.default,
	_toolbar2.default,
	_user2.default]).
	
	
	name;exports.default =
	
	commonModule;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _pageBack = __webpack_require__(418);var _pageBack2 = _interopRequireDefault(_pageBack);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var directiveModule = _angular2.default.module('app.directives', []).
	
	directive('pageBack', _pageBack2.default).
	
	name;exports.default =
	
	directiveModule;

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var pageBack = function pageBack() {
	    return {
	        restrict: 'A',
	        scope: true,
	        link: function link($scope, elem, attrs) {
	            elem.on('click', function () {
	                window.history.back();
	            });
	        } };
	
	};
	
	pageBack.$inject = [];exports.default =
	
	pageBack;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _todayOrBefore = __webpack_require__(420);var _todayOrBefore2 = _interopRequireDefault(_todayOrBefore);
	var _todayOrLater = __webpack_require__(425);var _todayOrLater2 = _interopRequireDefault(_todayOrLater);
	var _afterDate = __webpack_require__(426);var _afterDate2 = _interopRequireDefault(_afterDate);
	var _beforeDate = __webpack_require__(427);var _beforeDate2 = _interopRequireDefault(_beforeDate);
	var _timeFieldNowOrLater = __webpack_require__(428);var _timeFieldNowOrLater2 = _interopRequireDefault(_timeFieldNowOrLater);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var fieldValidatorsModule = _angular2.default.module('app.fieldValidators', []).
	
	directive('sbTodayOrBefore', _todayOrBefore2.default).
	directive('sbTodayOrLater', _todayOrLater2.default).
	directive('sbAfterDate', _afterDate2.default).
	directive('sbBeforeDate', _beforeDate2.default).
	directive('sbTimeFieldNowOrLater', _timeFieldNowOrLater2.default).
	
	name;exports.default =
	
	fieldValidatorsModule;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var todayOrBefore = function todayOrBefore() {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModelController) {
	      ngModelController.$validators.todayOrBefore = function (modelValue, viewValue) {
	        if (ngModelController.$isEmpty(modelValue) === true) {
	          return true;
	        }
	
	        var date = moment(modelValue).startOf('day');
	
	        return date.isSameOrBefore(moment().startOf('day'));
	      };
	    } };
	
	};
	
	todayOrBefore.$inject = [];exports.default =
	
	todayOrBefore;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./pt": 424
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 423;


/***/ }),
/* 424 */,
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var todayOrLater = function todayOrLater() {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModelController) {
	      ngModelController.$validators.todayOrLater = function (modelValue, viewValue) {
	        if (ngModelController.$isEmpty(modelValue) === true) {
	          return true;
	        }
	
	        var date = moment(modelValue).startOf('day');
	
	        return date.isSameOrAfter(moment().startOf('day'));
	      };
	    } };
	
	};
	
	todayOrLater.$inject = [];exports.default =
	
	todayOrLater;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var afterDate = function afterDate() {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModelController) {
	      ngModelController.$validators.afterDate = function (modelValue, viewValue) {
	        if (ngModelController.$isEmpty(modelValue) === true) {
	          return true;
	        }
	
	        var value = moment(modelValue).startOf('day');
	
	        if (!attrs.sbAfterDate) {
	          return true;
	        }
	
	        var startDate = attrs.sbAfterDate.replace(/\"/g, '');
	
	        startDate = moment(startDate).startOf('day');
	
	        return value.isSameOrAfter(startDate);
	      };
	    } };
	
	};
	
	afterDate.$inject = [];exports.default =
	
	afterDate;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var beforeDate = function beforeDate() {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModelController) {
	      ngModelController.$validators.beforeDate = function (modelValue, viewValue) {
	        if (ngModelController.$isEmpty(modelValue) === true) {
	          return true;
	        }
	
	        var value = moment(modelValue).startOf('day');
	
	        if (!attrs.sbBeforeDate) {
	          return true;
	        }
	
	        var endDate = attrs.sbBeforeDate.replace(/\"/g, '');
	
	        endDate = moment(endDate).startOf('day');
	
	        return value.isSameOrBefore(endDate);
	      };
	    } };
	
	};
	
	beforeDate.$inject = [];exports.default =
	
	beforeDate;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var timeFieldNowOrLater = function timeFieldNowOrLater() {
	  return {
	    restrict: 'A',
	    scope: {
	      sbDate: '@' },
	
	    require: 'ngModel',
	    link: function link(scope, element, attrs, ngModelController) {
	      ngModelController.$validators.timeFieldNowOrLater = function (modelValue, viewValue) {
	        if (ngModelController.$isEmpty(modelValue) === true) {
	          return true;
	        }
	
	        var sbDate = scope.sbDate.replace(/\"/g, '');
	
	        var date = moment(sbDate);
	
	        var datetimeText = date.format('YYYY-MM-DD');
	
	        datetimeText += ' ' + modelValue;
	
	        var datetime = moment(datetimeText);
	
	        return datetime.isValid() && datetime.isSameOrAfter(moment());
	      };
	    } };
	
	};
	
	timeFieldNowOrLater.$inject = [];exports.default =
	
	timeFieldNowOrLater;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _relevantTerms = __webpack_require__(430);var _relevantTerms2 = _interopRequireDefault(_relevantTerms);
	var _firstLastName = __webpack_require__(431);var _firstLastName2 = _interopRequireDefault(_firstLastName);
	var _momentFormat = __webpack_require__(432);var _momentFormat2 = _interopRequireDefault(_momentFormat);
	var _phoneFormat = __webpack_require__(433);var _phoneFormat2 = _interopRequireDefault(_phoneFormat);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var filtersModule = _angular2.default.module('app.filters', []).
	
	filter('relevantTerms', _relevantTerms2.default).
	filter('firstLastName', _firstLastName2.default).
	filter('momentFormat', _momentFormat2.default).
	filter('phoneFormat', _phoneFormat2.default).
	
	name;exports.default =
	
	filtersModule;

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var RelevantTerms = function RelevantTerms() {
	  return function (input) {
	    return input.replace(/\s(da|de|do|dos|das)/ig, '');
	  };
	};
	
	RelevantTerms.$inject = [];exports.default =
	
	RelevantTerms;

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var FirstLastName = function FirstLastName() {
	  return function (input) {
	    var words = input.split(' ');
	    return words.length > 1 ? words[0] + ' ' + words[words.length - 1] : words[0];
	  };
	};
	
	FirstLastName.$inject = [];exports.default =
	
	FirstLastName;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var momentFormat = function momentFormat() {
	  return function (datetime, format) {
	    format = format || 'LLLL';
	    var momentDate = moment(datetime);
	    return momentDate.isValid() ? momentDate.format(format) : 'Data inválida';
	  };
	};
	
	momentFormat.$inject = [];exports.default =
	
	momentFormat;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var PhoneFormat = function PhoneFormat() {
	  return function (input) {
	    var formatted = input + '';
	    formatted = formatted.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
	    return formatted;
	  };
	};
	
	PhoneFormat.$inject = [];exports.default =
	
	PhoneFormat;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _toast = __webpack_require__(435);var _toast2 = _interopRequireDefault(_toast);
	var _auth = __webpack_require__(436);var _auth2 = _interopRequireDefault(_auth);
	var _httpInterceptor = __webpack_require__(438);var _httpInterceptor2 = _interopRequireDefault(_httpInterceptor);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var servicesModule = _angular2.default.module('app.services', []).
	
	service('Auth', _auth2.default).
	service('Toast', _toast2.default).
	factory('HttpInterceptor', _httpInterceptor2.default).
	
	run(["Auth", function (Auth) {
		"ngInject";
	
		Auth.init();
	}]).
	
	name;exports.default =
	
	servicesModule;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var ToastService = function ToastService($mdToast) {
	  function show(textContent, options) {
	    var position = _.get(options, 'position') || 'bottom right';
	    var theme = _.get(options, 'theme') || 'default';
	
	    $mdToast.show(
	    $mdToast.simple().
	    position(position).
	    textContent(textContent).
	    theme(theme));
	
	  }
	
	  function error(textContent) {
	    show(textContent, {
	      theme: 'error-toast' });
	
	  }
	
	  function success(textContent) {
	    show(textContent, {
	      theme: 'success-toast' });
	
	  }
	
	  return { error: error, show: show, success: success };
	};
	
	ToastService.$inject = ['$mdToast'];exports.default =
	
	ToastService;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _sidenav = __webpack_require__(437);var _sidenav2 = _interopRequireDefault(_sidenav);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var AuthService = function AuthService(
	Restangular,
	Toast,
	$filter,
	$localStorage,
	$mdDialog,
	$rootScope,
	$sessionStorage,
	$state,
	$transitions)
	{
	  function init() {
	    $transitions.onStart({}, function (transition) {
	      return authenticate(transition.to()).catch(function (redirect) {
	        return $state.target(redirect);
	      });
	    });
	  }
	
	  function forbidAccess(reject) {
	    $mdDialog.show(
	    $mdDialog.
	    alert().
	    clickOutsideToClose(true).
	    title($filter("translate")("auth-service-forbid-access-dialog-title")).
	    textContent(
	    $filter("translate")("auth-service-forbid-access-dialog-text")).
	
	    ariaLabel(
	    $filter("translate")("auth-service-forbid-access-dialog-text")).
	
	    ok($filter("translate")("common-ok")));
	
	    logout();
	    reject("login");
	  }
	
	  function authenticate(target) {
	    var isPublicTarget = _.get(target, "data.public");
	
	    return new Promise(function (resolve, reject) {
	      if (isPublicTarget && !isAuthenticated()) {
	        resolve();
	        return;
	      } else if (!isPublicTarget && !isAuthenticated()) {
	        reject("login");
	        return;
	      }
	
	      Restangular.service("admin/me").
	      one().
	      get().
	      then(function (me) {
	        if (me.access_group) {
	          $rootScope.user = me;
	          if (target.name === "login") {
	            reject("unit.list");
	          } else {
	            resolve();
	          }
	        } else {
	          forbidAccess(reject);
	        }
	      }).
	      catch(function (err) {
	        forbidAccess(reject);
	      });
	    });
	  }
	
	  function getAuthorizedModules(accessGroup) {
	    var modules = accessGroup.admin_modules;
	
	    if (!accessGroup || accessGroup.deleted_at || _.isEmpty(modules)) {
	      return false;
	    }
	
	    var authorizedModules = _.map(modules, function (module) {
	      return module.name;
	    });
	
	    return authorizedModules;
	  }
	
	  function getAuthorizedStates(accessGroup) {
	    var modules = accessGroup.admin_modules;
	
	    if (!accessGroup || accessGroup.deleted_at || _.isEmpty(modules)) {
	      return false;
	    }
	
	    var authorizedStates = [];
	
	    _.forEach(modules, function (module) {
	      var found = _.find(_sidenav2.default, { title: module.name });
	      var subMenu = found.subMenu;
	
	      if (subMenu) {
	        _.forEach(subMenu, function (item) {
	          authorizedStates = authorizedStates.concat(item.children);
	        });
	      } else {
	        authorizedStates = authorizedStates.concat(found.children);
	      }
	    });
	
	    return authorizedStates;
	  }
	
	  function login(token, user, rememberMe) {
	    if (rememberMe) {
	      $localStorage.token = token;
	    } else {
	      $sessionStorage.token = token;
	    }
	  }
	
	  function logout() {
	    $localStorage.$reset();
	    localStorage.clear();
	    $sessionStorage.$reset();
	    sessionStorage.clear();
	    $state.go("login");
	  }
	
	  function isAuthenticated() {
	    return $localStorage.token || $sessionStorage.token;
	  }
	
	  function isAuthorized(targetState, accessGroup) {
	    if (accessGroup.is_super || targetState === "me") {
	      return true;
	    }
	
	    var authorizedStates = getAuthorizedStates(accessGroup);
	    return authorizedStates.indexOf(targetState) > -1;
	  }
	
	  return { getAuthorizedModules: getAuthorizedModules, init: init, isAuthenticated: isAuthenticated, login: login, logout: logout };
	};
	
	AuthService.$inject = [
	"Restangular",
	"Toast",
	"$filter",
	"$localStorage",
	"$mdDialog",
	"$rootScope",
	"$sessionStorage",
	"$state",
	"$transitions"];exports.default =
	
	
	AuthService;

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.default = [
	{
	  title: 'unit',
	  icon: 'mdi-map-marker',
	  home: 'unit.list',
	  subMenu: [
	  {
	    title: 'unit-list',
	    goto: 'unit.list',
	    children: ['unit.list', 'unit.create', 'unit.edit'] },
	
	  {
	    title: 'time-title',
	    goto: 'time-title.list',
	    children: ['time-title.list'] },
	
	  {
	    title: 'region',
	    goto: 'region.list',
	    children: ['region.list', 'region.create', 'region.edit'] },
	
	  {
	    title: 'differential',
	    goto: 'differential.list',
	    children: ['differential.list', 'differential.create', 'differential.edit'] },
	
	  {
	    title: 'service',
	    goto: 'service.list',
	    children: ['service.list', 'service.create', 'service.edit'] }] },
	
	
	
	{
	  title: 'attendance',
	  icon: 'mdi-cellphone',
	  home: 'attendance.list',
	  subMenu: [
	  {
	    title: 'attendance-list',
	    goto: 'attendance.list',
	    children: ['attendance.list', 'attendance.show'] },
	
	  {
	    title: 'email',
	    goto: 'email.list',
	    children: ['email.list', 'email.create', 'email.edit'] }] },
	
	
	
	{
	  title: 'procedure',
	  icon: 'mdi-folder',
	  abstract: true,
	  home: 'procedure.list',
	  children: ['procedure.list', 'procedure.show'],
	  goto: 'procedure.list' },
	
	{
	  title: 'news',
	  icon: 'mdi-earth',
	  abstract: true,
	  home: 'news.list',
	  children: ['news.list', 'news.create', 'news.edit'],
	  goto: 'news.list' },
	
	{
	  title: 'custom-page',
	  icon: 'mdi-lead-pencil',
	  home: 'page.about',
	  subMenu: [
	  {
	    title: 'page.home-app',
	    goto: 'page.home-app',
	    children: ['page.home-app'] },
	
	  {
	    title: 'page-video-home',
	    goto: 'page.video-home',
	    children: ['page.video-home'] },
	
	  {
	    title: 'page-about',
	    goto: 'page.about',
	    children: ['page.about'] },
	
	  {
	    title: 'page-privacy',
	    goto: 'page.privacy',
	    children: ['page.privacy'] },
	
	  {
	    title: 'page-cid',
	    goto: 'page.cid',
	    children: ['page.cid'] }] },
	
	
	
	{
	  title: 'users-and-groups',
	  icon: 'mdi-account-circle',
	  home: 'admin.list',
	  subMenu: [
	  {
	    title: 'admin',
	    goto: 'admin.list',
	    children: ['admin.list', 'admin.create', 'admin.edit'] },
	
	  {
	    title: 'group',
	    goto: 'group.list',
	    children: ['group.list', 'group.create', 'group.edit'] }] },
	
	
	
	{
	  title: 'vaccine',
	  icon: 'mdi-calendar',
	  home: 'vaccine.list',
	  subMenu: [
	  {
	    title: 'target',
	    goto: 'target.list',
	    children: ['target.list'] },
	
	  {
	    title: 'target-category',
	    goto: 'target.category',
	    children: ['target.category'] },
	
	  {
	    title: 'vaccine-vaccine',
	    goto: 'vaccine.list',
	    children: ['vaccine.list', 'vaccine.create', 'vaccine.edit'] }] },
	
	
	
	{
	  title: 'card',
	  icon: 'mdi-needle',
	  abstract: true,
	  home: 'card.list',
	  children: ['card.list', 'card.create', 'card.edit'],
	  goto: 'card.list' },
	
	{
	  title: 'insurance',
	  icon: 'mdi-hospital',
	  abstract: true,
	  home: 'insurance.list',
	  subMenu: [
	  {
	    title: 'insurance',
	    goto: 'insurance.list',
	    children: ['insurance.list', 'insurance.create', 'insurance.edit'] },
	
	  {
	    title: 'insurance-states',
	    goto: 'insurance.state',
	    children: ['insurance.state.list', 'insurance.state.create', 'insurance.state.edit', 'insurance.city.create', 'insurance.city.edit'] }] },
	
	
	
	{
	  title: 'campaign',
	  icon: 'mdi-star-circle',
	  abstract: true,
	  home: 'campaign.list',
	  children: ['campaign.list', 'campaign.create', 'campaign.edit'],
	  goto: 'campaign.list' },
	
	{
	  title: 'client',
	  icon: 'mdi-clipboard-account',
	  abstract: true,
	  home: 'client.report',
	  children: ['client.report'],
	  goto: 'client.report' },
	
	{
	  title: 'notification',
	  icon: 'mdi-message-alert',
	  abstract: true,
	  home: 'notification.list',
	  children: ['notification.create', 'notification.list', 'notification.edit'],
	  goto: 'notification.list' },
	
	{
	  title: 'pop-up',
	  icon: 'mdi-file-image',
	  abstract: true,
	  home: 'pop-up.list',
	  children: ['pop-up.create', 'pop-up.list', 'pop-up.edit'],
	  goto: 'pop-up.list' },
	
	{
	  title: 'app-version.list',
	  icon: 'mdi-checkbox-marked-circle',
	  abstract: true,
	  home: 'app-version.list',
	  children: ['app-version.list'],
	  goto: 'app-version.list' },
	
	{
	  title: 'apiaccesslog',
	  icon: 'mdi-yeast',
	  abstract: true,
	  home: 'apiaccesslog.list',
	  children: ['apiaccesslog.create', 'apiaccesslog.list', 'apiaccesslog.edit'],
	  goto: 'apiaccesslog.list' },
	
	{
	  title: 'faq',
	  icon: 'mdi-comment-question',
	  abstract: true,
	  subMenu: [
	  {
	    title: 'faq.list',
	    goto: 'faq.list',
	    children: ['faq.categories.list', 'faq.log-list', 'faq.log-detail'] },
	
	  {
	    title: 'faq-categories',
	    goto: 'categories.list' }] }];

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var HttpInterceptor = function HttpInterceptor($localStorage, $sessionStorage) {
	  var interceptor = {
	    request: function request(config) {
	      var token = $localStorage.token || $sessionStorage.token;
	
	      if (token) {
	        config.headers = config.headers || {};
	        config.headers.Authorization = 'Bearer ' + token;
	      }
	      config.timeout = 1000 * 60 * 30;
	
	      return config;
	    } };
	
	
	  return interceptor;
	};
	
	HttpInterceptor.$inject = ['$localStorage', '$sessionStorage'];exports.default =
	
	HttpInterceptor;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _shell = __webpack_require__(440);var _shell2 = _interopRequireDefault(_shell);
	var _shell3 = __webpack_require__(447);var _shell4 = _interopRequireDefault(_shell3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var shellModule = _angular2.default.module('shell', [
	_angularUiRouter2.default]).
	
	
	service('ShellService', _shell4.default).
	
	run(["ShellService", function (ShellService) {
		"ngInject";
	
		ShellService.init();
	}]).
	
	component('shell', _shell2.default).
	
	name;exports.default =
	
	shellModule;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _shell = __webpack_require__(441);var _shell2 = _interopRequireDefault(_shell);
	var _shell3 = __webpack_require__(442);var _shell4 = _interopRequireDefault(_shell3);
	__webpack_require__(443);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var shellComponent = {
	  bindings: {},
	  template: _shell2.default,
	  controller: _shell4.default };exports.default =
	
	
	shellComponent;

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-shell sb-fill-height\" ng-class=\"{'sb-visible-shell': $root.isShellVisible}\">\n  <toolbar ng-if=\"$root.isShellVisible\"></toolbar>\n\n  <section layout=\"row\" flex class=\"sb-fill-height\">\n    <sidenav ng-if=\"$root.isShellVisible\"></sidenav>\n\n    <md-content flex>\n      <div ui-view></div>\n    </md-content>\n  </section>\n</div>"

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var ShellController =
	function ShellController() {_classCallCheck(this, ShellController);
	  this.name = 'shell';
	};exports.default =
	
	
	ShellController;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(444);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./shell.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./shell.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%}h1,h2,h3,h4,h5,h6{font-weight:400}.sb-fill-height,div[ui-view]{height:100%}.sb-fill-parent{position:relative;width:100%;height:100%}.sb-absolute-center{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.sb-no-margin{margin:0}.sb-content-container{max-width:1200px;height:100%;margin:auto}md-toast.md-success-toast-theme .md-toast-content{background-color:#43a047}md-toast.md-error-toast-theme .md-toast-content{background-color:#f44336}[ng-click]:hover{cursor:pointer}*{outline:none}table.md-table th.md-column.md-active md-icon.md-sort-icon,table.md-table th.md-column:hover md-icon.md-sort-icon{height:12px;min-height:12px}.sb-empty-state .sb-empty-state-text{text-align:center;margin:16px 0 24px}.sb-empty-state .sb-empty-state-text p{margin:2px 0;font-size:14px;color:rgba(0,0,0,.4)}.sb-empty-state .md-button{padding:0 16px}.sb-page-section{margin-bottom:32px}.sb-page-section .sb-page-section-sub-title,.sb-page-section .sb-page-section-title{margin-left:16px}.sb-page-section md-card{padding:16px}.sb-page-section-title{margin-top:0;margin-bottom:8px;font-weight:600;text-transform:uppercase;color:rgba(0,0,0,.72);font-size:14px}.sb-page-section-sub-title{font-size:14px;color:rgba(0,0,0,.48);margin:0 0 16px}tr:not([sb-disabled=true])[ng-click]:hover,tr[ng-click]:hover{cursor:pointer;background:rgba(0,0,0,.12);transition:background .5s linear}.sb-checkboxes .sb-section-title{color:rgba(0,0,0,.56);font-weight:600;margin:32px 0 0}.sb-checkboxes md-checkbox{margin:0;padding:16px;width:280px;flex:0 0 auto;font-size:14px}.sb-table-search{padding:4px 8px 0}.sb-table-search input{border:0;font-size:14px;color:rgba(0,0,0,.64)}label[for=fileInput] div.sb-avatar-input{height:200px;width:200px;border:1px solid rgba(0,0,0,.12);background-color:rgba(0,0,0,.12);border-radius:50%;cursor:pointer}.sb-avatar-image{border-radius:50%;cursor:pointer}.sb-avatar-div{max-width:75%;width:75%;height:auto;display:block;padding-top:75%;border-radius:50%;background-position-y:center;background-position-x:center;background-repeat:no-repeat;background-size:cover;margin:0 auto;top:0;left:0;right:0;bottom:0}.sb-text-align-center{text-align:center}form md-card{margin-bottom:0}.sb-title{font-weight:600;font-size:14px;margin:16px 0 0;color:rgba(0,0,0,.8)}.sb-body-2{margin-top:8px;font-size:14px;font-weight:500;letter-spacing:.01em;line-height:24px}.sb-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sb-datepicker-input-container{padding:16px 0}.sb-datepicker-input-container>label{margin-bottom:8px;color:rgba(0,0,0,.4)}.sb-hint{color:grey;font-size:12px;line-height:14px;overflow:hidden;opacity:1;margin-top:0;padding-top:5px}.sb-hint.lg{color:rgba(0,0,0,.4);font-size:16px;padding-top:32px;padding-left:12px;padding-bottom:8px}.sb-autocomplete-custom-template li{border-bottom:1px solid #ccc;height:56px!important;padding-top:8px!important;padding-bottom:8px!important;white-space:normal}.sb-autocomplete-custom-template li:last-child{border-bottom-width:0}.sb-autocomplete-custom-template .item-title{display:block;line-height:2}.sb-autocomplete-custom-template .item-metadata{display:block;line-height:2;font-size:12px;color:grey}.sb-conditional-section>md-checkbox{margin-top:32px}.sb-table-column-xs{width:25px}.sb-shell{position:relative}.sb-shell>toolbar>md-toolbar{position:absolute}.sb-shell>toolbar>md-toolbar .sb-logo{padding:0 24px 0 12px}.sb-shell>toolbar>md-toolbar div.avatar-wrapper,.sb-shell>toolbar>md-toolbar img.md-avatar{margin-top:8px;margin-bottom:8px;margin-right:16px;width:40px;height:40px}.sb-shell>toolbar>md-toolbar img.md-avatar{border-radius:50%;box-sizing:content-box}.sb-shell>toolbar>md-toolbar .sb-toolbar-user-info{font-size:12px}.sb-shell>toolbar>md-toolbar .sb-toolbar-user-info h3{font-weight:700}.sb-shell>toolbar>md-toolbar .sb-toolbar-user-info p{margin:0}.sb-shell.sb-visible-shell>section{padding-top:64px}.sb-shell.sb-visible-shell>section>md-content{padding-top:32px;padding-right:32px;height:fit-content}.sb-shell>section>sidenav>md-sidenav{width:300px;min-width:300px;background-color:#fafafa}.sb-shell>section>sidenav>md-sidenav md-content{color:rgba(0,0,0,.56);background-color:#fafafa}.sb-shell>section>sidenav>md-sidenav md-content md-list md-list-item.active{color:#f44336}.sb-shell>section>sidenav>md-sidenav md-content md-list md-list-item.sb-sub-menu p{padding-left:56px}.sb-shell>section>sidenav>md-sidenav md-content md-list md-list-item p.md-body-2{padding-top:8px;font-weight:600}", ""]);
	
	// exports


/***/ }),
/* 445 */,
/* 446 */,
/* 447 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var ShellService = function ShellService($rootScope, $transitions) {
	  function init() {
	    $transitions.onSuccess({}, function (transition) {
	      $rootScope.isShellVisible = _.get(transition.to(), 'data.hideShell') !== true;
	      $rootScope.currentState = transition.to();
	    });
	  }
	
	  return { init: init };
	};
	
	ShellService.$inject = ['$rootScope', '$transitions'];exports.default =
	
	ShellService;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _sidenav = __webpack_require__(449);var _sidenav2 = _interopRequireDefault(_sidenav);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var sidenavModule = _angular2.default.module('sidenav', [
	_angularUiRouter2.default]).
	
	
	component('sidenav', _sidenav2.default).
	
	name;exports.default =
	
	sidenavModule;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _sidenav = __webpack_require__(450);var _sidenav2 = _interopRequireDefault(_sidenav);
	var _sidenav3 = __webpack_require__(451);var _sidenav4 = _interopRequireDefault(_sidenav3);
	__webpack_require__(452);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var sidenavComponent = {
	  bindings: {},
	  template: _sidenav2.default,
	  controller: _sidenav4.default };exports.default =
	
	
	sidenavComponent;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	module.exports = "<md-sidenav\n    class=\"md-sidenav-left\"\n    md-component-id=\"left\"\n    md-is-locked-open=\"true\">\n\n  <md-content layout-padding>\n    <md-list>\n      <div ng-repeat=\"menuItem in $ctrl.sideMenu\">\n        <md-list-item ng-if=\"$ctrl.isAuthorized(menuItem)\"\n                      ng-click=\"menuItem.isOpen = !menuItem.isOpen\"\n                      ui-sref=\"{{ menuItem.goto }}\"\n                      ng-class=\"{'active': $root.currentState.name === menuItem.goto || (menuItem.children && menuItem.children.indexOf($root.currentState.name) > -1)}\">\n          <md-icon md-font-set=\"mdi\" md-font-icon=\"{{ menuItem.icon }}\" class=\"mdi-24px\">\n          </md-icon>\n\n          <p class=\"md-body-2\">{{ 'shell-' + menuItem.title | translate }}</p>\n        </md-list-item>\n\n        <md-list-item ng-if=\"$ctrl.isAuthorized(menuItem)\"\n                      ng-repeat=\"subMenuItem in menuItem.subMenu\"\n                      ng-show=\"menuItem.isOpen\"\n                      ui-sref=\"{{ subMenuItem.goto }}\"\n                      class=\"sb-sub-menu\"\n                      ng-class=\"{'active': $root.currentState.name === subMenuItem.goto || (subMenuItem.children && subMenuItem.children.indexOf($root.currentState.name) > -1)}\">\n          <p class=\"md-body-2\">{{ 'shell-' + subMenuItem.title | translate }}</p>\n        </md-list-item>\n      </div>\n    </md-list>\n  </md-content>\n</md-sidenav>"

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();var _sidenav = __webpack_require__(437);var _sidenav2 = _interopRequireDefault(_sidenav);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var
	
	SidenavController = function () {
	  function SidenavController($rootScope, $state, $timeout, Auth) {_classCallCheck(this, SidenavController);
	    this.$rootScope = $rootScope;
	    this.$state = $state;
	    this.$timeout = $timeout;
	    this.Auth = Auth;
	    this.name = 'sidenav';
	    this.setup();
	  }_createClass(SidenavController, [{ key: 'isAuthorized', value: function isAuthorized(
	
	    menuItem) {
	      if (this.$rootScope.user.access_group.is_super) {
	        return true;
	      }
	
	      var authorizedModules = this.Auth.getAuthorizedModules(this.$rootScope.user.access_group);
	      return authorizedModules.indexOf(menuItem.title) > -1;
	    }
	
	    // Local functions
	  }, { key: 'setup', value: function setup()
	    {
	      this.setupSideNav();
	    } }, { key: 'setupSideNav', value: function setupSideNav()
	
	    {
	      this.sideMenu = _sidenav2.default;
	      this.openActiveMenu();
	    } }, { key: 'openActiveMenu', value: function openActiveMenu()
	
	    {var _this = this;
	      this.$timeout(function () {
	        var activeMenuItem = _.find(_this.sideMenu, function (menuItem) {
	          return menuItem.subMenu && _.find(menuItem.subMenu, function (subMenuItem) {
	            if (subMenuItem.children) {
	              return subMenuItem.children.indexOf(_this.$state.current.name) > -1;
	            }
	          });
	        });
	
	        if (activeMenuItem) {activeMenuItem.isOpen = true;}
	
	      }, 100);
	    } }]);return SidenavController;}();
	
	
	SidenavController.$inject = ['$rootScope', '$state', '$timeout', 'Auth'];exports.default =
	
	SidenavController;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(453);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./sidenav.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./sidenav.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".sidenav{color:red}", ""]);
	
	// exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _toolbar = __webpack_require__(455);var _toolbar2 = _interopRequireDefault(_toolbar);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var toolbarModule = _angular2.default.module('toolbar', [
	_angularUiRouter2.default]).
	
	
	component('toolbar', _toolbar2.default).
	
	name;exports.default =
	
	toolbarModule;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _toolbar = __webpack_require__(456);var _toolbar2 = _interopRequireDefault(_toolbar);
	var _toolbar3 = __webpack_require__(457);var _toolbar4 = _interopRequireDefault(_toolbar3);
	__webpack_require__(458);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var toolbarComponent = {
	  bindings: {},
	  template: _toolbar2.default,
	  controller: _toolbar4.default };exports.default =
	
	
	toolbarComponent;

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	module.exports = "<md-toolbar layout=\"row\" class=\"md-accent\">\n    <div class=\"md-toolbar-tools\">\n      <img class=\"sb-logo\" ng-src=\"{{ $root.baseAssetsUrl }}/logo-white.png\"/>\n\n      <h3 flex>{{ 'shell-' + $root.currentState.name | translate }}</h3>\n\n      <img ng-if=\"$root.user.image_uri\" ng-src=\"{{ $root.user.image_uri }}\" class=\"md-avatar\">\n\n      <div ng-if=\"!$root.user.image_uri\">\n        <ng-avatar string=\"{{ $root.user.name | firstLastName | uppercase }}\"\n                   max-length=2\n                   round-shape=\"true\"\n                   text-color=\"#666\"\n                   width=\"40\"\n                   bg-color=\"#fff\">\n        </ng-avatar>\n      </div>\n\n      <div class=\"sb-toolbar-user-info\">\n         <h3>{{ $root.user.name }}</h3>\n         <p>{{ $root.user.email }}</p>\n      </div>\n\n      <md-menu md-position-mode=\"target-right target\" md-offset=\"0 65\">\n        <md-button aria-label=\"Toolbar menu\"\n                   class=\"md-icon-button \"\n                   ng-click=\"$mdMenu.open($event)\">\n          <md-icon md-menu-origin\n                   md-font-set=\"mdi\" md-font-icon=\"mdi-dots-vertical\" class=\"mdi-24px\">\n          </md-icon>\n        </md-button>\n\n        <md-menu-content width=\"4\">\n          <md-menu-item>\n            <md-button ui-sref=\"me\">\n              <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-account\" class=\"mdi-24px\" md-menu-align-target>\n              </md-icon>\n              {{ 'shell-me' | translate }}\n            </md-button>\n          </md-menu-item>\n\n          <md-menu-item>\n            <md-button ng-click=\"$ctrl.logout()\">\n              <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-logout\" class=\"mdi-24px\" md-menu-align-target>\n              </md-icon>\n              {{ 'common-sign-out' | translate }}\n            </md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </div>\n</md-toolbar>\n"

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var ToolbarController = function () {
	  function ToolbarController(Auth) {_classCallCheck(this, ToolbarController);
	    this.Auth = Auth;
	    this.name = 'toolbar';
	  }_createClass(ToolbarController, [{ key: 'logout', value: function logout()
	
	    {
	      this.Auth.logout();
	    } }]);return ToolbarController;}();
	
	
	ToolbarController.$inject = ['Auth'];exports.default =
	
	ToolbarController;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(459);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./toolbar.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./toolbar.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".toolbar{color:red}.md-toolbar.md-default-theme:not(.md-menu-toolbar).md-accent,.md-toolbar.md-default-theme:not(.md-menu-toolbar).md-accent md-icon,md-toolbar:not(.md-menu-toolbar).md-accent,md-toolbar:not(.md-menu-toolbar).md-accent md-icon{color:#fff!important}.sb-shell>toolbar>md-toolbar.fixed{position:fixed}", ""]);
	
	// exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _user = __webpack_require__(461);var _user2 = _interopRequireDefault(_user);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var userModule = _angular2.default.module('user', []).
	
	factory('User', _user2.default).
	
	name;exports.default =
	
	userModule;

/***/ }),
/* 461 */
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var UserFactory = function UserFactory() {
	  var user = {};
	
	  var getUser = function getUser() {
	    return user;
	  };
	
	  var isSignedIn = function isSignedIn() {
	    return user.isSignedIn;
	  };
	
	  return { getUser: getUser, isSignedIn: isSignedIn };
	};exports.default =
	
	UserFactory;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _admin = __webpack_require__(463);var _admin2 = _interopRequireDefault(_admin);
	var _attendance = __webpack_require__(479);var _attendance2 = _interopRequireDefault(_attendance);
	var _email = __webpack_require__(492);var _email2 = _interopRequireDefault(_email);
	var _group = __webpack_require__(505);var _group2 = _interopRequireDefault(_group);
	var _home = __webpack_require__(519);var _home2 = _interopRequireDefault(_home);
	var _city = __webpack_require__(525);var _city2 = _interopRequireDefault(_city);
	var _state = __webpack_require__(532);var _state2 = _interopRequireDefault(_state);
	var _differential = __webpack_require__(539);var _differential2 = _interopRequireDefault(_differential);
	var _service = __webpack_require__(552);var _service2 = _interopRequireDefault(_service);
	var _login = __webpack_require__(565);var _login2 = _interopRequireDefault(_login);
	var _news = __webpack_require__(573);var _news2 = _interopRequireDefault(_news);
	var _page = __webpack_require__(586);var _page2 = _interopRequireDefault(_page);
	var _region = __webpack_require__(607);var _region2 = _interopRequireDefault(_region);
	var _unit = __webpack_require__(621);var _unit2 = _interopRequireDefault(_unit);
	var _procedure = __webpack_require__(648);var _procedure2 = _interopRequireDefault(_procedure);
	var _vaccine = __webpack_require__(661);var _vaccine2 = _interopRequireDefault(_vaccine);
	var _target = __webpack_require__(675);var _target2 = _interopRequireDefault(_target);
	var _campaign = __webpack_require__(686);var _campaign2 = _interopRequireDefault(_campaign);
	var _client = __webpack_require__(699);var _client2 = _interopRequireDefault(_client);
	var _card = __webpack_require__(715);var _card2 = _interopRequireDefault(_card);
	var _insurance = __webpack_require__(728);var _insurance2 = _interopRequireDefault(_insurance);
	var _notification = __webpack_require__(750);var _notification2 = _interopRequireDefault(_notification);
	var _me = __webpack_require__(763);var _me2 = _interopRequireDefault(_me);
	var _apiaccesslog = __webpack_require__(769);var _apiaccesslog2 = _interopRequireDefault(_apiaccesslog);
	var _version = __webpack_require__(782);var _version2 = _interopRequireDefault(_version);
	var _faq = __webpack_require__(792);var _faq2 = _interopRequireDefault(_faq);
	var _categories = __webpack_require__(815);var _categories2 = _interopRequireDefault(_categories);
	var _popUp = __webpack_require__(819);var _popUp2 = _interopRequireDefault(_popUp);
	var _timeTitle = __webpack_require__(834);var _timeTitle2 = _interopRequireDefault(_timeTitle);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var componentModule = _angular2.default.module('app.components', [
	_admin2.default,
	_attendance2.default,
	_email2.default,
	_campaign2.default,
	_card2.default,
	_client2.default,
	_group2.default,
	_city2.default,
	_differential2.default,
	_home2.default,
	_login2.default,
	_me2.default,
	_apiaccesslog2.default,
	_news2.default,
	_notification2.default,
	_page2.default,
	_procedure2.default,
	_region2.default,
	_service2.default,
	_state2.default,
	_target2.default,
	_unit2.default,
	_vaccine2.default,
	_insurance2.default,
	_version2.default,
	_faq2.default,
	_categories2.default,
	_popUp2.default,
	_timeTitle2.default]).
	
	
	name;exports.default =
	
	componentModule;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _admin = __webpack_require__(464);var _admin2 = _interopRequireDefault(_admin);
	var _adminList = __webpack_require__(469);var _adminList2 = _interopRequireDefault(_adminList);
	var _adminDetail = __webpack_require__(472);var _adminDetail2 = _interopRequireDefault(_adminDetail);
	var _admin3 = __webpack_require__(477);var _admin4 = _interopRequireDefault(_admin3);
	var _adminDetail3 = __webpack_require__(478);var _adminDetail4 = _interopRequireDefault(_adminDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var adminModule = _angular2.default.module('admin', [
	_angularUiRouter2.default]).
	
	
	service('Admin', _admin4.default).
	service('AdminDetail', _adminDetail4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/admin');
	
	  $stateProvider.
	  state('admin', {
	    component: 'admin' }).
	
	  state('admin.list', {
	    url: '/admin',
	    component: 'adminList' }).
	
	  state('admin.create', {
	    url: '/admin/new',
	    component: 'adminDetail',
	    params: {
	      id: "" } }).
	
	
	  state('admin.edit', {
	    url: '/admin/:id/edit',
	    component: 'adminDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('admin', _admin2.default).
	component('adminList', _adminList2.default).
	component('adminDetail', _adminDetail2.default).
	
	name;exports.default =
	
	adminModule;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _admin = __webpack_require__(465);var _admin2 = _interopRequireDefault(_admin);
	var _admin3 = __webpack_require__(466);var _admin4 = _interopRequireDefault(_admin3);
	__webpack_require__(467);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var adminComponent = {
	  bindings: {},
	  template: _admin2.default,
	  controller: _admin4.default };exports.default =
	
	
	adminComponent;

/***/ }),
/* 465 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var AdminController =
	function AdminController() {_classCallCheck(this, AdminController);
	  this.name = 'admin';
	};exports.default =
	
	
	AdminController;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(468);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./admin.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./admin.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".admin{color:red}", ""]);
	
	// exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _adminList = __webpack_require__(470);var _adminList2 = _interopRequireDefault(_adminList);
	var _adminList3 = __webpack_require__(471);var _adminList4 = _interopRequireDefault(_adminList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var adminListComponent = {
	  bindings: {},
	  template: _adminList2.default,
	  controller: _adminList4.default };exports.default =
	
	
	adminListComponent;

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\" \n         ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n        <md-button class=\"md-raised md-accent\" ui-sref=\"admin.create\">\n            {{ 'common-new-masculine' | translate }}\n        </md-button>\n\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\" \n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'admin-list-table-header-name' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"email\"\n                        ng-click=\"$ctrl.orderList('email')\">\n                        {{ 'admin-list-table-header-email' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"access_group.name\"\n                        ng-click=\"$ctrl.orderList('access_group.name')\">\n                        {{ 'admin-list-table-header-access-group' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"created_at\"\n                        ng-click=\"$ctrl.orderList('created_at')\">\n                        {{ 'admin-list-table-header-created-at' | translate }}\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit(resource.id)\">\n                    <td md-cell class=\"sb-table-truncate\">{{ resource.name }}</td>\n\n                    <td md-cell>{{ resource.email }}</td>\n\n                    <td ng-if=\"resource.access_group\" md-cell>\n                        {{ resource.access_group.name }}\n                    </td>\n\n                    <td ng-if=\"!resource.access_group\" md-cell>\n                        {{ 'admin-list-table-access-group-null' | translate }}\n                    </td>\n                    \n                    <td md-cell>{{ resource.created_at | momentFormat : 'DD/MM/YYYY' }}</td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination \n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'admin-list-empty-state-line-1' | translate }}</p>\n                <p>{{ 'admin-list-empty-state-line-2' | translate }}</p>\n            </div>\n\n            <md-button class=\"md-raised md-accent\" ui-sref=\"admin.create\">\n                {{ 'admin-list-create-admin-button' | translate }}\n            </md-button>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var AdminListController = function AdminListController(Admin, $scope, $state, $filter, $mdDialog, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name',
	      like_search: '',
	      like_search_fields: [
	      'name',
	      'email',
	      '$access_group.name$'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function edit(id) {
	    $state.go('admin.edit', { id: id });
	  }
	
	  function handleDelete(resource) {
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Admin.
	      destroy(resource).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        _.remove($ctrl.resources.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Admin.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	};
	
	AdminListController.$inject = ['Admin', '$scope', '$state', '$filter', '$mdDialog', 'Toast'];exports.default =
	
	AdminListController;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _adminDetail = __webpack_require__(473);var _adminDetail2 = _interopRequireDefault(_adminDetail);
	var _adminDetail3 = __webpack_require__(474);var _adminDetail4 = _interopRequireDefault(_adminDetail3);
	__webpack_require__(475);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var adminDetailComponent = {
	  bindings: {},
	  template: _adminDetail2.default,
	  controller: _adminDetail4.default };exports.default =
	
	
	adminDetailComponent;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-admin\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <form name=\"adminForm\" ng-submit=\"$ctrl.handleSave(adminForm, $ctrl.admin)\" novalidate>\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">\n                    {{ 'admin-detail-title' | translate }}\n                </h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'admin-detail-title-caption' | translate }}\n                </p>\n\n                <div layout=\"row\">\n                    <div layout=\"column\" layout-align=\"start center\" flex=\"25\" style=\"position: relative;\">\n                        <div>\n                            <input ng-show=\"false\" type=\"file\" id=\"fileInput\" />\n\n                            <label for=\"fileInput\">\n                                <div ng-show=\"!$ctrl.myCroppedImage && !$ctrl.admin.image_uri\" class=\"sb-avatar-input\">\n                                </div>\n\n                                <img class=\"sb-avatar-image\" ng-show=\"$ctrl.admin.image_uri || $ctrl.myCroppedImage\"\n                                    ng-src=\"{{ $ctrl.myCroppedImage || $ctrl.admin.image_uri }}\" />\n                            </label>\n                        </div>\n\n                        <div class=\"sb-hint sb-text-align-center\" ng-show=\"!$ctrl.myCroppedImage\">\n                            {{ 'admin-detail-form-image-hint' | translate }}\n                        </div>\n\n                        <md-button ng-click=\"$ctrl.clearImage()\" ng-show=\"$ctrl.myCroppedImage || $ctrl.admin.image_uri\"\n                            class=\"md-icon-button md-warn\" style=\"position: absolute; top: 0px; right: 0px\">\n                            <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-close\" class=\"mdi-24px\">\n                            </md-icon>\n                        </md-button>\n                    </div>\n\n                    <div flex=\"75\">\n                        <md-card>\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'admin-detail-form-admin-name' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.admin.name\" name=\"name\" required>\n                                    </input>\n\n                                    <div ng-messages=\"adminForm.name.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'admin-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'admin-detail-form-admin-sector' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.admin.sector\" name=\"sector\" required>\n                                    </input>\n\n                                    <div ng-messages=\"adminForm.sector.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'admin-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'admin-detail-form-admin-email' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.admin.email\" name=\"email\" type=\"email\" required>\n                                    </input>\n\n                                    <div ng-messages=\"adminForm.email.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"email\">\n                                            {{ 'form-error-email-invalid' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'admin-detail-form-admin-access-group' | translate }}\n                                    </label>\n\n                                    <md-select ng-model=\"$ctrl.admin.access_group_id\" name=\"access_group\"\n                                        id=\"inputAccess_group_id\" required>\n                                        <md-option ng-repeat=\"access_group in $ctrl.access_groups\"\n                                            ng-value=\"access_group.id\">\n                                            {{ access_group.name }}\n                                        </md-option>\n                                    </md-select>\n\n                                    <div ng-messages=\"adminForm.access_group.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"sb-password-container md-block\" flex>\n                                    <label>\n                                        {{ $ctrl.id ? 'admin-detail-form-admin-new-password' : 'admin-detail-form-admin-password' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.admin.password\" name=\"password\"\n                                        type=\"{{ $ctrl.isPasswordVisible ? 'text' : 'password'}}\"\n                                        ng-required=\"!$ctrl.id\" minlength=\"6\">\n                                    </input>\n\n                                    <md-icon ng-click=\"$ctrl.isPasswordVisible = !$ctrl.isPasswordVisible;\"\n                                        md-font-set=\"mdi\"\n                                        md-font-icon=\"{{ $ctrl.isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye'}}\"\n                                        class=\"mdi-24px\">\n                                    </md-icon>\n\n                                    <div ng-messages=\"adminForm.password.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"minlength\">\n                                            {{ 'admin-detail-form-error-password-min-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <div layout=\"row\" layout-align=\"center start\" flex>\n                                    <md-switch md-invert aria-label=\"Switch 7\"\n                                        ng-change=\"$ctrl.desactivated_at_changed = true\"\n                                        ng-model=\"$ctrl.admin.isActive\">\n                                        {{ 'admin-detail-form-desactivate-switch' | translate }}\n                                    </md-switch>\n                                </div>\n                            </div>\n\n                            <div ng-hide=\"$ctrl.admin.access_group_id === 1\" class=\"search-unit-square\" layout=\"row\"\n                                flex>\n                                <div ng-show=\"$ctrl.admin.access_group.special_rule === 'MANAGER '\" class=\"input-square\" layout=\"column\"\n                                    flex class=\"sb-conditional-section\">\n                                    <md-autocomplete md-no-cache=\"true\" md-selected-item=\"$ctrl.squareSelected\"\n                                        md-selected-item-change=\"$ctrl.selectedSquareChange($ctrl.squareSelected)\"\n                                        md-items=\"square in $ctrl.querySearchSquare($ctrl.searchTextSquare)\"\n                                        md-search-text=\"$ctrl.searchTextSquare\"\n                                        md-item-text=\"$ctrl.squareSelected.name ? $ctrl.squareSelected.name : square.name\"\n                                        md-menu-class=\"sb-autocomplete-custom-template\"\n                                        placeholder=\"Pesquise por uma região\" ng-required=\"$ctrl.hasNewsItem\">\n                                        <md-item-template>\n                                            <span class=\"item-title\">\n                                                <span>{{ square.name }}</span>\n                                            </span>\n\n                                            <span class=\"item-metadata\">\n                                                <span>\n                                                    {{ square.name }}\n                                                </span>\n                                            </span>\n                                        </md-item-template>\n\n                                        <md-not-found>\n                                            {{ 'list-empty-search-state-line-1' | translate }}\n                                        </md-not-found>\n                                    </md-autocomplete>\n\n                                    <div class=\"sb-error-message\"\n                                        ng-show=\"notificationForm.$submitted && ($ctrl.hasNewsItem && !$ctrl.selectedNewsItem)\">\n                                        {{ 'form-error-required-field' | translate}}\n                                    </div>\n                                </div>\n\n                                <div ng-show=\"$ctrl.admin.access_group.special_rule === 'COORDINATOR'\" class=\"input-unit\" layout=\"column\" flex\n                                    class=\"sb-conditional-section\">\n                                    <md-autocomplete md-no-cache=\"true\" md-selected-item=\"$ctrl.unitSelected\"\n                                        md-selected-item-change=\"$ctrl.selectedUnitChange($ctrl.unitSelected)\"\n                                        md-items=\"unit in $ctrl.querySearchUnit($ctrl.searchTextUnit)\"\n                                        md-search-text=\"$ctrl.searchTextUnit\"\n                                        md-item-text=\"$ctrl.unitSelected.name ? $ctrl.unitSelected.name : unit.name\"\n                                        md-menu-class=\"sb-autocomplete-custom-template\"\n                                        placeholder=\"Pesquise por uma unidade\" ng-required=\"$ctrl.hasNewsItem\">\n                                        <md-item-template>\n                                            <span class=\"item-title\">\n                                                <span>{{ unit.name }}</span>\n                                            </span>\n\n                                            <span class=\"item-metadata\">\n                                                <span>\n                                                    {{ unit.address_street + \", \" + unit.address_neighborhood }}\n                                                </span>\n\n                                                <span> - </span>\n\n                                                <span>\n                                                    {{ unit.address_complement }}\n                                                </span>\n                                            </span>\n                                        </md-item-template>\n\n                                        <md-not-found>\n                                            {{ 'list-empty-search-state-line-1' | translate }}\n                                        </md-not-found>\n                                    </md-autocomplete>\n\n                                    <div class=\"sb-error-message\"\n                                        ng-show=\"notificationForm.$submitted && ($ctrl.hasNewsItem && !$ctrl.selectedNewsItem)\">\n                                        {{ 'form-error-required-field' | translate}}\n                                    </div>\n                                </div>\n                            </div>\n                        </md-card>\n\n                        <md-progress-linear ng-show=\"$ctrl.saving || $ctrl.deleting\" md-mode=\"indeterminate\">\n                        </md-progress-linear>\n                    </div>\n                </div>\n\n            </div>\n            <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n                <md-button page-back ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                    {{ 'common-cancel-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.handleDelete($ctrl.admin, $event)\" ng-if=\"$ctrl.id\"\n                    ng-disabled=\"$ctrl.saving || $ctrl.deleting\" class=\"md-warn md-raised\">\n                    {{ 'common-delete-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.clearForm(adminForm)\" ng-if=\"!$ctrl.id\"\n                    ng-disabled=\"$ctrl.saving || $ctrl.deleting\" class=\"md-raised\">\n                    {{ 'common-clear-button-text' | translate }}\n                </md-button>\n\n                <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\" class=\"md-accent md-raised\">\n                    {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                </md-button>\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _asyncToGenerator(fn) {return function () {var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {function step(key, arg) {try {var info = gen[key](arg);var value = info.value;} catch (error) {reject(error);return;}if (info.done) {resolve(value);} else {return Promise.resolve(value).then(function (value) {step("next", value);}, function (err) {step("throw", err);});}}return step("next");});};}
	
	var AdminDetailController = function AdminDetailController($filter, $mdDialog, $scope, $state, Toast, Admin, AdminDetail, Group) {
	  DialogController.$inject = ["$scope", "$mdDialog"];var activate = function () {var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	    function _callee() {return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
	              clearForm();
	
	              _angular2.default.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
	
	              $ctrl.uiState = 'LOADING';
	              $ctrl.squares = [];
	              $ctrl.units = [];_context.next = 7;return (
	
	                AdminDetail.getSquares().then(function (data) {$ctrl.squares = data;}).catch(function (err) {console.log(err);}));case 7:_context.next = 9;return (
	                AdminDetail.getUnits().then(function (data) {$ctrl.units = data;}).catch(function (err) {console.log(err);}));case 9:
	
	              loadDomainResources().
	              then(function (result) {
	                $ctrl.access_groups = result[0];
	                loadResource($ctrl.id);
	              }).
	              catch(function (err) {
	                console.log('err:', err);
	                $ctrl.uiState = 'ERROR';
	              });case 10:case 'end':return _context.stop();}}}, _callee, this);}));return function activate() {return _ref.apply(this, arguments);};}();var handleSave = function () {var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	    function _callee11(form, admin) {var _this = this;return regeneratorRuntime.wrap(function _callee11$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:if (
	              form.$valid) {_context11.next = 3;break;}
	              Toast.error($filter('translate')('common-form-incomplete'));return _context11.abrupt('return');case 3:
	
	
	
	              admin.image_base64 = $ctrl.myCroppedImage;
	
	              if ($ctrl.desactivated_at_changed) {
	                admin.desactivated_at = $ctrl.admin.isActive ? null : moment();
	              }
	
	              $ctrl.saving = true;_context11.next = 8;return (
	
	                Admin.
	                save(admin).
	                then(function () {var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(response) {return regeneratorRuntime.wrap(function _callee10$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:
	                            Toast.success($filter('translate')('admin-detail-save-success'));if (!(
	                            response.access_group.special_rule === 'MANAGER')) {_context10.next = 9;break;}if (
	                            response.admin_user_regions.length) {_context10.next = 7;break;}_context10.next = 5;return (
	                              AdminDetail.setRegionInUser({
	                                region_id: $ctrl.squareSelected2.id,
	                                admin_user_id: response.id }).
	
	                              then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {return regeneratorRuntime.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:case 'end':return _context2.stop();}}}, _callee2, _this);}))).
	                              catch(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {return regeneratorRuntime.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:case 'end':return _context3.stop();}}}, _callee3, _this);}))));case 5:_context10.next = 9;break;case 7:_context10.next = 9;return (
	
	                              AdminDetail.updateRegionInUser({
	                                id: response.id,
	                                data: {
	                                  region_id: $ctrl.squareSelected2.id } }).
	
	
	                              then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {return regeneratorRuntime.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:case 'end':return _context4.stop();}}}, _callee4, _this);}))).
	                              catch(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {return regeneratorRuntime.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:case 'end':return _context5.stop();}}}, _callee5, _this);}))));case 9:if (!(
	
	
	                            response.access_group.special_rule === 'COORDINATOR')) {_context10.next = 17;break;}if (
	                            response.admin_user_units.length) {_context10.next = 15;break;}_context10.next = 13;return (
	                              AdminDetail.setUnitInUser({
	                                unit_id: $ctrl.unitSelected2.id,
	                                admin_user_id: response.id }).
	
	                              then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {return regeneratorRuntime.wrap(function _callee6$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:case 'end':return _context6.stop();}}}, _callee6, _this);}))).
	                              catch(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {return regeneratorRuntime.wrap(function _callee7$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:case 'end':return _context7.stop();}}}, _callee7, _this);}))));case 13:_context10.next = 17;break;case 15:_context10.next = 17;return (
	
	                              AdminDetail.updateUnitInUser({
	                                id: response.id,
	                                data: {
	                                  unit_id: $ctrl.unitSelected2.id } }).
	
	
	                              then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {return regeneratorRuntime.wrap(function _callee8$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:case 'end':return _context8.stop();}}}, _callee8, _this);}))).
	                              catch(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {return regeneratorRuntime.wrap(function _callee9$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:case 'end':return _context9.stop();}}}, _callee9, _this);}))));case 17:
	
	
	                            $ctrl.admin = response;
	                            $ctrl.saving = false;
	                            $state.go('admin.list');case 20:case 'end':return _context10.stop();}}}, _callee10, _this);}));return function (_x3) {return _ref3.apply(this, arguments);};}()).
	
	                catch(function (err) {
	                  var defaultErrMsg = $filter('translate')('common-server-error');
	                  var fourONineMsg = $filter('translate')('admin-detail-409-error');
	                  var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	                  Toast.error(message);
	                  console.log('err:', err);
	                  $ctrl.saving = false;
	                }));case 8:case 'end':return _context11.stop();}}}, _callee11, this);}));return function handleSave(_x, _x2) {return _ref2.apply(this, arguments);};}();
	
	
	  // Local functions
	  var $ctrl = this;$ctrl.id = $state.params.id;$ctrl.admin;$ctrl.isPasswordVisible = false;_angular2.default.extend($ctrl, { clearImage: clearImage, clearForm: clearForm, handleSave: handleSave, handleDelete: handleDelete, querySearchSquare: querySearchSquare, selectedSquareChange: selectedSquareChange, querySearchUnit: querySearchUnit, selectedUnitChange: selectedUnitChange });activate();function clearImage() {_angular2.default.element(document.querySelector('#fileInput')).val(undefined);$ctrl.myImage = '';$ctrl.myCroppedImage = '';$ctrl.fileName = undefined;$ctrl.admin.image_uri = null;}function querySearchSquare(searchText) {searchText = searchText.toLowerCase();var results = _.filter($ctrl.squares, function (square) {return square.name.toLowerCase().indexOf(searchText) > -1;});return results;}function selectedSquareChange(square) {if (square) {$ctrl.squareSelected2 = square;$ctrl.searchTextUnit = null;}}function querySearchUnit(searchText) {searchText = searchText.toLowerCase();var results = _.filter($ctrl.units, function (unit) {return unit.address_neighborhood.toLowerCase().indexOf(searchText) > -1 || unit.name.toLowerCase().indexOf(searchText) > -1;});return results;}function selectedUnitChange(unit) {if (unit) {$ctrl.unitSelected2 = unit;$ctrl.searchTextSquare = null;}}function clearForm(form) {$ctrl.admin = { isActive: true };if (form) {form.email.$$element[0].value = '';form.$setPristine();form.$setUntouched();}$ctrl.myImage = '';$ctrl.myCroppedImage = '';$ctrl.fileName = undefined;}function handleDelete(admin, event) {var confirm = $mdDialog.confirm().textContent($filter('translate')('admin-detail-delete-confirm-text')).ariaLabel($filter('translate')('admin-detail-delete-confirm-text')).targetEvent(event).ok($filter('translate')('common-yes')).cancel($filter('translate')('common-cancel'));$mdDialog.show(confirm).then(function () {$ctrl.deleting = true;Admin.destroy(admin).then(function (response) {Toast.success($filter('translate')('admin-detail-delete-success'));$ctrl.deleting = false;$state.go('admin.list');}).catch(function (err) {Toast.error($filter('translate')('common-server-error'));console.log('err:', err);$ctrl.deleting = false;});}).catch(function () {});}
	  function handleFileSelect(event) {
	    var file = event.currentTarget.files[0];
	
	    if (!file) {
	      return;
	    }
	
	    var reader = new FileReader();
	    reader.onload = function (event) {
	      $ctrl.myImage = event.target.result;
	      $scope.$apply();
	      $ctrl.fileName = file.name;
	      showCropDialog(event);
	    };
	
	    reader.readAsDataURL(file);
	  }
	
	  function showCropDialog(event) {
	    $mdDialog.show({
	      controller: DialogController,
	      targetEvent: event,
	      template:
	      '<md-dialog aria-label="List dialog">' +
	      '  <md-dialog-content>' +
	      '    <ui-cropper' +
	      '      image="myImage"' +
	      '      area-type="circle"' +
	      '      chargement="loadingText"' +
	      '      result-image-size="{w: 200,h: 200}"' +
	      '      result-image="myCroppedImage" canvas-scalemode="true">' +
	      '    </ui-cropper>' +
	      '  </md-dialog-content>' +
	      '  <md-dialog-actions>' +
	      '    <md-button ng-click="cancel()">' +
	      '      Cancelar' +
	      '    </md-button>' +
	      '    <md-button ng-click="cropImage(myCroppedImage)" class="md-accent">' +
	      '      Feito' +
	      '    </md-button>' +
	      '  </md-dialog-actions>' +
	      '</md-dialog>',
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(function (myCroppedImage) {
	      $ctrl.myCroppedImage = myCroppedImage;
	      $ctrl.myImage = '';
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  }
	
	  function DialogController($scope, $mdDialog) {
	    "ngInject";
	    $scope.loadingText = 'Carregando';
	    $scope.myImage = $ctrl.myImage;
	    $scope.myCroppedImage = $ctrl.myCroppedImage;
	
	    $scope.hide = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.cancel();
	    };
	
	    $scope.cropImage = function (myCroppedImage) {
	      $mdDialog.hide(myCroppedImage);
	    };
	  }
	
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Admin.show(id).
	      then(function (response) {
	        response.isActive = !response.desactivated_at;
	        $ctrl.admin = response;
	        if ($ctrl.admin.admin_user_units.length) {
	          $ctrl.unitSelected = $ctrl.units.find(function (el) {return el.id === $ctrl.admin.admin_user_units[0].unit_id;});
	        }
	        if ($ctrl.admin.admin_user_regions.length) {
	          $ctrl.squareSelected = $ctrl.squares.find(function (el) {return el.id === $ctrl.admin.admin_user_regions[0].region_id;});
	        }
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	      $scope.$apply();
	    }
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Group.index());
	
	    return Promise.all(promises);
	  }
	
	};
	
	AdminDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Admin', 'AdminDetail', 'Group'];exports.default =
	
	AdminDetailController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(476);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./admin-detail.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./admin-detail.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".search-unit-square .input-square{padding-right:5px}.search-unit-square .input-unit{padding-left:5px}", ""]);
	
	// exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var AdminService = function AdminService(Restangular) {
	  var Admin = Restangular.all('admin/admin_user');
	
	  var count = function count(query) {
	    return Admin.customGET('count', query);
	  };
	
	  var save = function save(admin) {
	    if (admin.save) {
	      return admin.save();
	    } else {
	      return Admin.post(admin);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Admin.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Admin.get(id);
	  };
	
	  var destroy = function destroy(admin) {
	    admin.deleted_at = moment();
	    return admin.save();
	  };
	
	  return { load: load, save: save, show: show, destroy: destroy };
	};
	
	AdminService.$inject = ['Restangular'];exports.default =
	
	AdminService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var uriProduction = 'https://api.sabin.com.br';
	var uriDeveloper = 'https://apidev.cloudsabin.com';
	var uriStaging = 'https://api-staging.cloudsabin.com';
	var uriLocalhost = 'http://localhost:3000';
	
	var urls = [
	{ 'localhost:8080': uriLocalhost },
	{ 'backofficedev.cloudsabin.com': uriDeveloper },
	{ 'backoffice-staging.cloudsabin.com': uriStaging },
	{ 'backoffice.sabin.com.br': uriProduction }];
	
	
	var AdminDetailService = function AdminDetailService(Restangular) {
	  var Service = Restangular.allUrl('admin/attendance_hour', urls.find(function (elem) {return elem[window.location.host];})[window.location.host]);
	  var ServiceAdmin = Restangular.all('admin');
	
	  var getSquares = function getSquares() {return Service.customGET('region?limit=100');};
	  var getUnits = function getUnits() {return Service.customGET('unit?limit=100');};
	  var setRegionInUser = function setRegionInUser(payload) {return ServiceAdmin.customPOST(payload, 'admin_region');};
	  var setUnitInUser = function setUnitInUser(payload) {return ServiceAdmin.customPOST(payload, 'admin_unit');};
	  var updateRegionInUser = function updateRegionInUser(payload) {return ServiceAdmin.customPUT(payload.data, 'admin_region/' + payload.id);};
	  var updateUnitInUser = function updateUnitInUser(payload) {return ServiceAdmin.customPUT(payload.data, 'admin_unit/' + payload.id);};
	
	  return {
	    getSquares: getSquares,
	    getUnits: getUnits,
	    setRegionInUser: setRegionInUser,
	    setUnitInUser: setUnitInUser,
	    updateRegionInUser: updateRegionInUser,
	    updateUnitInUser: updateUnitInUser };
	
	};
	
	AdminDetailService.$inject = ['Restangular'];exports.default =
	
	AdminDetailService;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _attendance = __webpack_require__(480);var _attendance2 = _interopRequireDefault(_attendance);
	var _attendanceList = __webpack_require__(485);var _attendanceList2 = _interopRequireDefault(_attendanceList);
	var _attendanceDetail = __webpack_require__(488);var _attendanceDetail2 = _interopRequireDefault(_attendanceDetail);
	var _attendance3 = __webpack_require__(491);var _attendance4 = _interopRequireDefault(_attendance3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var attendanceModule = _angular2.default.module('attendance', [
	_angularUiRouter2.default]).
	
	
	service('Attendance', _attendance4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/attendance');
	
	  $stateProvider.
	  state('attendance', {
	    component: 'attendance' }).
	
	  state('attendance.list', {
	    url: '/attendance',
	    component: 'attendanceList' }).
	
	  state('attendance.create', {
	    url: '/attendance/new',
	    component: 'attendanceDetail',
	    params: {
	      id: "" } }).
	
	
	  state('attendance.show', {
	    url: '/attendance/:id',
	    component: 'attendanceDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('attendance', _attendance2.default).
	component('attendanceList', _attendanceList2.default).
	component('attendanceDetail', _attendanceDetail2.default).
	
	name;exports.default =
	
	attendanceModule;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _attendance = __webpack_require__(481);var _attendance2 = _interopRequireDefault(_attendance);
	var _attendance3 = __webpack_require__(482);var _attendance4 = _interopRequireDefault(_attendance3);
	__webpack_require__(483);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var attendanceComponent = {
	  bindings: {},
	  template: _attendance2.default,
	  controller: _attendance4.default };exports.default =
	
	
	attendanceComponent;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var AttendanceController =
	function AttendanceController() {_classCallCheck(this, AttendanceController);
	  this.name = 'attendance';
	};exports.default =
	
	
	AttendanceController;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(484);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./attendance.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./attendance.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".sb-attendance .description-vaccine_name{text-transform:capitalize}.sb-attendance .sb-reference-values-table div.refrence-value-cell{margin-top:8px;padding:8px;background-color:rgba(0,0,0,.08)}.sb-attendance .sb-reference-values-table div.refrence-value-cell p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sb-attendance .sb-medical-request-image{max-width:300px;max-height:300px;margin:10px auto 0;border-radius:6px;box-shadow:1px 2px 3px 0 rgba(0,0,0,.1);width:100%}.sb-attendance .sb-health-insurance-img{width:304px;height:188.97px;margin:10px auto 0;border:1px solid #ddd;border-radius:6px;background-color:#fff;box-shadow:1px 2px 3px 0 rgba(0,0,0,.1)}md-dialog-content .sb-medical-request-image-dialog{width:600px}", ""]);
	
	// exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _attendanceList = __webpack_require__(486);var _attendanceList2 = _interopRequireDefault(_attendanceList);
	var _attendanceList3 = __webpack_require__(487);var _attendanceList4 = _interopRequireDefault(_attendanceList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var attendanceListComponent = {
	  bindings: {},
	  template: _attendanceList2.default,
	  controller: _attendanceList4.default };exports.default =
	
	
	attendanceListComponent;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"end\">\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column>\n                      {{ 'attendance-list-table-header-name' | translate }}\n                    </th>\n                    <th md-column md-order-by=\"type\"\n                        ng-click=\"$ctrl.orderList('type')\">\n                      {{ 'attendance-list-table-header-type' | translate }}\n                    </th>\n                    <th md-column md-order-by=\"service\"\n                        ng-click=\"$ctrl.orderList('service')\">\n                      {{ 'attendance-list-table-header-service' | translate }}\n                    </th>\n                    <th md-column md-numeric md-order-by=\"place\"\n                        ng-click=\"$ctrl.orderList('place')\">\n                      {{ 'attendance-list-table-header-place' | translate }}\n                    </th>\n                    <th md-column>\n                      {{ 'attendance-list-table-header-unit' | translate }}\n                    </th>\n                    <th md-column>\n                      {{ 'attendance-list-table-header-city' | translate }}\n                    </th>\n                    <th md-column>\n                      {{ 'attendance-list-table-header-state' | translate }}\n                    </th>\n                    <th md-column md-numeric md-order-by=\"finished\"\n                        ng-click=\"$ctrl.orderList('finished')\">\n                      {{ 'attendance-list-table-header-finished' | translate }}\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\">\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.show(resource.id)\">\n                    \t{{ resource.pre_attendance_user.name }}\n                    </td>\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.show(resource.id)\">\n                    \t{{ 'attendance-info-' + resource.type | translate }}\n                    </td>\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.show(resource.id)\">\n                      <span class=\"sb-body-2\" ng-show=\"resource.service\">\n                        {{ 'attendance-info-' + resource.service | translate }}\n                      </span>\n                      <span class=\"sb-body-2\" ng-show=\"!resource.service\">\n                        {{ 'common-not-informed' | translate }}\n                      </span>\n                    </td>\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.show(resource.id)\">\n                    \t{{ 'attendance-info-' + resource.place | translate }}\n                    </td>\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.show(resource.id)\">\n                    \t{{ resource.place === 'HOME' ? '' : resource.unit.name }}\n                    </td>\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.show(resource.id)\">\n                    \t{{ resource.place === 'HOME' ? resource.pre_attendance_address.city.name : resource.unit.city.name }}\n                    </td>\n                    <td md-cell ng-click=\"$ctrl.show(resource.id)\">\n                    \t{{ resource.place === 'HOME' ? resource.pre_attendance_address.state : resource.unit.state }}\n                    </td>\n                    <td md-cell>\n                      <md-switch ng-change=\"activeStatus(resource)\" ng-model=\"resource.finished\" aria-label=\"Active\"></md-switch>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var AttendanceListController = function AttendanceListController(Attendance, $filter, Toast, $scope, $state) {
	  var $ctrl = this;
	  $ctrl.resources;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    show: show, orderList: orderList });
	
	
	  activate();
	
	
	  $scope.activeStatus = function (resource) {
	    Attendance.
	    save(resource).
	    then(function (response) {
	      $ctrl.resource = response;
	      var messageSuccess = $filter('translate')('attendance-list-active-success');
	      Toast.success(messageSuccess);
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      var messageError = $filter('translate')('attendance-list-active-error');
	      Toast.error(messageError);
	    });
	
	  };
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'created_at',
	      like_search: ''
	      // like_search_fields: [
	      //   'name',
	      //   'description'
	      // ]
	    };
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function show(id) {
	    $state.go('attendance.show', { id: id });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Attendance.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      setPlaceHolderValues(response.data);
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	AttendanceListController.$inject = ['Attendance', '$filter', 'Toast', '$scope', '$state'];exports.default =
	
	AttendanceListController;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _attendanceDetail = __webpack_require__(489);var _attendanceDetail2 = _interopRequireDefault(_attendanceDetail);
	var _attendanceDetail3 = __webpack_require__(490);var _attendanceDetail4 = _interopRequireDefault(_attendanceDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var attendanceDetailComponent = {
	  bindings: {},
	  template: _attendanceDetail2.default,
	  controller: _attendanceDetail4.default };exports.default =
	
	
	attendanceDetailComponent;

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-attendance\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <!-- attendance -->\n        <div layout=\"column\" class=\"sb-page-section\">\n            <h3 class=\"sb-page-section-title\">{{ 'attendance-detail-title' | translate }}</h3>\n\n            <p class=\"sb-page-section-sub-title\">\n                {{ 'attendance-detail-title-caption' | translate }}\n            </p>\n\n            <md-card>\n                <!-- name -->\n                <div layout=\"row\" flex>\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'attendance-detail-type' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                            {{ 'attendance-info-' + $ctrl.attendance.type | translate }}\n                        </p>\n                    </div>\n\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                          {{ 'attendance-list-table-header-finished' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                          <md-switch ng-change=\"activeStatus($ctrl.attendance)\" ng-model=\"$ctrl.attendance.finished\" aria-label=\"Active\"></md-switch>\n                        </p>\n                    </div>\n                </div>\n\n                <!-- service -->\n                <div layout=\"row\" flex>\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'attendance-detail-service' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\" ng-show=\"$ctrl.attendance.service\">\n                          {{ 'attendance-info-' + $ctrl.attendance.service | translate }}\n                          <span class=\"description-vaccine_name\" ng-show=\"$ctrl.attendance.service === 'VACCINE'\">\n                          - {{ $ctrl.attendance.vaccine_name }}\n                          </span>\n                        </p>\n                        <p class=\"sb-body-2\" ng-show=\"!$ctrl.attendance.service\">\n                            {{ 'common-not-informed' | translate }}\n                        </p>\n                    </div>\n\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                          {{ 'attendance-detail-place' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                          {{ 'attendance-info-' + $ctrl.attendance.place | translate }}\n                        </p>\n                    </div>\n                </div>\n\n                <!-- type unit_info  -->\n                <div layout=\"row\" flex>\n                    <div layout=\"column\" flex ng-show=\"$ctrl.attendance.place === 'HOME'\">\n                        <p class=\"sb-title\">\n                          {{ 'attendance-detail-unit-address' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                          {{ $ctrl.attendance.pre_attendance_address.street }} {{ $ctrl.attendance.pre_attendance_address.complement }} - {{ $ctrl.attendance.pre_attendance_address.neighborhood }}\n                        </p>\n                    </div>\n\n                    <div layout=\"column\" flex ng-show=\"$ctrl.attendance.place !== 'HOME'\">\n                        <p class=\"sb-title\">\n                          {{ 'attendance-detail-unit-name' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                          {{ $ctrl.attendance.place === 'HOME' ? $ctrl.attendance.pre_attendance_address.city : $ctrl.attendance.unit.name }}\n                        </p>\n                    </div>\n\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'attendance-detail-city' | translate }}\n                        </p>\n                        <p class=\"sb-body-2 sb-truncate\">\n                            {{ $ctrl.attendance.place === 'HOME' ? $ctrl.attendance.pre_attendance_address.city : $ctrl.attendance.unit.city.name }}\n                        </p>\n                    </div>\n                </div>\n\n                <!-- unit_state -->\n                <div layout=\"row\" flex>\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                          {{ 'attendance-detail-state' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                          {{ $ctrl.attendance.place === 'HOME' ? $ctrl.attendance.pre_attendance_address.state : $ctrl.attendance.unit.city.state.name }}\n                        </p>\n                    </div>\n                </div>\n\n                <!-- finished -->\n                <div layout=\"row\" flex>\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'attendance-detail-finished' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                            {{ $ctrl.attendance.finished ? 'Atendido' : 'Aguardando' }}\n                        </p>\n                    </div>\n                </div>\n            </md-card>\n        </div>\n\n        <!-- user_info -->\n        <div layout=\"column\" class=\"sb-page-section\">\n            <h3 class=\"sb-page-section-title\">{{ 'attendance-detail-reference-user-title' | translate }}</h3>\n\n            <p class=\"sb-page-section-sub-title\">\n                {{ 'attendance-detail-reference-user-title-caption' | translate }}\n            </p>\n\n            <md-card>\n                <div layout=\"row\" flex>\n                    <p class=\"sb-title\" flex>\n                        {{ 'attendance-detail-reference-user-name' | translate }}\n                    </p>\n                    <div style=\"width: 8px;\"></div>\n                    <p class=\"sb-title\" flex>\n                        {{ 'attendance-detail-reference-user-phone' | translate }}\n                    </p>\n                    <div style=\"width: 8px;\"></div>\n                    <p class=\"sb-title\" flex>\n                        {{ 'attendance-detail-reference-user-email' | translate }}\n                    </p>\n                    <div style=\"width: 8px;\"></div>\n                    <p class=\"sb-title\" flex>\n                        {{ 'attendance-detail-reference-user-document' | translate }}\n                    </p>\n                    <div style=\"width: 8px;\"></div>\n                    <p class=\"sb-title\" flex>\n                        {{ 'attendance-detail-reference-user-birthdate' | translate }}\n                    </p>\n                </div>\n\n                <div layout=\"row\" class=\"sb-reference-values-table\" flex>\n                    <div layout=\"column\" flex class=\"refrence-value-cell\">\n                        <p class=\"sb-body-2\">\n                          {{ $ctrl.attendance.pre_attendance_user.name }}\n                        </p>\n                    </div>\n                    <div style=\"width: 8px;\"></div>\n                    <div layout=\"column\" flex class=\"refrence-value-cell\">\n                        <p class=\"sb-body-2\">\n                          {{ $ctrl.attendance.pre_attendance_user.phone }}\n                        </p>\n                    </div>\n                    <div style=\"width: 8px;\"></div>\n                    <div layout=\"column\" flex class=\"refrence-value-cell\">\n                        <p class=\"sb-body-2\">\n                          {{ $ctrl.attendance.pre_attendance_user.email }}\n                        </p>\n                    </div>\n                    <div style=\"width: 8px;\"></div>\n                    <div layout=\"column\" flex class=\"refrence-value-cell\">\n                        <p class=\"sb-body-2\">\n                          {{ $ctrl.attendance.pre_attendance_user.document }}\n                        </p>\n                    </div>\n                    <div style=\"width: 8px;\"></div>\n                    <div layout=\"column\" flex class=\"refrence-value-cell\">\n                        <p class=\"sb-body-2\" ng-show=\"attendance-detail-reference-user-birthdate\">\n                          {{ $ctrl.attendance.pre_attendance_user.birthdate | momentFormat : 'DD/MM/YYYY' }}\n                        </p>\n                        <p class=\"sb-body-2\" ng-show=\"!attendance-detail-reference-user-birthdate\">\n                            {{ 'common-not-informed' | translate }}\n                        </p>\n                    </div>\n                </div>\n            </md-card>\n\n            <div layout=\"row\" class=\"layout-padding\" flex\n              ng-show=\"$ctrl.attendance.pre_attendance_health_insurance.front_image_uri || $ctrl.attendance.pre_attendance_health_insurance.rear_image_uri\">\n              <div flex=\"33\">\n                  <p class=\"sb-title\">\n                    {{ 'attendance-detail-health-insurance-front_image' | translate }}\n                  </p>\n                  <img ng-show=\"$ctrl.attendance.pre_attendance_health_insurance.front_image_uri\"\n                      ng-src=\"{{ $ctrl.attendance.pre_attendance_health_insurance.front_image_uri }}\"\n                      class=\"sb-health-insurance-img\"/>\n              </div>\n\n              <div flex=\"33\">\n                  <p class=\"sb-title\">\n                    {{ 'attendance-detail-health-insurance-rear_image' | translate }}\n                  </p>\n                  <img ng-show=\"$ctrl.attendance.pre_attendance_health_insurance.rear_image_uri\"\n                      ng-src=\"{{ $ctrl.attendance.pre_attendance_health_insurance.rear_image_uri }}\"\n                      class=\"sb-health-insurance-img\"/>\n              </div>\n            </div>\n        </div>\n\n        <!-- medical_request -->\n        <div layout=\"column\" class=\"sb-page-section\" ng-show=\"$ctrl.attendance.pre_attendance_medical_requests.length\">\n            <div layout=\"row\" class=\"layout-padding\" flex>\n              <div flex=\"33\">\n                <p class=\"sb-title\">\n                  {{ 'attendance-detail-medical-request-title' | translate }}\n                </p>\n                <div\n                  ng-repeat=\"medical_requests in $ctrl.pre_attendance_medical_requests()\"\n                  ng-value=\"medical_requests.id\"\n                >\n                  <img class=\"sb-medical-request-image\"\n                    ng-show=\"medical_requests.image_uri\"\n                    ng-src=\"{{ medical_requests.image_uri }}\"\n                    ng-click=\"$ctrl.showCreateDialog($event, $ctrl.attendance, medical_requests.image_uri)\"\n                  />\n                </div>\n              </div>\n            </div>\n        </div>\n\n        <!-- form actions -->\n        <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n            <md-button page-back\n                       ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                {{ 'common-go-back-button-text' | translate }}\n            </md-button>\n        </div>\n\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var attendanceDetailController = function attendanceDetailController($filter, $mdDialog, $scope, $state, Attendance, Toast) {
	  DialogController.$inject = ["$scope", "$mdDialog"];
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.attendance;
	
	  _angular2.default.extend($ctrl, {
	    showCreateDialog: showCreateDialog,
	    pre_attendance_medical_requests: pre_attendance_medical_requests });
	
	
	  $scope.activeStatus = function (resource) {
	    Attendance.
	    save(resource).
	    then(function (response) {
	      $ctrl.attendance = response;
	      var messageSuccess = $filter('translate')('attendance-list-active-success');
	      Toast.success(messageSuccess);
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      var messageError = $filter('translate')('attendance-list-active-error');
	      Toast.error(messageError);
	    });
	  };
	
	  activate();
	
	  function pre_attendance_medical_requests() {
	    if ($ctrl.attendance) {
	      var oldUri = [{
	        image_uri: $ctrl.attendance.medical_request_uri }];
	
	      var dataArray = $ctrl.attendance.pre_attendance_medical_requests;
	      if ($ctrl.attendance.medical_request_uri) dataArray = dataArray.concat(oldUri);
	      return dataArray || [];
	    }
	    return [];
	  }
	
	  function activate() {
	    loadResource($ctrl.id);
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Attendance.show(id).
	      then(function (response) {
	        $ctrl.attendance = response;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	      $scope.$apply();
	    }
	  }
	
	  function showCreateDialog(event, selectedAttendance, uri) {
	    $ctrl.selectedAttendance = selectedAttendance;
	
	    var title = '\'attendance-detail-medical-request-title\'';
	    // let uri = $ctrl.selectedAttendance.medical_request_uri;
	
	    var dialog = {
	      controller: DialogController,
	      targetEvent: event,
	      template:
	      '<md-dialog aria-label="List dialog">' +
	      '  <md-dialog-content class="layout-padding">' +
	      '  <div class="md-dialog-content" >' +
	      '    <h2>{{ ' + title + ' | translate }}</h2><br>' +
	      '    <md-input-container class="md-block" flex>' +
	      '      <img class="sb-medical-request-image-dialog" src="' + uri + '" >' +
	      '    </md-input-container>' +
	      '    </div>' +
	      '    </md-dialog-content>' +
	      '  <md-dialog-actions>',
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false };
	
	
	    dialog.template += '' +
	    '    <md-button ng-click="cancel()">' +
	    '      {{ \'common-ok\' | translate }}' +
	    '    </md-button>' +
	    '  </md-dialog-actions>' +
	    '</md-dialog>';
	
	    $mdDialog.show(dialog).
	    then(function (differential) {
	      if (selectedAttendance) {
	        differential = _angular2.default.extend(selectedAttendance, differential);
	      }
	    }, function () {});
	  }
	
	  function DialogController($scope, $mdDialog) {
	    "ngInject";
	
	    $scope.differential = _angular2.default.copy($ctrl.selectedAttendance) || {};
	
	    $scope.hide = function () {
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      $mdDialog.cancel();
	    };
	  }
	};
	
	attendanceDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Attendance', 'Toast'];exports.default =
	
	attendanceDetailController;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var attendanceService = function attendanceService(Restangular) {
	  var Service = Restangular.all('admin/pre_attendance');
	
	  var count = function count(query) {
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.patch();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	attendanceService.$inject = ['Restangular'];exports.default =
	
	attendanceService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _email = __webpack_require__(493);var _email2 = _interopRequireDefault(_email);
	var _emailList = __webpack_require__(498);var _emailList2 = _interopRequireDefault(_emailList);
	var _emailDetail = __webpack_require__(501);var _emailDetail2 = _interopRequireDefault(_emailDetail);
	var _email3 = __webpack_require__(504);var _email4 = _interopRequireDefault(_email3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var emailModule = _angular2.default.module('email', [
	_angularUiRouter2.default]).
	
	
	service('Email', _email4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/email');
	
	  $stateProvider.
	  state('email', {
	    component: 'email' }).
	
	  state('email.list', {
	    url: '/email',
	    component: 'emailList' }).
	
	  state('email.create', {
	    url: '/email/new',
	    component: 'emailDetail',
	    params: {
	      id: "" } }).
	
	
	  state('email.edit', {
	    url: '/email/:id/edit',
	    component: 'emailDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('email', _email2.default).
	component('emailList', _emailList2.default).
	component('emailDetail', _emailDetail2.default).
	
	name;exports.default =
	
	emailModule;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _email = __webpack_require__(494);var _email2 = _interopRequireDefault(_email);
	var _email3 = __webpack_require__(495);var _email4 = _interopRequireDefault(_email3);
	__webpack_require__(496);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var emailComponent = {
	  bindings: {},
	  template: _email2.default,
	  controller: _email4.default };exports.default =
	
	
	emailComponent;

/***/ }),
/* 494 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var EmailController =
	function EmailController() {_classCallCheck(this, EmailController);
	  this.name = 'email';
	};exports.default =
	
	
	EmailController;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(497);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./email.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./email.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".email{color:red}.layout-padding-email-config{min-width:350px}", ""]);
	
	// exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _emailList = __webpack_require__(499);var _emailList2 = _interopRequireDefault(_emailList);
	var _emailList3 = __webpack_require__(500);var _emailList4 = _interopRequireDefault(_emailList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var emailListComponent = {
	  bindings: {},
	  template: _emailList2.default,
	  controller: _emailList4.default };exports.default =
	
	
	emailListComponent;

/***/ }),
/* 499 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\">\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'common-name' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'common-email' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'common-updated-at' | translate }}\n                    </th>\n\n                    <th md-column md-numeric class=\"sb-table-column-xs\">\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit($event, resource)\">\n                    <td md-cell class=\"sb-table-truncate\">\n                    \t{{ resource.name }}\n                    </td>\n\n                    <td md-cell>\n                    \t{{ resource.email }}\n                    </td>\n\n                    <td md-cell>\n                      {{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var EmailListController = function EmailListController($filter, $mdDialog, $scope, $state, Email, Toast) {
	  DialogController.$inject = ["$scope", "$mdDialog"];
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, showCreateDialog: showCreateDialog });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name ASC',
	      like_search: '',
	      like_search_fields: [
	      'name'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function edit(event, email) {
	    showCreateDialog(event, email);
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  function showCreateDialog(event, selectedEmail) {
	    $ctrl.selectedEmail = selectedEmail;
	
	    var title = selectedEmail ? '\'common-edit\'' : '\'common-new-masculine\'';
	
	    var dialog = {
	      controller: DialogController,
	      targetEvent: event,
	      template:
	      '<md-dialog aria-label="List dialog">' +
	      '  <form name="form" ng-cloak ng-submit="saveResource(email)">' +
	      '  <md-dialog-content class="layout-padding layout-padding-email-config">' +
	      '  <div class="md-dialog-content" >' +
	      '    <h2>{{ ' + title + ' | translate }}</h2>' +
	      '<br>' +
	      '    <md-input-container class="md-block" flex>' +
	      '      <label>{{ \'common-name\' | translate }}</label>' +
	      '' +
	      '      <input ng-model="email.name" required>' +
	      '    </md-input-container>' +
	      '    <md-input-container class="md-block" flex>' +
	      '      <label>{{ \'common-email\' | translate }}</label>' +
	      '' +
	      '      <input ng-model="email.email" required>' +
	      '    </md-input-container>' +
	      '    </div>' +
	      '    </md-dialog-content>' +
	      '  <md-dialog-actions>',
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false };
	
	
	    dialog.template += '' +
	    '    <md-button ng-click="cancel()">' +
	    '      {{ \'common-cancel\' | translate }}' +
	    '    </md-button>' +
	    '' +
	    '    <md-button type="submit"' +
	    '               ng-disabled="!form.$valid" class="md-accent">' +
	    '      {{ \'common-save-button-text\' | translate }}' +
	    '    </md-button>' +
	    '  </md-dialog-actions>' +
	    '  </form>' +
	    '</md-dialog>';
	
	    $mdDialog.show(dialog).
	    then(function (email) {
	      if (selectedEmail) {
	        email = _angular2.default.extend(selectedEmail, email);
	      }
	
	      save(email);
	    }, function () {});
	  }
	
	  function DialogController($scope, $mdDialog) {
	    "ngInject";
	
	    $scope.email = _angular2.default.copy($ctrl.selectedEmail) || {};
	
	    $scope.hide = function () {
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      $mdDialog.cancel();
	    };
	
	    $scope.saveResource = function (email) {
	      $mdDialog.hide(email);
	    };
	  }
	
	  // Local functions
	  function loadData() {
	    _angular2.default.extend($ctrl.$scope.tableConfig, $state.params);
	
	    $ctrl.promise = Email.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function save(email) {
	    $ctrl.promise = Email.
	    save(email).
	    then(function (response) {
	      loadData();
	      Toast.success($filter('translate')('email-detail-save-success'));
	    }).
	    catch(function (err) {
	      loadData();
	      var defaultErrMsg = 'common-server-error';
	      var fourONineMsg = 'email-detail-409-error';
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter('translate')(message));
	      console.log('err:', err);
	    });
	  }
	};
	
	EmailListController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Email', 'Toast'];exports.default =
	
	EmailListController;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _emailDetail = __webpack_require__(502);var _emailDetail2 = _interopRequireDefault(_emailDetail);
	var _emailDetail3 = __webpack_require__(503);var _emailDetail4 = _interopRequireDefault(_emailDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var emailDetailComponent = {
	  bindings: {},
	  template: _emailDetail2.default,
	  controller: _emailDetail4.default };exports.default =
	
	
	emailDetailComponent;

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-email-detail\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <form name=\"emailForm\" ng-submit=\"$ctrl.handleSave(emailForm, $ctrl.email)\"\n              novalidate>\n            <!-- email -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">{{ 'email-detail-title' | translate }}</h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'email-detail-title-caption' | translate }}\n                </p>\n\n                <md-card>\n                    <!-- name -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'email-detail-form-service-name' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.email.name\" name=\"name\"\n                                   required>\n                            </input>\n\n                            <div ng-messages=\"emailForm.name.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'email-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- form actions -->\n            <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n                <md-button page-back\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                    {{ 'common-cancel-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.handleDelete($ctrl.email, $event)\"\n                           ng-if=\"$ctrl.id && !$ctrl.email.is_super\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-warn md-raised\">\n                    {{ 'common-delete-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.clearForm(emailForm)\"\n                           ng-if=\"!$ctrl.id\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-raised\">\n                    {{ 'common-clear-button-text' | translate }}\n                </md-button>\n\n                <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-accent md-raised\">\n                    {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                </md-button>\n            </div>\n        </form>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var EmailDetailController = function EmailDetailController($filter, $mdDialog, $scope, $state, Toast, Email) {
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.email;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    loadResource($ctrl.id);
	  }
	
	  function clearForm(form) {
	    $ctrl.email = {};
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(email, event) {
	    var confirmMessage = 'service-detail-delete-confirm-text';
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')(confirmMessage)).
	    ariaLabel($filter('translate')(confirmMessage)).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Email.
	      destroy(email).
	      then(function (response) {
	        Toast.success($filter('translate')('email-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('email.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, email) {
	    if (!form.$valid) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    save(email);
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Email.show(id).
	      then(function (response) {
	        $ctrl.email = response;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	    }
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Module.index());
	
	    return Promise.all(promises);
	  }
	
	  function save(email) {
	    $ctrl.saving = true;
	
	    Email.
	    save(email).
	    then(function (response) {
	      Toast.success($filter('translate')('email-detail-save-success'));
	      $ctrl.service = response;
	      $ctrl.saving = false;
	      $state.go('email.list');
	    }).
	    catch(function (err) {
	      var defaultErrMsg = 'common-server-error';
	      var fourONineMsg = 'email-detail-409-error';
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter('translate')(message));
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	};
	
	EmailDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Email'];exports.default =
	
	EmailDetailController;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var EmailService = function EmailService(Restangular) {
	  var Email = Restangular.all('admin/pre_attendance_email');
	
	  var count = function count(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Email.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.patch();
	    } else {
	      return Email.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Email.getList(query);
	  };
	
	  var load = function load(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Email.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	EmailService.$inject = ['Restangular'];exports.default =
	
	EmailService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _group = __webpack_require__(506);var _group2 = _interopRequireDefault(_group);
	var _groupList = __webpack_require__(511);var _groupList2 = _interopRequireDefault(_groupList);
	var _groupDetail = __webpack_require__(514);var _groupDetail2 = _interopRequireDefault(_groupDetail);
	var _group3 = __webpack_require__(517);var _group4 = _interopRequireDefault(_group3);
	var _module = __webpack_require__(518);var _module2 = _interopRequireDefault(_module);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var groupModule = _angular2.default.module('group', [
	_angularUiRouter2.default]).
	
	
	service('Module', _module2.default).
	service('Group', _group4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/group');
	
	  $stateProvider.
	  state('group', {
	    component: 'group' }).
	
	  state('group.list', {
	    url: '/group',
	    component: 'groupList' }).
	
	  state('group.create', {
	    url: '/group/new',
	    component: 'groupDetail',
	    params: {
	      id: "" } }).
	
	
	  state('group.edit', {
	    url: '/group/:id/edit',
	    component: 'groupDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('group', _group2.default).
	component('groupList', _groupList2.default).
	component('groupDetail', _groupDetail2.default).
	
	name;exports.default =
	
	groupModule;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _group = __webpack_require__(507);var _group2 = _interopRequireDefault(_group);
	var _group3 = __webpack_require__(508);var _group4 = _interopRequireDefault(_group3);
	__webpack_require__(509);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var groupComponent = {
	  bindings: {},
	  template: _group2.default,
	  controller: _group4.default };exports.default =
	
	
	groupComponent;

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var GroupController =
	function GroupController() {_classCallCheck(this, GroupController);
	  this.name = 'group';
	};exports.default =
	
	
	GroupController;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(510);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./group.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./group.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".group{color:red}.margin-bottom-permissions{margin-bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _groupList = __webpack_require__(512);var _groupList2 = _interopRequireDefault(_groupList);
	var _groupList3 = __webpack_require__(513);var _groupList4 = _interopRequireDefault(_groupList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var groupListComponent = {
	  bindings: {},
	  template: _groupList2.default,
	  controller: _groupList4.default };exports.default =
	
	
	groupListComponent;

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\"\n         ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n        <md-button class=\"md-raised md-accent\" ui-sref=\"group.create\">\n            {{ 'common-new-masculine' | translate }}\n        </md-button>\n\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'group-list-table-header-name' | translate }}\n                    </th>\n\n                    <th md-column>\n                        {{ 'group-list-table-header-modules' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'common-updated-at' | translate }}\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit(resource.id)\">\n                    <td md-cell class=\"sb-table-truncate\">{{ resource.name }}</td>\n\n                    <td ng-if=\"resource.admin_modules.length && !resource.is_super\"\n                        md-cell>{{ resource.modulesString }}\n                    </td>\n\n                    <td ng-if=\"!resource.admin_modules.length && !resource.is_super\"\n                        md-cell>{{ 'group-list-table-no-modules-text' | translate }}\n                    </td>\n\n                    <td ng-if=\"resource.is_super\"\n                        md-cell>{{ 'group-list-table-all-modules-text' | translate }}\n                    </td>\n\n                    <td md-cell>{{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}</td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'group-list-empty-state-line-1' | translate }}</p>\n                <p>{{ 'group-list-empty-state-line-2' | translate }}</p>\n            </div>\n\n            <md-button class=\"md-raised md-accent\" ui-sref=\"group.create\">\n                {{ 'group-list-create-group-button' | translate }}\n            </md-button>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var GroupListController = function GroupListController(Group, $filter, $scope, $state) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name',
	      like_search: '',
	      like_search_fields: [
	      'name'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function edit(id) {
	    $state.go('group.edit', { id: id });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Group.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      _.forEach(response.data, function (item) {
	        item.admin_modules = _.map(item.admin_modules, function (module) {
	          var key = 'shell-' + module.name;
	          return $filter('translate')(key);
	        });
	
	        item.admin_modules.sort();
	
	        item.modulesString = item.admin_modules.join(', ');
	      });
	
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	};
	
	GroupListController.$inject = ['Group', '$filter', '$scope', '$state'];exports.default =
	
	GroupListController;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _groupDetail = __webpack_require__(515);var _groupDetail2 = _interopRequireDefault(_groupDetail);
	var _groupDetail3 = __webpack_require__(516);var _groupDetail4 = _interopRequireDefault(_groupDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var groupDetailComponent = {
	  bindings: {},
	  template: _groupDetail2.default,
	  controller: _groupDetail4.default };exports.default =
	
	
	groupDetailComponent;

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div class=\"sb-content sb-group\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n    <form name=\"groupForm\" ng-submit=\"$ctrl.handleSave(groupForm, $ctrl.group)\" novalidate>\n      <!-- group -->\n      <div layout=\"column\" class=\"sb-page-section\">\n        <h3 class=\"sb-page-section-title\">{{ 'group-detail-title' | translate }}</h3>\n\n        <p class=\"sb-page-section-sub-title\">\n          {{ 'group-detail-title-caption' | translate }}\n        </p>\n\n        <md-card>\n          <div layout='column'>\n            <!-- name phone_number-->\n            <div layout=\"row\" flex>\n              <md-input-container class=\"md-block\" flex>\n                <label>\n                  {{ 'group-detail-form-group-name' | translate }}\n                </label>\n\n                <input ng-model=\"$ctrl.group.name\" name=\"name\" required>\n                </input>\n\n                <div ng-messages=\"groupForm.name.$error\" multiple>\n                  <div ng-message=\"required\">\n                    {{ 'form-error-required-field' | translate}}\n                  </div>\n\n                  <div ng-message=\"md-maxlength\">\n                    {{ 'group-detail-form-error-title-max-length' | translate}}\n                  </div>\n                </div>\n              </md-input-container>\n            </div>\n            <div layout=\"row\" layout-wrap class=\"sb-checkboxes\">\n              <div layout='column'>\n                <label id=\"permissionCheckbox\" class=\"margin-bottom-permissions\">{{ 'form-permission-checkbox-field' | translate}}</label>\n                <md-radio-group ng-model=\"$ctrl.group.special_rule\" aria-labelledby=\"permissionCheckbox\" layout='row'>\n                  <md-radio-button value=\"MANAGER\" class=\"md-primary\">Gestor</md-radio-button>\n                  <md-radio-button value=\"COORDINATOR\" class=\"md-primary\">Coordenador</md-radio-button>\n                  <md-radio-button value=\"NONE\" class=\"md-primary\">Nenhum</md-radio-button>\n                </md-radio-group>\n              </div>\n            </div>\n          </div>\n        </md-card>\n      </div>\n\n      <!-- admin-modules -->\n      <div layout=\"column\" class=\"sb-page-section\">\n        <h3 class=\"sb-page-section-title\">\n          {{ 'group-detail-section-title-admin-modules' | translate }}\n        </h3>\n\n        <p ng-if=\"!$ctrl.group.is_super\" class=\"sb-page-section-sub-title\">\n          {{ 'group-detail-section-title-admin-modules-caption' | translate }}\n        </p>\n\n        <p ng-if=\"$ctrl.group.is_super\" class=\"sb-page-section-sub-title\">\n          {{ 'group-detail-section-title-admin-modules-caption-super' | translate }}\n        </p>\n\n        <md-card>\n          <div layout=\"row\" layout-wrap class=\"sb-checkboxes\">\n            <md-checkbox ng-repeat=\"module in $ctrl.modules\" flex\n              ng-click=\"$ctrl.toggleItemInList($ctrl.group.admin_modules, module)\" ng-disabled=\"$ctrl.group.is_super\"\n              ng-checked=\"$ctrl.group.is_super || $ctrl.isIdInList($ctrl.group.admin_modules, module.id)\">\n              {{ module.name }}\n            </md-checkbox>\n          </div>\n        </md-card>\n      </div>\n\n      <!-- form actions -->\n      <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n        <md-button page-back ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n          {{ 'common-cancel-button-text' | translate }}\n        </md-button>\n\n        <md-button ng-click=\"$ctrl.handleDelete($ctrl.group, $event)\" ng-if=\"$ctrl.id && !$ctrl.group.is_super\"\n          ng-disabled=\"$ctrl.saving || $ctrl.deleting\" class=\"md-warn md-raised\">\n          {{ 'common-delete-button-text' | translate }}\n        </md-button>\n\n        <md-button ng-click=\"$ctrl.clearForm(groupForm)\" ng-if=\"!$ctrl.id\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n          class=\"md-raised\">\n          {{ 'common-clear-button-text' | translate }}\n        </md-button>\n\n        <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\" class=\"md-accent md-raised\">\n          {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n        </md-button>\n      </div>\n    </form>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n    <div class=\"sb-absolute-center sb-empty-state\" layout=\"column\" layout-align=\"center center\">\n      <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\" class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\" layout=\"column\" layout-align=\"center center\">\n      <div class=\"sb-error-message\">\n        {{ 'common-load-error' | translate}}\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var GroupDetailController = function GroupDetailController($filter, $mdDialog, $scope, $state, Module, Toast, Group) {
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.group;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete,
	    isIdInList: isIdInList,
	    toggleItemInList: toggleItemInList });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    loadDomainResources().
	    then(function (result) {
	      _.forEach(result[0], function (item) {
	        item.name = $filter('translate')('shell-' + item.name);
	      });
	      $ctrl.modules = result[0];
	
	      loadResource($ctrl.id);
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function clearForm(form) {
	    $ctrl.group = {
	      admin_modules: [] };
	
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(group, event) {
	    if (group.is_super) {
	      Toast.show('Super grupo não pode ser removido');
	      return;
	    }
	
	    var confirmMessage = group.admin_users.length ? 'group-detail-delete-with-users-confirm-text' : 'group-detail-delete-confirm-text';
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')(confirmMessage)).
	    ariaLabel($filter('translate')(confirmMessage)).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Group.
	      destroy(group).
	      then(function (response) {
	        Toast.success($filter('translate')('group-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('group.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, group) {
	    if (!form.$valid) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    if (!group.admin_modules.length) {
	      var confirm = $mdDialog.confirm().
	      textContent($filter('translate')('group-detail-no-access-confirm-text')).
	      ariaLabel($filter('translate')('group-detail-no-access-confirm-text')).
	      targetEvent(event).
	      ok($filter('translate')('common-yes')).
	      cancel($filter('translate')('common-cancel'));
	
	      $mdDialog.show(confirm).
	      then(function () {
	        save(group);
	      }).
	      catch(function () {
	      });
	    } else {
	      save(group);
	    }
	  }
	
	  function isIdInList(list, id) {
	    return _.find(list, { id: id });
	  }
	
	  function toggleItemInList(list, item) {
	    console.log($ctrl.group.special_rule);
	    if (_.find(list, { id: item.id })) {
	      _.remove(list, { id: item.id });
	    } else {
	      list.push(item);
	    }
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Group.show(id).
	      then(function (response) {
	        $ctrl.group = response;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	      $scope.$apply();
	    }
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Module.index());
	
	    return Promise.all(promises);
	  }
	
	  function save(group) {
	    $ctrl.saving = true;
	
	    Group.
	    save(group).
	    then(function (response) {
	      Toast.success($filter('translate')('group-detail-save-success'));
	      $ctrl.group = response;
	      $ctrl.saving = false;
	      $state.go('group.list');
	    }).
	    catch(function (err) {
	      var defaultErrMsg = $filter('translate')('common-server-error');
	      var fourONineMsg = $filter('translate')('group-detail-409-error');
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error(message);
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	};
	
	GroupDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Module', 'Toast', 'Group'];exports.default =
	
	GroupDetailController;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var GroupService = function GroupService(Restangular) {
	  var Service = Restangular.all('admin/access_group');
	
	  var count = function count(query) {
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	GroupService.$inject = ['Restangular'];exports.default =
	
	GroupService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var ModuleService = function ModuleService(Restangular) {
	  var Service = Restangular.all('admin/admin_module');
	
	  var count = function count(query) {
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index };
	};
	
	ModuleService.$inject = ['Restangular'];exports.default =
	
	ModuleService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _home = __webpack_require__(520);var _home2 = _interopRequireDefault(_home);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var homeModule = _angular2.default.module('home', [
	_angularUiRouter2.default]).
	
	
	component('home', _home2.default).
	
	name;exports.default =
	
	homeModule;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _home = __webpack_require__(521);var _home2 = _interopRequireDefault(_home);
	var _home3 = __webpack_require__(522);var _home4 = _interopRequireDefault(_home3);
	__webpack_require__(523);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var homeComponent = {
	  bindings: {},
	  template: _home2.default,
	  controller: _home4.default };exports.default =
	
	
	homeComponent;

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	module.exports = "<h1>Found in {{ $ctrl.name }}.html</h1>\n\n<div>\n\t<md-input-container>\n\t    <label>CPF</label>\n\t    <input type=\"text\" name=\"field\" ng-model=\"initializedCpf\" ui-br-cpf-mask>\n\t</md-input-container>\n</div>\n\n<div flex-gt-xs>\n\t<h4>Standard date-picker</h4>\n\n\t<md-datepicker ng-model=\"myDate\" md-placeholder=\"Enter date\"></md-datepicker>\n</div>\n"

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var HomeController =
	function HomeController() {_classCallCheck(this, HomeController);
	  this.name = 'home';
	};exports.default =
	
	
	HomeController;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(524);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./home.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".home{height:100%}", ""]);
	
	// exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _city = __webpack_require__(526);var _city2 = _interopRequireDefault(_city);
	var _city3 = __webpack_require__(531);var _city4 = _interopRequireDefault(_city3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var cityModule = _angular2.default.module('city', [
	_angularUiRouter2.default]).
	
	
	service('City', _city4.default).
	
	component('city', _city2.default).
	
	name;exports.default =
	
	cityModule;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _city = __webpack_require__(527);var _city2 = _interopRequireDefault(_city);
	var _city3 = __webpack_require__(528);var _city4 = _interopRequireDefault(_city3);
	__webpack_require__(529);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var cityComponent = {
	  bindings: {},
	  template: _city2.default,
	  controller: _city4.default };exports.default =
	
	
	cityComponent;

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <h1>{{ $ctrl.name }}</h1>\n</div>\n"

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var CityController =
	function CityController() {_classCallCheck(this, CityController);
	  this.name = 'city';
	};exports.default =
	
	
	CityController;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(530);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./city.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./city.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".city{color:red}", ""]);
	
	// exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var CityService = function CityService(Restangular) {
	  var Service = Restangular.all('admin/city');
	
	  var count = function count(query) {
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(city) {
	    if (city.save) {
	      return city.save();
	    } else {
	      return Service.post(city);
	    }
	  };
	
	  var index = function index(query) {
	    return Service.getList(query);
	  };
	
	  var listCitiesWithClient = function listCitiesWithClient(query) {
	    return Service.customGET('clients', query);
	  };
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(city) {
	    city.deleted_at = moment();
	    return city.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy, listCitiesWithClient: listCitiesWithClient };
	};
	
	CityService.$inject = ['Restangular'];exports.default =
	
	CityService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _state = __webpack_require__(533);var _state2 = _interopRequireDefault(_state);
	var _state3 = __webpack_require__(538);var _state4 = _interopRequireDefault(_state3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var stateModule = _angular2.default.module('state', [
	_angularUiRouter2.default]).
	
	
	service('State', _state4.default).
	
	component('state', _state2.default).
	
	name;exports.default =
	
	stateModule;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _state = __webpack_require__(534);var _state2 = _interopRequireDefault(_state);
	var _state3 = __webpack_require__(535);var _state4 = _interopRequireDefault(_state3);
	__webpack_require__(536);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var stateComponent = {
	  bindings: {},
	  template: _state2.default,
	  controller: _state4.default };exports.default =
	
	
	stateComponent;

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <h1>{{ $ctrl.name }}</h1>\n</div>\n"

/***/ }),
/* 535 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var StateController =
	function StateController() {_classCallCheck(this, StateController);
	  this.name = 'state';
	};exports.default =
	
	
	StateController;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(537);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./state.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./state.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".state{color:red}", ""]);
	
	// exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var StateService = function StateService(Restangular) {
	  var Service = Restangular.all('admin/state');
	
	  var count = function count(query) {
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(state) {
	    if (state.save) {
	      return state.save();
	    } else {
	      return Service.post(state);
	    }
	  };
	
	  var index = function index(query) {
	    return Service.getList(query);
	  };
	
	  var listStatesWithClient = function listStatesWithClient(query) {
	    return Service.customGET('clients', query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(state) {
	    state.deleted_at = moment();
	    return state.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy, listStatesWithClient: listStatesWithClient };
	};
	
	StateService.$inject = ['Restangular'];exports.default =
	
	StateService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _differential = __webpack_require__(540);var _differential2 = _interopRequireDefault(_differential);
	var _differentialList = __webpack_require__(545);var _differentialList2 = _interopRequireDefault(_differentialList);
	var _differentialDetail = __webpack_require__(548);var _differentialDetail2 = _interopRequireDefault(_differentialDetail);
	var _differential3 = __webpack_require__(551);var _differential4 = _interopRequireDefault(_differential3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var differentialModule = _angular2.default.module('differential', [
	_angularUiRouter2.default]).
	
	
	service('Differential', _differential4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/differential');
	
	  $stateProvider.
	  state('differential', {
	    component: 'differential' }).
	
	  state('differential.list', {
	    url: '/differential',
	    component: 'differentialList' }).
	
	  state('differential.create', {
	    url: '/differential/new',
	    component: 'differentialDetail',
	    params: {
	      id: "" } }).
	
	
	  state('differential.edit', {
	    url: '/differential/:id/edit',
	    component: 'differentialDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('differential', _differential2.default).
	component('differentialList', _differentialList2.default).
	component('differentialDetail', _differentialDetail2.default).
	
	name;exports.default =
	
	differentialModule;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _differential = __webpack_require__(541);var _differential2 = _interopRequireDefault(_differential);
	var _differential3 = __webpack_require__(542);var _differential4 = _interopRequireDefault(_differential3);
	__webpack_require__(543);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var differentialComponent = {
	  bindings: {},
	  template: _differential2.default,
	  controller: _differential4.default };exports.default =
	
	
	differentialComponent;

/***/ }),
/* 541 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 542 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var DifferentialController =
	function DifferentialController() {_classCallCheck(this, DifferentialController);
	  this.name = 'differential';
	};exports.default =
	
	
	DifferentialController;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(544);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./differential.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./differential.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".differential{color:red}", ""]);
	
	// exports


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _differentialList = __webpack_require__(546);var _differentialList2 = _interopRequireDefault(_differentialList);
	var _differentialList3 = __webpack_require__(547);var _differentialList4 = _interopRequireDefault(_differentialList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var differentialListComponent = {
	  bindings: {},
	  template: _differentialList2.default,
	  controller: _differentialList4.default };exports.default =
	
	
	differentialListComponent;

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\">\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.showCreateDialog($event)\">\n            {{ 'common-new-feminine' | translate }}\n        </md-button>\n\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'common-name' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'common-updated-at' | translate }}\n                    </th>\n\n                    <th md-column md-numeric class=\"sb-table-column-xs\">\n                    </th>\n                  </tr>\n                </thead>\n\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit($event, resource)\">\n                    <td md-cell class=\"sb-table-truncate\">\n                        {{ resource.name }}\n                    </td>\n\n                    <td md-cell>\n                        {{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n\n                    <td md-cell>\n                        <md-button aria-label=\"Toolbar menu\"\n                                   class=\"md-icon-button\"\n                                   ng-click=\"$ctrl.handleDelete(resource, $event)\">\n                          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var DifferentialListController = function DifferentialListController($filter, $mdDialog, $scope, $state, Differential, Toast) {
	  DialogController.$inject = ["$scope", "$mdDialog"];
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, showCreateDialog: showCreateDialog, handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name ASC',
	      like_search: '',
	      like_search_fields: [
	      'name'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function edit(event, differential) {
	    showCreateDialog(event, differential);
	  }
	
	  function handleDelete(resource, event) {
	    event.stopPropagation();
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Differential.
	      destroy(resource).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        _.remove($ctrl.resources.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  function showCreateDialog(event, selectedDifferential) {
	    $ctrl.selectedDifferential = selectedDifferential;
	
	    var contentText = '\'differential-list-create-dialog-content\'';
	    var title = selectedDifferential ? '\'common-edit\'' : '\'common-new-feminine\'';
	
	    var dialog = {
	      controller: DialogController,
	      targetEvent: event,
	      template:
	      '<md-dialog aria-label="List dialog">' +
	      '  <form name="form" ng-cloak ng-submit="saveResource(differential)">' +
	      '  <md-dialog-content class="layout-padding">' +
	      '  <div class="md-dialog-content" >' +
	      '    <h2>{{ ' + title + ' | translate }}</h2>' +
	      '' +
	      '    <p>{{' + contentText + '| translate }}</p>' +
	      '' +
	      '<br>' +
	      '    <md-input-container class="md-block" flex>' +
	      '      <label>{{ \'common-name\' | translate }}</label>' +
	      '' +
	      '      <input ng-model="differential.name" required>' +
	      '    </md-input-container>' +
	      '    </div>' +
	      '    </md-dialog-content>' +
	      '  <md-dialog-actions>',
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false };
	
	
	    // if (false) {
	    //   dialog.template += '' +
	    //   '    <md-button ng-click="cancel()" class="md-raised md-warn">' +
	    //   '      {{ \'common-delete\' | translate }}' +
	    //   '    </md-button>' +
	    //   '' +
	    //   '    <span style="width: 100px;"></span>';
	    // }
	
	    dialog.template += '' +
	    '    <md-button ng-click="cancel()">' +
	    '      {{ \'common-cancel\' | translate }}' +
	    '    </md-button>' +
	    '' +
	    '    <md-button type="submit"' +
	    '               ng-disabled="!form.$valid" class="md-accent">' +
	    '      {{ \'common-save-button-text\' | translate }}' +
	    '    </md-button>' +
	    '  </md-dialog-actions>' +
	    '  </form>' +
	    '</md-dialog>';
	
	    $mdDialog.show(dialog).
	    then(function (differential) {
	      if (selectedDifferential) {
	        differential = _angular2.default.extend(selectedDifferential, differential);
	      }
	
	      save(differential);
	    }, function () {});
	  }
	
	  function DialogController($scope, $mdDialog) {
	    "ngInject";
	
	    $scope.differential = _angular2.default.copy($ctrl.selectedDifferential) || {};
	
	    $scope.hide = function () {
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      $mdDialog.cancel();
	    };
	
	    $scope.saveResource = function (differential) {
	      $mdDialog.hide(differential);
	    };
	
	    $scope.deleteResource = function (differential) {
	      // $mdDialog.hide(differential);
	    };
	  }
	
	  // Local functions
	
	  function loadData() {
	    _angular2.default.extend($ctrl.$scope.tableConfig, $state.params);
	
	    $ctrl.promise = Differential.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	
	  function save(differential) {
	    $ctrl.promise = Differential.
	    save(differential).
	    then(function (response) {
	      loadData();
	      Toast.success($filter('translate')('differential-detail-save-success'));
	    }).
	    catch(function (err) {
	      loadData();
	      var defaultErrMsg = 'common-server-error';
	      var fourONineMsg = 'differential-detail-409-error';
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter('translate')(message));
	      console.log('err:', err);
	    });
	  }
	};
	
	DifferentialListController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Differential', 'Toast'];exports.default =
	
	DifferentialListController;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _differentialDetail = __webpack_require__(549);var _differentialDetail2 = _interopRequireDefault(_differentialDetail);
	var _differentialDetail3 = __webpack_require__(550);var _differentialDetail4 = _interopRequireDefault(_differentialDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var differentialDetailComponent = {
	  bindings: {},
	  template: _differentialDetail2.default,
	  controller: _differentialDetail4.default };exports.default =
	
	
	differentialDetailComponent;

/***/ }),
/* 549 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-differential\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <form name=\"differentialForm\" ng-submit=\"$ctrl.handleSave(differentialForm, $ctrl.differential)\" \n              novalidate>\n            <!-- differential -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">{{ 'differential-detail-title' | translate }}</h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'differential-detail-title-caption' | translate }}\n                </p>\n\n                <md-card>\n                    <!-- name -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'differential-detail-form-differential-name' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.differential.name\" name=\"name\" \n                                   required>\n                            </input>\n\n                            <div ng-messages=\"differentialForm.name.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'differential-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- form actions -->\n            <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n                <md-button page-back\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                    {{ 'common-cancel-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.handleDelete($ctrl.differential, $event)\"\n                           ng-if=\"$ctrl.id && !$ctrl.differential.is_super\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-warn md-raised\">\n                    {{ 'common-delete-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.clearForm(differentialForm)\"\n                           ng-if=\"!$ctrl.id\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-raised\">\n                    {{ 'common-clear-button-text' | translate }}\n                </md-button>\n\n                <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-accent md-raised\">\n                    {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                </md-button>\n            </div>\n        </form>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var DifferentialDetailController = function DifferentialDetailController($filter, $mdDialog, $scope, $state, Toast, Differential) {
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.differential;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    loadResource($ctrl.id);
	  }
	
	  function clearForm(form) {
	    $ctrl.differential = {};
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(differential, event) {
	    var confirmMessage = 'differential-detail-delete-confirm-text';
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')(confirmMessage)).
	    ariaLabel($filter('translate')(confirmMessage)).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Differential.
	      destroy(differential).
	      then(function (response) {
	        Toast.success($filter('translate')('differential-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('differential.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, differential) {
	    if (!form.$valid) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    save(differential);
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Differential.show(id).
	      then(function (response) {
	        $ctrl.differential = response;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	    }
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Module.index());
	
	    return Promise.all(promises);
	  }
	
	  function save(differential) {
	    $ctrl.saving = true;
	
	    Differential.
	    save(differential).
	    then(function (response) {
	      Toast.success($filter('translate')('differential-detail-save-success'));
	      $ctrl.differential = response;
	      $ctrl.saving = false;
	      $state.go('differential.list');
	    }).
	    catch(function (err) {
	      var defaultErrMsg = 'common-server-error';
	      var fourONineMsg = 'differential-detail-409-error';
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter('translate')(message));
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	};
	
	DifferentialDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Differential'];exports.default =
	
	DifferentialDetailController;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var DifferentialService = function DifferentialService(Restangular) {
	  var Service = Restangular.all('admin/differential');
	
	  var count = function count(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	DifferentialService.$inject = ['Restangular'];exports.default =
	
	DifferentialService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _service = __webpack_require__(553);var _service2 = _interopRequireDefault(_service);
	var _serviceList = __webpack_require__(558);var _serviceList2 = _interopRequireDefault(_serviceList);
	var _serviceDetail = __webpack_require__(561);var _serviceDetail2 = _interopRequireDefault(_serviceDetail);
	var _service3 = __webpack_require__(564);var _service4 = _interopRequireDefault(_service3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var serviceModule = _angular2.default.module('service', [
	_angularUiRouter2.default]).
	
	
	service('Service', _service4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/service');
	
	  $stateProvider.
	  state('service', {
	    component: 'service' }).
	
	  state('service.list', {
	    url: '/service',
	    component: 'serviceList' }).
	
	  state('service.create', {
	    url: '/service/new',
	    component: 'serviceDetail',
	    params: {
	      id: "" } }).
	
	
	  state('service.edit', {
	    url: '/service/:id/edit',
	    component: 'serviceDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('service', _service2.default).
	component('serviceList', _serviceList2.default).
	component('serviceDetail', _serviceDetail2.default).
	
	name;exports.default =
	
	serviceModule;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _service = __webpack_require__(554);var _service2 = _interopRequireDefault(_service);
	var _service3 = __webpack_require__(555);var _service4 = _interopRequireDefault(_service3);
	__webpack_require__(556);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var serviceComponent = {
	  bindings: {},
	  template: _service2.default,
	  controller: _service4.default };exports.default =
	
	
	serviceComponent;

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var ServiceController =
	function ServiceController() {_classCallCheck(this, ServiceController);
	  this.name = 'service';
	};exports.default =
	
	
	ServiceController;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(557);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./service.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./service.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".service{color:red}", ""]);
	
	// exports


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _serviceList = __webpack_require__(559);var _serviceList2 = _interopRequireDefault(_serviceList);
	var _serviceList3 = __webpack_require__(560);var _serviceList4 = _interopRequireDefault(_serviceList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var serviceListComponent = {
	  bindings: {},
	  template: _serviceList2.default,
	  controller: _serviceList4.default };exports.default =
	
	
	serviceListComponent;

/***/ }),
/* 559 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\">\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.showCreateDialog($event)\">\n            {{ 'common-new-masculine' | translate }}\n        </md-button>\n\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'common-name' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'common-updated-at' | translate }}\n                    </th>\n\n                    <th md-column md-numeric class=\"sb-table-column-xs\">\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit($event, resource)\">\n                    <td md-cell class=\"sb-table-truncate\">\n                    \t{{ resource.name }}\n                    </td>\n\n                    <td md-cell>\n                    \t{{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n\n                    <td md-cell>\n                        <md-button aria-label=\"Toolbar menu\"\n                                   class=\"md-icon-button\"\n                                   ng-click=\"$ctrl.handleDelete(resource, $event)\">\n                          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var ServiceListController = function ServiceListController($filter, $mdDialog, $scope, $state, Service, Toast) {
	  DialogController.$inject = ["$scope", "$mdDialog"];
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, showCreateDialog: showCreateDialog, handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name ASC',
	      like_search: '',
	      like_search_fields: [
	      'name'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function edit(event, service) {
	    showCreateDialog(event, service);
	  }
	
	  function handleDelete(resource, event) {
	    event.stopPropagation();
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Service.
	      destroy(resource).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        _.remove($ctrl.resources.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  function showCreateDialog(event, selectedService) {
	    $ctrl.selectedService = selectedService;
	
	    var contentText = '\'service-list-create-dialog-content\'';
	    var title = selectedService ? '\'common-edit\'' : '\'common-new-masculine\'';
	
	    var dialog = {
	      controller: DialogController,
	      targetEvent: event,
	      template:
	      '<md-dialog aria-label="List dialog">' +
	      '  <form name="form" ng-cloak ng-submit="saveResource(service)">' +
	      '  <md-dialog-content class="layout-padding">' +
	      '  <div class="md-dialog-content" >' +
	      '    <h2>{{ ' + title + ' | translate }}</h2>' +
	      '' +
	      '    <p>{{' + contentText + '| translate }}</p>' +
	      '' +
	      '<br>' +
	      '    <md-input-container class="md-block" flex>' +
	      '      <label>{{ \'common-name\' | translate }}</label>' +
	      '' +
	      '      <input ng-model="service.name" required>' +
	      '    </md-input-container>' +
	      '    </div>' +
	      '    </md-dialog-content>' +
	      '  <md-dialog-actions>',
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false };
	
	
	    // if (false) {
	    //   dialog.template += '' +
	    //   '    <md-button ng-click="cancel()" class="md-raised md-warn">' +
	    //   '      {{ \'common-delete\' | translate }}' +
	    //   '    </md-button>' +
	    //   '' +
	    //   '    <span style="width: 100px;"></span>';
	    // }
	
	    dialog.template += '' +
	    '    <md-button ng-click="cancel()">' +
	    '      {{ \'common-cancel\' | translate }}' +
	    '    </md-button>' +
	    '' +
	    '    <md-button type="submit"' +
	    '               ng-disabled="!form.$valid" class="md-accent">' +
	    '      {{ \'common-save-button-text\' | translate }}' +
	    '    </md-button>' +
	    '  </md-dialog-actions>' +
	    '  </form>' +
	    '</md-dialog>';
	
	    $mdDialog.show(dialog).
	    then(function (service) {
	      if (selectedService) {
	        service = _angular2.default.extend(selectedService, service);
	      }
	
	      save(service);
	    }, function () {});
	  }
	
	  function DialogController($scope, $mdDialog) {
	    "ngInject";
	
	    $scope.service = _angular2.default.copy($ctrl.selectedService) || {};
	
	    $scope.hide = function () {
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      $mdDialog.cancel();
	    };
	
	    $scope.saveResource = function (service) {
	      $mdDialog.hide(service);
	    };
	
	    $scope.deleteResource = function (service) {
	      // $mdDialog.hide(service);
	    };
	  }
	
	  // Local functions
	
	  function loadData() {
	    _angular2.default.extend($ctrl.$scope.tableConfig, $state.params);
	
	    $ctrl.promise = Service.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	
	  function save(service) {
	    $ctrl.promise = Service.
	    save(service).
	    then(function (response) {
	      loadData();
	      Toast.success($filter('translate')('service-detail-save-success'));
	    }).
	    catch(function (err) {
	      loadData();
	      var defaultErrMsg = 'common-server-error';
	      var fourONineMsg = 'service-detail-409-error';
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter('translate')(message));
	      console.log('err:', err);
	    });
	  }
	};
	
	ServiceListController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Service', 'Toast'];exports.default =
	
	ServiceListController;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _serviceDetail = __webpack_require__(562);var _serviceDetail2 = _interopRequireDefault(_serviceDetail);
	var _serviceDetail3 = __webpack_require__(563);var _serviceDetail4 = _interopRequireDefault(_serviceDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var serviceDetailComponent = {
	  bindings: {},
	  template: _serviceDetail2.default,
	  controller: _serviceDetail4.default };exports.default =
	
	
	serviceDetailComponent;

/***/ }),
/* 562 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-service\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <form name=\"serviceForm\" ng-submit=\"$ctrl.handleSave(serviceForm, $ctrl.service)\" \n              novalidate>\n            <!-- service -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">{{ 'service-detail-title' | translate }}</h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'service-detail-title-caption' | translate }}\n                </p>\n\n                <md-card>\n                    <!-- name -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'service-detail-form-service-name' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.service.name\" name=\"name\" \n                                   required>\n                            </input>\n\n                            <div ng-messages=\"serviceForm.name.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'service-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- form actions -->\n            <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n                <md-button page-back\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                    {{ 'common-cancel-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.handleDelete($ctrl.service, $event)\"\n                           ng-if=\"$ctrl.id && !$ctrl.service.is_super\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-warn md-raised\">\n                    {{ 'common-delete-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.clearForm(serviceForm)\"\n                           ng-if=\"!$ctrl.id\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-raised\">\n                    {{ 'common-clear-button-text' | translate }}\n                </md-button>\n\n                <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-accent md-raised\">\n                    {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                </md-button>\n            </div>\n        </form>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var ServiceDetailController = function ServiceDetailController($filter, $mdDialog, $scope, $state, Toast, Service) {
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.service;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    loadResource($ctrl.id);
	  }
	
	  function clearForm(form) {
	    $ctrl.service = {};
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(service, event) {
	    var confirmMessage = 'service-detail-delete-confirm-text';
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')(confirmMessage)).
	    ariaLabel($filter('translate')(confirmMessage)).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Service.
	      destroy(service).
	      then(function (response) {
	        Toast.success($filter('translate')('service-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('service.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, service) {
	    if (!form.$valid) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    save(service);
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Service.show(id).
	      then(function (response) {
	        $ctrl.service = response;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	    }
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Module.index());
	
	    return Promise.all(promises);
	  }
	
	  function save(service) {
	    $ctrl.saving = true;
	
	    Service.
	    save(service).
	    then(function (response) {
	      Toast.success($filter('translate')('service-detail-save-success'));
	      $ctrl.service = response;
	      $ctrl.saving = false;
	      $state.go('service.list');
	    }).
	    catch(function (err) {
	      var defaultErrMsg = 'common-server-error';
	      var fourONineMsg = 'service-detail-409-error';
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter('translate')(message));
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	};
	
	ServiceDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Service'];exports.default =
	
	ServiceDetailController;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var ServiceService = function ServiceService(Restangular) {
	  var Service = Restangular.all('admin/service');
	
	  var count = function count(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	ServiceService.$inject = ['Restangular'];exports.default =
	
	ServiceService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _login = __webpack_require__(566);var _login2 = _interopRequireDefault(_login);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var loginModule = _angular2.default.module('login', [
	_angularUiRouter2.default]).
	
	
	config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.
	  state('login', {
	    url: '/login',
	    component: 'login',
	    data: {
	      hideShell: true,
	      public: true } });
	
	
	
	}]).
	
	component('login', _login2.default).
	
	name;exports.default =
	
	loginModule;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _login = __webpack_require__(567);var _login2 = _interopRequireDefault(_login);
	var _login3 = __webpack_require__(568);var _login4 = _interopRequireDefault(_login3);
	__webpack_require__(571);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var loginComponent = {
	  bindings: {},
	  template: _login2.default,
	  controller: _login4.default };exports.default =
	
	
	loginComponent;

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"sb-login\"\n  style=\"background-image: url('{{ $root.baseAssetsUrl }}/bg_login.jpg');\"\n>\n  <div class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center\">\n      <div layout=\"row\" class=\"sb-login-content\">\n        <div layout-padding layout=\"row\" layout-align=\"end center\" flex>\n          <img class=\"sb-logo\" ng-src=\"{{ $root.baseAssetsUrl }}/logo_sm.png\" />\n        </div>\n\n        <div class=\"sb-divider\"></div>\n\n        <div flex layout-padding layout=\"column\">\n          <form\n            ng-submit=\"$ctrl.login(loginForm, $ctrl.email, $ctrl.password, $ctrl.rememberMe)\"\n            name=\"loginForm\"\n            novalidate\n          >\n            <md-input-container class=\"md-block\" flex>\n              <label>{{ 'common-email' | translate }}</label>\n\n              <input\n                ng-model=\"$ctrl.email\"\n                name=\"email\"\n                type=\"email\"\n                required\n                md-no-asterisk\n              />\n\n              <div ng-messages=\"loginForm.email.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n\n                <div ng-message=\"email\">\n                  {{ 'form-error-email-invalid' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex>\n              <label>{{ 'common-password' | translate }}</label>\n\n              <input\n                ng-model=\"$ctrl.password\"\n                name=\"password\"\n                type=\"password\"\n                required\n                md-no-asterisk\n              />\n\n              <div ng-messages=\"loginForm.password.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n            <div layout=\"column\">\n              <md-button type=\"submit\" ng-disabled=\"$ctrl.loading\">\n                {{ $ctrl.loading ? 'login-button-loading-text' :\n                'login-button-text' | translate }}\n              </md-button>\n            </div>\n          </form>\n          <div class=\"md-block margin-google\">\n            <div class=\"google-btn\" ng-click=\"$ctrl.oauth2SignIn()\">\n              <div class=\"google-icon-wrapper\">\n                <img class=\"google-icon\" src=\"https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg\"/>\n              </div>\n              <p class=\"btn-text\"><b>Entrar com o Google</b></p>\n            </div>\n          </div>\n          <div class=\"actions\" layout=\"row\" layout-align=\"space-between\">\n            <md-checkbox ng-model=\"$ctrl.rememberMe\" aria-label=\"Remember me\">\n              {{ 'login-remember-me-checkbox-text' | translate }}\n            </md-checkbox>\n\n            <a ng-if=\"false\" href=\"#\"\n              >{{ 'login-forgot-password-text' | translate }}</a\n            >\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"sb-footer\">\n    <div layout=\"row\" layout-align=\"space-between center\">\n      <span>\n        &#169;{{ $ctrl.thisYear }} {{ 'common-sabin' | translate }}. {{\n        'common-all-rights-reserved-text' | translate }}\n      </span>\n\n      <div ng-if=\"false\">\n        <span><a href=\"#\">{{ 'common-about-text' | translate }}</a></span>\n\n        <span>\n          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-circle\" class=\"mdi-12px\">\n          </md-icon>\n        </span>\n\n        <span><a href=\"#\">{{ 'common-help-text' | translate }}</a></span>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();var _sidenav = __webpack_require__(437);var _sidenav2 = _interopRequireDefault(_sidenav);
	var _constantsGMB = __webpack_require__(569);var _constantsGMB2 = _interopRequireDefault(_constantsGMB);
	var _unit = __webpack_require__(570);var UnitHelper = _interopRequireWildcard(_unit);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _asyncToGenerator(fn) {return function () {var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {function step(key, arg) {try {var info = gen[key](arg);var value = info.value;} catch (error) {reject(error);return;}if (info.done) {resolve(value);} else {return Promise.resolve(value).then(function (value) {step("next", value);}, function (err) {step("throw", err);});}}return step("next");});};}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var
	
	LoginController = function () {
	  function LoginController($state, Auth, Restangular, Toast, $mdDialog, $interval) {_classCallCheck(this, LoginController);
	    this.$state = $state;
	    this.$interval = $interval;
	    this.$mdDialog = $mdDialog;
	    this.Auth = Auth;
	    this.Toast = Toast;
	    this.thisYear = moment().format("YYYY");
	    this.Login = Restangular.service("admin/login");
	    this.LoginGoogle = Restangular.service("admin/login/google");
	    this.setToken();
	  }_createClass(LoginController, [{ key: "setToken", value: function () {var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
	
	
	                  UnitHelper.setTokenToLocalStorage(this.$state.params));case 2:
	                if (localStorage.getItem("id_token")) {
	                  this.onSignIn();
	                }case 3:case "end":return _context.stop();}}}, _callee, this);}));function setToken() {return _ref.apply(this, arguments);}return setToken;}() }, { key: "loadingDialog", value: function loadingDialog()
	
	
	    {
	      var parentEl = angular.element(document.body);
	      this.$mdDialog.show({
	        parent: parentEl,
	        template:
	        '<div layout="row" style="width: 100px; height: 100px; text-align: center; padding-top: 23px;" layout-sm="column" layout-align="space-around">' +
	        '<md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular>' +
	        "</div>",
	        controllerAs: 'ctrl' });
	
	    } }, { key: "onSignIn", value: function onSignIn()
	
	    {var _this = this;
	      var aToken = { token: localStorage.getItem("id_token") };
	      this.loadingDialog();
	      this.LoginGoogle.post(aToken).
	      then(function (response) {
	        _this.Auth.login(response.token, response.user, false);
	        var home = "unit.list";
	        if (
	        response.user.access_group &&
	        !response.user.access_group.is_super &&
	        response.user.access_group.admin_modules.length)
	        {
	          var homeModule = _this.Auth.getAuthorizedModules(
	          response.user.access_group)[
	          0];
	          home = _.find(_sidenav2.default, { title: homeModule }).home;
	        }
	        _this.$mdDialog.hide();
	        _this.$state.go(home);
	      }).
	      catch(function (err) {
	        _this.Auth.logout();
	        _this.$mdDialog.hide();
	        _this.loading = false;
	        _this.$mdDialog.show(
	        _this.$mdDialog.
	        alert().
	        clickOutsideToClose(true).
	        title("Não autorizado").
	        textContent(
	        "Olá, este é um painel administrativo do Sabin Canal Mobile, no momento este email não tem permissão para acessar este canal.\nEnvie um email para suporte@usemobile.com.br para solicitar o acesso informando o seu nome, a sua área, o seu email e uma justificativa para a inclusão do seu acesso.\nObrigado pela compreensão.").
	
	        ok("Ok"));
	
	      });
	    } }, { key: "oauth2SignIn", value: function oauth2SignIn()
	
	    {
	      var oauth2Endpoint = "https://accounts.google.com/o/oauth2/v2/auth";
	
	      var form = document.createElement("form");
	      form.setAttribute("method", "GET");
	      form.setAttribute("action", oauth2Endpoint);
	
	      var params = {
	        client_id: _constantsGMB2.default.clientId,
	        redirect_uri: _constantsGMB2.default.redirectUriGoogle,
	        scope: "openid profile email",
	        state: "try_sample_request",
	        response_type: "id_token",
	        nonce: "n-0S6_WzA2Mj" };
	
	
	      for (var p in params) {
	        var input = document.createElement("input");
	        input.setAttribute("type", "hidden");
	        input.setAttribute("name", p);
	        input.setAttribute("value", params[p]);
	        form.appendChild(input);
	      }
	
	      document.body.appendChild(form);
	      form.submit();
	    } }, { key: "login", value: function login(
	
	    form, email, password, rememberMe) {var _this2 = this;
	      if (form.$valid === false) {
	        console.log("invalid form");
	        return;
	      }
	
	      this.loading = true;
	
	      this.Login.post({ email: email, password: password }).
	      then(function (response) {
	        _this2.Auth.login(response.token, response.user, rememberMe);
	        var home = "unit.list";
	        if (
	        response.user.access_group &&
	        !response.user.access_group.is_super &&
	        response.user.access_group.admin_modules.length)
	        {
	          var homeModule = _this2.Auth.getAuthorizedModules(
	          response.user.access_group)[
	          0];
	          home = _.find(_sidenav2.default, { title: homeModule }).home;
	        }
	
	        _this2.$state.go(home);
	      }).
	      catch(function (err) {
	        _this2.Auth.logout();
	        _this2.loading = false;
	        _this2.Toast.show("Email ou senha incorreto", { position: "top right" });
	      });
	    } }]);return LoginController;}();
	
	
	LoginController.$inject = [
	"$state",
	"Auth",
	"Restangular",
	"Toast",
	"$mdDialog",
	"$interval"];exports.default =
	
	
	LoginController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var clientIdDevelopment = '1088869909332-runqepkkffh1i66h365v59gp338m3fhb.apps.googleusercontent.com';
	var clientIdProduction = '1088869909332-runqepkkffh1i66h365v59gp338m3fhb.apps.googleusercontent.com';
	var clientIdLocal = clientIdDevelopment;
	
	var scope = 'https://www.googleapis.com/auth/business.manage https://www.googleapis.com/auth/plus.business.manage';
	
	var redirectUriLogin = 'https://' + window.location.host + '/login';
	var redirectUriUnit = 'https://' + window.location.host + '/unit/authentication';
	
	var clientIds = {
	  'localhost:8080': clientIdLocal,
	  'localhost:4200': clientIdDevelopment,
	  'backoffice.sabin.com.br': clientIdProduction,
	  'backofficedev.cloudsabin.com': clientIdDevelopment,
	  'backoffice-staging.cloudsabin.com': clientIdDevelopment };
	
	
	function getClientID() {
	  var clientId = clientIds[window.location.host];
	  if (clientId === undefined) {
	    console.info('Not found environment key for host: ' + window.location.host + '\n, using developer clientID');
	    clientId = clientIdDevelopment;
	  }
	  return clientId;
	}
	
	var urls = {
	  'clientId': getClientID(),
	  'redirectUri': redirectUriUnit,
	  'redirectUriGoogle': redirectUriLogin,
	  scope: scope };exports.default =
	
	
	urls;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.setTokenToLocalStorage = exports.setToken = exports.getToken = undefined;var _constantsGMB = __webpack_require__(569);var _constantsGMB2 = _interopRequireDefault(_constantsGMB);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var getToken = exports.getToken = function getToken() {return localStorage.getItem("access_token");};
	
	var setToken = exports.setToken = function setToken(params) {
	  console.info("setToken");
	  console.info(params);
	  console.info("LOCATION");
	  console.info(location);
	  if (params["#"]) {
	    localStorage.setItem(
	    params["#"].split("&")[1].split("=")[0],
	    params["#"].split("&")[1].split("=")[1]);
	
	    location.href = location.href.split("#")[0] + "?authenticated=true";
	  } else if (!location.href.split("?")[1]) {
	    oauth2SignIn();
	  }
	};
	
	var setTokenToLocalStorage = exports.setTokenToLocalStorage = function setTokenToLocalStorage(params) {
	  console.info("SETTokenToLocalStorage");
	  console.info(params);
	  console.info("LOCATION");
	  console.info(location);
	  if (params["#"]) {
	    localStorage.setItem(
	    params["#"].split("&")[1].split("=")[0],
	    params["#"].split("&")[1].split("=")[1]);
	
	    location.href = "" + location.href.split("#")[0];
	  }
	};
	
	var oauth2SignIn = function oauth2SignIn() {
	  var oauth2Endpoint = "https://accounts.google.com/o/oauth2/v2/auth";
	
	  var form = document.createElement("form");
	  form.setAttribute("method", "GET");
	  form.setAttribute("action", oauth2Endpoint);
	
	  var params = {
	    client_id: _constantsGMB2.default.clientId,
	    redirect_uri: _constantsGMB2.default.redirectUri,
	    scope: _constantsGMB2.default.scope,
	    state: "try_sample_request",
	    include_granted_scopes: "true",
	    response_type: "token" };
	
	
	  for (var p in params) {
	    var input = document.createElement("input");
	    input.setAttribute("type", "hidden");
	    input.setAttribute("name", p);
	    input.setAttribute("value", params[p]);
	    form.appendChild(input);
	  }
	
	  document.body.appendChild(form);
	  form.submit();
	};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(572);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./login.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./login.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:500);", ""]);
	
	// module
	exports.push([module.id, ".sb-login{position:relative;height:100%;color:#fff;background-size:cover}.sb-login .sb-divider{background-color:#fff;width:1px}.sb-login .sb-login-content{width:900px}.sb-login .sb-login-content .sb-logo{width:234px;height:63px}.sb-login .sb-footer{position:absolute;bottom:24px;width:100%}.sb-login .sb-footer>div{margin-left:auto;margin-right:auto;width:80%;font-size:12px}.sb-login .sb-footer>div span{padding:0 8px}.sb-login .sb-footer>div span md-icon{color:#fff;font-size:6px;text-align:center}.sb-login .layout-padding,.sb-login .layout-padding-gt-sm,.sb-login .layout-padding-gt-sm>*,.sb-login .layout-padding-md,.sb-login .layout-padding-md>*,.sb-login .layout-padding>*,.sb-login .layout-padding>.flex,.sb-login .layout-padding>.flex-gt-sm,.sb-login .layout-padding>.flex-md{padding:0 32px}.sb-login form .md-button{width:100%;margin:0;border:1px solid #fff}.sb-login form .md-button.md-accent[disabled],.sb-login form .md-button.md-default-theme.md-accent[disabled],.sb-login form .md-button.md-default-theme.md-fab[disabled],.sb-login form .md-button.md-default-theme.md-raised[disabled],.sb-login form .md-button.md-default-theme.md-warn[disabled],.sb-login form .md-button.md-default-theme[disabled],.sb-login form .md-button.md-fab[disabled],.sb-login form .md-button.md-raised[disabled],.sb-login form .md-button.md-warn[disabled],.sb-login form .md-button[disabled]{color:hsla(0,0%,100%,.5)}.sb-login form md-input-container .md-input{color:#fff}.sb-login form md-input-container.md-default-theme .md-input,.sb-login form md-input-container .md-input{border-color:hsla(0,0%,100%,.5)}.sb-login form md-input-container.md-default-theme .md-placeholder,.sb-login form md-input-container.md-default-theme label,.sb-login form md-input-container .md-placeholder,.sb-login form md-input-container label{color:hsla(0,0%,100%,.5)}.sb-login form md-input-container:not(.md-input-invalid).md-input-focused .md-input{border-color:#fff}.sb-login form md-input-container.md-default-theme.md-input-invalid .md-char-counter,.sb-login form md-input-container.md-default-theme.md-input-invalid .md-input-message-animation,.sb-login form md-input-container.md-default-theme.md-input-invalid label,.sb-login form md-input-container.md-default-theme .md-input-message-animation,.sb-login form md-input-container.md-default-theme .md-input-messages-animation,.sb-login form md-input-container.md-default-theme:not(.md-input-invalid).md-input-has-value label,.sb-login form md-input-container.md-input-focused.md-default-theme .md-placeholder,.sb-login form md-input-container.md-input-focused.md-default-theme label,.sb-login form md-input-container.md-input-focused .md-placeholder,.sb-login form md-input-container.md-input-focused label,.sb-login form md-input-container.md-input-invalid .md-char-counter,.sb-login form md-input-container.md-input-invalid .md-input-message-animation,.sb-login form md-input-container.md-input-invalid label,.sb-login form md-input-container .md-input-message-animation,.sb-login form md-input-container .md-input-messages-animation,.sb-login form md-input-container:not(.md-input-invalid).md-input-has-value label{color:#fff}.sb-login md-checkbox.md-default-theme:not(.md-checked) .md-icon,.sb-login md-checkbox:not(.md-checked) .md-icon{border-color:#fff}.sb-login md-checkbox.md-checked .md-icon,.sb-login md-checkbox.md-checked .md-ink-ripple,.sb-login md-checkbox.md-default-theme.md-checked .md-icon,.sb-login md-checkbox.md-default-theme.md-checked .md-ink-ripple{background-color:#e53935}.sb-login .actions{font-size:14px;padding-top:16px}.sb-login a:active,.sb-login a:link,.sb-login a:visited{color:#fff}.sb-login a:hover{color:#fff;text-decoration:none}.margin-google{height:100%;padding:0 32px;display:block}.abcRioButtonLightBlue{width:100%!important;height:36px!important;border-radius:2px!important;background-color:#fff;color:#757575}.google-btn{height:42px;background-color:#fff;border-radius:2px;box-shadow:0 3px 4px 0 rgba(0,0,0,.25)}.google-btn .google-icon-wrapper{position:absolute;margin-top:1px;margin-left:1px;width:40px;height:40px;border-radius:2px;background-color:#fff}.google-btn .google-icon{position:absolute;margin-top:11px;margin-left:11px;width:18px;height:18px}.google-btn .btn-text{text-align:center;padding:11px;margin:11px 11px 0 0;color:#4285f4;font-size:14px;letter-spacing:.2px;font-family:Roboto}.google-btn:hover{cursor:pointer}.google-btn:active{background:#fff}.md-dialog-content{max-width:385px;text-align:justify}.md-dialog-content-body p{white-space:break-spaces}md-dialog{min-width:0!important}", ""]);
	
	// exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _news = __webpack_require__(574);var _news2 = _interopRequireDefault(_news);
	var _newsList = __webpack_require__(579);var _newsList2 = _interopRequireDefault(_newsList);
	var _newsDetail = __webpack_require__(582);var _newsDetail2 = _interopRequireDefault(_newsDetail);
	var _news3 = __webpack_require__(585);var _news4 = _interopRequireDefault(_news3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var newsModule = _angular2.default.module('news', [
	_angularUiRouter2.default]).
	
	
	service('News', _news4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/news');
	
	  $stateProvider.
	  state('news', {
	    component: 'news' }).
	
	  state('news.list', {
	    url: '/news',
	    component: 'newsList' }).
	
	  state('news.create', {
	    url: '/news/new',
	    component: 'newsDetail',
	    params: {
	      id: "" } }).
	
	
	  state('news.edit', {
	    url: '/news/:id/edit',
	    component: 'newsDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('news', _news2.default).
	component('newsList', _newsList2.default).
	component('newsDetail', _newsDetail2.default).
	
	name;exports.default =
	
	newsModule;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _news = __webpack_require__(575);var _news2 = _interopRequireDefault(_news);
	var _news3 = __webpack_require__(576);var _news4 = _interopRequireDefault(_news3);
	__webpack_require__(577);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var newsComponent = {
	  bindings: {},
	  template: _news2.default,
	  controller: _news4.default };exports.default =
	
	
	newsComponent;

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var NewsController =
	function NewsController() {_classCallCheck(this, NewsController);
	  this.name = 'news';
	};exports.default =
	
	
	NewsController;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(578);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./news.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./news.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".sb-news canvas{margin:0!important}.sb-news .sb-news-image-container img.sb-news-image{width:100%;height:auto}.sb-news .md-button{margin:6px 0}", ""]);
	
	// exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _newsList = __webpack_require__(580);var _newsList2 = _interopRequireDefault(_newsList);
	var _newsList3 = __webpack_require__(581);var _newsList4 = _interopRequireDefault(_newsList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var newsListComponent = {
	  bindings: {},
	  template: _newsList2.default,
	  controller: _newsList4.default };exports.default =
	
	
	newsListComponent;

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\"\n         ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n        <md-button class=\"md-raised md-accent\" ui-sref=\"news.create\">\n            {{ 'common-new-feminine' | translate }}\n        </md-button>\n\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"title\"\n                        ng-click=\"$ctrl.orderList('title')\">\n                        {{ 'news-list-table-header-title' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"category\"\n                        ng-click=\"$ctrl.orderList('user_profile_type')\">\n                        {{ 'news-list-table-header-target' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"published_at\"\n                        ng-click=\"$ctrl.orderList('published_at')\">\n                        {{ 'news-list-table-header-published-at' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_at\"\n                        ng-click=\"$ctrl.orderList('updated_at')\">\n                        {{ 'news-list-table-header-updated-at' | translate }}\n                    </th>\n\n                    <th md-column md-numeric class=\"sb-table-column-xs\">\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"newsItem in $ctrl.newsItems.data\"\n                      ng-click=\"$ctrl.edit(newsItem.id)\">\n                    <td md-cell class=\"sb-table-truncate\">{{ newsItem.title }}</td>\n\n                    <td md-cell>\n                        {{ 'news-list-table-target-' + newsItem.category | translate }}\n                    </td>\n\n                    <td md-cell>{{ newsItem.published_at | momentFormat : 'DD/MM/YYYY' }}</td>\n\n                    <td md-cell>{{ newsItem.updated_at | momentFormat : 'DD/MM/YYYY' }}</td>\n\n                    <td md-cell>\n                        <md-button aria-label=\"Toolbar menu\"\n                                   class=\"md-icon-button\"\n                                   ng-click=\"$ctrl.handleDelete(newsItem, $event)\">\n                          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.newsItems.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <img src=\"{{ $root.baseAssetsUrl }}/empty_news.png\"/>\n\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'news-list-empty-state-line-1' | translate }}</p>\n                <p>{{ 'news-list-empty-state-line-2' | translate }}</p>\n            </div>\n\n            <md-button class=\"md-raised md-accent\" ui-sref=\"news.create\">\n                {{ 'news-list-create-news-button' | translate }}\n            </md-button>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var NewsListController = function NewsListController(News, $scope, $state, $filter, $mdDialog, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.newsItems = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'published_at DESC',
	      like_search: '',
	      like_search_fields: [
	      'title'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function edit(id) {
	    $state.go('news.edit', { id: id });
	  }
	
	  function handleDelete(resource, event) {
	    event.stopPropagation();
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      News.
	      destroy(resource).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        _.remove($ctrl.newsItems.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = News.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.newsItems = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	};
	
	NewsListController.$inject = ['News', '$scope', '$state', '$filter', '$mdDialog', 'Toast'];exports.default =
	
	NewsListController;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _newsDetail = __webpack_require__(583);var _newsDetail2 = _interopRequireDefault(_newsDetail);
	var _newsDetail3 = __webpack_require__(584);var _newsDetail4 = _interopRequireDefault(_newsDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var newsDetailComponent = {
	  bindings: {},
	  template: _newsDetail2.default,
	  controller: _newsDetail4.default };exports.default =
	
	
	newsDetailComponent;

/***/ }),
/* 583 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-news\">\n        <div layout=\"row\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n            <div flex=\"60\" class=\"layout-padding\">\n                <h3 class=\"sb-page-section-title\">{{ 'news-create-page-title' | translate }}</h3>\n\n                <form name=\"newsForm\" ng-submit=\"$ctrl.handleSave(newsForm, $ctrl.newsItem)\"\n                      novalidate>\n                    <md-input-container class=\"md-block\" flex>\n                        <label>{{ 'common-title' | translate }}</label>\n\n                        <input ng-model=\"$ctrl.newsItem.title\" name=\"title\"\n                               md-maxlength=\"100\"\n                               required>\n                        </input>\n\n                        <div ng-messages=\"newsForm.title.$error\" multiple>\n                            <div ng-message=\"required\">\n                                {{ 'form-error-required-field' | translate}}\n                            </div>\n\n                            <div ng-message=\"md-maxlength\">\n                                {{ 'news-detail-form-error-title-max-length' | translate}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <md-input-container class=\"md-block\">\n                        <label>{{ 'common-category' | translate }}</label>\n\n                        <md-select ng-model=\"$ctrl.newsItem.category\"\n                                   required>\n                            <md-option ng-value=\"'COMMUNICATE'\" >\n                                {{ 'common-communicate' | translate }}\n                            </md-option>\n\n                            <md-option ng-value=\"'CAMPAIGN'\" >\n                                {{ 'common-campaign' | translate }}\n                            </md-option>\n                        </md-select>\n                    </md-input-container>\n\n                    <md-input-container class=\"md-block\">\n                      <md-checkbox ng-model=\"$ctrl.filter.isEnabled\"\n                                   ng-disabled=\"$ctrl.hasNews\"\n                                   aria-label=\"Checkbox 1\">\n                        {{ 'news-detail-form-filter-checkbox' | translate }}\n                      </md-checkbox>\n                    </md-input-container>\n\n\n                    <div layout=\"row\" ng-show=\"$ctrl.filter.isEnabled\">\n\n                      <md-input-container class=\"md-block\" flex>\n                        <label>{{ 'notification-detail-type' | translate }}</label>\n\n                        <md-select name=\"user_profile_type\"\n                                   ng-model=\"$ctrl.filter.user_profile_type\"\n                        >\n                          <md-option ng-value=\"'ALL'\">\n                            {{ 'common-general' | translate }}\n                          </md-option>\n\n                          <md-option ng-value=\"'CLIENT'\">\n                            {{ 'common-clients' | translate }}\n                          </md-option>\n\n                          <md-option ng-value=\"'MEDIC'\">\n                            {{ 'common-medics' | translate }}\n                          </md-option>\n                        </md-select>\n                      </md-input-container>\n\n                      <md-input-container class=\"md-block\" flex>\n                        <label>\n                          {{ 'common-state' | translate }}\n                        </label>\n\n                        <md-select ng-model=\"$ctrl.filter.state_id\"\n                                  ng-change=\"$ctrl.onChangeState($ctrl.filter.state_id)\"\n                                  name=\"state\" multiple md-on-close=\"$ctrl.clearSearch()\"\n                                  md-container-class=\"selectdemoSelectHeader\">\n                          <md-select-header layout=\"column\" class=\"demo-select-header\">\n                            <md-input-container class=\"md-block\" flex>\n                                <input ng-model=\"$ctrl.searchState\" type=\"text\"\n                                      ng-model-options=\"{debounce: {'default': 250, 'blur': 0}}\"\n                                      class=\"demo-header-searchbox md-text input-search-state\" aria-label=\"state filter\"\n                                      placeholder=\"Buscar estados\"/>\n                            </md-input-container>\n                          </md-select-header>\n\n                            <md-optgroup label=\"state\">\n                              <md-option ng-selected=\"$ctrl.filter.state_id.includes(state.id.toString())\n                                  && !$ctrl.filter.state_id.includes(null)\"\n                              ng-repeat=\"state in $ctrl.states | filter:$ctrl.searchState\"\n                                        ng-value=\"state.id.toString()\">\n                                {{ state.name }}\n                              </md-option>\n                            </md-optgroup>\n                        </md-select>\n                      </md-input-container>\n\n                      <md-input-container class=\"md-block\" flex>\n                        <label>\n                          {{ $ctrl.filter.city_id.includes(null) ? 'Todas' : 'common-city' | translate }}\n                        </label>\n\n                        <md-select ng-model=\"$ctrl.filter.city_id\"\n                                   ng-disabled=\"!$ctrl.filter.state_id || $ctrl.loadingCities\"\n                                   name=\"city\" multiple md-on-close=\"$ctrl.clearSearch()\"\n                                   md-container-class=\"selectdemoSelectHeader\">\n                          <md-select-header layout=\"column\" class=\"demo-select-header\">\n                            <md-input-container class=\"md-block\" flex>\n                              <input ng-model=\"$ctrl.search\" type=\"text\" ng-model-options=\"{debounce: {'default': 250, 'blur': 0}}\"\n                              class=\"demo-header-searchbox md-text input-search-city\" aria-label=\"city filter\"  placeholder=\"Buscar cidades\"/>\n                          </md-input-container>\n\n                          </md-select-header>\n                          <md-optgroup label=\"city\">\n                            <md-option ng-value=\"null\">\n                                      {{ 'common-all-feminine' | translate }}\n                            </md-option>\n                            <md-option ng-repeat=\"city in $ctrl.cities | filter:$ctrl.search\"\n                              ng-selected=\"$ctrl.filter.city_id.includes(city.id.toString())\n                              && !$ctrl.filter.city_id.includes(null)\"\n                              ng-value=\"city.id.toString()\">{{ city.name }}\n                            </md-option>\n                          </md-optgroup>\n                        </md-select>\n                      </md-input-container>\n\n                      <md-input-container class=\"md-block\" flex>\n                        <label>{{ 'common-gender' | translate}}</label>\n                        <md-select name=\"gender\"\n                                   ng-model=\"$ctrl.filter.gender\"\n                        >\n                          <md-option ng-value=\"null\">\n                            {{ 'common-all-masculine' | translate}}\n                          </md-option>\n\n                          <md-option ng-value=\"'MALE'\">\n                            {{ 'common-male' | translate}}\n                          </md-option>\n\n                          <md-option ng-value=\"'FEMALE'\">\n                            {{ 'common-female' | translate}}\n                          </md-option>\n                        </md-select>\n                      </md-input-container>\n                    </div>\n                    <md-card class=\"sb-ta-container\"\n                             ng-class=\"{'sb-input-invalid': (newsForm.content.$touched || newsForm.$submitted) && (!$ctrl.newsItem.content || $ctrl.newsItem.content.trim().length < 12) }\">\n                        <text-angular name=\"content\"\n                                      ng-model=\"$ctrl.newsItem.content\">\n                        </text-angular>\n                    </md-card>\n\n                    <div class=\"sb-error-message\" ng-show=\"(newsForm.content.$touched || newsForm.$submitted) && (!$ctrl.newsItem.content || $ctrl.newsItem.content.trim().length < 1)\">\n                        {{ 'form-error-required-field' | translate}}\n                    </div>\n\n                    <div class=\"sb-error-message\" ng-show=\"(newsForm.content.$touched || newsForm.$submitted) && ($ctrl.newsItem.content.trim().length < 12)\">\n                        {{ 'news-detail-form-error-content-min-length' | translate }}\n                    </div>\n\n                    <md-progress-linear ng-show=\"$ctrl.saving || $ctrl.deleting\"\n                                        md-mode=\"indeterminate\">\n                    </md-progress-linear>\n\n                    <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions\">\n                        <md-button page-back\n                                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                            {{ 'common-cancel-button-text' | translate }}\n                        </md-button>\n\n                        <md-button ng-click=\"$ctrl.handleDelete($ctrl.newsItem, $event)\"\n                                   ng-if=\"$ctrl.id\"\n                                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                                   class=\"md-warn md-raised\">\n                            {{ 'common-delete-button-text' | translate }}\n                        </md-button>\n\n                        <md-button ng-click=\"$ctrl.clearForm(newsForm)\"\n                                   ng-if=\"!$ctrl.id\"\n                                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                                   class=\"md-raised\">\n                            {{ 'common-clear-button-text' | translate }}\n                        </md-button>\n\n                        <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                                   class=\"md-accent md-raised\">\n                            {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                        </md-button>\n\n                    </div>\n                </form>\n            </div>\n\n            <div flex=\"40\" class=\"layout-padding\">\n                <h3 class=\"sb-page-section-title\">{{ 'common-image' | translate }}</h3>\n\n                <div>\n                    <input ng-show=\"false\" type=\"file\" id=\"fileInput\"/>\n\n                    <label for=\"fileInput\" class=\"md-button md-raised\">\n                        {{ 'common-choose-a-file' | translate }}\n                    </label>\n                </div>\n\n                <div class=\"sb-error-message\"\n                     ng-show=\"newsForm.$submitted && (!$ctrl.myCroppedImage && !$ctrl.newsItem.image_uri)\">\n                    {{ 'form-error-required-file' | translate}}\n                </div>\n\n                <div ng-show=\"$ctrl.fileName\">\n                    <span class=\"md-caption\">{{ $ctrl.fileName }}</span>\n                </div>\n\n                <div class=\"sb-hint\">\n                    {{ 'news-detail-form-image-hint' | translate }}\n                </div>\n\n                <div ng-show=\"$ctrl.myCroppedImage\"\n                     class=\"sb-news-image-container\">\n                    <img class=\"sb-news-image\" ng-src=\"{{ $ctrl.myCroppedImage }}\"/>\n                </div>\n\n                <div ng-show=\"$ctrl.newsItem.image_uri && !$ctrl.myCroppedImage\"\n                     class=\"sb-news-image-container\">\n                    <img class=\"sb-news-image\" ng-src=\"{{ $ctrl.newsItem.image_uri }}\"/>\n\n                    <md-progress-linear ng-show=\"$ctrl.loadingImage\" md-mode=\"indeterminate\">\n                    </md-progress-linear>\n                </div>\n            </div>\n        </div>\n\n        <div ng-show=\"$ctrl.uiState === 'LOADING'\"\n             class=\"sb-fill-parent\">\n            <div class=\"sb-absolute-center sb-empty-state\"\n                 layout=\"column\" layout-align=\"center center\">\n                <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n            </div>\n        </div>\n\n        <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n             class=\"sb-fill-parent\">\n            <div class=\"sb-absolute-center sb-empty-state\"\n                 layout=\"column\" layout-align=\"center center\">\n                <div class=\"sb-error-message\">\n                    {{ 'common-load-error' | translate}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _slicedToArray = function () {function sliceIterator(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"]) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}return function (arr, i) {if (Array.isArray(arr)) {return arr;} else if (Symbol.iterator in Object(arr)) {return sliceIterator(arr, i);} else {throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var NewsDetailController = function NewsDetailController($filter, $mdDialog, $scope, $state, $timeout, News, Toast, State, City) {
	  DialogController.$inject = ["$scope", "$mdDialog", "$filter"];
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  if ($ctrl.id) $ctrl.hasNews = true;
	  $ctrl.search = '';
	  $ctrl.searchState = '';
	
	  $timeout(function () {
	    _angular2.default.element(document.querySelector('.input-search-state')).on('keydown', function (ev) {
	      ev.stopPropagation();
	    });
	  }, 500);
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm, handleSave: handleSave,
	    onChangeState: onChangeState, handleDelete: handleDelete, clearSearch: clearSearch });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    _angular2.default.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
	
	    var id = $ctrl.id;
	
	    $ctrl.uiState = 'LOADING';
	
	    loadResource(id).
	    then(function (response) {
	
	      simulateImageLoadProgress();
	      $ctrl.states = response[0];
	      if (response[1]) {
	        $ctrl.newsItem = response[1];
	        if ($ctrl.newsItem.state_id) {
	          onChangeState($ctrl.newsItem.state_id);
	        }
	        $ctrl.filter.isEnabled = !$ctrl.newsItem.is_for_all_users;
	        $ctrl.filter.gender = $ctrl.newsItem.gender;
	        $ctrl.filter.state_id = $ctrl.newsItem.state_id;
	        $ctrl.filter.city_id = $ctrl.newsItem.city_id;
	        $ctrl.filter.user_profile_type = $ctrl.newsItem.user_profile_type;
	
	      }
	      $ctrl.uiState = 'COMPLETE';
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function clearForm(form) {
	    $ctrl.newsItem = {};
	    $ctrl.myImage = '';
	    $ctrl.myCroppedImage = '';
	    $ctrl.fileName = undefined;
	    $ctrl.filter = {};
	    $ctrl.search = '';
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function clearSearch() {
	    $ctrl.search = '';
	  };
	
	  function handleDelete(newsItem, event) {
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('news-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('news-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      News.
	      destroy(newsItem).
	      then(function (response) {
	        Toast.success($filter('translate')('news-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('news.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, newsItem) {
	    newsItem.image_base64 = $ctrl.myCroppedImage;
	
	    if (!form.$valid || !newsItem.image_base64 && !newsItem.image_uri || !newsItem.content || newsItem.content.trim().length < 12) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    var count = newsItem.content.search(/"color:/),count2 = newsItem.content.search(/color=/);
	
	    while (count > -1) {
	      var startIdx = newsItem.content.search(/"color:/) + 1;
	      var endIdx = newsItem.content.substring(startIdx, startIdx + 35).search(/;/) + 1;
	      var styleColor = newsItem.content.substring(startIdx, startIdx + endIdx);
	      newsItem.content = newsItem.content.replaceAll(styleColor, '');
	      count = newsItem.content.search(/"color:/);
	    }
	
	    while (count2 > -1) {
	      console.log(count2);
	      var _startIdx = newsItem.content.search(/color=/);
	      var _endIdx = newsItem.content.substring(_startIdx, _startIdx + 20).search("\">") + 1;
	      var _styleColor = newsItem.content.substring(_startIdx, _startIdx + _endIdx);
	      newsItem.content = newsItem.content.replaceAll(_styleColor, '');
	      count2 = newsItem.content.search(/color=/);
	    }
	
	    $ctrl.saving = true;
	
	    if ($ctrl.id && $ctrl.filter.isEnabled) {var _iteratorNormalCompletion = true;var _didIteratorError = false;var _iteratorError = undefined;try {
	        for (var _iterator = Object.entries($ctrl.filter)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {var _step$value = _slicedToArray(_step.value, 2),k = _step$value[0],v = _step$value[1];
	          newsItem[k] = v;
	        }} catch (err) {_didIteratorError = true;_iteratorError = err;} finally {try {if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}} finally {if (_didIteratorError) {throw _iteratorError;}}}
	      delete newsItem.filter;
	      newsItem.state_id = newsItem.state_id.filter(function (i) {return i.length > 0;});
	    } else
	    if ($ctrl.filter.isEnabled) {
	      $ctrl.filter.state_id = $ctrl.filter.state_id.filter(function (i) {return i.length > 0;});
	      newsItem.filter = $ctrl.filter;
	    }
	
	    News.
	    save(newsItem).
	    then(function (response) {
	      Toast.success($filter('translate')('news-detail-save-success'));
	      $ctrl.newsItem = response;
	      $ctrl.myImage = '';
	      $ctrl.myCroppedImage = '';
	      $ctrl.fileName = undefined;
	      $ctrl.saving = false;
	      $state.go('news.list');
	    }).
	    catch(function (err) {
	      Toast.error($filter('translate')('common-save-error'));
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	
	  function onChangeState(stateIdArr) {
	    if (stateIdArr.length !== 0) {
	      var states = stateIdArr.filter(function (i) {return i;});
	
	      $ctrl.filter.city_id = null;
	      $ctrl.loadingCities = true;
	      City.
	      index({
	        state_id: states,
	        limit: 1000000 }).
	
	      then(function (cities) {
	        $ctrl.cities = cities;
	        $ctrl.loadingCities = false;
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.loadingCities = false;
	      }).finally(function () {
	        _angular2.default.
	        element(document.querySelector('.input-search-city')).
	        on('keydown', function (ev) {
	          ev.stopPropagation();
	        });
	      });
	    }
	
	    if (stateIdArr && stateIdArr.length > 1) {
	      $ctrl.search = "";
	      $ctrl.filter.city_id = null;
	      $ctrl.cities = [];
	    }
	  }
	
	  // Local functions
	
	  function handleFileSelect(event) {
	    var file = event.currentTarget.files[0];
	
	    if (!file) {
	      console.log('no file added!');
	      return;
	    }
	
	    var reader = new FileReader();
	    reader.onload = function (event) {
	      $ctrl.myImage = event.target.result;
	      $scope.$apply();
	      $ctrl.fileName = file.name;
	      showCropDialog(event);
	    };
	
	    reader.readAsDataURL(file);
	  }
	
	  function showCropDialog(event) {
	    $mdDialog.show({
	      controller: DialogController,
	      targetEvent: event,
	      template:
	      '<md-dialog aria-label="Image cropper dialog" class="sb-ui-cropper-dialog">' +
	      '  <md-dialog-content>' +
	      '    <div layout="row" layout-align="center center" ng-show="!isDoneLoading">' +
	      '      <md-progress-linear md-mode="indeterminate"></md-progress-linear>' +
	      '    </div>' +
	      '' +
	      '    <ui-cropper' +
	      '      ng-show="isDoneLoading === true"' +
	      '      on-load-done="isDoneLoading = true"' +
	      '      image="myImage"' +
	      '      area-type="rectangle"' +
	      '      aspect-ratio="1.6744186047"' +
	      '      init-max-area="true"' +
	      '      chargement="loadingText"' +
	      '      result-image-size="{w: 720,h: 430}"' +
	      '      result-image="myCroppedImage" canvas-scalemode="true">' +
	      '    </ui-cropper>' +
	      '  </md-dialog-content>' +
	      '  <md-dialog-actions' +
	      '     ng-show="isDoneLoading === true">' +
	      '    <md-button ng-click="cancel()">' +
	      '      Cancelar' +
	      '    </md-button>' +
	      '    <md-button ng-click="cropImage(myCroppedImage)" class="md-accent">' +
	      '      Feito' +
	      '    </md-button>' +
	      '  </md-dialog-actions>' +
	      '</md-dialog>',
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(function (myCroppedImage) {
	      $ctrl.myCroppedImage = myCroppedImage;
	      $ctrl.myImage = '';
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  }
	
	  function DialogController($scope, $mdDialog, $filter) {
	    "ngInject";
	    $scope.loadingText = $filter('translate')('common-loading');
	    $scope.myImage = $ctrl.myImage;
	    $scope.myCroppedImage = $ctrl.myCroppedImage;
	
	    $scope.hide = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.cancel();
	    };
	
	    $scope.cropImage = function (myCroppedImage) {
	      $mdDialog.hide(myCroppedImage);
	    };
	  }
	
	  function loadResource(id) {
	
	    var promises = [];
	
	    promises.push(State.listStatesWithClient());
	    if (id) {
	      promises.push(News.show(id));
	    }
	
	    return Promise.all(promises);
	  }
	
	  function simulateImageLoadProgress() {
	    $ctrl.loadingImage = true;
	    $timeout(function () {
	      $ctrl.loadingImage = false;
	    }, 1000);
	  }
	};
	
	NewsDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', '$timeout', 'News', 'Toast', 'State', 'City'];exports.default =
	
	NewsDetailController;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var NewsService = function NewsService(Restangular) {
	  var News = Restangular.all('admin/news_item');
	
	  var count = function count(query) {
	    return News.customGET('count', query);
	  };
	
	  var save = function save(newsItem) {
	    if (newsItem.save) {
	      return newsItem.save();
	    } else {
	      return News.post(newsItem);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return News.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return News.get(id);
	  };
	
	  var destroy = function destroy(newsItem) {
	    newsItem.deleted_at = moment();
	    return News.customDELETE(newsItem.id);
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	NewsService.$inject = ['Restangular'];exports.default =
	
	NewsService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _page = __webpack_require__(587);var _page2 = _interopRequireDefault(_page);
	var _pageAbout = __webpack_require__(592);var _pageAbout2 = _interopRequireDefault(_pageAbout);
	var _pagePrivacy = __webpack_require__(594);var _pagePrivacy2 = _interopRequireDefault(_pagePrivacy);
	var _pageCid = __webpack_require__(595);var _pageCid2 = _interopRequireDefault(_pageCid);
	var _page3 = __webpack_require__(596);var _page4 = _interopRequireDefault(_page3);
	var _pageHomeApp = __webpack_require__(597);var _pageHomeApp2 = _interopRequireDefault(_pageHomeApp);
	
	var _video = __webpack_require__(600);var _video2 = _interopRequireDefault(_video);
	var _pageHomeVideo = __webpack_require__(601);var _pageHomeVideo2 = _interopRequireDefault(_pageHomeVideo);
	var _pageNewHomeVideo = __webpack_require__(604);var _pageNewHomeVideo2 = _interopRequireDefault(_pageNewHomeVideo);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var pageModule = _angular2.default.module('page', [
	_angularUiRouter2.default]).
	
	
	service('Page', _page4.default).
	service('Video', _video2.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.
	  state('page', {
	    component: 'page' }).
	
	  state('page.home-app', {
	    url: '/page/custom-home-app',
	    component: 'homeApp' }).
	
	  state('page.video-home', {
	    url: '/page/video-home',
	    component: 'homeVideoComponent',
	    params: {
	      name: 'about' } }).
	
	
	  state('page.new-video-home', {
	    url: '/page/video-home/new',
	    component: 'newHomeVideoComponent' }).
	
	  state('page.view-video-home', {
	    url: '/page/video-home/:id',
	    component: 'newHomeVideoComponent',
	    params: {
	      name: '' } }).
	
	
	  state('page.about', {
	    url: '/page/about',
	    component: 'about',
	    params: {
	      name: 'about' } }).
	
	
	  state('page.privacy', {
	    url: '/page/privacy',
	    component: 'privacy',
	    params: {
	      name: 'privacy' } }).
	
	
	  state('page.cid', {
	    url: '/page/cid',
	    component: 'cid',
	    params: {
	      name: 'cid' } });
	
	
	}]).
	
	component('page', _page2.default).
	component('about', _pageAbout2.default).
	component('privacy', _pagePrivacy2.default).
	component('cid', _pageCid2.default).
	component('homeApp', _pageHomeApp2.default).
	component('homeVideoComponent', _pageHomeVideo2.default).
	component('newHomeVideoComponent', _pageNewHomeVideo2.default).
	name;exports.default =
	
	pageModule;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _page = __webpack_require__(588);var _page2 = _interopRequireDefault(_page);
	var _page3 = __webpack_require__(589);var _page4 = _interopRequireDefault(_page3);
	__webpack_require__(590);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var pageComponent = {
	  bindings: {},
	  template: _page2.default,
	  controller: _page4.default };exports.default =
	
	
	pageComponent;

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var PageController = function PageController($filter, $mdDialog, $scope, $state, $timeout, Page, Toast) {
	  DialogController.$inject = ["$scope", "$mdDialog", "$filter"];
	  var $ctrl = this;
	
	  $ctrl.name = $state.params.name;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm, handleSave: handleSave });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    _angular2.default.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
	
	    var id = $ctrl.name;
	
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      loadResource(id).
	      then(function (response) {
	        simulateImageLoadProgress();
	        $ctrl.page = response;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	    }
	  }
	
	  function clearForm(form) {
	    $ctrl.page = {};
	    $ctrl.myImage = '';
	    $ctrl.myCroppedImage = '';
	    $ctrl.fileName = undefined;
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleSave(form, page) {
	    page.image_base64 = $ctrl.myCroppedImage;
	
	    if (!form.$valid || !page.image_base64 && !page.image_uri && page.name === 'about' || !page.content || page.content.trim().length < 12) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    $ctrl.saving = true;
	
	    Page.
	    save(page).
	    then(function (response) {
	      Toast.success($filter('translate')('page-detail-save-success'));
	      $ctrl.page = response;
	      $ctrl.myImage = '';
	      $ctrl.myCroppedImage = '';
	      $ctrl.fileName = undefined;
	      $ctrl.saving = false;
	    }).
	    catch(function (err) {
	      Toast.error($filter('translate')('common-save-error'));
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	
	  // Local functions
	
	  function handleFileSelect(event) {
	    var file = event.currentTarget.files[0];
	
	    if (!file) {
	      console.log('no file added!');
	      return;
	    }
	
	    var reader = new FileReader();
	    reader.onload = function (event) {
	      $ctrl.myImage = event.target.result;
	      $scope.$apply();
	      $ctrl.fileName = file.name;
	      showCropDialog(event);
	    };
	
	    reader.readAsDataURL(file);
	  }
	
	  function showCropDialog(event) {
	    $mdDialog.show({
	      controller: DialogController,
	      targetEvent: event,
	      template:
	      '<md-dialog aria-label="Image cropper dialog" class="sb-ui-cropper-dialog">' +
	      '  <md-dialog-content>' +
	      '    <div layout="row" layout-align="center center" ng-show="!isDoneLoading">' +
	      '      <md-progress-linear md-mode="indeterminate"></md-progress-linear>' +
	      '    </div>' +
	      '' +
	      '    <ui-cropper' +
	      '      ng-show="isDoneLoading === true"' +
	      '      on-load-done="isDoneLoading = true"' +
	      '      image="myImage"' +
	      '      area-type="rectangle"' +
	      '      aspect-ratio="1.6744186047"' +
	      '      init-max-area="true"' +
	      '      chargement="loadingText"' +
	      '      result-image-size="{w: 720,h: 430}"' +
	      '      result-image="myCroppedImage" canvas-scalemode="true">' +
	      '    </ui-cropper>' +
	      '  </md-dialog-content>' +
	      '  <md-dialog-actions' +
	      '     ng-show="isDoneLoading === true">' +
	      '    <md-button ng-click="cancel()">' +
	      '      Cancelar' +
	      '    </md-button>' +
	      '    <md-button ng-click="cropImage(myCroppedImage)" class="md-accent">' +
	      '      Feito' +
	      '    </md-button>' +
	      '  </md-dialog-actions>' +
	      '</md-dialog>',
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(function (myCroppedImage) {
	      $ctrl.myCroppedImage = myCroppedImage;
	      $ctrl.myImage = '';
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  }
	
	  function DialogController($scope, $mdDialog, $filter) {
	    "ngInject";
	    $scope.loadingText = $filter('translate')('common-loading');
	    $scope.myImage = $ctrl.myImage;
	    $scope.myCroppedImage = $ctrl.myCroppedImage;
	
	    $scope.hide = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.cancel();
	    };
	
	    $scope.cropImage = function (myCroppedImage) {
	      $mdDialog.hide(myCroppedImage);
	    };
	  }
	
	  function loadResource(name) {
	    return Page.show(name);
	  }
	
	  function simulateImageLoadProgress() {
	    $ctrl.loadingImage = true;
	    $timeout(function () {
	      $ctrl.loadingImage = false;
	    }, 1000);
	  }
	};
	
	PageController.$inject = ['$filter', '$mdDialog', '$scope', '$state', '$timeout', 'Page', 'Toast'];exports.default =
	
	PageController;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(591);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./page.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./page.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".sb-page canvas{margin:0!important}.sb-page .sb-page-image-container img.sb-page-image{width:100%;height:auto}.sb-page .md-button{margin:6px 0}", ""]);
	
	// exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _pageDetail = __webpack_require__(593);var _pageDetail2 = _interopRequireDefault(_pageDetail);
	var _page = __webpack_require__(589);var _page2 = _interopRequireDefault(_page);
	__webpack_require__(590);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var pageComponent = {
	  bindings: {},
	  template: _pageDetail2.default,
	  controller: _page2.default };exports.default =
	
	
	pageComponent;

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-page\">\n        <div layout=\"row\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n            <div flex class=\"layout-padding\">\n                <h3 class=\"sb-page-section-title\">{{ 'page-edit-page-title' | translate }}</h3>\n\n                <form name=\"pageForm\" ng-submit=\"$ctrl.handleSave(pageForm, $ctrl.page)\"\n                      novalidate>\n                    <md-input-container class=\"md-block\" flex>\n                        <label>{{ 'common-title' | translate }}</label>\n\n                        <input ng-model=\"$ctrl.page.title\" name=\"title\" \n                               required>\n                        </input>\n\n                        <div ng-messages=\"pageForm.title.$error\" multiple>\n                            <div ng-message=\"required\">\n                                {{ 'form-error-required-field' | translate}}\n                            </div>\n\n                            <div ng-message=\"md-maxlength\">\n                                {{ 'page-detail-form-error-title-max-length' | translate}}\n                            </div>\n                        </div>\n                    </md-input-container>\n\n                    <md-card class=\"sb-ta-container\"\n                             ng-class=\"{'sb-input-invalid': (pageForm.content.$touched || pageForm.$submitted) && (!$ctrl.page.content || $ctrl.page.content.trim().length < 12) }\">\n                        <text-angular name=\"content\"\n                                      ng-model=\"$ctrl.page.content\">\n                        </text-angular>\n                    </md-card>\n\n                    <div class=\"sb-error-message\" ng-show=\"(pageForm.content.$touched || pageForm.$submitted) && (!$ctrl.page.content || $ctrl.page.content.trim().length < 1)\">\n                        {{ 'form-error-required-field' | translate}}\n                    </div>\n\n                    <div class=\"sb-error-message\" ng-show=\"(pageForm.content.$touched || pageForm.$submitted) && ($ctrl.page.content.trim().length < 12)\">\n                        {{ 'page-detail-form-error-content-min-length' | translate }}\n                    </div>\n\n                    <md-progress-linear ng-show=\"$ctrl.saving || $ctrl.deleting\"\n                                        md-mode=\"indeterminate\">\n                    </md-progress-linear>\n\n                    <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions\">\n                        <md-button page-back\n                                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                            {{ 'common-cancel-button-text' | translate }}\n                        </md-button>\n\n                        <md-button ng-click=\"$ctrl.handleDelete($ctrl.page, $event)\"\n                                   ng-if=\"$ctrl.id\"\n                                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                                   class=\"md-warn md-raised\">\n                            {{ 'common-delete-button-text' | translate }}\n                        </md-button>\n\n                        <md-button ng-click=\"$ctrl.clearForm(pageForm)\"\n                                   ng-if=\"!$ctrl.id\"\n                                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                                   class=\"md-raised\">\n                            {{ 'common-clear-button-text' | translate }}\n                        </md-button>\n\n                        <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                                   class=\"md-accent md-raised\">\n                            {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                        </md-button>\n\n                    </div>\n                </form>\n            </div>\n\n            <div flex=\"40\" class=\"layout-padding\" ng-show=\"$ctrl.name === 'about'\">\n                <h3 class=\"sb-page-section-title\">{{ 'common-image' | translate }}</h3>\n\n                <div>\n                    <input ng-show=\"false\" type=\"file\" id=\"fileInput\"/>\n                    \n                    <label for=\"fileInput\" class=\"md-button md-raised\">\n                        {{ 'common-choose-a-file' | translate }}\n                    </label>\n                </div>\n\n                <div class=\"sb-error-message\"\n                     ng-show=\"pageForm.$submitted && (!$ctrl.myCroppedImage && !$ctrl.page.image_uri)\">\n                    {{ 'form-error-required-file' | translate}}\n                </div>\n\n                <div ng-show=\"$ctrl.fileName\">\n                    <span class=\"md-caption\">{{ $ctrl.fileName }}</span>\n                </div>\n\n                <div class=\"sb-hint\">\n                    {{ 'news-detail-form-image-hint' | translate }}\n                </div>\n\n                <div ng-show=\"$ctrl.myCroppedImage\"\n                     class=\"sb-page-image-container\">\n                    <img class=\"sb-page-image\" ng-src=\"{{ $ctrl.myCroppedImage }}\"/>\n                </div>\n\n                <div ng-show=\"$ctrl.page.image_uri && !$ctrl.myCroppedImage\"\n                     class=\"sb-page-image-container\">\n                    <img class=\"sb-page-image\" ng-src=\"{{ $ctrl.page.image_uri }}\"/>\n\n                    <md-progress-linear ng-show=\"$ctrl.loadingImage\" md-mode=\"indeterminate\">\n                    </md-progress-linear>\n                </div>\n            </div>\n        </div>\n\n        <div ng-show=\"$ctrl.uiState === 'LOADING'\"\n             class=\"sb-fill-parent\">\n            <div class=\"sb-absolute-center sb-empty-state\" \n                 layout=\"column\" layout-align=\"center center\">\n                <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n            </div>\n        </div>\n\n        <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n             class=\"sb-fill-parent\">\n            <div class=\"sb-absolute-center sb-empty-state\" \n                 layout=\"column\" layout-align=\"center center\">\n                <div class=\"sb-error-message\">\n                    {{ 'common-load-error' | translate}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _pageDetail = __webpack_require__(593);var _pageDetail2 = _interopRequireDefault(_pageDetail);
	var _page = __webpack_require__(589);var _page2 = _interopRequireDefault(_page);
	__webpack_require__(590);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var pageComponent = {
	  bindings: {},
	  template: _pageDetail2.default,
	  controller: _page2.default };exports.default =
	
	
	pageComponent;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _pageDetail = __webpack_require__(593);var _pageDetail2 = _interopRequireDefault(_pageDetail);
	var _page = __webpack_require__(589);var _page2 = _interopRequireDefault(_page);
	__webpack_require__(590);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var pageComponent = {
	  bindings: {},
	  template: _pageDetail2.default,
	  controller: _page2.default };exports.default =
	
	
	pageComponent;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {"use strict";Object.defineProperty(exports, "__esModule", { value: true });var PageService = function PageService(Restangular) {
	  var Service = Restangular.all("admin/custom_page");
	  var ServiceImage = Restangular.all("admin/dashboard/img");
	
	  var count = function count(query) {
	    return Service.customGET("count", query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return ServiceAPI.customPUT(copyData, resource.id);
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var getImg = function getImg() {
	    return ServiceImage.customGET("");
	  };
	
	  var saveImg = function saveImg(data) {
	    if (data.save) {
	      var _data = angular.copy(data);
	      delete _data.id;
	      return ServiceImage.customPUT(_data, data.id);
	    } else {
	      return ServiceImage.post(data);
	    }
	  };
	
	  var deleteImg = function deleteImg(resource) {
	    return ServiceImage.customDELETE(resource.id);
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = "null";
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = "null";
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, save: save, show: show, getImg: getImg, saveImg: saveImg, deleteImg: deleteImg };
	};
	
	PageService.$inject = ["Restangular"];exports.default =
	
	PageService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _pageHomeApp = __webpack_require__(598);var _pageHomeApp2 = _interopRequireDefault(_pageHomeApp);
	var _pageHomeApp3 = __webpack_require__(599);var _pageHomeApp4 = _interopRequireDefault(_pageHomeApp3);
	__webpack_require__(590);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var pageHomeAppComponent = {
	  bindings: {},
	  template: _pageHomeApp2.default,
	  controller: _pageHomeApp4.default };exports.default =
	
	
	pageHomeAppComponent;

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-news\">\n        <div>\n            <div flex=\"100\" class=\"layout-padding\">\n                <span class=\"sb-page-section-title\"> Tela inicial do aplicativo </span>\n                <p class=\"sb-page-section-sub-title\">\n                    Defina a imagem de fundo da tela inicial do aplicativo\n                </p>\n            </div>\n            <md-card class=\"layout-padding\">\n                <div>\n                    <md-input-container class=\"md-block\" flex>\n                        <label>Título da imagem</label>\n                        <input ng-model=\"$ctrl.data.title\" name=\"title\" required>\n                        </input>\n                    </md-input-container>\n            \n                    <div>\n                        <div>Status da imagem</div>\n                        <md-switch ng-model=\"$ctrl.data.is_active\" aria-label=\"Status\">\n                            Status\n                        </md-switch>\n                    </div>\n            \n                    <md-input-container class=\"md-block\" flex>\n                        <label>URL da imagem da tela inicial</label>\n                        <input ng-model=\"$ctrl.data.image_url\" name=\"urlImage\" required>\n                        </input>\n                    </md-input-container>\n                </div>\n            </md-card>\n            <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n                <md-button page-back ng-disabled=\"$ctrl.saving\">\n                    {{ 'common-cancel-button-text' | translate }}\n                </md-button>\n\n                <md-button\n                    ng-if=\"$ctrl.data.id\"\n                    ng-click=\"$ctrl.removeImg($ctrl.data)\"\n                    class=\"md-warn md-raised\"\n                    ng-disabled=\"$ctrl.saving\"\n                >\n                    {{ 'common-delete-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\"\n                    ng-disabled=\"!$ctrl.data.image_url || !$ctrl.data.title || $ctrl.saving\">\n                    {{ 'common-save-button-text' | translate }}\n                </md-button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var HomeAppController = function HomeAppController(
	$filter,
	$mdDialog,
	$scope,
	$state,
	$timeout,
	Page,
	Toast)
	{
	  var $ctrl = this;
	  _angular2.default.extend($ctrl, {
	    save: save,
	    removeImg: removeImg });
	
	
	  $ctrl.saving = false;
	  $ctrl.data = {
	    title: "",
	    status: false,
	    urlImage: "" };
	
	
	  function activate() {
	    $ctrl.saving = true;
	    Page.getImg().
	    then(function (response) {
	      if (response) $ctrl.data = _angular2.default.copy(response);else
	      {
	        $ctrl.data = {
	          title: "",
	          is_active: false,
	          image_url: "" };
	
	      }
	      $ctrl.saving = false;
	    }).
	    catch(function (err) {
	      $ctrl.saving = false;
	    });
	  }
	
	  function save() {
	    $ctrl.saving = true;
	    Page.saveImg($ctrl.data).
	    then(function (response) {
	      Toast.success("Dados da imagem salvos com sucesso");
	      $ctrl.saving = false;
	      activate();
	    }).
	    catch(function (err) {
	      Toast.error($filter("translate")("common-save-error"));
	      $ctrl.saving = false;
	    });
	  }
	
	  function removeImg(data) {
	    var confirm = $mdDialog.confirm().
	    textContent("Deseja remover essa imagem").
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      Page.
	      deleteImg(data).
	      then(function (response) {
	        Toast.success("Imagem removida com sucesso");
	        activate();
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	
	  activate();
	};
	
	HomeAppController.$inject = [
	"$filter",
	"$mdDialog",
	"$scope",
	"$state",
	"$timeout",
	"Page",
	"Toast"];exports.default =
	
	
	HomeAppController;

/***/ }),
/* 600 */
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var VideoService = function VideoService(Restangular) {
	  var ServiceAPI = Restangular.all("admin/dashboard/banner");
	
	  var getList = function getList(query) {
	    return Restangular.all("admin/dashboard/banner").customGET("", query);
	  };
	
	  var save = function save(resource) {
	    var api = Restangular.all("admin/mobile/banner");
	    if (resource.id) {
	      var copyData = angular.copy(resource);
	      delete copyData.id;
	      return ServiceAPI.customPUT(copyData, resource.id);
	    } else {
	      return api.post(resource);
	    }
	  };
	
	  var getVideo = function getVideo(id) {
	    return ServiceAPI.customGET("" + id);
	  };
	
	  var destroy = function destroy(resource) {
	    return ServiceAPI.customDELETE(resource.id);
	  };
	
	  return { getList: getList, save: save, destroy: destroy, getVideo: getVideo };
	};
	
	VideoService.$inject = ["Restangular"];exports.default =
	
	VideoService;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _pageHomeVideo = __webpack_require__(602);var _pageHomeVideo2 = _interopRequireDefault(_pageHomeVideo);
	var _pageHomeVideo3 = __webpack_require__(603);var _pageHomeVideo4 = _interopRequireDefault(_pageHomeVideo3);
	__webpack_require__(590);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var pageHomeVideoComponent = {
	  bindings: {},
	  template: _pageHomeVideo2.default,
	  controller: _pageHomeVideo4.default };exports.default =
	
	
	pageHomeVideoComponent;

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\">\n          <div layout=\"row\">\n            <md-button class=\"md-raised md-accent mr-68\" ui-sref=\"page.new-video-home\">\n                {{ 'common-new-video' | translate }}\n            </md-button>\n          </div>\n\n          <md-card>\n              <div class=\"sb-table-search\">\n                  <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                  </md-icon>\n\n                  <input ng-model=\"$ctrl.filter.description\"\n                  ng-change=\"$ctrl.onChangeFilter()\"\n                      ng-model-options=\"{ debounce: 300 }\"\n                      type=\"text\" name=\"\">\n              </div>\n          </md-card>\n      </div>\n    <md-card\n      ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\"\n    >\n      <md-table-container>\n        <table md-table md-progress=\"$ctrl.promise\">\n          <thead md-head>\n            <tr md-row>\n              <th md-column>Título</th>\n              <th md-column>Status</th>\n              <th md-column>Abertura</th>\n              <th md-column>Região</th>\n              <th md-column>Data criação</th>\n              <th md-column style=\"width: 110px;\"></th>\n            </tr>\n          </thead>\n          <tbody md-body>\n            <tr md-row ng-repeat=\"item in $ctrl.resources.data\">\n              <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.detail(item.id)\">{{ item.description }}</td>\n              <td md-cell>{{ item.status ? 'Ativo' : 'Inativo' }}</td>\n              <td md-cell>{{ item.open_in_webview ? 'Webview' : 'Navegador' }}</td>\n\n              <td md-cell ng-click=\"$ctrl.detail(item.id)\">\n                  <div class=\"content-regions\">\n                      {{ item.regions.length ? $ctrl.getRegions(item.regions) : 'Todas' }}\n                  </div>\n              </td>\n              <td md-cell>{{ item.createdAt | momentFormat : 'DD/MM/YYYY' }}</td>\n              <td md-cell>\n                <md-button\n                title=\"Editar\"\n                type=\"button\"\n                class=\"md-icon-button\"\n                ng-click=\"$ctrl.detail(item.id)\"\n              >\n                <md-icon\n                  md-font-set=\"mdi\"\n                  md-font-icon=\"mdi-pencil\"\n                  class=\"mdi-24px\"\n                />\n              </md-button>\n                <md-button\n                  aria-label=\"Toolbar menu\"\n                  title=\"Remover vídeo\"\n                  type=\"button\"\n                  class=\"md-icon-button\"\n                >\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\" ng-click=\"$ctrl.deleteVideo(item)\">\n                </md-button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </md-table-container>\n      <md-table-pagination\n          md-limit=\"10\"\n          md-page=\"$ctrl.filter.page\"\n          md-total=\"{{ $ctrl.filter.total }}\"\n          md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n          md-on-paginate=\"$ctrl.loadData\"\n          >\n      </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY'\" class=\"sb-fill-parent\">\n      <div class=\"sb-empty-state sb-empty-state-text\" layout-align=\"center center\">\n        <p style=\"text-align: center;\">Não foram encontrados resultados.</p>\n      </div>\n    </div>\n\n    <div\n      ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n      class=\"sb-fill-parent\"\n    >\n      <div\n        class=\"sb-absolute-center sb-empty-state\"\n        layout=\"column\"\n        layout-align=\"center center\"\n      >\n        <div class=\"sb-empty-state-text\">\n          <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n        </div>\n      </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\" class=\"sb-fill-parent\">\n      <div\n        class=\"sb-absolute-center sb-empty-state\"\n        layout=\"column\"\n        layout-align=\"center center\"\n      >\n        <div class=\"sb-error-message\">{{ 'common-load-error' | translate}}</div>\n      </div>\n    </div>\n  </div>\n"

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var HomeVideoController = function HomeVideoController(
	$filter,
	$mdDialog,
	$scope,
	$state,
	$timeout,
	Video,
	Toast)
	{
	  var $ctrl = this;
	  _angular2.default.extend($ctrl, {});
	
	  $ctrl.filter = {
	    description: "",
	    page: 1,
	    total: 0 };
	
	
	  $ctrl.loadData = function () {
	    Video.getList($ctrl.filter).
	    then(function (response) {
	      $ctrl.resources = _angular2.default.copy(response);
	      $ctrl.filter.page = response.page;
	      $ctrl.filter.total = response.total;
	      $ctrl.uiState = response.data.length ? "COMPLETE" : "EMPTY";
	    }).
	    catch(function (err) {
	      console.log(err);
	      $ctrl.uiState = "ERROR";
	    });
	  };
	
	  $ctrl.getRegions = function (regionsList) {
	    var newList = [];
	    regionsList.forEach(function (item) {
	      if (!item.regions.length) {
	        newList.push(item.state);
	        return;
	      }
	      item.regions.forEach(function (region) {
	        newList.push(region.name + " - " + item.state);
	      });
	    });
	    return newList.join(", ");
	  };
	
	  $ctrl.onChangeFilter = function () {
	    $ctrl.filter.page = 1;
	    $ctrl.loadData();
	  };
	
	  function activate() {
	    $ctrl.loadData();
	  }
	
	  $ctrl.deleteVideo = function (item) {
	    var confirm = $mdDialog.
	    confirm().
	    textContent("Remover video \"" + item.description + "\"").
	    ariaLabel("Remover pop-up \"" + item.description + "\"").
	    targetEvent(event).
	    ok($filter("translate")("common-yes")).
	    cancel($filter("translate")("common-cancel"));
	
	    $mdDialog.
	    show(confirm).
	    then(function () {
	      Video.destroy(item).
	      then(function (response) {
	        Toast.success($filter("translate")("common-detail-delete-success"));
	        $ctrl.loadData();
	      }).
	      catch(function (err) {
	        Toast.error($filter("translate")("common-server-error"));
	      });
	    }).
	    catch(function () {});
	  };
	
	  $ctrl.detail = function (id) {
	    $state.go("page.view-video-home", { id: id });
	  };
	
	  activate();
	};
	
	HomeVideoController.$inject = [
	"$filter",
	"$mdDialog",
	"$scope",
	"$state",
	"$timeout",
	"Video",
	"Toast"];exports.default =
	
	
	HomeVideoController;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _pageNewHomeVideo = __webpack_require__(605);var _pageNewHomeVideo2 = _interopRequireDefault(_pageNewHomeVideo);
	var _pageNewHomeVideo3 = __webpack_require__(606);var _pageNewHomeVideo4 = _interopRequireDefault(_pageNewHomeVideo3);
	__webpack_require__(590);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var newHomeVideoComponent = {
	  bindings: {},
	  template: _pageNewHomeVideo2.default,
	  controller: _pageNewHomeVideo4.default };exports.default =
	
	
	newHomeVideoComponent;

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div class=\"sb-content sb-news\">\n      <div>\n          <md-card class=\"layout-padding\">\n              <div>\n                  <md-input-container class=\"md-block\" flex>\n                      <label>Título do banner</label>\n                      <input ng-model=\"$ctrl.data.description\" name=\"title\" required>\n                      </input>\n                  </md-input-container>\n\n                <div>\n                  <div>Status do Banner</div>\n                  <md-switch ng-model=\"$ctrl.data.status\" aria-label=\"Status\">\n                    Status\n                  </md-switch>\n                </div>\n                <div>\n                  <div>Abertura do Banner</div>\n                  <md-switch ng-model=\"$ctrl.data.open_in_webview\" aria-label=\"Abrir em Webview\">\n                    Abrir em Webview\n                  </md-switch>\n                </div>\n                <br>\n                <div>\n                  <md-input-container class=\"md-block\" flex>\n                    <label>\n                      Tipo de banner\n                    </label>\n                    <md-select ng-model=\"$ctrl.data.type\" required class=\"form-control\">\n                      <md-option value=\"\">Tipo de banner</md-option>\n                      <md-option value=\"IMAGE\">Imagem</md-option>\n                      <md-option value=\"VIDEO\">Vídeo</md-option>\n                    </md-select>\n\n                    <div ng-messages=\"$ctrl.data.$error\" multiple>\n                      <div ng-message=\"required\">\n                        {{ 'form-error-required-field' | translate}}\n                      </div>\n                    </div>\n                  </md-input-container>\n                </div>\n                <div ng-if=\"$ctrl.data.type == 'VIDEO'\" flex=\"100\" class=\"layout-padding\">\n                  <span class=\"sb-page-section-title\">Vídeo para tela Home do aplicativo</span>\n                  <p class=\"sb-page-section-sub-title\">\n                    Defina o vídeo que será exibido na tela home do aplicativo juntamente dos demais serviços Sabin. <br>\n                    O formato do vídeo deve ser: .mp4  .3gp .webm ou .ts com o codec H.264/AAC.\n                  </p>\n                </div>\n\n                  <md-input-container class=\"md-block\" flex>\n                      <label>URL do Banner</label>\n                      <input ng-model=\"$ctrl.data.banner_url\" name=\"urlImage\" required>\n                  </md-input-container>\n                  <md-input-container class=\"md-block\" flex>\n                      <label>URL redirecionamento (opcional)</label>\n                      <input ng-model=\"$ctrl.data.url\" name=\"url\" type=\"url\">\n                  </md-input-container>\n\n                  <div class=\"title-filter\" layout=\"row\" flex>\n                    <label style=\"font-weight: 500;\">{{ 'notification-detail-filer-public' | translate }}</label>\n                  </div>\n                  <div layout=\"row\">\n                    <md-input-container class=\"md-block\" flex>\n                      <label> {{ $ctrl.campaignPopUp.only_vaccine_regions === null ? ('common-state' | translate) : 'Não se aplica' }} </label>\n                      <md-select\n                        ng-model=\"$ctrl.data.state_id\"\n                        ng-change=\"$ctrl.onChangeState($ctrl.filter.state_id, true)\"\n                        name=\"state\"\n                        multiple\n                        md-on-close=\"$ctrl.clearSearch()\"\n                        md-container-class=\"selectdemoSelectHeader\"\n                        ng-disabled=\"$ctrl.disableSelect() || $ctrl.disabledFilterStateCities\"\n                      >\n                        <md-select-header layout=\"column\" class=\"demo-select-header\">\n                          <md-input-container class=\"md-block\" flex>\n                            <input\n                              ng-model=\"$ctrl.searchState\"\n                              type=\"text\"\n                              ng-model-options=\"{debounce: {'default': 250, 'blur': 0}}\"\n                              ng-change=\"$ctrl.filterContent($ctrl.searchState, 'states')\"\n                              class=\"md-text input-search-state\"\n                              placeholder=\"Buscar estados\"\n                            />\n                          </md-input-container>\n                        </md-select-header>\n\n                        <md-optgroup label=\"state\">\n                          <md-option\n                            ng-value=\"null\"\n                            ng-click=\"$ctrl.setListContent(null, $ctrl.selectedStates)\"\n                          >\n                            {{ 'common-all-masculine' | translate }}\n                          </md-option>\n\n                          <md-option\n                            ng-selected=\"$ctrl.data.state_id.includes(state.id.toString())\n                                          && !$ctrl.data.state_id.includes(null)\"\n                            ng-click=\"$ctrl.setListContent(state.name, $ctrl.selectedStates)\"\n                            ng-disabled=\"$ctrl.data.state_id.includes(null)\"\n                            ng-repeat=\"state in $ctrl.states\"\n                            ng-value=\"state.id.toString()\"\n                          >\n                            {{ state.name }}\n                          </md-option>\n                        </md-optgroup>\n                      </md-select>\n\n                      <div ng-messages=\"notificationForm.state.$error\" multiple>\n                        <div ng-message=\"required\">\n                          {{ 'form-error-required-field' | translate}}\n                        </div>\n                      </div>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\" flex>\n                      <label>{{ $ctrl.campaignPopUp.only_vaccine_regions === null ? ('common-city' | translate) : 'Não se aplica' }} </label>\n\n                      <md-select\n                        ng-model=\"$ctrl.data.city_id\"\n                        name=\"city\"\n                        multiple\n                        md-on-close=\"$ctrl.clearSearch()\"\n                        md-container-class=\"selectdemoSelectHeader\"\n                        ng-disabled=\"$ctrl.disabledFilterStateCities\"\n                      >\n                        <md-select-header layout=\"column\" class=\"demo-select-header\">\n                          <md-input-container class=\"md-block\" flex>\n                            <input\n                              ng-model=\"$ctrl.search\"\n                              type=\"text\"\n                              ng-model-options=\"{debounce: {'default': 250, 'blur': 0}}\"\n                              class=\"demo-header-searchbox md-text input-search-city\"\n                              ng-change=\"$ctrl.filterContent($ctrl.search, 'cities')\"\n                              placeholder=\"Buscar cidades\"\n                            />\n                          </md-input-container>\n                        </md-select-header>\n\n                        <md-optgroup label=\"city\">\n                          <md-option\n                            ng-value=\"null\"\n                            ng-click=\"$ctrl.setListContent(null, $ctrl.selectedCities)\"\n                          >\n                            {{ 'common-all-masculine' | translate }}\n                          </md-option>\n\n                          <md-option\n                            ng-selected=\"$ctrl.data.city_id.includes(city.id.toString())\n                                          && !$ctrl.data.city_id.includes(null)\"\n                            ng-disabled=\"$ctrl.data.city_id.includes(null)\"\n                            ng-click=\"$ctrl.setListContent(city.name, $ctrl.selectedCities)\"\n                            ng-repeat=\"city in $ctrl.cities\"\n                            ng-value=\"city.id.toString()\"\n                            >{{ city.name }}\n                          </md-option>\n                        </md-optgroup>\n                      </md-select>\n\n                      <div ng-messages=\"notificationForm.city.$error\" multiple>\n                        <div ng-message=\"required\">\n                          {{ 'form-error-required-field' | translate}}\n                        </div>\n                      </div>\n                    </md-input-container>\n                  </div>\n              <div>\n                  <div ng-if=\"$ctrl.data.state_id.length\">\n                    <div>Total de Estados: <span><strong>{{ $ctrl.data.state_id.includes(null) ? \"Todos\" : $ctrl.data.state_id.length }}</strong></span></div>\n                    <div ng-if=\"!$ctrl.data.state_id.includes(null)\"><strong>{{ $ctrl.getStateNames() }}</strong></div>\n                  </div>\n\n                  <div ng-if=\"$ctrl.data.city_id.length\">\n                    <div>Total de Cidades: <span><strong>{{$ctrl.data.city_id.includes(null) ? \"Todas\" : $ctrl.data.city_id.length }}</strong></span></div>\n                    <div ng-if=\"!$ctrl.data.city_id.includes(null)\"><strong>{{ $ctrl.getCitiesNames() }}</strong></div>\n                  </div>\n              </div>\n            </div>\n          </md-card>\n          <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n              <md-button page-back>\n                  {{ 'common-cancel-button-text' | translate }}\n              </md-button>\n\n              <md-button ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\"\n                  ng-disabled=\"!$ctrl.data.banner_url || !$ctrl.data.description || (!$ctrl.data.type || $ctrl.data.type == '')\">\n                  {{ 'common-save-button-text' | translate }}\n              </md-button>\n          </div>\n      </div>\n  </div>\n</div>\n"

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var NewVideoController = function NewVideoController(
	$filter,
	$mdDialog,
	$scope,
	$state,
	$timeout,
	Video,
	State,
	City,
	Toast)
	{
	  var $ctrl = this;
	  _angular2.default.extend($ctrl, {
	    save: save,
	    onChangeState: onChangeState });
	
	
	  $ctrl.id = $state.params.id;
	  $ctrl.states = [];
	  $ctrl.cities = [];
	
	  $ctrl.data = {
	    description: "",
	    status: false,
	    open_in_webview: false,
	    banner_url: "",
	    url: "",
	    type: "",
	    state_id: [],
	    city_id: [] };
	
	
	  function loadResource(id) {
	    State.index({ limit: 10000000000 }).
	    then(function (result) {
	      $ctrl.states = result;
	      if (id) {
	        Video.getVideo(id).
	        then(function (response) {
	          $ctrl.data.id = response.id;
	          $ctrl.data.description = response.description;
	          $ctrl.data.status = response.status;
	          $ctrl.data.open_in_webview = Boolean(response.open_in_webview);
	          $ctrl.data.type = response.type;
	          $ctrl.data.banner_url = response.banner_url;
	          $ctrl.data.url = response.url;
	          if (response.regions.length) {
	            var _result = getStateCities(response.regions);
	            $ctrl.data.state_id = _angular2.default.copy(_result.states);
	            $ctrl.data.city_id = _angular2.default.copy(_result.cities);
	          } else
	          {
	            $ctrl.data.state_id = [null];
	            $ctrl.data.city_id = [null];
	          }
	          onChangeState();
	        }).
	        catch(function (err) {
	          $ctrl.uiState = "ERROR";
	        });
	      }
	    }).
	    catch(function (err) {
	      console.log("err:", err);
	      $ctrl.uiState = "ERROR";
	    });
	  }
	
	  function getStateCities(regions) {
	    var cities = [];
	    var states = [];
	    regions.forEach(function (state) {
	      states.push(state.id.toString());
	      state.regions.forEach(function (region) {
	        cities.push(region.id.toString());
	      });
	    });
	
	    return {
	      cities: cities,
	      states: states };
	
	  }
	
	  function onChangeState(stateIdArr) {var clearCities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    if ($ctrl.data.state_id.length !== 0) {
	      var lastPosition = $ctrl.data.state_id.length - 1;
	      if (
	      $ctrl.data.state_id.includes(null) &&
	      $ctrl.data.state_id[lastPosition] === null &&
	      lastPosition !== 0)
	      {
	        $ctrl.data.state_id = [null];
	        if (clearCities) $ctrl.data.city_id = [null];
	        return;
	      } else if (
	      $ctrl.data.state_id[0] === null &&
	      $ctrl.data.state_id.length > 1)
	      {
	        $ctrl.data.state_id.split(0, 1);
	      }
	
	      City.index({
	        state_id: $ctrl.data.state_id,
	        limit: 1000000 }).
	
	      then(function (cities) {
	        $ctrl.cities = cities;
	      }).
	      catch(function (err) {
	        console.log("err:", err);
	        $ctrl.loadingCities = false;
	      }).
	      finally(function () {
	        _angular2.default.
	        element(document.querySelector(".input-search-city")).
	        on("keydown", function (ev) {
	          ev.stopPropagation();
	        });
	      });
	    }
	
	    if (clearCities) {
	      $ctrl.search = "";
	      $ctrl.data.city_id = [];
	      $ctrl.cities = [];
	    }
	  }
	
	  $ctrl.getStateNames = function () {
	    var map = $ctrl.data.state_id.map(function (_id) {
	      var idx = $ctrl.states.findIndex(
	      function (_ref) {var id = _ref.id;return _id.toString() === id.toString();});
	
	      if (idx > -1) return $ctrl.states[idx].name;else
	      return "";
	    });
	    return map.join(", ");
	  };
	
	  $ctrl.getCitiesNames = function () {
	    var map = $ctrl.data.city_id.map(function (_id) {
	      var idx = $ctrl.cities.findIndex(
	      function (_ref2) {var id = _ref2.id;return _id.toString() === id.toString();});
	
	      if (idx > -1) return $ctrl.cities[idx].name;else
	      return "";
	    });
	    return map.join(", ");
	  };
	
	  function activate() {
	    loadResource($ctrl.id);
	  }
	
	  function save() {
	    var data = _angular2.default.copy($ctrl.data);
	    if (data.state_id.includes(null)) {
	      delete data.state_id;
	    } else {
	      data.state_id = data.state_id.map(function (item) {return Number(item);});
	    }
	
	    if (data.city_id.includes(null)) {
	      delete data.city_id;
	    } else {
	      data.city_id = data.city_id.map(function (item) {return Number(item);});
	    }
	
	    Video.save(data).
	    then(function (response) {
	      $state.go("page.video-home");
	    }).
	    catch(function (err) {
	      Toast.error(err.data.message);
	      $ctrl.uiState = "ERROR";
	    });
	  }
	
	  activate();
	};
	
	NewVideoController.$inject = [
	"$filter",
	"$mdDialog",
	"$scope",
	"$state",
	"$timeout",
	"Video",
	"State",
	"City",
	"Toast"];exports.default =
	
	
	NewVideoController;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _region = __webpack_require__(608);var _region2 = _interopRequireDefault(_region);
	var _regionList = __webpack_require__(613);var _regionList2 = _interopRequireDefault(_regionList);
	var _regionDetail = __webpack_require__(616);var _regionDetail2 = _interopRequireDefault(_regionDetail);
	var _region3 = __webpack_require__(620);var _region4 = _interopRequireDefault(_region3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var regionModule = _angular2.default.module('region', [
	_angularUiRouter2.default]).
	
	
	service('Region', _region4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/region');
	
	  $stateProvider.
	  state('region', {
	    component: 'region' }).
	
	  state('region.list', {
	    url: '/region',
	    component: 'regionList' }).
	
	  state('region.create', {
	    url: '/region/new',
	    component: 'regionDetail',
	    params: {
	      id: "" } }).
	
	
	  state('region.edit', {
	    url: '/region/:id/edit',
	    component: 'regionDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('region', _region2.default).
	component('regionList', _regionList2.default).
	component('regionDetail', _regionDetail2.default).
	
	name;exports.default =
	
	regionModule;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _region = __webpack_require__(609);var _region2 = _interopRequireDefault(_region);
	var _region3 = __webpack_require__(610);var _region4 = _interopRequireDefault(_region3);
	__webpack_require__(611);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var regionComponent = {
	  bindings: {},
	  template: _region2.default,
	  controller: _region4.default };exports.default =
	
	
	regionComponent;

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 610 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var RegionController =
	function RegionController() {_classCallCheck(this, RegionController);
	  this.name = 'region';
	};exports.default =
	
	
	RegionController;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(612);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./region.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./region.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".region{color:red}.pre_attendance{width:1px;padding:0!important}.pre_attendance .pre_attendance-icon{font-size:24px;margin:auto;position:relative;display:block;width:fit-content}.label-pre-attendance{top:-49px;font-size:13px}#addSpecialSchedules{text-transform:none}#addSpecialSchedules .schedules-header-icon{color:#b90a00}", ""]);
	
	// exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _regionList = __webpack_require__(614);var _regionList2 = _interopRequireDefault(_regionList);
	var _regionList3 = __webpack_require__(615);var _regionList4 = _interopRequireDefault(_regionList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var regionListComponent = {
	  bindings: {},
	  template: _regionList2.default,
	  controller: _regionList4.default };exports.default =
	
	
	regionListComponent;

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\"\n         ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n        <md-button class=\"md-raised md-accent\" ui-sref=\"region.create\">\n            {{ 'common-new-masculine' | translate }}\n        </md-button>\n\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'common-name' | translate }}\n                    </th>\n\n                    <th md-column md-numeric>\n                        {{ 'common-phone-number' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'common-updated-at' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"accept_pre_attendance\"\n                        ng-click=\"$ctrl.orderList('accept_pre_attendance')\">\n                        {{ 'common-pre-attendance' | translate }}\n                    </th>\n\n                    <th md-column md-numeric class=\"sb-table-column-xs\">\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit(resource.id)\">\n                    <td md-cell class=\"sb-table-truncate\">\n                        {{ resource.name }}\n                    </td>\n\n                    <td md-cell>\n                        {{ resource.phone_number }}\n                    </td>\n\n                    <td md-cell>\n                        {{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n\n                    <td md-cell class=\"pre_attendance\">\n                        <md-icon class=\"pre_attendance-icon\" ng-show=\"!resource.accept_pre_attendance\" md-font-set=\"mdi\" md-font-icon=\"mdi-checkbox-blank-circle-outline\" class=\"mdi-24px schedules-header-icon\"></md-icon>\n                        <md-icon class=\"pre_attendance-icon\" ng-show=\"resource.accept_pre_attendance\" md-font-set=\"mdi\" md-font-icon=\"mdi-checkbox-marked-circle\" class=\"mdi-24px schedules-header-icon\"></md-icon>\n                    </td>\n\n                    <td md-cell>\n                        <md-button aria-label=\"Toolbar menu\"\n                                   class=\"md-icon-button\"\n                                   ng-click=\"$ctrl.handleDelete(resource, $event)\">\n                          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'region-list-empty-state-line-1' | translate }}</p>\n                <p>{{ 'region-list-empty-state-line-2' | translate }}</p>\n            </div>\n\n            <md-button class=\"md-raised md-accent\" ui-sref=\"region.create\">\n                {{ 'region-list-create-region-button' | translate }}\n            </md-button>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var RegionListController = function RegionListController(Region, $filter, $scope, $state, $mdDialog, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name',
	      like_search: '',
	      like_search_fields: [
	      'name',
	      'phone_number'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function edit(id) {
	    $state.go('region.edit', { id: id });
	  }
	
	  function handleDelete(resource, event) {
	    event.stopPropagation();
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Region.
	      destroy(resource).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        _.remove($ctrl.resources.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Region.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	RegionListController.$inject = ['Region', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];exports.default =
	
	RegionListController;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _regionDetail = __webpack_require__(617);var _regionDetail2 = _interopRequireDefault(_regionDetail);
	var _regionDetail3 = __webpack_require__(618);var _regionDetail4 = _interopRequireDefault(_regionDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var regionDetailComponent = {
	  bindings: {},
	  template: _regionDetail2.default,
	  controller: _regionDetail4.default };exports.default =
	
	
	regionDetailComponent;

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div class=\"sb-content sb-region\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n    <form\n      name=\"regionForm\"\n      ng-submit=\"$ctrl.handleSave(regionForm, $ctrl.region)\"\n      novalidate\n    >\n      <!-- region -->\n      <div layout=\"column\" class=\"sb-page-section\">\n        <h3 class=\"sb-page-section-title\">\n          {{ 'region-detail-title' | translate }}\n        </h3>\n\n        <p class=\"sb-page-section-sub-title\">\n          {{ 'region-detail-title-caption' | translate }}\n        </p>\n\n        <md-card>\n          <!-- name -->\n          <div layout=\"row\" flex>\n            <md-input-container class=\"md-block\" flex>\n              <label> {{ 'common-name' | translate }} </label>\n\n              <input ng-model=\"$ctrl.region.name\" name=\"name\" required />\n\n              <div ng-messages=\"regionForm.name.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n\n                <div ng-message=\"md-maxlength\">\n                  {{ 'region-detail-form-error-title-max-length' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n          </div>\n\n          <!-- phone_number -->\n          <div layout=\"row\" flex>\n            <md-input-container class=\"md-block\" flex>\n              <label> {{ 'common-phone-number' | translate }} </label>\n\n              <input\n                ng-model=\"$ctrl.region.phone_number\"\n                name=\"phone_number\"\n                required\n              />\n\n              <div ng-messages=\"regionForm.phone_number.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n\n                <div ng-message=\"md-maxlength\">\n                  {{ 'region-detail-form-error-title-max-length' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n          </div>\n\n          <!-- pre_attendance -->\n          <div layout=\"row\" flex>\n            <md-input-container class=\"md-block\" flex>\n              <label class=\"label-pre-attendance\">\n                {{ 'common-pre-attendance' | translate }}\n              </label>\n\n              <md-checkbox\n                ng-model=\"$ctrl.region.accept_pre_attendance\"\n                aria-label=\"Checkbox 1\"\n              >\n                {{ $ctrl.region.accept_pre_attendance ?\n                'common-accept-pre-attendance' :\n                'common-no-accept-pre-attendance' | translate }}\n              </md-checkbox>\n            </md-input-container>\n          </div>\n        </md-card>\n      </div>\n\n      <div layout=\"column\" class=\"sb-page-section\">\n        <h3 class=\"sb-page-section-title\">\n          {{ 'region-detail-modal-title-opening-hours' | translate }}\n        </h3>\n\n        <md-card layout=\"column\" layout-padding>\n          <md-card-title layout=\"row\" layout-align=\"space-between center\">\n            <div>\n              <md-icon\n                md-font-set=\"mdi\"\n                md-font-icon=\"mdi-information\"\n                class=\"mdi-18px\"\n              ></md-icon>\n              <small\n                >{{ 'region-detail-section-title-date-info' | translate\n                }}</small\n              >\n            </div>\n\n            <md-button ng-show=\"$ctrl.isManager\">\n              <span id=\"syncHoursGMB\">\n                <md-icon\n                  md-font-set=\"mdi\"\n                  md-font-icon=\"mdi-sync\"\n                  class=\"mdi-24px schedules-header-icon\"\n                ></md-icon>\n                {{ 'unit-detail-sync-gmb' | translate }}\n              </span>\n            </md-button>\n\n            <md-button ng-click=\"showPrerenderedDialog($event)\">\n              <span id=\"addSpecialSchedules\">\n                <md-icon\n                  md-font-set=\"mdi\"\n                  md-font-icon=\"mdi-calendar\"\n                  class=\"mdi-24px schedules-header-icon\"\n                ></md-icon>\n                {{ 'unit-detail-add-special-hours' | translate }}\n              </span>\n            </md-button>\n          </md-card-title>\n\n          <div class=\"mt-3\">\n            <md-table-container>\n              <md-progress-linear\n                ng-show=\"$ctrl.isLoading\"\n                md-mode=\"indeterminate\"\n                value=\"30\"\n              ></md-progress-linear>\n\n              <table md-table>\n                <thead md-head class=\"text-18\">\n                  <tr md-row>\n                    <th md-column>\n                      {{'region-list-table-header-name' | translate }}\n                    </th>\n\n                    <th md-column>\n                      {{ 'region-list-table-header-first-date' | translate }}\n                    </th>\n\n                    <th md-column>\n                      {{ 'region-list-table-header-last-date' | translate }}\n                    </th>\n\n                    <th md-column>\n                      {{ 'region-list-table-header-quantity' | translate }}\n                    </th>\n                  </tr>\n                </thead>\n\n                <tbody md-body>\n                  <tr\n                    md-row\n                    ng-repeat=\"(idx, resource) in $ctrl.specialHours\"\n                    ng-click=\"$ctrl.edit(resource.id)\"\n                    ng-if=\"resource.days > 0\"\n                  >\n                    <td md-cell class=\"sb-table-truncate\">\n                      {{ resource.name }}\n                    </td>\n\n                    <td md-cell>{{ $ctrl.formatDate(resource.first_date) }}</td>\n\n                    <td md-cell>{{ $ctrl.formatDate(resource.last_date)}}</td>\n\n                    <td md-cell style=\"text-align: center\">\n                      {{ resource.days }} dias\n\n                      <span>\n                        <md-icon\n                          md-font-set=\"mdi\"\n                          ng-attr-title=\"{{ $ctrl.getDates(resource.special_hours).join('&#013;')}}\"\n                          md-font-icon=\"mdi-information\"\n                          class=\"mdi-24px\"\n                        >\n                        </md-icon>\n                      </span>\n                    </td>\n\n                    <td\n                      md-cell\n                      ng-click=\"showPrerenderedDialog($event, resource, idx)\"\n                    >\n                      <md-button\n                        aria-label=\"Toolbar menu\"\n                        class=\"md-icon-button\"\n                      >\n                        <md-icon\n                          md-font-set=\"mdi\"\n                          md-font-icon=\"mdi-pencil\"\n                          class=\"mdi-24px\"\n                        ></md-icon>\n                      </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </md-table-container>\n          </div>\n        </md-card>\n      </div>\n\n      <!-- form actions -->\n      <div\n        layout=\"row\"\n        layout-align=\"end center\"\n        flex\n        class=\"sb-form-actions after-card\"\n      >\n        <md-button page-back ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n          {{ 'common-cancel-button-text' | translate }}\n        </md-button>\n\n        <md-button\n          ng-click=\"$ctrl.handleDelete($ctrl.region, $event)\"\n          ng-if=\"$ctrl.id && !$ctrl.region.is_super\"\n          ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n          class=\"md-warn md-raised\"\n        >\n          {{ 'common-delete-button-text' | translate }}\n        </md-button>\n\n        <md-button\n          ng-click=\"$ctrl.clearForm(regionForm)\"\n          ng-if=\"!$ctrl.id\"\n          ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n          class=\"md-raised\"\n        >\n          {{ 'common-clear-button-text' | translate }}\n        </md-button>\n\n        <md-button\n          type=\"submit\"\n          ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n          class=\"md-accent md-raised\"\n        >\n          {{ $ctrl.saving ? 'common-save-button-loading-text' :\n          'common-save-button-text' | translate }}\n        </md-button>\n      </div>\n    </form>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\" class=\"sb-fill-parent\">\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-error-message\">{{ 'common-load-error' | translate}}</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _specialHourSchedule = __webpack_require__(619);var _specialHourSchedule2 = _interopRequireDefault(_specialHourSchedule);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var RegionDetailController = function RegionDetailController(
	$filter,
	$mdDialog,
	$scope,
	$state,
	Toast,
	Region)
	{
	  DialogController.$inject = ["$scope", "$mdDialog", "specialHours", "idx"];
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.region;
	  $ctrl.specialHours = [];
	  $ctrl.events = [];
	  $ctrl.specialHoursBody = {};
	  $ctrl.isLoading = false;
	
	  function DialogController($scope, $mdDialog, specialHours, idx) {
	    "ngInject";
	
	    if (specialHours) {
	      $scope.specialHoursBody = {
	        special_hours: _angular2.default.copy(specialHours.special_hours),
	        name: specialHours.name,
	        is_priority: specialHours.is_priority,
	        id: specialHours.id };
	
	
	      $scope.specialHoursBody.special_hours.forEach(function (hour) {
	        hour.date = new Date(hour.date);
	      });
	    } else {
	      $scope.specialHoursBody = {
	        name: "",
	        special_hours: [
	        {
	          date: new Date(),
	          flag: false,
	          description: "" }] };
	
	
	
	    }
	
	    $scope.addOpeningHour = function () {
	      $scope.specialHoursBody.special_hours.push({
	        date: new Date(),
	        flag: false,
	        description: "" });
	
	    };
	
	    $scope.handleSpecialHoursDelete = function (date) {
	      if (date.id) {
	        Region.deleteSpecialHours(date).
	        then(function (response) {
	          loadResource($ctrl.id);
	          $mdDialog.hide();
	        }).
	        catch(function (err) {
	          console.log("err:", err);
	          $ctrl.uiState = "ERROR";
	        });
	      } else {
	        _.remove($scope.specialHoursBody.special_hours, {
	          $$hashKey: date.$$hashKey });
	
	      }
	    };
	
	    $scope.createOrEditSpecialHour = function () {
	      saveSpecialHours(_angular2.default.copy($scope.specialHoursBody), idx);
	      $mdDialog.hide();
	    };
	  }
	
	  function sendSpecialHours(resource) {
	    $ctrl.isLoading = true;
	    Region.createSpecialHours(resource, $ctrl.id || $ctrl.region.id).
	    then(function (response) {
	      $ctrl.specialHoursBody = { name: "", special_hours: [] };
	    }).
	    catch(function (err) {
	      console.log("err:", err);
	      $ctrl.uiState = "ERROR";
	    }).
	    finally(function () {
	      $ctrl.isLoading = false;
	      $ctrl.id ?
	      loadResource($ctrl.id || $ctrl.region.id) :
	      $state.go("region.list");
	    });
	  }
	
	  $ctrl.resource = null;
	  function saveSpecialHours(resource) {var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    if (resource.length) {
	      $ctrl.resource = _angular2.default.copy(resource);
	    } else {
	      $ctrl.resource = resource.id ?
	      _angular2.default.copy(resource) :
	      [_angular2.default.copy(resource)];
	    }
	
	    if ($ctrl.id) {
	      sendSpecialHours($ctrl.resource);
	    } else {
	      var dates = resource.special_hours.map(function (date) {
	        return date.date;
	      });
	      var orderedDates = dates.sort(function (a, b) {
	        return Date.parse(a) - Date.parse(b);
	      });
	
	      var event = {
	        name: resource.name,
	        first_date: orderedDates[0],
	        last_date: orderedDates[orderedDates.length - 1],
	        days: resource.special_hours.length,
	        special_hours: _angular2.default.copy(resource.special_hours) };
	
	
	      if (typeof idx === 'number') {
	        $ctrl.specialHours[idx] = _angular2.default.copy(event);
	        $ctrl.events[idx] = _angular2.default.copy(resource);
	
	      } else
	      {
	        $ctrl.specialHours.push(event);
	        $ctrl.events.push(resource);
	      }
	    }
	  }
	
	  $scope.showPrerenderedDialog = function (ev, resource) {var idx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    $ctrl.selectedSpecialHour = resource;
	
	    $mdDialog.show({
	      controller: DialogController,
	      bindToController: true,
	      template: _specialHourSchedule2.default,
	      parent: _angular2.default.element(document.body),
	      targetEvent: ev,
	      clickOutsideToClose: true,
	      locals: { specialHours: _angular2.default.copy(resource), idx: idx } });
	
	  };
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete,
	    formatDate: formatDate });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	    loadResource($ctrl.id);
	  }
	
	  function clearForm(form) {
	    $ctrl.region = {};
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(region, event) {
	    var confirmMessage = "region-detail-delete-confirm-text";
	
	    var confirm = $mdDialog.
	    confirm().
	    textContent($filter("translate")(confirmMessage)).
	    ariaLabel($filter("translate")(confirmMessage)).
	    targetEvent(event).
	    ok($filter("translate")("common-yes")).
	    cancel($filter("translate")("common-cancel"));
	
	    $mdDialog.
	    show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Region.destroy(region).
	      then(function (response) {
	        Toast.success($filter("translate")("region-detail-delete-success"));
	        $ctrl.deleting = false;
	        $state.go("region.list");
	      }).
	      catch(function (err) {
	        Toast.error($filter("translate")("common-server-error"));
	        console.log("err:", err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {});
	  }
	
	  function handleSave(form, region) {
	    if (!form.$valid) {
	      Toast.error($filter("translate")("common-form-incomplete"));
	      return;
	    }
	
	    save(region);
	  }
	  $ctrl.getDates = function (special_hours) {
	    var dates = (special_hours.special_hours || special_hours).map(function (special_hour) {
	      return $ctrl.formatDate(special_hour.date);
	    });
	    return dates;
	  };
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = "LOADING";
	
	      Region.show(id).
	      then(function (response) {
	        $ctrl.region = response;
	        $ctrl.uiState = "COMPLETE";
	      }).
	      catch(function (err) {
	        console.log("err:", err);
	        $ctrl.uiState = "ERROR";
	      }).
	      finally(function () {
	        $ctrl.isLoading = true;
	
	        Region.getSpecialHours(id).
	        then(function (response) {
	          $ctrl.specialHours = response;
	          $ctrl.isLoading = false;
	        }).
	        catch(function (err) {
	          console.log("err:", err);
	          $ctrl.uiState = "ERROR";
	        }).
	        finally(function () {return $ctrl.uiState = "COMPLETE";});
	      });
	    } else {
	      $ctrl.uiState = "COMPLETE";
	    }
	  }
	
	  function loadDomainResources() {
	    $ctrl.uiState = "LOADING";
	
	    var promises = [];
	
	    promises.push(Module.index());
	
	    return Promise.all(promises);
	  }
	
	  function save(region) {
	    $ctrl.saving = true;
	
	    Region.save(region).
	    then(function (response) {
	      Toast.success($filter("translate")("region-detail-save-success"));
	      $ctrl.region = response;
	      $ctrl.saving = false;
	    }).
	    catch(function (err) {
	      var defaultErrMsg = "common-server-error";
	      var fourONineMsg = "region-detail-409-error";
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter("translate")(message));
	      console.log("err:", err);
	      $ctrl.saving = false;
	    }).
	    finally(function () {
	      if (!$ctrl.id) {
	        sendSpecialHours($ctrl.events);
	      } else {
	        $state.go("region.list");
	      }
	    });
	  }
	
	  function formatDate(date) {
	    return new Intl.DateTimeFormat(navigator.language).format(new Date(date));
	  }
	};
	
	RegionDetailController.$inject = [
	"$filter",
	"$mdDialog",
	"$scope",
	"$state",
	"Toast",
	"Region"];exports.default =
	
	
	RegionDetailController;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog\n  layout-padding\n  style=\"width: 600px\"\n  class=\"sb-ui-cropper-dialog modal-special-schedules\"\n>\n  <md-dialog-content>\n    <div>\n      <h3 class=\"sb-page-section-title\">\n        {{ 'region-detail-modal-title-opening-hours' | translate }}\n      </h3>\n\n      <p class=\"sb-page-section-sub-title\">\n        {{ 'region-detail-modal-caption' | translate }}\n      </p>\n    </div>\n\n    <form>\n      <div layout=\"column\">\n        <md-input-container class=\"md-block mb-0\" flex>\n          <label>Nome do evento</label>\n          <input ng-model=\"specialHoursBody.name\" name=\"name\" required />\n        </md-input-container>\n\n        <div\n          layout=\"column\"\n          ng-repeat=\"(index, specialHour) in specialHoursBody.special_hours\"\n        >\n          <div\n            class=\"schedule-week_day\"\n            layout=\"row\"\n            layout-align=\"start center\"\n          >\n            <strong>\n              <input\n                time=\"false\"\n                date=\"true\"\n                mdc-datetime-picker=\"\"\n                type=\"text\"\n                id=\"date\"\n                day-of-week-len=\"3\"\n                placeholder=\"00/00/0000\"\n                click-outside-to-close=\"true\"\n                today-btn=\"false\"\n                format=\"DD/MM/yyyy\"\n                ng-model=\"specialHour.date\"\n                class=\"md-input ml-10\"\n              />\n            </strong>\n\n            <div class=\"ml-10 mt-0 schedule-toggle\" flex=\"20\">\n              <md-switch\n                class=\"mt-0\"\n                ng-change=\"activeStatus(resource)\"\n                ng-model=\"specialHour.flag\"\n                aria-label=\"Active\"\n              ></md-switch>\n            </div>\n          </div>\n\n          <div layout=\"row\" layout-align=\"space-between center\" layout-padding>\n            <textarea\n              flex=\"90\"\n              ng-model=\"specialHour.description\"\n              rows=\"3\"\n            ></textarea>\n\n            <md-icon\n              md-font-set=\"mdi\"\n              md-font-icon=\"mdi-delete\"\n              class=\"mdi-24px icon-red\"\n              style=\"cursor: pointer\"\n              ng-click=\"handleSpecialHoursDelete(specialHour)\"\n            >\n            </md-icon>\n          </div>\n        </div>\n      </div>\n\n      <md-dialog-actions\n        class=\"my-md-dialog-actions mt-3\"\n        layout=\"row\"\n        layout-align=\"space-between\"\n      >\n        <md-button class=\"my-md-button\" ng-click=\"addOpeningHour()\">\n          Adicionar nova data\n        </md-button>\n\n        <md-button\n          class=\"my-md-button\"\n          type=\"button\"\n          ng-click=\"createOrEditSpecialHour()\"\n          ng-disabled=\"!specialHoursBody.name || specialHoursBody.special_hours.length < 1\"\n          class=\"md-accent\"\n        >\n          Salvar\n        </md-button>\n      </md-dialog-actions>\n    </form>\n  </md-dialog-content>\n</md-dialog>\n"

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {"use strict";Object.defineProperty(exports, "__esModule", { value: true });var RegionService = function RegionService(Restangular) {
	  var Service = Restangular.all("admin/region");
	  var RegionEvent = Restangular.all("v2/admin/events");
	
	  var getSpecialHours = function getSpecialHours(id) {
	    return RegionEvent.get("region/" + id);
	  };
	
	  var createSpecialHours = function createSpecialHours(postBody, id) {
	    return postBody.id ?
	    RegionEvent.customPUT(postBody, postBody.id) :
	    RegionEvent.customPOST(postBody, "region/" + id);
	  };
	
	  var deleteSpecialHours = function deleteSpecialHours(date) {
	    return Restangular.one(
	    "v2/admin/special_hours",
	    date.id).
	    remove();
	  };
	
	  var count = function count(query) {
	    query = query || {};
	    query.deleted_at = "null";
	    return Service.customGET("count", query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = "null";
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query = query || {};
	    query.deleted_at = "null";
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return {
	    index: index,
	    load: load,
	    save: save,
	    show: show,
	    destroy: destroy,
	    getSpecialHours: getSpecialHours,
	    createSpecialHours: createSpecialHours,
	    deleteSpecialHours: deleteSpecialHours };
	
	};
	
	RegionService.$inject = ["Restangular"];exports.default =
	
	RegionService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _unit = __webpack_require__(622);var _unit2 = _interopRequireDefault(_unit);
	var _unitAuthenticationGoogle = __webpack_require__(627);var _unitAuthenticationGoogle2 = _interopRequireDefault(_unitAuthenticationGoogle);
	var _unitList = __webpack_require__(630);var _unitList2 = _interopRequireDefault(_unitList);
	var _unitDetail = __webpack_require__(638);var _unitDetail2 = _interopRequireDefault(_unitDetail);
	var _unit3 = __webpack_require__(645);var _unit4 = _interopRequireDefault(_unit3);
	var _unitDetail3 = __webpack_require__(646);var _unitDetail4 = _interopRequireDefault(_unitDetail3);
	var _timeTitle = __webpack_require__(647);var _timeTitle2 = _interopRequireDefault(_timeTitle);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var unitModule = _angular2.default.module('unit', [
	_angularUiRouter2.default]).
	
	
	service('Unit', _unit4.default).
	service('UnitDetail', _unitDetail4.default).
	service('TimeTitleService', _timeTitle2.default).
	
	config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.
	  state('unit', {
	    component: 'unit' }).
	
	  state('unit.list', {
	    url: '/unit',
	    component: 'unitList' }).
	
	  state('unit.create', {
	    url: '/unit/new',
	    component: 'unitDetail',
	    params: {
	      id: "" } }).
	
	
	  state('unit.edit', {
	    url: '/unit/:id/edit',
	    component: 'unitDetail',
	    params: {
	      id: "" } }).
	
	
	  state('unit.authentication', {
	    url: '/unit/authentication',
	    component: 'unitAuthenticationGoogle' });
	
	}]).
	
	component('unit', _unit2.default).
	component('unitList', _unitList2.default).
	component('unitDetail', _unitDetail2.default).
	component('unitAuthenticationGoogle', _unitAuthenticationGoogle2.default).
	
	name;exports.default =
	
	unitModule;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _unit = __webpack_require__(623);var _unit2 = _interopRequireDefault(_unit);
	var _unit3 = __webpack_require__(624);var _unit4 = _interopRequireDefault(_unit3);
	__webpack_require__(625);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var unitComponent = {
	  bindings: {},
	  template: _unit2.default,
	  controller: _unit4.default };exports.default =
	
	
	unitComponent;

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 624 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var UnitController =
	function UnitController() {_classCallCheck(this, UnitController);
	  this.name = 'unit';
	};exports.default =
	
	
	UnitController;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(626);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./unit.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./unit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".sb-opening-hours{padding:16px;border:1px solid rgba(0,0,0,.12);margin-bottom:16px}.sb-opening-hours md-input-container{margin-bottom:0}.sb-opening-hours .md-button{margin:0}.input-search{margin-left:auto}.md-button.md-accent.md-raised.button-spin-active{background:#fff;color:#d50000;box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.button-loader{display:inline-block;vertical-align:middle;margin-left:5px}.sb-content-container .image-container{margin-bottom:40px}.sb-content-container .image-container .sb-page-section-title{margin-left:0;color:rgba(0,0,0,.54)}.sb-content-container .image-container .md-button{margin:0}.sb-content-container .sb-unit-image-container{margin-left:40px;margin-bottom:30px}.sb-content-container .sb-unit-image-container .sb-unit-image{max-width:180px}.sb-page-section-sub-title-schedules{color:#f44336!important;font-size:12px!important;font-weight:700;margin:-12px 0 10px 16px!important;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _unitAuthenticationGoogle = __webpack_require__(628);var _unitAuthenticationGoogle2 = _interopRequireDefault(_unitAuthenticationGoogle);
	var _unitAuthenticationGoogle3 = __webpack_require__(629);var _unitAuthenticationGoogle4 = _interopRequireDefault(_unitAuthenticationGoogle3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var unitAuthenticationGoogleComponent = {
	    bindings: {},
	    template: _unitAuthenticationGoogle2.default,
	    controller: _unitAuthenticationGoogle4.default };exports.default =
	
	
	unitAuthenticationGoogleComponent;

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	
	var _unit = __webpack_require__(570);var UnitHelper = _interopRequireWildcard(_unit);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _asyncToGenerator(fn) {return function () {var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {function step(key, arg) {try {var info = gen[key](arg);var value = info.value;} catch (error) {reject(error);return;}if (info.done) {resolve(value);} else {return Promise.resolve(value).then(function (value) {step("next", value);}, function (err) {step("throw", err);});}}return step("next");});};}
	
	var unitAuthenticationGoogleController = function () {var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13($state, Unit, UnitDetail) {var _this = this;var $ctrl, requestPackage, runAction, setResponse, approvalAttendanceHour, syncHoursGMB, getLocationsGMB, approvedSpecialHours, syncSpecialHours, removeSpecialHours;return regeneratorRuntime.wrap(function _callee13$(_context13) {while (1) {switch (_context13.prev = _context13.next) {case 0:
	            $ctrl = this;
	            $ctrl.uiState = 'LOADING';
	            _angular2.default.extend($ctrl, {});
	            requestPackage = JSON.parse(sessionStorage.requestPackage);_context13.next = 6;return (
	              UnitHelper.setToken($state.params));case 6:
	
	            runAction = function runAction() {
	              return {
	                syncHoursGMB: syncHoursGMB,
	                approvalAttendanceHour: approvalAttendanceHour,
	                getLocationsGMB: getLocationsGMB,
	                approvedSpecialHours: approvedSpecialHours,
	                removeSpecialHours: removeSpecialHours,
	                syncSpecialHours: syncSpecialHours }[
	              requestPackage.action](requestPackage.params);
	            };
	
	            setResponse = function setResponse(itWorked) {
	              requestPackage['response'] = {
	                itWorked: itWorked };
	
	              sessionStorage.setItem('responsePackage', JSON.stringify(requestPackage));
	              $state.go(requestPackage.redirectUrl, { id: requestPackage.params.id });
	            };
	
	            approvalAttendanceHour = function approvalAttendanceHour() {
	              Unit.approvalAttendanceHour(requestPackage.payload).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.next = 2;return (
	                          setResponse(true));case 2:case 'end':return _context.stop();}}}, _callee, _this);}))).
	              catch(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {return regeneratorRuntime.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (
	                          setResponse(true));case 2:case 'end':return _context2.stop();}}}, _callee2, _this);})));
	
	            };
	
	            syncHoursGMB = function syncHoursGMB() {
	              UnitDetail.syncHoursGMB(requestPackage.payload).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {return regeneratorRuntime.wrap(function _callee3$(_context3) {while (1) {switch (_context3.prev = _context3.next) {case 0:_context3.next = 2;return (
	                          setResponse(true));case 2:case 'end':return _context3.stop();}}}, _callee3, _this);}))).
	              catch(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {return regeneratorRuntime.wrap(function _callee4$(_context4) {while (1) {switch (_context4.prev = _context4.next) {case 0:_context4.next = 2;return (
	                          setResponse(false));case 2:case 'end':return _context4.stop();}}}, _callee4, _this);})));
	
	            };
	
	            getLocationsGMB = function getLocationsGMB() {
	              UnitDetail.getLocationsGMB().then(function () {var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(data) {return regeneratorRuntime.wrap(function _callee5$(_context5) {while (1) {switch (_context5.prev = _context5.next) {case 0:_context5.next = 2;return (
	                            setResponse(true));case 2:
	                          sessionStorage.setItem('locationsGMB', JSON.stringify(data));case 3:case 'end':return _context5.stop();}}}, _callee5, _this);}));return function (_x4) {return _ref6.apply(this, arguments);};}()).
	              catch(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {return regeneratorRuntime.wrap(function _callee6$(_context6) {while (1) {switch (_context6.prev = _context6.next) {case 0:_context6.next = 2;return (
	                          setResponse(false));case 2:case 'end':return _context6.stop();}}}, _callee6, _this);})));
	
	            };
	
	            approvedSpecialHours = function approvedSpecialHours() {
	              UnitDetail.approveSpecialHours(requestPackage.payload).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {return regeneratorRuntime.wrap(function _callee7$(_context7) {while (1) {switch (_context7.prev = _context7.next) {case 0:_context7.next = 2;return (
	                          setResponse(true));case 2:case 'end':return _context7.stop();}}}, _callee7, _this);}))).
	              catch(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {return regeneratorRuntime.wrap(function _callee8$(_context8) {while (1) {switch (_context8.prev = _context8.next) {case 0:_context8.next = 2;return (
	                          setResponse(false));case 2:case 'end':return _context8.stop();}}}, _callee8, _this);})));
	
	            };
	
	            syncSpecialHours = function syncSpecialHours() {
	              UnitDetail.syncSpecialHours(requestPackage.payload).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {return regeneratorRuntime.wrap(function _callee9$(_context9) {while (1) {switch (_context9.prev = _context9.next) {case 0:_context9.next = 2;return (
	                          setResponse(true));case 2:case 'end':return _context9.stop();}}}, _callee9, _this);}))).
	              catch(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {return regeneratorRuntime.wrap(function _callee10$(_context10) {while (1) {switch (_context10.prev = _context10.next) {case 0:_context10.next = 2;return (
	                          setResponse(false));case 2:case 'end':return _context10.stop();}}}, _callee10, _this);})));
	
	            };
	
	            removeSpecialHours = function removeSpecialHours() {
	              UnitDetail.removeSpecialHours(requestPackage.payload).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {return regeneratorRuntime.wrap(function _callee11$(_context11) {while (1) {switch (_context11.prev = _context11.next) {case 0:_context11.next = 2;return (
	                          setResponse(true));case 2:case 'end':return _context11.stop();}}}, _callee11, _this);}))).
	              catch(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {return regeneratorRuntime.wrap(function _callee12$(_context12) {while (1) {switch (_context12.prev = _context12.next) {case 0:_context12.next = 2;return (
	                          setResponse(false));case 2:case 'end':return _context12.stop();}}}, _callee12, _this);})));
	
	            };
	
	            runAction(requestPackage);case 15:case 'end':return _context13.stop();}}}, _callee13, this);}));return function unitAuthenticationGoogleController(_x, _x2, _x3) {return _ref.apply(this, arguments);};}();
	
	
	unitAuthenticationGoogleController.$inject = ['$state', 'Unit', 'UnitDetail'];exports.default =
	
	unitAuthenticationGoogleController;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _unitList = __webpack_require__(631);var _unitList2 = _interopRequireDefault(_unitList);
	var _unitList3 = __webpack_require__(632);var _unitList4 = _interopRequireDefault(_unitList3);
	__webpack_require__(636);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var unitListComponent = {
	  bindings: {},
	  template: _unitList2.default,
	  controller: _unitList4.default };exports.default =
	
	
	unitListComponent;

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container unit-list\">\n    <div layout=\"row\" layout-align=\"flex start\"\n         ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n        <md-button class=\"md-raised md-accent\" ui-sref=\"unit.create\">\n            {{ 'common-new-feminine' | translate }}\n        </md-button>\n\n        <md-button ng-click=\"downloadReport()\" class=\"md-raised md-accent\"\n        ng-disabled=\"$ctrl.activeSpin\"\n        ng-class=\"{'button-spin-active': $ctrl.activeSpinButton }\" >\n            <span ng-show=\"!$ctrl.activeSpin\">{{ 'button-download-report' | translate }}</span>\n            <span ng-show=\"$ctrl.activeSpin\">{{ 'button-download-report-spin' | translate }} <md-progress-circular md-mode=\"indeterminate\" class=\"md-accent md-hue-1 button-loader\" md-diameter=\"20\"></md-progress-circular></span>\n        </md-button>\n\n        <md-input-container class=\"md-block\" flex>\n          <label>\n            {{ 'common-state' | translate }}\n          </label>\n\n          <md-select ng-model=\"$ctrl.filter.state_id\"\n                     ng-change=\"$ctrl.onChangeState($ctrl.filter.state_id)\"\n                     ng-disabled=\"$ctrl.isSent\"\n                     name=\"state\">\n            <md-option ng-value=\"null\">\n              {{ 'common-all-masculine' | translate }}\n            </md-option>\n            <md-option ng-repeat=\"state in $ctrl.states\"\n                       ng-value=\"state.id\">\n              {{ state.name }}\n            </md-option>\n          </md-select>\n        </md-input-container>\n\n        <md-input-container class=\"md-block\" flex>\n          <label>\n            {{ 'common-city' | translate }}\n          </label>\n\n          <md-select ng-model=\"$ctrl.filter.city_id\"\n                     ng-change=\"$ctrl.onChangeCity($ctrl.filter.city_id)\"\n                     ng-disabled=\"!$ctrl.filter.state_id || $ctrl.loadingCities || $ctrl.isSent\"\n                     name=\"city\">\n            <md-option ng-value=\"null\">\n              {{ 'common-all-feminine' | translate }}\n            </md-option>\n\n            <md-option ng-repeat=\"city in $ctrl.cities\"\n                       ng-value=\"city.id\">\n              {{ city.name }}\n            </md-option>\n          </md-select>\n        </md-input-container>\n        <md-input-container class=\"md-block\" flex>\n          <label>Status</label>\n          <md-select name=\"gender\"\n                     ng-model=\"$ctrl.filter.gender\"\n                     ng-change=\"$ctrl.onChangeStatus($ctrl.filter.gender)\"\n                     ng-disabled=\"$ctrl.isSent\">\n            <md-option ng-value=\"null\">\n              Todos\n            </md-option>\n\n            <md-option ng-value=\"true\">\n              Ativo\n            </md-option>\n\n            <md-option ng-value=\"false\">\n              Inativo\n            </md-option>\n          </md-select>\n        </md-input-container>\n        <md-card class=\"input-search\">\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'unit-list-table-header-name' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"address_street\"\n                        ng-click=\"$ctrl.orderList('address_street')\">\n                        {{ 'unit-list-table-header-address-street' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"city_id\"\n                        ng-click=\"$ctrl.orderList('city_id')\">\n                        {{ 'unit-list-table-header-city' | translate }}\n                    </th>\n\n                    <th md-column>\n                        {{ 'unit-list-table-header-uf' | translate }}\n                    </th>\n\n                    <th md-column md-numeric>\n                        {{ 'unit-list-table-header-phone-number' | translate }}\n                    </th>\n\n                    <th md-column md-numeric class=\"sb-table-column-xs\">\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit(resource.id)\">\n                    <td md-cell class=\"sb-table-truncate\">{{ resource.name }}</td>\n\n                    <td md-cell>{{ resource.address_street }}</td>\n\n                    <td md-cell>{{ resource.city.name }}</td>\n\n                    <td md-cell>{{ resource.city.state.uf }}</td>\n\n                    <td md-cell>{{ resource.phone_number | phoneFormat }}</td>\n\n                    <td md-cell ng-show=\"$ctrl.isManager\">\n                        <md-button aria-label=\"Toolbar menu\"\n                                   class=\"md-icon-button\"\n                                   ng-click=\"$ctrl.handleDelete(resource, $event)\">\n                          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                        <md-button aria-label=\"Toolbar menu\"\n                                   ng-show=\"resource.attendance_hour_approvals.length > 0\"\n                                   class=\"md-icon-button\"\n                                   ng-attr-title=\"{{ $ctrl.getMessage(resource.attendance_hour_approvals.length > 0) }}\">\n                          <md-icon ng-class=\"{approvalTimes: resource.attendance_hour_approvals.length > 0}\" md-font-set=\"mdi\" md-font-icon=\"mdi-alert-circle-outline\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-if=\"false\" ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'unit-list-empty-state-line-1' | translate }}</p>\n                <p>{{ 'unit-list-empty-state-line-2' | translate }}</p>\n            </div>\n\n            <md-button class=\"md-raised md-accent\" ui-sref=\"unit.create\">\n                {{ 'unit-list-create-unit-button' | translate }}\n            </md-button>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _FileSaver = __webpack_require__(633);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var UnitListController = function UnitListController(Unit, $scope, $state, $filter, $mdDialog, Toast, State, City) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	  $ctrl.isManager = $scope.$root.user.access_group.special_rule === 'MANAGER' || $scope.$root.user.access_group.is_super;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, handleDelete: handleDelete, getMessage: getMessage, onChangeState: onChangeState, onChangeCity: onChangeCity, onChangeStatus: onChangeStatus });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.filter = {};
	
	
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    State.index({ limit: 10000000000 }).then(function (states) {
	      $ctrl.states = states;
	
	      $ctrl.promise;
	
	      $ctrl.$scope.tableConfig = {
	        page: 1,
	        limit: 10,
	        order: 'name',
	        like_search: '',
	        state_id: '',
	        city_id: '',
	        activated: null,
	        like_search_fields: [
	        'name',
	        'address_street'] };
	
	
	
	      $ctrl.$scope.$watch('tableConfig', function () {
	        loadData();
	      }, true);
	    });
	  }
	
	  function onChangeStatus(status) {
	    $ctrl.$scope.tableConfig.is_visible = status;
	  }
	
	  function onChangeCity(cityId) {
	    $ctrl.$scope.tableConfig.city_id = cityId;
	  }
	  function onChangeState(stateId) {
	    $ctrl.filter.city_id = null;
	
	    $ctrl.$scope.tableConfig.state_id = stateId;
	    $ctrl.$scope.tableConfig.city_id = '';
	
	    $ctrl.loadingCities = true;
	    City.
	    index({
	      state_id: stateId,
	      limit: 1000000 }).
	
	    then(function (cities) {
	      $ctrl.cities = cities;
	      $ctrl.loadingCities = false;
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.loadingCities = false;
	    });
	  }
	  $scope.downloadReport = function () {
	    $ctrl.activeSpin = true;
	    $ctrl.activeSpinButton = true;
	    Unit.
	    downloadReport().
	    then(function (res) {
	      var file = new Blob([res], { type: 'text/csv;charset=utf-8;' });
	      var messageSuccess = $filter('translate')('report-success');
	      $ctrl.activeSpin = false;
	      $ctrl.activeSpinButton = false;
	      Toast.success(messageSuccess);
	      (0, _FileSaver.saveAs)(file, 'rel_analitico_unidades.csv');
	    }).catch(function (err) {
	      console.log('err:', err);
	      var messageError = $filter('translate')('report-error');
	      $ctrl.activeSpin = false;
	      $ctrl.activeSpinButton = false;
	      Toast.error(messageError);
	    });
	  };
	
	  function edit(id) {
	    $state.go('unit.edit', { id: id });
	  }
	
	  function getMessage(showMessage) {
	    return showMessage ? 'Existem solicitações pendentes nesta unidade!' : null;
	  }
	
	  function handleDelete(resource, event) {
	    event.stopPropagation();
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Unit.
	      destroy(resource).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        _.remove($ctrl.resources.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Unit.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      // $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.uiState = 'COMPLETE';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	};
	
	UnitListController.$inject = ['Unit', '$scope', '$state', '$filter', '$mdDialog', 'Toast', 'State', 'City'];exports.default =
	
	UnitListController;

/***/ }),
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(637);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./unit-list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./unit-list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, "table tbody tr td:nth-of-type(5){padding:0!important;text-align:start!important}table tbody tr td:nth-of-type(6){display:inline-flex}table tbody tr td:nth-of-type(6) button:last-of-type{cursor:default}table tbody tr .approvalTimes{color:#b90a00;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _unitDetail = __webpack_require__(639);var _unitDetail2 = _interopRequireDefault(_unitDetail);
	var _unitDetail3 = __webpack_require__(640);var _unitDetail4 = _interopRequireDefault(_unitDetail3);
	__webpack_require__(643);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var unitDetailComponent = {
	  bindings: {},
	  template: _unitDetail2.default,
	  controller: _unitDetail4.default };exports.default =
	
	
	unitDetailComponent;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div id=\"unitDetail\" class=\"sb-content sb-unit\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <form name=\"unitForm\" ng-submit=\"$ctrl.handleSave(unitForm, $ctrl.unit)\"\n              novalidate>\n            <!-- unit -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">{{ 'unit-detail-title' | translate }}</h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'unit-detail-title-caption' | translate }}\n                </p>\n\n                <p ng-show=\"$ctrl.pendingRequests\" id=\"subTitleSchedules\" class=\"sb-page-section-sub-title sb-page-section-sub-title-schedules\">\n                    {{ 'unit-detail-pending-requests' | translate }}\n                </p>\n\n                <md-card>\n                    <!-- name phone_number-->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-name' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.unit.name\" name=\"name\"\n                                   required/>\n                           \n\n                            <div ng-messages=\"unitForm.name.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-phone_number' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.unit.phone_number\" name=\"phone_number\"\n                                   ui-br-phone-number\n                                   required/>\n\n\n                            <div ng-messages=\"unitForm.phone_number.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <!-- address_street address_number -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-address_street' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.unit.address_street\" name=\"address_street\"\n                                   required/>\n                          \n\n                            <div ng-messages=\"unitForm.address_street.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex=\"25\">\n                            <label>\n                                {{ 'unit-detail-form-unit-address_number' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.unit.address_number\" name=\"address_number\"\n                                   required/>\n\n\n                            <div ng-messages=\"unitForm.address_number.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <!-- address_complement address_neighborhood addess_postal_code-->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-address_complement' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.unit.address_complement\" name=\"address_complement\"/>\n\n                            <div ng-messages=\"unitForm.address_complement.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-address_neighborhood' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.unit.address_neighborhood\" name=\"address_neighborhood\"\n                                   required/>\n\n                            <div ng-messages=\"unitForm.address_neighborhood.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-address_postal_code' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.unit.address_postal_code\"\n                                   name=\"address_postal_code\"\n                                   ui-br-cep-mask\n                                   required/>\n\n                            <div ng-messages=\"unitForm.address_postal_code.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <!-- region state city -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-region_id' | translate }}\n                            </label>\n\n                            <md-select ng-model=\"$ctrl.unit.region_id\"\n                                       name=\"region\"\n                                       required>\n                                <md-option ng-repeat=\"region in $ctrl.regions\"\n                                           ng-value=\"region.id\" >\n                                    {{ region.name }}\n                                </md-option>\n                            </md-select>\n\n                            <div ng-messages=\"unitForm.region.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-state' | translate }}\n                            </label>\n\n                            <md-select ng-model=\"$ctrl.unit.city.state_id\"\n                                       ng-change=\"$ctrl.onChangeState($ctrl.unit.city.state_id)\"\n                                       name=\"state\"\n                                       required>\n                                <md-option ng-repeat=\"state in $ctrl.states\"\n                                           ng-value=\"state.id\" >\n                                    {{ state.name }}\n                                </md-option>\n                            </md-select>\n\n                            <div ng-messages=\"unitForm.state.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-city_id' | translate }}\n                            </label>\n\n                            <md-select ng-model=\"$ctrl.unit.city_id\"\n                                       ng-disabled=\"!$ctrl.unit.city.state_id || $ctrl.loadingCities\"\n                                       name=\"city\"\n                                       required>\n                                <md-option ng-repeat=\"city in $ctrl.cities\"\n                                           ng-value=\"city.id\" >\n                                    {{ city.name }}\n                                </md-option>\n                            </md-select>\n\n                            <div ng-messages=\"unitForm.city.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <!-- latitude longitude -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-latitude' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.unit.latitude\" name=\"latitude\"\n                                   required/>\n\n\n                            <div class=\"hint\" ng-show=\"!unitForm.latitude.$error.required\">\n                                {{ 'unit-detail-form-unit-latitude-hint' | translate}}\n                            </div>\n\n                            <div ng-messages=\"unitForm.latitude.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-longitude' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.unit.longitude\" name=\"longitude\"\n                                   required/>\n\n                            <div ng-messages=\"unitForm.longitude.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <!-- is_visible -->\n                    <div>Exibir Unidade</div>\n                    <div layout=\"row\" flex layout-align=\"start center\" flex=\"25\">\n                        <div class=\"flex-radio-content\">\n                            <span><label>App e Portal*</label></span>\n                            <span><md-switch ng-model=\"$ctrl.unit.is_visible\"></md-switch></span>\n                        </div>\n                        <div class=\"flex-radio-content\">\n                            <span><label>Atendimento Digital*</label></span>\n                            <span><md-switch ng-model=\"$ctrl.unit.is_visible_service_attendance\"></md-switch></span>\n                        </div>\n\n                    </div>\n                    <span><small>*Desabilitado irá ocultar a unidade das respectivas páginas</small></span>\n\n\n                  <!-- Google My Business Unit -->\n                    <div ng-show=\"$ctrl.isManager\" layout=\"column\" flex class=\"sb-conditional-section\">\n                        <md-checkbox ng-model=\"$ctrl.hasNewsItem\"\n                                     ng-disabled=\"$ctrl.isSent\"\n                                     aria-label=\"Checkbox 1\">\n                            {{ 'unit-detail-link-google-unit' | translate }}\n                        </md-checkbox>\n\n                        <md-autocomplete\n                            md-no-cache=\"true\"\n                            md-selected-item=\"$ctrl.locationSelected_id2\"\n                            md-selected-item-change=\"$ctrl.selectedNewsItemChange($ctrl.locationSelected_id2)\"\n                            md-items=\"newsItem in $ctrl.querySearch($ctrl.searchText)\"\n                            md-search-text=\"$ctrl.searchText\"\n                            md-item-text=\"$ctrl.locationSelected_id2.location_name\"\n                            md-menu-class=\"sb-autocomplete-custom-template\"\n                            placeholder=\"Pesquise por uma unidade\"\n                            ng-required=\"$ctrl.hasNewsItem\"\n                            ng-disabled=\"!$ctrl.hasNewsItem || $ctrl.isSent\">\n                            <md-item-template>\n                                <span class=\"item-title\">\n                                    <span>{{ newsItem.location_name }}</span>\n                                </span>\n\n                                <span class=\"item-metadata\">\n                                    <span>\n                                    {{ newsItem.address.sublocality + \", \" + newsItem.address.locality }}\n                                    </span>\n\n                                    <span> - </span>\n\n                                    <span>\n                                    {{ newsItem.address.administrativeArea }}\n                                    </span>\n                                </span>\n                            </md-item-template>\n\n                            <md-not-found>\n                                {{ 'list-empty-search-state-line-1' | translate }}\n                            </md-not-found>\n                        </md-autocomplete>\n\n                        <div class=\"sb-error-message\"\n                             ng-show=\"notificationForm.$submitted && ($ctrl.hasNewsItem && !$ctrl.selectedNewsItem)\">\n                            {{ 'form-error-required-field' | translate}}\n                        </div>\n                    </div>\n\n                    <!-- observation -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-unit-observation' | translate }}\n                            </label>\n\n                            <textarea ng-model=\"$ctrl.unit.observation\" name=\"observation\"\n                                      md-maxlength=\"150\" rows=\"2\"\n                                      md-select-on-focus>\n                            </textarea>\n\n                            <div ng-messages=\"unitForm.observation.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <!-- is_schedule_available -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <md-checkbox ng-model=\"$ctrl.unit.is_schedule_available\">\n                                {{ 'unit-detail-form-unit-is-schedule-available' | translate }}\n                            </md-checkbox>\n                        </md-input-container>\n                    </div>\n\n                    <!-- image_unit -->\n                    <div layout=\"row\" flex>\n                      <div class=\"image-container\">\n                        <div layout=\"row\" flex>\n                          <h3 class=\"sb-page-section-title flex\">{{ 'common-image' | translate }}</h3>\n                        </div>\n                        <div layout=\"row\" flex>\n                          <div class=\"md-input-container\">\n                            <input ng-show=\"false\" type=\"file\" id=\"fileInput\"/>\n                            <label for=\"fileInput\" class=\"md-button md-raised\">\n                              {{ 'common-choose-a-file' | translate }}\n                            </label>\n                          </div>\n                        </div>\n                      </div>\n\n                      <div\n                        ng-show=\"$ctrl.unit.image_base64\"\n                        class=\"sb-unit-image-container\"\n                      >\n                        <img class=\"sb-unit-image\" ng-src=\"{{ $ctrl.unit.image_base64 }}\"/>\n                      </div>\n\n                      <div\n                        ng-show=\"$ctrl.unit.image_uri && !$ctrl.unit.image_base64\"\n                        class=\"sb-unit-image-container\"\n                      >\n                        <img class=\"sb-unit-image\" ng-src=\"{{ $ctrl.unit.image_uri }}\"/>\n\n                        <md-progress-linear ng-show=\"$ctrl.loadingImage\" md-mode=\"indeterminate\"></md-progress-linear>\n                      </div>\n                    </div>\n\n                    <!-- map -->\n                    <map id=\"map\" ng-if=\"$ctrl.uiState === 'COMPLETE'\"\n                         center=\"[{{ $ctrl.unit.latitude }}, {{ $ctrl.unit.longitude }}]\">\n                        <marker ng-if=\"$ctrl.unit.latitude && $ctrl.unit.longitude\"\n                         position=\"[{{ $ctrl.unit.latitude }}, {{ $ctrl.unit.longitude }}]\">\n                        </marker>\n                    </map>\n                </md-card>\n            </div>\n\n            <!-- opening hours -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">\n                    Horários Especiais\n                </h3>\n\n                <md-card class=\"schedules-card\">\n                    <div layout=\"row\" >\n                        <span class=\"schedule-toggle\" flex=\"10\">\n                            <md-switch ng-model=\"$ctrl.prioritizeSpecialHour\" aria-label=\"Active\"></md-switch>\n                        </span>\n                        <p>Ignorar horários especiais da praça</p>\n                    </div>\n                    <div layout=\"row\" layout-wrap class=\"sb-checkboxes\">\n                        <div class=\"container\">\n                            <div class=\"schedules-header\" layout=\"row\">\n                                <div flex=\"33\">\n                                    <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-information\" class=\"mdi-18px\"></md-icon>\n                                    <small>As datas dos eventos podem não ser consecutivas</small>\n                                </div>\n                                <div flex=\"33\" ng-show=\"$ctrl.isManager\">\n                                    <span id=\"syncHoursGMB\">\n                                        <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-sync\" class=\"mdi-24px schedules-header-icon\"></md-icon>\n                                        {{ 'unit-detail-sync-gmb' | translate }}\n                                    </span>\n                                </div>\n                                <div flex=\"33\">\n                                    <span id=\"addSpecialSchedules\">\n                                        <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-calendar\" class=\"mdi-24px schedules-header-icon\"></md-icon>\n                                        {{ 'unit-detail-add-special-hours' | translate }}\n                                    </span>\n                                </div>\n                            </div>\n                            <div class=\"mt-3\">\n                                <md-table-container>\n                                    <table md-table md-progress=\"$ctrl.promise\">\n                                        <thead md-head class=\"text-18\">\n                                          <tr md-row>\n                                            <th md-column md-order-by=\"name\">\n                                                Nome do evento\n                                            </th>\n\n                                            <th md-column md-order-by=\"address_street\">\n                                                Primeira data\n                                            </th>\n\n                                            <th md-column md-order-by=\"address_street\">\n                                                Última data\n                                            </th>\n\n                                            <th md-column md-order-by=\"city_id\">\n                                                Quantidade de datas\n                                            </th>\n\n                                            <th md-column md-numeric class=\"sb-table-column-xs\">\n                                            </th>\n                                          </tr>\n                                        </thead>\n                                        <tbody md-body>\n                                          <tr md-row ng-repeat=\"(idx, resource) in $ctrl.events\"\n                                              ng-click=\"$ctrl.edit(resource.id)\">\n                                            <td md-cell class=\"sb-table-truncate\">{{ resource.name }}</td>\n\n                                            <td md-cell>{{ $ctrl.formatDate(resource.first_date) }}</td>\n\n                                            <td md-cell>{{ $ctrl.formatDate(resource.last_date)}}</td>\n\n                                            <td md-cell style=\"text-align: center\">\n                                                {{ resource.days }} dias\n\n                                                <span>\n                                                    <md-icon md-font-set=\"mdi\"\n                                                        ng-attr-title=\"{{ $ctrl.getDates(resource.special_hours).join('&#013;')}}\"\n                                                        md-font-icon=\"mdi-information\" class=\"mdi-24px\">\n                                                    </md-icon>\n                                                </span>\n                                            </td>\n\n                                            <td md-cell ng-show=\"$ctrl.isManager\">\n                                                <md-button aria-label=\"Toolbar menu\"\n                                                           class=\"md-icon-button\"\n                                                           ng-click=\" $ctrl.editSpecialHour(resource.id, idx, $event)\">\n                                                  <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-pencil\" class=\"mdi-24px\">\n                                                  </md-icon>\n                                                </md-button>\n                                            </td>\n                                          </tr>\n                                        </tbody>\n                                    </table>\n                                </md-table-container>\n                            </div>\n                            <div class=\"schedules-footer\" layout=\"row\" layout-align=\"center center\">\n                                <div flex=\"100\">\n                                    <img src=\"assets/google-logo.jpg\"/>\n                                </div>\n                                <div layout=\"row\" layout-align=\"end center\" flex>\n                                    <md-button class=\"md-accent\" ng-disabled=\"!$ctrl.requestChangeScheduleObservation\"\n                                        ng-click=\"$ctrl.requestChangeSchedule()\">\n                                        {{ $ctrl.changeScheduleLoading ? 'Solicitando...' : 'Solicitar mudança' }}\n                                    </md-button>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- services -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">\n                    {{ 'unit-detail-section-title-services' | translate }}\n                </h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'unit-detail-section-title-services-caption' | translate }}\n                </p>\n\n                <md-card>\n                    <div layout=\"row\" layout-wrap class=\"sb-checkboxes\">\n                        <md-checkbox ng-repeat=\"service in $ctrl.services\" flex\n                                     ng-click=\"$ctrl.toggleItemInList($ctrl.unit.services, service)\"\n                                     ng-checked=\"$ctrl.isIdInList($ctrl.unit.services, service.id)\">\n                            {{ service.name }}\n                        </md-checkbox>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- differential -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">\n                    {{ 'unit-detail-section-title-differentials' | translate }}\n                </h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'unit-detail-section-title-differentials-caption' | translate }}\n                </p>\n\n                <md-card>\n                    <div layout=\"row\" layout-wrap class=\"sb-checkboxes\">\n                        <md-checkbox ng-repeat=\"differential in $ctrl.differentials\" flex\n                                     ng-click=\"$ctrl.toggleItemInList($ctrl.unit.differentials, differential)\"\n                                     ng-checked=\"$ctrl.isIdInList($ctrl.unit.differentials, differential.id)\">\n                            {{ differential.name }}\n                        </md-checkbox>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- opening_hours -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">\n                    {{ 'unit-detail-section-title-opening-hours' | translate }}\n                </h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'unit-detail-section-title-opening-hours-caption' | translate }}\n                </p>\n                <md-card>\n                    <div layout=\"column\" ng-repeat=\"opening_hour in $ctrl.unit.opening_hours\"\n                         class=\"sb-opening-hours\">\n                        <md-input-container class=\"md-block pb-3\" flex>\n                            <label>\n                                {{ 'unit-detail-form-opening-hour-name' | translate }}\n                            </label>\n\n                            <md-select\n                              ng-model=\"opening_hour.schedule_title_id\"\n                              required\n                            >\n                              <md-option\n                                ng-repeat=\"item in $ctrl.scheduleTitles\"\n                                ng-value=\"item.id ? item.id : item\"\n                              >\n                                {{item.title ? item.title : item}}\n                              </md-option>\n                          </md-select>\n\n\n                            <div ng-messages=\"unitForm.schedule_title_id.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'unit-detail-form-opening-hour-value' | translate }}\n                            </label>\n\n                            <textarea ng-model=\"opening_hour.value\" name=\"observation\"\n                                      rows=\"3\" required\n                                      md-select-on-focus>\n                            </textarea>\n\n                            <div ng-messages=\"unitForm.observation.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <div layout=\"row\" layout-align=\"end center\" flex>\n                            <md-button class=\"md-accent\"\n                                       ng-click=\"$ctrl.removeOpeningHour(opening_hour)\">\n                                {{ 'unit-detail-form-opening-hour-remove-button' | translate}}\n                            </md-button>\n                        </div>\n                    </div>\n\n                    <div layout=\"row\">\n                        <md-button class=\"md-raised\"\n                                   ng-click=\"$ctrl.addOpeningHour(opening_hour)\">\n                            {{ 'unit-detail-form-opening-hour-add-button' | translate}}\n                        </md-button>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- form actions -->\n            <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n                <md-button page-back\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                    {{ 'common-cancel-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.handleDelete($ctrl.unit, $event)\"\n                           ng-if=\"$ctrl.id\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-warn md-raised\">\n                    {{ 'common-delete-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.clearForm(unitForm)\"\n                           ng-if=\"!$ctrl.id\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-raised\">\n                    {{ 'common-clear-button-text' | translate }}\n                </md-button>\n\n                <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-accent md-raised\">\n                    {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                </md-button>\n            </div>\n        </form>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _moment = __webpack_require__(421);var _moment2 = _interopRequireDefault(_moment);
	
	var _modalSpecialSchedules = __webpack_require__(641);var _modalSpecialSchedules2 = _interopRequireDefault(_modalSpecialSchedules);
	var _modalApprovalSpecialSchedules = __webpack_require__(642);var _modalApprovalSpecialSchedules2 = _interopRequireDefault(_modalApprovalSpecialSchedules);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _asyncToGenerator(fn) {return function () {var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {function step(key, arg) {try {var info = gen[key](arg);var value = info.value;} catch (error) {reject(error);return;}if (info.done) {resolve(value);} else {return Promise.resolve(value).then(function (value) {step("next", value);}, function (err) {step("throw", err);});}}return step("next");});};}
	
	var weedDays = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
	
	var UnitDetailController = function UnitDetailController($filter, $mdDialog, $scope, $state, City, Differential, NgMap, Region, Service, State, Toast, Unit, UnitDetail, TimeTitleService) {
	    DialogController.$inject = ["$scope", "$mdDialog", "$filter", "eventData", "idx"];var activate = function () {var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	    function _callee() {return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
	              _angular2.default.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
	              _angular2.default.element(document.querySelector('#syncHoursGMB')).on('click', syncHoursGMB);
	              _angular2.default.element(document.querySelector('#addSpecialSchedules')).on('click', toggleModalSpecialSchedules);
	              _angular2.default.element(document.querySelector('#subTitleSchedules')).on('click', toggleModalApprovalSpecialSchedules);
	              getTimeTitleList();
	
	              $scope.$on('mapInitialized', function (event, map) {
	                var center = map.getCenter();
	                google.maps.event.trigger(map, 'resize');
	                map.setCenter(center);
	              });
	
	              clearForm();
	
	              $ctrl.uiState = 'LOADING';
	
	              loadDomainResources().
	              then(function (result) {
	                $ctrl.differentials = result[0];
	                $ctrl.regions = result[1];
	                $ctrl.services = result[2];
	                $ctrl.states = result[3];
	
	                loadResource($ctrl.id);
	              }).
	              catch(function (err) {
	                $ctrl.uiState = 'ERROR';
	              });_context.next = 11;return (
	
	                UnitDetail.getRequestChangeSchedule().
	                then(function (data) {
	                  if (data.length) {
	                    var approvalSchedules = data[0].attendance_hour_approvals;
	                    $ctrl.reviewerName = approvalSchedules[0].author.name;
	                    $ctrl.approvalSchedules = approvalSchedules.slice(approvalSchedules.length - 7);
	                    $ctrl.modalApprovalSpecialSchedulesActived = true;
	                    setTimeout(function () {
	                      $ctrl.pendingRequests = true;
	                      toggleModalApprovalSpecialSchedules();
	                    }, 10000);
	                  }
	                }).
	                catch(function (err) {
	                  console.log(err);
	                }));case 11:case 'end':return _context.stop();}}}, _callee, this);}));return function activate() {return _ref.apply(this, arguments);};}();var requestChangeSchedule = function () {var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	    function _callee2() {var schedules;return regeneratorRuntime.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
	              schedules = [];
	              $ctrl.schedules.forEach(function (el) {
	                schedules.push(Object.assign({}, el));
	              });
	              schedules.map(function (el) {
	                if (el.id) {
	                  delete el.id;
	                }
	                el.is_open = el.is_open ? el.is_open : false;
	                el.start_hour = (0, _moment2.default)(el.start_hour).format('LT');
	                el.end_hour = (0, _moment2.default)(el.end_hour).format('LT');
	                el.change_reason = $ctrl.requestChangeScheduleObservation;
	              });
	              $ctrl.changeScheduleLoading = true;_context2.next = 6;return (
	                UnitDetail.requestChangeSchedule(schedules).
	                then(function (response) {
	                  Toast.success($filter('translate')('toast-success-request-change-schedule'));
	                }).
	                catch(function (err) {
	                  Toast.error($filter('translate')('toast-error-request-change-schedule'));
	                }));case 6:
	              $ctrl.requestChangeScheduleObservation = null;
	              setTimeout(function () {
	                document.querySelectorAll('.md-input-invalid')[0].classList.remove('md-input-invalid');
	              }, 500);
	              $ctrl.changeScheduleLoading = false;case 9:case 'end':return _context2.stop();}}}, _callee2, this);}));return function requestChangeSchedule() {return _ref2.apply(this, arguments);};}();var $ctrl = this;$ctrl.isManager = $scope.$root.user.access_group.special_rule.includes('MANAGER') || $scope.$root.user.access_group.is_super;var responseMessages = function responseMessages(responsePackage) {try {return { syncHoursGMB: responsePackage.response.itWorked ? $filter('translate')('toast-success-hours-sync') : $filter('translate')('toast-error-houts-sync'), approvalAttendanceHour: responsePackage.response.itWorked ? $filter('translate')('toast-success-approval-attendance-hour') : $filter('translate')('toast-error-approval-attendance-hour'), approvedSpecialHours: responsePackage.response.itWorked ? $filter('translate')('toast-success-approved-special-hours') : $filter('translate')('toast-error-approved-special-hours'), removeSpecialHours: responsePackage.response.itWorked ? $filter('translate')('toast-success-remove-special-hours') : $filter('translate')('toast-error-remove-special-hours'), syncSpecialHours: responsePackage.response.itWorked ? $filter('translate')('toast-success-sync-special-hours') : $filter('translate')('toast-error-sync-special-hours') }[responsePackage.action];} catch (error) {sessionStorage.removeItem('responsePackage');}};var responsePackage = sessionStorage.responsePackage ? JSON.parse(sessionStorage.responsePackage) : null;if (responsePackage) {if (responsePackage.action != 'getLocationsGMB') {if (responsePackage.response.itWorked) {Toast.success(responseMessages(responsePackage));} else {Toast.error(responseMessages(responsePackage));}}if (responsePackage.callback) {setTimeout(function () {$ctrl[responsePackage.callback]();}, 7000);}sessionStorage.removeItem('responsePackage');}$ctrl.id = $state.params.id;$ctrl.unit;$ctrl.reviewerName;$ctrl.unitRequest;$ctrl.changeScheduleLoading = false;$ctrl.pendingRequests = false;$ctrl.new_opening_hour = {};$ctrl.schedules = [];$ctrl.approvalSchedules = [];$ctrl.approvalSpecialSchedules = [];$ctrl.requestChangeScheduleObservation = null;$ctrl.modalApprovalSpecialSchedulesActived = false;$ctrl.newsItems = sessionStorage.locationsGMB ? JSON.parse(sessionStorage.locationsGMB) : [];$ctrl.schedulesGMB = [];$ctrl.events = [];$ctrl.editingSpecialHour = false;$ctrl.scheduleTitles = ["Horário de Funcionamento", "Horário de Coleta", "Horário de entrega de Resultados", "Horário de Coleta Exame Covid-19", "Horário de Vacinas", "Horário de Coleta Espermograma", "Atendimento Ultrassonografia", "Atendimento Tomografia", "Atendimento Ressonância", "Horário de Imagem"];var defaultUnitHour = { schedule_title_id: "", name: $filter('translate')('unit-detail-default-unit-opening-hour-text'), value: '', type: 'UNIT' };_angular2.default.extend($ctrl, { addOpeningHour: addOpeningHour, clearForm: clearForm, handleSave: handleSave, handleDelete: handleDelete, isIdInList: isIdInList, onChangeState: onChangeState, toggleItemInList: toggleItemInList, removeOpeningHour: removeOpeningHour, replaceSpecialChar: replaceSpecialChar, requestChangeSchedule: requestChangeSchedule, syncHoursGMB: syncHoursGMB, querySearch: querySearch, selectedNewsItemChange: selectedNewsItemChange, saveEvent: saveEvent });activate();function querySearch(searchText) {searchText = searchText.toLowerCase();var results = _.filter($ctrl.newsItems, function (newsItem) {return newsItem.location_name.toLowerCase().indexOf(searchText) > -1;});return results;}function selectedNewsItemChange(newsItem) {if (newsItem) {$ctrl.locationSelected_id = newsItem;}}function getAttendanceHour(unitData) {UnitDetail.getAttendanceHour($ctrl.id).then(function (data) {$ctrl.schedules = [];var schedulesAux = data;weedDays.forEach(function (day) {if (schedulesAux.map(function (el) {return el.week_day;}).indexOf(day) < 0) {schedulesAux.push({ week_day: day === 'Sabado' ? 'Sábado' : day, is_open: false, start_hour: '08:00', end_hour: '18:00', unit_id: unitData.id, unit: unitData });}});weedDays.forEach(function (day) {schedulesAux.forEach(function (dayAux) {if (day === dayAux.week_day) {$ctrl.schedules.push(dayAux);}});});}).catch(function (err) {console.log(err);});}function addOpeningHour() {$ctrl.unit.opening_hours.push({ schedule_title_id: '', value: '', type: 'OTHER' });}function syncHoursGMB() {$ctrl.uiState = 'LOADING';sessionStorage.setItem('requestPackage', JSON.stringify({ redirectUrl: 'unit.edit', action: 'syncHoursGMB', params: { id: $ctrl.id }, payload: $ctrl.id }));$state.go('unit.authentication');}function getLocationsGMB() {$ctrl.uiState = 'LOADING';sessionStorage.setItem('requestPackage', JSON.stringify({ redirectUrl: 'unit.edit', action: 'getLocationsGMB', params: { id: $state.params.id } }));$state.go('unit.authentication');}function clearForm(form) {$ctrl.myImage = '';$ctrl.fileName = undefined;$ctrl.unit = { city: {}, opening_hours: [defaultUnitHour], differentials: [], services: [], image_base64: '', image_uri: '' };if (form) {form.$setPristine();form.$setUntouched();}}function handleDelete(unit, event) {var confirm = $mdDialog.confirm().textContent($filter('translate')('unit-detail-delete-confirm-text')).ariaLabel($filter('translate')('unit-detail-delete-confirm-text')).targetEvent(event).ok($filter('translate')('common-yes')).cancel($filter('translate')('common-cancel'));$mdDialog.show(confirm).then(function () {$ctrl.deleting = true;Unit.destroy(unit).then(function (response) {Toast.success($filter('translate')('unit-detail-delete-success'));$ctrl.deleting = false;$state.go('unit.list');}).catch(function (err) {Toast.error($filter('translate')('common-server-error'));console.log('err:', err);$ctrl.deleting = false;});}).catch(function () {});}function handleSave(form, unit) {unit.is_priority_special_hours = $ctrl.prioritizeSpecialHour ? 1 : 0;if ($ctrl.requestChangeScheduleObservation) {if (!form.$valid) {Toast.error($filter('translate')('common-form-incomplete'));return;}}unit.opening_hours.forEach(function (item) {if (isNaN(item.schedule_title_id)) {item.name = item.schedule_title_id;item.schedule_title_id = null;}});if ($ctrl.locationSelected_id) {unit.gmb_id = $ctrl.locationSelected_id.location_id;} else if ($ctrl.locationSelected_id2) {unit.gmb_id = $ctrl.locationSelected_id2.location_id;} else {unit.gmb_id = null;}$ctrl.saving = true;Unit.save(unit).then(function (response) {Toast.success($filter('translate')('unit-detail-save-success'));$ctrl.unit = response;$state.go('unit.list');}).catch(function (err) {Toast.error($filter('translate')('common-save-error'));$ctrl.saving = false;}).finally(function () {if ($ctrl.unit.id) {saveEvent($ctrl.events);}});}function saveEvent(data) {$ctrl.saving = true;var content = void 0;if (data.length) {content = data.map(function (event) {return event.special_hours;});content.forEach(function (event) {event.special_hours.forEach(function (item) {item.flag = Number(item.flag);});});} else if (data.special_hours) {data.special_hours.forEach(function (item) {item.flag = Number(item.flag);});content = data.id ? data : [data];}Unit.saveEvent(content, $ctrl.id || $ctrl.unit.id).then(function (resp) {if (!data.special_hours) {$state.go('unit.list');} else {loadSpecialHours($ctrl.id);}}).catch(function () {Toast.error($filter('translate')('common-save-error'));}).finally(function () {$ctrl.saving = false;});}function isIdInList(list, id) {return _.find(list, { id: id });}function onChangeState(stateId) {$ctrl.unit.city_id = undefined;$ctrl.loadingCities = true;City.index({ state_id: stateId, limit: 10000 }).then(function (cities) {$ctrl.cities = cities;$ctrl.loadingCities = false;}).catch(function (err) {$ctrl.loadingCities = false;});}function toggleItemInList(list, item) {if (_.find(list, { id: item.id })) {_.remove(list, { id: item.id });} else {list.push(item);}}function removeOpeningHour(item) {var confirm = $mdDialog.confirm().textContent($filter('translate')('unit-detail-remove-opening-hour-confirm-text')).ariaLabel($filter('translate')('unit-detail-remove-opening-hour-confirm-text')).targetEvent(event).ok($filter('translate')('common-yes')).cancel($filter('translate')('common-cancel'));$mdDialog.show(confirm).then(function () {if (item.id) {_.remove($ctrl.unit.opening_hours, { id: item.id });} else {_.remove($ctrl.unit.opening_hours, { $$hashKey: item.$$hashKey });}}).catch(function () {});} // Local functions
	  function handleFileSelect(event) {var file = event.currentTarget.files[0];if (!file) {return;}var reader = new FileReader();reader.onload = function (event) {$ctrl.myImage = event.target.result;$scope.$apply();$ctrl.fileName = file.name;showCropDialog(event);};reader.readAsDataURL(file);}function showCropDialog(event) {$mdDialog.show({ controller: DialogController, targetEvent: event, template: '<md-dialog aria-label="Image cropper dialog" class="sb-ui-cropper-dialog">' + '  <md-dialog-content>' + '    <div layout="row" layout-align="center center" ng-show="!isDoneLoading">' + '      <md-progress-linear md-mode="indeterminate"></md-progress-linear>' + '    </div>' + '' + '    <ui-cropper' + '      ng-show="isDoneLoading === true"' + '      on-load-done="isDoneLoading = true"' + '      image="myImage"' + '      area-type="rectangle"' + '      aspect-ratio="1.6744186047"' + '      init-max-area="true"' + '      chargement="loadingText"' + '      result-image-size="{w: 720,h: 430}"' + '      result-image="image_base64" canvas-scalemode="true">' + '    </ui-cropper>' + '  </md-dialog-content>' + '  <md-dialog-actions' + '     ng-show="isDoneLoading === true">' + '    <md-button ng-click="cancel()">' + '      Cancelar' + '    </md-button>' + '    <md-button ng-click="cropImage(image_base64)" class="md-accent">' + '      Feito' + '    </md-button>' + '  </md-dialog-actions>' + '</md-dialog>', bindToController: true, parent: _angular2.default.element(document.body), clickOutsideToClose: true, fullscreen: false }).then(function (image_base64) {// $ctrl.image_base64 = image_base64;
	      $ctrl.unit.image_base64 = image_base64;$ctrl.myImage = '';}, function () {$scope.status = 'You cancelled the dialog.';});}function DialogController($scope, $mdDialog, $filter, eventData, idx) {"ngInject";$scope.loadingText = $filter('translate')('common-loading');$scope.myImage = $ctrl.myImage;$scope.minDate = new Date(); // $scope.image_base64 = $ctrl.image_base64;
	    $scope.labelDays = { 1: 'Domingo', 2: 'Segunda', 3: 'Terça', 4: 'Quarta', 5: 'Quinta', 6: 'Sexta', 7: 'Sábado' };$ctrl.unit.image_base64 = $ctrl.unit.image_base64;$scope.isManager = $ctrl.isManager;$scope.unit = $ctrl.unit;$scope.reviewerName = $ctrl.reviewerName;$scope.isEditing = eventData && eventData.id;$scope.schedulesGMB = eventData && eventData.special_hours ? _angular2.default.copy(eventData.special_hours) : [{ date: new Date(), flag: false, description: '' }];$scope.eventName = eventData && eventData.name ? eventData.name : '';$scope.reasonRejection = '';$scope.reasonRejectionSpecialSchedules = '';$scope.isRejectSchedulesChange = false;$scope.approvalSchedules = $ctrl.approvalSchedules;$scope.approvalSpecialSchedules = $ctrl.approvalSpecialSchedules;$scope.modalBody1 = true;$scope.modalBody2 = true;if (!$scope.approvalSchedules.length) {$scope.modalBody1 = false;}if (!$scope.approvalSpecialSchedules.length) {$scope.modalBody2 = false;}$scope.moment = _moment2.default;$scope.toggleRejectSchedulesChange = function () {_angular2.default.element(document.querySelector('.schedules-reject'))[0].style.display = 'initial';_angular2.default.element(document.querySelector('.my-md-dialog-actions'))[0].style.display = 'none';_angular2.default.element(document.querySelector('.my-md-dialog-actions-reject'))[0].style.display = 'initial';};$scope.buttonBack = function () {_angular2.default.element(document.querySelector('.schedules-reject'))[0].style.display = 'none';_angular2.default.element(document.querySelector('.my-md-dialog-actions'))[0].style.display = 'initial';_angular2.default.element(document.querySelector('.my-md-dialog-actions-reject'))[0].style.display = 'none';};$scope.toggleRejectSpecialSchedulesChange = function () {_angular2.default.element(document.querySelector('.special-schedule > .schedules-reject'))[0].style.display = 'initial';_angular2.default.element(document.querySelector('.special-schedule > .my-md-dialog-actions'))[0].style.display = 'none';_angular2.default.element(document.querySelector('.special-schedule > .my-md-dialog-actions-reject'))[0].style.display = 'initial';};$scope.buttonBackSpecialSchedules = function () {_angular2.default.element(document.querySelector('.special-schedule > .schedules-reject'))[0].style.display = 'none';_angular2.default.element(document.querySelector('.special-schedule > .my-md-dialog-actions'))[0].style.display = 'initial';_angular2.default.element(document.querySelector('.special-schedule > .my-md-dialog-actions-reject'))[0].style.display = 'none';};$scope.approvedAttendanceHour = function () {$ctrl.uiState = 'LOADING';sessionStorage.setItem('requestPackage', JSON.stringify({ redirectUrl: 'unit.edit', action: 'approvalAttendanceHour', params: { id: $ctrl.id }, payload: $ctrl.id }));$state.go('unit.authentication');$mdDialog.cancel();};$scope.approvedSpecialHours = function () {$ctrl.uiState = 'LOADING';sessionStorage.setItem('requestPackage', JSON.stringify({ redirectUrl: 'unit.edit', action: 'approvedSpecialHours', params: { id: $ctrl.id }, payload: $ctrl.id }));$state.go('unit.authentication');$mdDialog.cancel();};$scope.syncSpecialHours = function () {$ctrl.uiState = 'LOADING';sessionStorage.setItem('requestPackage', JSON.stringify({ redirectUrl: 'unit.edit', action: 'syncSpecialHours', params: { id: $ctrl.id }, payload: $ctrl.id, callback: 'toggleModalSpecialSchedules' }));$state.go('unit.authentication');$mdDialog.cancel();};$scope.rejectAttendanceHour = function () {Unit.rejectAttendanceHour({ id: $ctrl.id, data: { review_reason: $scope.reasonRejection } }).then(function (data) {Toast.success($filter('translate')('toast-success-reject-attendance-hour'));$mdDialog.cancel();}).catch(function (err) {Toast.error($filter('translate')('toast-error-reject-attendance-hour'));$mdDialog.cancel();});};$scope.rejectSpecialHours = function () {UnitDetail.rejectSpecialHours({ id: $ctrl.id, data: { review_reason: $scope.reasonRejectionSpecialSchedules, reviewer_id: $scope.$root.user.id } }).then(function (data) {Toast.success($filter('translate')('toast-success-reject-special-hours'));$mdDialog.cancel();}).catch(function (err) {Toast.error($filter('translate')('toast-error-reject-special-hours'));$mdDialog.cancel();});};$scope.removeSpecialHours = function (idx, specialHour) {if (specialHour.id) {$ctrl.saving = true;Unit.removeSpecialHour(specialHour.id).then(function (resp) {$mdDialog.cancel();}).catch(function () {Toast.error($filter('translate')('common-save-error'));}).finally(function () {$ctrl.saving = false;loadSpecialHours($ctrl.id);});} else {$scope.schedulesGMB.splice(idx, 1);}};$scope.addNewSchedules = function () {$scope.schedulesGMB.push({ date: new Date(), flag: false, description: '' });};$scope.requestNewSpecialHours = function () {$scope.schedulesGMB.forEach(function (el) {delete el.id;el.is_closed = !el.is_closed;el.start_hour = (0, _moment2.default)(el.start_hour).format('LT');el.end_hour = (0, _moment2.default)(el.end_hour).format('LT');});UnitDetail.requestNewSpecialHours($scope.schedulesGMB).then(function (data) {Toast.success($filter('translate')('toast-success-request-new-special-hours'));$mdDialog.cancel();}).catch(function (err) {Toast.error($filter('translate')('toast-error-request-new-special-hours'));$mdDialog.cancel();});};$scope.hide = function () {_angular2.default.element(document.querySelector('#fileInput')).val(undefined);$mdDialog.hide();};$scope.saveHours = function () {var data = { name: $scope.eventName, special_hours: _angular2.default.copy($scope.schedulesGMB) };if ($ctrl.id) {if (eventData) data.id = eventData.id;saveEvent(_angular2.default.copy(data));} else {var dates = data.special_hours.map(function (date) {return date.date;});var orderedDates = dates.sort(function (a, b) {return Date.parse(a) - Date.parse(b);});var _event = { name: data.name, first_date: orderedDates[0], last_date: orderedDates[orderedDates.length - 1], days: data.special_hours.length, special_hours: _angular2.default.copy(data) };if (typeof idx === 'number') {$ctrl.events[idx] = _angular2.default.copy(_event);} else {$ctrl.events.push(_angular2.default.copy(_event));}}$mdDialog.cancel();};$scope.cancel = function () {_angular2.default.element(document.querySelector('#fileInput')).val(undefined);$mdDialog.cancel();};$scope.cropImage = function (image_base64) {$mdDialog.hide(image_base64);};}function loadResource(id) {if (id) {Unit.show(id).then(function (unit) {if (!unit.opening_hours.length) {unit.opening_hours.push(defaultUnitHour);}if (unit.city) {City.index({ state_id: unit.city.state_id, limit: 10000 }).then(function (cities) {$ctrl.cities = cities;$ctrl.unit = _angular2.default.copy(unit);formatUnitHours();$ctrl.uiState = 'COMPLETE';}).catch(function (err) {$ctrl.uiState = 'ERROR';});} else {$ctrl.unit = _angular2.default.copy(unit);formatUnitHours();$ctrl.uiState = 'COMPLETE';}$ctrl.locationSelected_id2 = $ctrl.newsItems.find(function (el) {return el.location_id === unit.gmb_id;});$ctrl.unitRequest = { id: unit.id, address_complement: unit.address_complement, address_neighborhood: unit.address_neighborhood, address_number: unit.address_number, address_street: unit.address_street, address_postal_code: unit.address_postal_code, is_priority_special_hours: unit.is_priority_special_hours, is_schedule_available: unit.is_schedule_available, is_visible: unit.is_visible, is_visible_service_attendance: unit.is_visible_service_attendance, latitude: unit.latitude, longitude: unit.longitude, name: unit.name, observation: unit.observation, phone_number: unit.phone_number, terms: unit.terms, image_uri: unit.image_uri, deleted_at: unit.deleted_at, gmb_id: unit.gmb_id, created_at: unit.created_at, updated_at: unit.updated_at, region_id: unit.address_complement5, city_id: unit.address_complement882 };$ctrl.hasNewsItem = unit.gmb_id ? true : false;$ctrl.prioritizeSpecialHour = unit.is_priority_special_hours === 1 ? true : false;getAttendanceHour($ctrl.unitRequest);}).catch(function (err) {$ctrl.uiState = 'ERROR';}).finally(function () {loadSpecialHours(id);});} else {$ctrl.uiState = 'COMPLETE';$scope.$apply();}}$ctrl.formatDate = function (dateStr) {var dt = new Date(dateStr);var month = dt.getMonth() + 1;return (dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()) + '/' + (month < 10 ? '0' + month : month) + '/' + dt.getFullYear();};$ctrl.getDates = function (special_hours) {var dates = (special_hours.special_hours || special_hours).map(function (special_hour) {return $ctrl.formatDate(special_hour.date);});return dates;};function formatUnitHours() {if ($ctrl.unit && $ctrl.unit.opening_hours.length) {var mapList = $ctrl.unit.opening_hours.map(function (item) {var data = { id: item.id, name: item.name, schedule_title_id: item.schedule_title ? item.schedule_title.id : item.name, type: item.type, value: item.value };return data;});$ctrl.unit.opening_hours = _angular2.default.copy(mapList);}}function loadSpecialHours(id) {$ctrl.events = [];Unit.getEvents(id).then(function (data) {$ctrl.events = _angular2.default.copy(data);}).catch(function (err) {console.log(err);});}$ctrl.specialHour = {};$ctrl.editSpecialHour = function (id, idx, event) {event.preventDefault();if (id) {Unit.getEventDetail(id).then(function (resp) {$ctrl.specialHour = _angular2.default.copy(resp[0]);toggleModalSpecialSchedules(event, _angular2.default.copy($ctrl.specialHour));$ctrl.editingSpecialHour = true;});} else if (idx.toString()) {$ctrl.specialHour = _angular2.default.copy($ctrl.events[idx]);toggleModalSpecialSchedules(event, _angular2.default.copy($ctrl.specialHour.special_hours), idx);}};function loadDomainResources() {$ctrl.uiState = 'LOADING';var promises = [];promises.push(Differential.index());promises.push(Region.index());promises.push(Service.index());promises.push(State.index());return Promise.all(promises);}function replaceSpecialChar(str) {return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');}$ctrl.toggleModalSpecialSchedules = function (event) {
	    $mdDialog.show({
	      controller: DialogController,
	      targetEvent: event,
	      template: _modalSpecialSchedules2.default,
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(function (image_base64) {
	      $ctrl.unit.image_base64 = image_base64;
	      $ctrl.myImage = '';
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  };
	
	  function toggleModalSpecialSchedules(event, eventData) {var idx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    $ctrl.editingSpecialHour = false;
	    if (eventData && eventData.special_hours.length > 0) {
	      eventData.special_hours.forEach(function (dateEvent) {
	        dateEvent.date = new Date(dateEvent.date);
	      });
	    }
	    $mdDialog.show({
	      controller: DialogController,
	      targetEvent: event,
	      template: _modalSpecialSchedules2.default,
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: false,
	      locals: {
	        eventData: _angular2.default.copy(eventData),
	        idx: idx },
	
	      fullscreen: false }).
	
	    then(function (image_base64) {
	      $ctrl.unit.image_base64 = image_base64;
	      $ctrl.myImage = '';
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  }
	
	  function toggleModalApprovalSpecialSchedules(event) {
	    $mdDialog.show({
	      controller: DialogController,
	      targetEvent: event,
	      template: _modalApprovalSpecialSchedules2.default,
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(function (image_base64) {
	      $ctrl.unit.image_base64 = image_base64;
	      $ctrl.myImage = '';
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  }
	
	  function getTimeTitleList() {
	    $ctrl.promise = TimeTitleService.getTimeTitleList().
	    then(function (response) {
	      response.data.forEach(function (item) {return $ctrl.scheduleTitles.push(item);});
	    });
	  }
	};
	
	UnitDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'City', 'Differential', 'NgMap', 'Region', 'Service', 'State', 'Toast', 'Unit', 'UnitDetail', 'TimeTitleService'];exports.default =
	
	UnitDetailController;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Image cropper dialog\" class=\"sb-ui-cropper-dialog modal-special-schedules\" style=\"width: 600px;\"> \n  <md-dialog-content class=\"my-md-dialog-content\">\n    <div class=\"modal-header\" layout=\"row\" layout-align=\"start stretch\">\n      <div flex=\"95\">\n        <p class=\"modal-header-title\">\n          Horários especiais\n        </p>\n        <p class=\"modal-header-subtitle\">\n          Insira o horário de funcionamento para os dias especiais\n        </p>\n      </div>\n      <div ng-click=\"cancel()\" class=\"icon-close\" flex=\"5\">\n        <md-icon md-font-set=\"mdi\"\n          md-font-icon=\"mdi-close\"\n          class=\"mdi-24px\">\n        </md-icon>\n      </div>\n    </div>\n\n    <div class=\"modal-body\" layout-align=\"center center\">\n      <md-input-container class=\"md-block mb-0\" flex>\n          <label>Nome do evento</label>\n          <input ng-model=\"eventName\" name=\"name\" required>\n      </md-input-container>\n\n      <div class=\"schedules-card-ul\">\n        <div ng-repeat=\"(idx, schedule) in schedulesGMB\">\n          <div class=\"schedule-week_day\" layout=\"row\" layout-align=\"start center\" >\n            <strong>\n              <input time=\"false\" date=\"true\" mdc-datetime-picker=\"\" type=\"text\" id=\"date\" day-of-week-len=\"3\"\n              placeholder=\"00/00/0000\" click-outside-to-close=\"true\" today-btn=\"false\" format=\"DD/MM/yyyy\"\n              ng-model=\"schedule.date\" min-date=\"minDate\" class=\"md-input ml-10\">\n            </strong>\n\n            <div class=\"ml-10 mt-0 schedule-toggle\" flex=\"20\"><md-switch class=\"mt-0\" ng-change=\"activeStatus(resource)\" ng-model=\"schedule.flag\" aria-label=\"Active\"></md-switch></div>\n          </div>\n\n          <div layout=\"row\">\n              <textarea ng-model=\"schedule.description\" name=\"name\" rows=\"4\" flex=\"90\" style=\"resize: none;\" required> </textarea>\n\n            <md-icon md-font-set=\"mdi\"\n              md-font-icon=\"mdi-delete\"\n              class=\"mdi-24px icon-red\"\n              style=\"cursor: pointer;\"\n              ng-click=\"removeSpecialHours(idx, schedule)\"\n              >\n            </md-icon>\n          </div>\n        </div>\n      </div>\n    </div>\n  </md-dialog-content> \n  <md-dialog-actions class=\"my-md-dialog-actions mt-3\">\n    <md-button class=\"my-md-button\" ng-click=\"addNewSchedules()\"> \n      Adicionar nova data\n    </md-button>\n    <md-button class=\"my-md-button\" ng-click=\"saveHours()\" class=\"md-accent\" ng-disabled=\"!eventName || schedulesGMB.length < 1\"> \n      Salvar \n    </md-button> \n  </md-dialog-actions> \n</md-dialog>"

/***/ }),
/* 642 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Image cropper dialog\" class=\"sb-ui-cropper-dialog modal-approval-special-schedules\"> \n  <md-dialog-content class=\"my-md-dialog-content\">\n    <div class=\"modal-header\" layout=\"row\" layout-align=\"center center\">\n      <div flex=\"95\">\n        <p class=\"modal-header-title\">\n          Aceita as mudanças de horários dessa unidade?\n        </p>\n      </div>\n      <div ng-click=\"cancel()\" class=\"icon-close\" flex=\"5\">\n        <md-icon md-font-set=\"mdi\"\n          md-font-icon=\"mdi-close\"\n          class=\"mdi-24px\">\n        </md-icon>\n      </div>\n    </div>\n    <div ng-show=\"modalBody1\" class=\"modal-body\" layout=\"column\" layout-align=\"center start\">\n      <p flex=\"100\"><strong>Unidade:</strong> {{ unit.name }}</p>\n      <p flex=\"100\"><strong>Responsável:</strong> {{ reviewerName }}</p>\n      <p flex=\"100\"><strong>Motivo:</strong> {{ approvalSchedules[0].change_reason }}</p>\n      <p flex=\"100\"><strong>Horários semanais:</strong></p>\n      <ul class=\"schedules-card-ul\">\n        <li ng-repeat=\"schedule in approvalSchedules\" layout=\"row\" layout-align=\"center center\">\n          <span class=\"schedule-week_day\" flex=\"20\">\n            <strong>\n                {{ schedule.date ? schedule.date : labelDays[schedule.week_day] }}\n            </strong>\n          </span>\n          <span class=\"schedule-toggle-label\" flex=\"20\">\n            <p>{{ (schedule.is_open ? 'open' : 'closed') | translate }}</p>\n          </span>\n          <span id=\"scheduleTimepicker\" class=\"schedule-timepicker\" flex=\"20\">\n            <strong>{{ schedule.start_hour }}</strong>\n          </span>\n          <span class=\"schedule-separator\" flex=\"10\"><p>-</p></span>\n          <span class=\"schedule-timepicker\" flex=\"20\">\n            <strong>{{ schedule.end_hour }}</strong>\n          </span>\n        </li>\n      </ul>\n      <div class=\"schedules-reject\">\n        <md-input-container class=\"md-block\" flex>\n            <label for=\"reasonRejection\">\n                Descreva o motivo da rejeição:\n            </label>\n\n            <textarea ng-model=\"reasonRejection\" name=\"reasonRejection\"\n                    md-maxlength=\"150\" rows=\"2\"\n                    md-select-on-focus required>\n            </textarea>\n\n            <div ng-messages=\"unitForm.observation.$error\" multiple>\n                <div ng-message=\"required\">\n                    {{ 'form-error-required-field' | translate}}\n                </div>\n\n                <div ng-message=\"md-maxlength\">\n                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                </div>\n            </div>\n        </md-input-container>\n      </div>\n      <div class=\"my-md-dialog-actions\">\n        <md-button class=\"my-md-button\" ng-click=\"toggleRejectSchedulesChange()\"> \n          Rejeitar \n        </md-button>\n        <md-button class=\"my-md-button\" ng-click=\"approvedAttendanceHour()\" class=\"md-accent\"> \n          Aceitar \n        </md-button>\n      </div>\n      <div class=\"my-md-dialog-actions-reject\">\n        <span class=\"my-md-button-back\" ng-click=\"buttonBack()\">voltar</span>\n        <md-button class=\"my-md-button\" ng-click=\"rejectAttendanceHour()\" class=\"md-accent\"> \n          Enviar\n        </md-button>\n      </div>\n    </div>\n    <div ng-class=\"{adjustmentModal: !modalBody1}\" ng-show=\"modalBody2\" class=\"modal-body special-schedule\" layout=\"column\" layout-align=\"center start\">\n      <div ng-show=\"!modalBody1\">\n        <p flex=\"100\"><strong>Unidade:</strong> 1 de maio</p>\n        <p flex=\"100\"><strong>Responsável:</strong> Roberto Bonfim</p>\n      </div>\n      <p flex=\"100\"><strong>Horários especiais:</strong></p>\n      <ul class=\"schedules-card-ul\">\n        <li ng-repeat=\"schedule in approvalSpecialSchedules\" layout=\"row\" layout-align=\"center center\">\n          <span class=\"schedule-week_day\" flex=\"20\">\n            <strong>\n                {{ moment(schedule.date).format('L') }}\n            </strong>\n          </span>\n          <span class=\"schedule-toggle-label\" flex=\"20\">\n            <p>{{ (schedule.is_closed ? 'closed' : 'open') | translate }}</p>\n          </span>\n          <span id=\"scheduleTimepicker\" class=\"schedule-timepicker\" flex=\"20\">\n            <strong>{{ schedule.start_hour }}</strong>\n          </span>\n          <span class=\"schedule-separator\" flex=\"10\"><p>-</p></span>\n          <span class=\"schedule-timepicker\" flex=\"20\">\n            <strong>{{ schedule.end_hour }}</strong>\n          </span>\n        </li>\n      </ul>\n      <div class=\"schedules-reject\">\n        <md-input-container class=\"md-block\" flex>\n            <label for=\"reasonRejectionSpecialSchedules\">\n                Descreva o motivo da rejeição:\n            </label>\n\n            <textarea ng-model=\"reasonRejectionSpecialSchedules\" name=\"reasonRejectionSpecialSchedules\"\n                    md-maxlength=\"150\" rows=\"2\"\n                    md-select-on-focus required>\n            </textarea>\n\n            <div ng-messages=\"unitForm.observation.$error\" multiple>\n                <div ng-message=\"required\">\n                    {{ 'form-error-required-field' | translate}}\n                </div>\n\n                <div ng-message=\"md-maxlength\">\n                    {{ 'unit-detail-form-error-title-max-length' | translate}}\n                </div>\n            </div>\n        </md-input-container>\n      </div>\n      <div class=\"my-md-dialog-actions\">\n        <md-button class=\"my-md-button\" ng-click=\"toggleRejectSpecialSchedulesChange()\"> \n          Rejeitar \n        </md-button>\n        <md-button class=\"my-md-button\" ng-click=\"approvedSpecialHours()\" class=\"md-accent\"> \n          Aceitar \n        </md-button>\n      </div>\n      <div class=\"my-md-dialog-actions-reject\">\n        <span class=\"my-md-button-back\" ng-click=\"buttonBackSpecialSchedules()\">voltar</span>\n        <md-button class=\"my-md-button\" ng-click=\"rejectSpecialHours()\" class=\"md-accent\"> \n          Enviar\n        </md-button>\n      </div>        \n    </div>\n  </md-dialog-content> \n</md-dialog>"

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(644);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./unit-detail.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./unit-detail.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".schedules-card .schedules-header{margin-top:10px}.schedules-card .schedules-header div>span{color:rgba(0,0,0,.85);font-family:Roboto;font-size:14px;text-align:center;display:block;cursor:pointer}.schedules-card .schedules-header div:first-of-type>span{color:#9b9b9b;font-family:Roboto;font-size:14px;letter-spacing:0;cursor:pointer}.schedules-card .schedules-header .schedules-header-icon{color:#b90a00;position:relative;top:-2px;cursor:pointer}.schedules-card .schedules-card-ul{margin:40px auto 20px}.schedules-card label{position:relative!important;top:0}.schedules-card .schedules-footer img{width:60px;display:block;float:left;position:relative;left:10px}.schedules-card .schedules-footer .md-accent{min-width:max-content}.schedules-card-ul{width:65%;margin:40px auto}.schedules-card-ul li{height:50px;list-style:none;display:inline-flex}.schedules-card-ul li span{height:60px;display:table}.schedules-card-ul li span>*{display:table-cell;vertical-align:middle}.schedules-card-ul li .schedule-week_day{width:100px}.schedules-card-ul li .schedule-week_day strong{width:60px;color:rgba(0,0,0,.85);font-family:Roboto;font-size:14px;font-weight:500;letter-spacing:0;line-height:19px}.schedules-card-ul li .schedule-toggle-label{min-width:95px}.schedules-card-ul li .schedule-toggle-label p{text-align:center!important}.schedules-card-ul li .schedule-timepicker .flex-gt-md-30{max-width:100%!important;position:relative;top:12px}.schedules-card-ul li .schedule-separator p{color:rgba(80,80,80,.85);text-align:center;font-family:Roboto;font-size:36px}.modal-approval-special-schedules,.modal-special-schedules{max-width:600px;padding:30px 30px 15px;box-sizing:border-box}.modal-approval-special-schedules .my-md-dialog-content,.modal-special-schedules .my-md-dialog-content{overflow-x:hidden;overflow-y:auto}.modal-approval-special-schedules .modal-header,.modal-special-schedules .modal-header{margin-top:-15px!important}.modal-approval-special-schedules .modal-header .modal-header-title,.modal-special-schedules .modal-header .modal-header-title{color:#4a4a4a;font-family:Roboto;font-size:14px;font-weight:500;letter-spacing:0}.modal-approval-special-schedules .modal-header .modal-header-subtitle,.modal-special-schedules .modal-header .modal-header-subtitle{color:#9b9b9b;font-family:Roboto;font-size:14px;letter-spacing:0;position:relative;top:-10px}.modal-approval-special-schedules .modal-header .icon-close,.modal-special-schedules .modal-header .icon-close{position:absolute;right:5px;top:5px;cursor:pointer}.modal-approval-special-schedules .modal-header #syncHoursGMB,.modal-special-schedules .modal-header #syncHoursGMB{position:absolute;top:7px;right:50px;cursor:pointer}.modal-approval-special-schedules .modal-header #syncHoursGMB .schedules-header-icon,.modal-special-schedules .modal-header #syncHoursGMB .schedules-header-icon{color:#b90a00;position:relative;top:-2px;cursor:pointer}.modal-approval-special-schedules .modal-body .schedules-card-ul,.modal-special-schedules .modal-body .schedules-card-ul{width:100%!important;margin:0 auto!important;max-height:300px}.modal-approval-special-schedules .modal-body .schedules-card-ul .schedule-week_day,.modal-special-schedules .modal-body .schedules-card-ul .schedule-week_day{position:relative;left:-10px;margin-right:0!important}.modal-approval-special-schedules .modal-body .schedules-card-ul .schedule-week_day .md-datepicker-calendar-icon svg,.modal-special-schedules .modal-body .schedules-card-ul .schedule-week_day .md-datepicker-calendar-icon svg{color:#b90a00!important}.modal-approval-special-schedules .my-md-dialog-actions,.modal-special-schedules .my-md-dialog-actions{display:block;border-top:none}.modal-approval-special-schedules .my-md-dialog-actions .my-md-button,.modal-special-schedules .my-md-dialog-actions .my-md-button{font-family:Roboto;font-size:14px;font-weight:500;text-transform:inherit}.modal-approval-special-schedules .my-md-dialog-actions .my-md-button:first-of-type,.modal-special-schedules .my-md-dialog-actions .my-md-button:first-of-type{float:left;color:#b90a00;position:relative;left:-5px}.modal-approval-special-schedules .my-md-dialog-actions .my-md-button:nth-of-type(2),.modal-special-schedules .my-md-dialog-actions .my-md-button:nth-of-type(2){float:right;color:#b90a00}.modal-approval-special-schedules .my-md-dialog-actions .my-md-button:nth-of-type(3),.modal-special-schedules .my-md-dialog-actions .my-md-button:nth-of-type(3){float:right;color:#4a4a4a}.modal-approval-special-schedules{max-width:500px;min-width:450px}.modal-approval-special-schedules .my-md-dialog-content{overflow-x:hidden;overflow-y:auto}.modal-approval-special-schedules .modal-header{margin-top:-15px!important}.modal-approval-special-schedules .modal-header .modal-header-title{color:#e02020;font-family:Roboto;font-size:14px;font-weight:500;letter-spacing:0;text-align:center;text-transform:uppercase}.modal-approval-special-schedules .modal-body{height:373px;margin-top:10px}.modal-approval-special-schedules .modal-body p{max-height:20px;color:#696969;margin:3px;text-align:left}.modal-approval-special-schedules .modal-body p:last-of-type{max-height:30px}.modal-approval-special-schedules .modal-body .schedule-week_day{min-width:75px}.modal-approval-special-schedules .modal-body .schedule-separator{margin:0 5px;position:relative;top:-1px}.modal-approval-special-schedules .modal-body .schedule-week_day>strong{font-size:16px!important;width:70px;color:rgba(80,80,80,.95)}.modal-approval-special-schedules .modal-body .schedule-timepicker{color:rgba(80,80,80,.85)}.modal-approval-special-schedules .modal-body #scheduleTimepicker{text-align:end!important}.modal-approval-special-schedules .modal-body .schedules-reject{width:100%;height:120px;overflow-x:hidden;overflow-y:auto;display:none}.modal-approval-special-schedules .modal-body .schedules-reject label{position:relative}.modal-approval-special-schedules .modal-body .schedules-reject label:after{content:none}.modal-approval-special-schedules .modal-body ul{overflow-y:auto;height:313px;max-width:318px}.modal-approval-special-schedules .modal-body ul li{height:35px}.modal-approval-special-schedules .my-md-dialog-actions{width:70%;margin:auto}.modal-approval-special-schedules .my-md-dialog-actions .my-md-button:first-of-type{color:#4a4a4a}.modal-approval-special-schedules .my-md-dialog-actions-reject{display:none;margin-bottom:-15px;border-top:none;width:100%}.modal-approval-special-schedules .my-md-dialog-actions-reject .my-md-button-back{text-transform:uppercase;font-size:10px;font-weight:700;float:left;position:relative;margin-top:12px}.modal-approval-special-schedules .my-md-dialog-actions-reject button{margin:auto;display:block;color:#e02020}.modal-approval-special-schedules .modal-body:last-of-type{margin-top:30px}.modal-approval-special-schedules .modal-body:last-of-type .my-md-dialog-actions-reject{margin:0}.modal-approval-special-schedules .adjustmentModal{margin-top:0!important}.modal-approval-special-schedules .special-schedule{height:fit-content!important}.modal-approval-special-schedules .special-schedule .schedules-card-ul{overflow-y:hidden!important;height:fit-content!important}.modal-special-schedules{min-width:600px}.modal-special-schedules ul{padding:0;overflow-y:auto}.modal-special-schedules ul .schedule-toggle{margin:0 -10px 0 10px}.modal-special-schedules ul .schedule-week_day input{width:0}.modal-special-schedules ul .schedule-toggle-label p{text-align:center!important}.flex-radio-content{display:flex;align-items:center;margin-left:50px;gap:16px}.dtp .dtp-hand.on,.dtp .dtp-picker-time>a.dtp-select-hour.selected,.dtp div.dtp-date,.dtp div.dtp-time{background-color:#b90a00}.icon-red{color:#b90a00}div .mb-0{margin-bottom:0}div .mt-0{margin-top:0}div .mt-3{margin-top:16px}.container table.md-table th.md-column{font-size:14px}.pb-3{padding-bottom:16px}", ""]);
	
	// exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _unit = __webpack_require__(570);var UnitHelper = _interopRequireWildcard(_unit);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _asyncToGenerator(fn) {return function () {var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {function step(key, arg) {try {var info = gen[key](arg);var value = info.value;} catch (error) {reject(error);return;}if (info.done) {resolve(value);} else {return Promise.resolve(value).then(function (value) {step("next", value);}, function (err) {step("throw", err);});}}return step("next");});};}
	
	var UnitService = function UnitService(Restangular) {var _this = this;
	  var Service = Restangular.all('admin/unit');
	
	  var count = function count(query) {
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(unit) {
	    if (unit.id) {
	      var copyData = angular.copy(unit);
	      delete copyData.id;
	      return unit.customPUT(copyData);
	    } else {
	      return Service.post(unit);
	    }
	  };
	
	  var saveEvent = function saveEvent(event, unit_id) {
	    if (event.id) {
	      return Restangular.all('/v2/admin/events/' + event.id).customPUT(event);
	    } else
	    {
	      return Restangular.all('/v2/admin/events/' + unit_id).post(event);
	    }
	  };
	
	  var editEvent = function editEvent(event) {
	    return Restangular.all('/v2/admin/events/' + event.id).customPUT(event);
	  };
	
	  var getEvents = function getEvents(unitID) {
	    return Restangular.all('/v2/admin/events/unit').customGET('' + unitID);
	  };
	
	  var getEventDetail = function getEventDetail(id) {
	    return Restangular.all('/v2/admin/events').customGET(id);
	  };
	
	  var removeSpecialHour = function removeSpecialHour(id) {
	    return Restangular.all('/v2/admin/special_hours/' + id).remove();
	  };
	
	  var removeEvent = function removeEvent(id) {
	    return Restangular.all('/v2/admin/events/' + id).remove();
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(unit) {
	    unit.deleted_at = moment();
	    return unit.save();
	  };
	
	  var downloadReport = function downloadReport() {
	    return Restangular.one('unit/report').get();
	  };
	
	  var rejectAttendanceHour = function rejectAttendanceHour(payload) {return Service.customPUT(payload.data, payload.id + '/attendance_hour/reject');};
	
	  var approvalAttendanceHour = function () {var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(unitId) {return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:_context.t0 = Service;_context.next = 3;return (
	                UnitHelper.getToken());case 3:_context.t1 = _context.sent;_context.t2 = { "access_token": _context.t1 };_context.t3 =
	              unitId + '/attendance_hour/approval';return _context.abrupt('return', _context.t0.customPUT.call(_context.t0, _context.t2, _context.t3));case 7:case 'end':return _context.stop();}}}, _callee, _this);}));return function approvalAttendanceHour(_x) {return _ref.apply(this, arguments);};}();
	
	  return { load: load, save: save, show: show, destroy: destroy, downloadReport: downloadReport, rejectAttendanceHour: rejectAttendanceHour, approvalAttendanceHour: approvalAttendanceHour, saveEvent: saveEvent, getEvents: getEvents, getEventDetail: getEventDetail, editEvent: editEvent, removeSpecialHour: removeSpecialHour, removeEvent: removeEvent };
	};
	
	UnitService.$inject = ['Restangular'];exports.default =
	
	UnitService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _unit = __webpack_require__(570);var UnitHelper = _interopRequireWildcard(_unit);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}
	
	var uriProduction = 'https://api.sabin.com.br';
	var uriDeveloper = 'https://apidev.cloudsabin.com';
	var uriStaging = 'https://api-staging.cloudsabin.com';
	var uriLocalhost = 'http://localhost:3000';
	
	var urls = [
	{ 'localhost:8080': uriLocalhost },
	{ 'localhost:4200': uriDeveloper },
	{ 'backofficedev.cloudsabin.com': uriDeveloper },
	{ 'backoffice-staging.cloudsabin.com': uriStaging },
	{ 'backoffice.sabin.com.br': uriProduction }];
	
	
	
	var UnitDetailService = function UnitDetailService(Restangular) {
	  var Service = Restangular.allUrl('admin/attendance_hour', urls.find(function (elem) {return elem[window.location.host];})[window.location.host]);
	  var ServiceAdmin = Restangular.all('admin/attendance_hour_approval');
	  var ServiceAdminSpecialHours = Restangular.all('admin/special_hours');
	  var ServiceAdminAttendanceHour = Restangular.all('admin/attendance_hour');
	
	  var getAttendanceHour = function getAttendanceHour(unitId) {return Service.customGET('attendance_hour', { unit_id: unitId });};
	
	  var getLocationsGMB = function getLocationsGMB() {return Service.customPOST({
	      "access_token": UnitHelper.getToken() }, 'units/sync');};
	
	
	  var syncHoursGMB = function syncHoursGMB(unitId) {return ServiceAdminAttendanceHour.customPUT({
	      "access_token": UnitHelper.getToken() }, 'unit/' +
	    unitId + '/sync_hours');};
	
	  var requestChangeSchedule = function requestChangeSchedule(schedules) {return ServiceAdmin.post(schedules);};
	
	  var getRequestChangeSchedule = function getRequestChangeSchedule() {return ServiceAdmin.customGET();};
	
	  var requestNewSpecialHours = function requestNewSpecialHours(specialHours) {return ServiceAdminSpecialHours.post(specialHours);};
	
	  var rejectSpecialHours = function rejectSpecialHours(payload) {return ServiceAdminSpecialHours.customPUT(payload.data, payload.id + '/reject');};
	
	  var removeSpecialHours = function removeSpecialHours(payload) {return ServiceAdminSpecialHours.customPUT({
	      "access_token": UnitHelper.getToken(),
	      "hour_id": payload.data.hour_id },
	    payload.id + '/remove');};
	
	  var approveSpecialHours = function approveSpecialHours(unitId) {return ServiceAdminSpecialHours.customPUT({
	      "access_token": UnitHelper.getToken() },
	    unitId + '/approve');};
	
	  var syncSpecialHours = function syncSpecialHours(unitId) {return ServiceAdminSpecialHours.customPUT({
	      "access_token": UnitHelper.getToken() },
	    unitId + '/sync_hours');};
	
	  return {
	    syncHoursGMB: syncHoursGMB,
	    getAttendanceHour: getAttendanceHour,
	    requestChangeSchedule: requestChangeSchedule,
	    requestNewSpecialHours: requestNewSpecialHours,
	    getRequestChangeSchedule: getRequestChangeSchedule,
	    getLocationsGMB: getLocationsGMB,
	    rejectSpecialHours: rejectSpecialHours,
	    approveSpecialHours: approveSpecialHours,
	    removeSpecialHours: removeSpecialHours,
	    syncSpecialHours: syncSpecialHours };
	
	};
	
	UnitDetailService.$inject = ['Restangular'];exports.default =
	
	UnitDetailService;

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var TimeTitleService = function TimeTitleService(Restangular) {
	  var ServiceAPI = Restangular.all('admin/schedule_titles');
	
	  var getTimeTitleList = function getTimeTitleList(query) {
	    return Restangular.all('schedule_titles').customGET("", query);
	  };
	
	  var save = function save(resource) {
	    if (resource.id) {
	      var copyData = angular.copy(resource);
	      delete copyData.id;
	      return ServiceAPI.customPUT(copyData, resource.id);
	    } else {
	      return ServiceAPI.post(resource);
	    }
	  };
	
	  var destroy = function destroy(resource) {
	    return ServiceAPI.customDELETE(resource.id);
	  };
	
	  return { getTimeTitleList: getTimeTitleList, save: save, destroy: destroy };
	};
	
	TimeTitleService.$inject = ['Restangular'];exports.default =
	
	TimeTitleService;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _procedure = __webpack_require__(649);var _procedure2 = _interopRequireDefault(_procedure);
	var _procedureList = __webpack_require__(654);var _procedureList2 = _interopRequireDefault(_procedureList);
	var _procedureDetail = __webpack_require__(657);var _procedureDetail2 = _interopRequireDefault(_procedureDetail);
	var _procedure3 = __webpack_require__(660);var _procedure4 = _interopRequireDefault(_procedure3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var procedureModule = _angular2.default.module('procedure', [
	_angularUiRouter2.default]).
	
	
	service('Procedure', _procedure4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/procedure');
	
	  $stateProvider.
	  state('procedure', {
	    component: 'procedure' }).
	
	  state('procedure.list', {
	    url: '/procedure',
	    component: 'procedureList' }).
	
	  state('procedure.create', {
	    url: '/procedure/new',
	    component: 'procedureDetail',
	    params: {
	      id: "" } }).
	
	
	  state('procedure.show', {
	    url: '/procedure/:id',
	    component: 'procedureDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('procedure', _procedure2.default).
	component('procedureList', _procedureList2.default).
	component('procedureDetail', _procedureDetail2.default).
	
	name;exports.default =
	
	procedureModule;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _procedure = __webpack_require__(650);var _procedure2 = _interopRequireDefault(_procedure);
	var _procedure3 = __webpack_require__(651);var _procedure4 = _interopRequireDefault(_procedure3);
	__webpack_require__(652);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var procedureComponent = {
	  bindings: {},
	  template: _procedure2.default,
	  controller: _procedure4.default };exports.default =
	
	
	procedureComponent;

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 651 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var ProcedureController =
	function ProcedureController() {_classCallCheck(this, ProcedureController);
	  this.name = 'procedure';
	};exports.default =
	
	
	ProcedureController;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(653);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./procedure.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./procedure.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".sb-procedure .sb-reference-values-table div.refrence-value-cell{margin-top:8px;padding:8px;background-color:rgba(0,0,0,.08)}", ""]);
	
	// exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _procedureList = __webpack_require__(655);var _procedureList2 = _interopRequireDefault(_procedureList);
	var _procedureList3 = __webpack_require__(656);var _procedureList4 = _interopRequireDefault(_procedureList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var procedureListComponent = {
	  bindings: {},
	  template: _procedureList2.default,
	  controller: _procedureList4.default };exports.default =
	
	
	procedureListComponent;

/***/ }),
/* 655 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"end\">\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'procedure-list-table-header-name' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"description\"\n                        ng-click=\"$ctrl.orderList('description')\">\n                        {{ 'procedure-list-table-header-description' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'common-updated-at' | translate }}\n                    </th>\n\n                    <th md-column>\n                        {{ 'common-updated-active' | translate }}\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\">\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.show(resource.id)\">\n                    \t{{ resource.name }}\n                    </td>\n\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.show(resource.id)\">\n                    \t{{ resource.description }}\n                    </td>\n\n                    <td md-cell ng-click=\"$ctrl.show(resource.id)\">\n                    \t{{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n                    <td md-cell>\n                      <md-switch ng-change=\"activeStatus(resource)\" ng-model=\"resource.is_active\" aria-label=\"Active\"></md-switch>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var ProcedureListController = function ProcedureListController(Procedure, $filter, Toast, $scope, $state) {
	  var $ctrl = this;
	  $ctrl.resources;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    show: show, orderList: orderList });
	
	
	  activate();
	
	
	  $scope.activeStatus = function (resource) {
	
	    Procedure.
	    save(resource).
	    then(function (response) {
	      $ctrl.resource = response;
	      var messageSuccess = $filter('translate')('procedure-list-active-success');
	      Toast.success(messageSuccess);
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      var messageError = $filter('translate')('procedure-list-active-error');
	      Toast.error(messageError);
	    });
	
	  };
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name',
	      like_search: '',
	      like_search_fields: [
	      'name',
	      'description'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function show(id) {
	    $state.go('procedure.show', { id: id });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Procedure.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      setPlaceHolderValues(response.data);
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	ProcedureListController.$inject = ['Procedure', '$filter', 'Toast', '$scope', '$state'];exports.default =
	
	ProcedureListController;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _procedureDetail = __webpack_require__(658);var _procedureDetail2 = _interopRequireDefault(_procedureDetail);
	var _procedureDetail3 = __webpack_require__(659);var _procedureDetail4 = _interopRequireDefault(_procedureDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var procedureDetailComponent = {
	  bindings: {},
	  template: _procedureDetail2.default,
	  controller: _procedureDetail4.default };exports.default =
	
	
	procedureDetailComponent;

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-procedure\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <!-- procedure -->\n        <div layout=\"column\" class=\"sb-page-section\">\n            <h3 class=\"sb-page-section-title\">{{ 'procedure-detail-title' | translate }}</h3>\n\n            <p class=\"sb-page-section-sub-title\">\n                {{ 'procedure-detail-title-caption' | translate }}\n            </p>\n\n            <md-card>\n                <!-- name methodology-->\n                <div layout=\"row\" flex>\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'procedure-detail-name' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">{{ $ctrl.procedure.name }}</p>\n                    </div>\n\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'procedure-detail-methodology' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                            {{ $ctrl.procedure.methodology }}\n                        </p>\n                    </div>\n                </div>\n\n                <!-- result_time  -->\n                <div layout=\"row\" flex>\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'procedure-detail-result_time' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">{{ $ctrl.procedure.result_time }}</p>\n                    </div>\n\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'procedure-detail-fasting_hours' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                            {{ $ctrl.procedure.fasting_hours }} \n                            {{ 'common-hours' | translate }}\n                        </p>\n                    </div>\n                </div>\n\n                <!-- collection_material client_info  -->\n                <div layout=\"row\" flex>\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'procedure-detail-collection_material' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                            {{ $ctrl.procedure.collection_material }}\n                        </p>\n                    </div>\n\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'procedure-detail-collection_info' | translate }}\n                        </p>\n                        <p class=\"sb-body-2 sb-truncate\">\n                            {{ $ctrl.procedure.collection_info }}\n                        </p>\n                    </div>\n                </div>\n\n                <!-- description -->\n                <div layout=\"row\" flex>\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'procedure-detail-description' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                            {{ $ctrl.procedure.description }}\n                        </p>\n                    </div>\n                </div>\n\n                <!-- collection_info -->\n                <div layout=\"row\" flex>\n                    <div layout=\"column\" flex>\n                        <p class=\"sb-title\">\n                            {{ 'procedure-detail-client_info' | translate }}\n                        </p>\n                        <p class=\"sb-body-2\">\n                            {{ $ctrl.procedure.client_info }} \n                        </p>\n                    </div>\n                </div>\n            </md-card>\n        </div>\n\n        <!-- reference_values -->\n        <div layout=\"column\" class=\"sb-page-section\">\n            <h3 class=\"sb-page-section-title\">{{ 'procedure-detail-reference-values-title' | translate }}</h3>\n\n            <p class=\"sb-page-section-sub-title\">\n                {{ 'procedure-detail-reference-values-title-caption' | translate }}\n            </p>\n\n            <md-card>\n                <div layout=\"row\" flex>\n                    <p class=\"sb-title\" flex>\n                        {{ 'procedure-detail-reference-value-value' | translate }}\n                    </p>\n\n                    <div style=\"width: 8px;\"></div>\n                    \n                    <p class=\"sb-title\" flex>\n                        {{ 'procedure-detail-reference-value-description' | translate }}\n                    </p>\n                </div>\n\n                <div layout=\"row\" class=\"sb-reference-values-table\" flex ng-repeat=\"rv in $ctrl.procedure.procedure_reference_values\">\n                    <div layout=\"column\" flex class=\"refrence-value-cell\">\n                        <p class=\"sb-body-2\">\n                            {{ rv.description }}\n                        </p>\n                    </div>\n\n                    <div style=\"width: 8px;\"></div>\n\n                    <div layout=\"column\" flex class=\"refrence-value-cell\">\n                        <p ng-show=\"rv.value\" class=\"sb-body-2\">\n                            {{ rv.value }}\n                        </p>\n\n                        <p ng-show=\"!rv.value\" class=\"sb-body-2\">\n                            {{ 'common-not-informed' | translate }}\n                        </p>\n                    </div>\n                </div>\n            </md-card>\n        </div>\n\n        <!-- form actions -->\n        <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n            <md-button page-back\n                       ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                {{ 'common-go-back-button-text' | translate }}\n            </md-button>\n        </div>\n\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var ProcedureDetailController = function ProcedureDetailController($filter, $mdDialog, $scope, $state, Procedure, Toast) {
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.procedure;
	
	  activate();
	
	  function activate() {
	    loadResource($ctrl.id);
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Procedure.show(id).
	      then(function (response) {
	        setPlaceHolderValues(response);
	        $ctrl.procedure = response;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	      $scope.$apply();
	    }
	  }
	
	  function setPlaceHolderValues(obj) {
	    _.forEach(obj, function (value, key) {
	      if (value === null || value === undefined) {
	        obj[key] = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	ProcedureDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Procedure', 'Toast'];exports.default =
	
	ProcedureDetailController;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var ProcedureService = function ProcedureService(Restangular) {
	  var Service = Restangular.all('admin/procedure');
	
	  var count = function count(query) {
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	ProcedureService.$inject = ['Restangular'];exports.default =
	
	ProcedureService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _vaccine = __webpack_require__(662);var _vaccine2 = _interopRequireDefault(_vaccine);
	var _vaccineList = __webpack_require__(667);var _vaccineList2 = _interopRequireDefault(_vaccineList);
	var _vaccineDetail = __webpack_require__(671);var _vaccineDetail2 = _interopRequireDefault(_vaccineDetail);
	var _vaccine3 = __webpack_require__(674);var _vaccine4 = _interopRequireDefault(_vaccine3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var vaccineModule = _angular2.default.module('vaccine', [
	_angularUiRouter2.default]).
	
	
	service('Vaccine', _vaccine4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/vaccine');
	
	  $stateProvider.
	  state('vaccine', {
	    component: 'vaccine' }).
	
	  state('vaccine.list', {
	    url: '/vaccine',
	    component: 'vaccineList' }).
	
	  state('vaccine.create', {
	    url: '/vaccine/new',
	    component: 'vaccineDetail',
	    params: {
	      id: "" } }).
	
	
	  state('vaccine.edit', {
	    url: '/vaccine/:id/edit',
	    component: 'vaccineDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('vaccine', _vaccine2.default).
	component('vaccineList', _vaccineList2.default).
	component('vaccineDetail', _vaccineDetail2.default).
	
	name;exports.default =
	
	vaccineModule;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _vaccine = __webpack_require__(663);var _vaccine2 = _interopRequireDefault(_vaccine);
	var _vaccine3 = __webpack_require__(664);var _vaccine4 = _interopRequireDefault(_vaccine3);
	__webpack_require__(665);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var vaccineComponent = {
	  bindings: {},
	  template: _vaccine2.default,
	  controller: _vaccine4.default };exports.default =
	
	
	vaccineComponent;

/***/ }),
/* 663 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var VaccineController =
	function VaccineController() {_classCallCheck(this, VaccineController);
	  this.name = 'vaccine';
	};exports.default =
	
	
	VaccineController;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(666);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./vaccine.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./vaccine.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".vaccine{color:red}.input-search{margin-left:auto}tr.md-row:active td{background-color:#adadad}", ""]);
	
	// exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _vaccineList = __webpack_require__(668);var _vaccineList2 = _interopRequireDefault(_vaccineList);
	var _vaccineList3 = __webpack_require__(669);var _vaccineList4 = _interopRequireDefault(_vaccineList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var vaccineListComponent = {
	  bindings: {},
	  template: _vaccineList2.default,
	  controller: _vaccineList4.default };exports.default =
	
	
	vaccineListComponent;

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"flex start\"\n         ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n        <md-button class=\"md-raised md-accent\" ui-sref=\"vaccine.create\">\n            {{ 'common-new-feminine' | translate }}\n        </md-button>\n\n        <md-button ng-click=\"downloadReport()\" class=\"md-raised md-accent\"\n        ng-disabled=\"$ctrl.activeSpin\"\n        ng-class=\"{'button-spin-active': $ctrl.activeSpinButton }\" >\n            <span ng-show=\"!$ctrl.activeSpin\">{{ 'button-download-report' | translate }}</span>\n            <span ng-show=\"$ctrl.activeSpin\">{{ 'button-download-report-spin' | translate }} <md-progress-circular md-mode=\"indeterminate\" class=\"md-accent md-hue-1 button-loader\" md-diameter=\"20\"></md-progress-circular></span>\n        </md-button>\n\n        <md-card class=\"input-search\">\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'vaccine-list-table-header-name' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"short_name\"\n                        ng-click=\"$ctrl.orderList('short_name')\">\n                        {{ 'vaccine-list-table-header-short_name' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'common-updated-at' | translate }}\n                    </th>\n\n                    <th md-column md-numeric class=\"sb-table-column-xs\">\n                    </th>\n                  </tr>\n                </thead>\n\n                <tbody md-body id=\"items\">\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit(resource.id)\" data-id=\"{{resource.id}}\">\n                    <td md-cell class=\"sb-table-truncate\">\n                    \t{{ resource.name }}\n                    </td>\n\n                    <td md-cell class=\"sb-table-truncate\">\n                        {{ resource.short_name }}\n                    </td>\n\n                    <td md-cell>\n                    \t{{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n\n                    <td md-cell>\n                        <md-button aria-label=\"Toolbar menu\"\n                                   class=\"md-icon-button\"\n                                   ng-click=\"$ctrl.handleDelete(resource, $event)\">\n                          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n          md-limit-options=\"[10, 30, 50, 100, 200]\"\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'vaccine-list-empty-state-line-1' | translate }}</p>\n                <p>{{ 'vaccine-list-empty-state-line-2' | translate }}</p>\n            </div>\n\n            <md-button class=\"md-raised md-accent\" ui-sref=\"vaccine.create\">\n                {{ 'vaccine-list-create-vaccine-button' | translate }}\n            </md-button>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _FileSaver = __webpack_require__(633);
	var _sortablejs = __webpack_require__(670);var _sortablejs2 = _interopRequireDefault(_sortablejs);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	
	var VaccineListController = function VaccineListController(Vaccine, $filter, $scope, $state, $mdDialog, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'updated_at DESC',
	      like_search: '',
	      like_search_fields: [
	      'name',
	      'short_name'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	
	    createSortableList();
	  }
	
	  function createSortableList() {
	    var el = document.getElementById("items");
	    var sortable = _sortablejs2.default.create(el, { onUpdate: reorderListItems });
	  }
	
	  function reorderListItems(event) {var
	    oldIndex = event.oldIndex,newIndex = event.newIndex;
	    var listCopy = _angular2.default.copy($ctrl.resources.data);
	    var id = event.item.getAttribute("data-id");
	
	    Vaccine.updatePosition(id, {
	      new_position: listCopy[newIndex].position,
	      old_position: listCopy[oldIndex].position }).
	
	    then(function (res) {
	      Toast.success($filter('translate')('table-list-new-order'));
	    }).
	    catch(function (_ref) {var data = _ref.data;
	      Toast.error(data.message);
	    }).
	    finally(function () {return loadData();});
	
	    var elementToMove = $ctrl.resources.data.splice(oldIndex, 1);
	    $ctrl.resources.data.splice(newIndex, 0, elementToMove[0]);
	  }
	
	  $scope.downloadReport = function () {
	    $ctrl.activeSpin = true;
	    $ctrl.activeSpinButton = true;
	    Vaccine.
	    downloadReport().
	    then(function (res) {
	      var file = new Blob([res], { type: 'text/csv;charset=utf-8;' });
	      var messageSuccess = $filter('translate')('report-success');
	      $ctrl.activeSpin = false;
	      $ctrl.activeSpinButton = false;
	      Toast.success(messageSuccess);
	      (0, _FileSaver.saveAs)(file, 'rel_analitico_vacinas.csv');
	    }).catch(function (err) {
	      console.log('err:', err);
	      var messageError = $filter('translate')('report-error');
	      $ctrl.activeSpin = false;
	      $ctrl.activeSpinButton = false;
	      Toast.error(messageError);
	    });
	  };
	
	  function edit(id) {
	    $state.go('vaccine.edit', { id: id });
	  }
	
	  function handleDelete(resource, event) {
	    event.stopPropagation();
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Vaccine.
	      destroy(resource).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        _.remove($ctrl.resources.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Vaccine.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      setPlaceHolderValues(response.data);
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.short_name === null || item.short_name === undefined) {
	        item.short_name = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	VaccineListController.$inject = ['Vaccine', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];exports.default =
	
	VaccineListController;

/***/ }),
/* 670 */,
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _vaccineDetail = __webpack_require__(672);var _vaccineDetail2 = _interopRequireDefault(_vaccineDetail);
	var _vaccineDetail3 = __webpack_require__(673);var _vaccineDetail4 = _interopRequireDefault(_vaccineDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var vaccineDetailComponent = {
	  bindings: {},
	  template: _vaccineDetail2.default,
	  controller: _vaccineDetail4.default };exports.default =
	
	
	vaccineDetailComponent;

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-vaccine\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <form name=\"vaccineForm\" ng-submit=\"$ctrl.handleSave(vaccineForm, $ctrl.vaccine)\" \n              novalidate>\n            <!-- vaccine  -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">{{ 'vaccine-detail-title' | translate }}</h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'vaccine-detail-title-caption' | translate }}\n                </p>\n\n                <md-card>\n                    <!-- name short_name -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'vaccine-detail-form-vaccine-name' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.vaccine.name\" name=\"name\" \n                                   required>\n                            </input>\n\n                            <div ng-messages=\"vaccineForm.name.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'vaccine-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'vaccine-detail-form-vaccine-short_name' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.vaccine.short_name\" name=\"short_name\" \n                                   md-maxlength=\"20\">\n                            </input>\n\n                            <div ng-messages=\"vaccineForm.short_name.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'vaccine-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <!-- schema -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'vaccine-detail-form-vaccine-schema' | translate }}\n                            </label>\n\n                            <textarea ng-model=\"$ctrl.vaccine.schema\" name=\"schema\"\n                                      rows=\"2\" required \n                                      md-select-on-focus>\n                            </textarea>\n\n                            <div ng-messages=\"vaccineForm.schema.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'vaccine-detail-form-error-schema-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <!-- comment -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'vaccine-detail-form-vaccine-comment' | translate }}\n                            </label>\n\n                            <textarea ng-model=\"$ctrl.vaccine.comment\" name=\"comment\"\n                                      rows=\"2\" \n                                      md-select-on-focus>\n                            </textarea>\n\n                            <div ng-messages=\"vaccineForm.comment.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'vaccine-detail-form-error-comment-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <!-- recommendations -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'vaccine-detail-form-vaccine-recommendations' | translate }}\n                            </label>\n\n                            <textarea ng-model=\"$ctrl.vaccine.recommendations\" name=\"recommendations\"\n                                      rows=\"2\" \n                                      md-select-on-focus>\n                            </textarea>\n\n                            <div ng-messages=\"vaccineForm.recommendations.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'vaccine-detail-form-error-recommendations-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- target_groups -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">\n                    {{ 'vaccine-detail-section-title-target_groups' | translate }}\n                </h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'vaccine-detail-section-title-target_groups-caption' | translate }}\n                </p>\n\n                <md-card>\n                    <div ng-repeat=\"topLevelGroup in $ctrl.topLevelGroups\"\n                         class=\"sb-checkboxes\">\n                        <p class=\"sb-section-title\">{{ topLevelGroup.name }}</p>\n\n                        <div layout=\"row\" layout-wrap>\n                            <md-checkbox ng-repeat=\"bottomLevelGroup in topLevelGroup.bottomLevelGroups\" flex\"\n                                         ng-click=\"$ctrl.toggleItemInList($ctrl.vaccine.target_groups, bottomLevelGroup)\"\n                                         ng-checked=\"$ctrl.isIdInList($ctrl.vaccine.target_groups, bottomLevelGroup.id)\"\n                                         layout=\"row\" layout-align=\"start-center\">\n                                {{ bottomLevelGroup.name }}\n                            </md-checkbox>\n                        </div>\n                    </div>\n\n                    <div class=\"sb-error-message\"\n                         ng-show=\"vaccineForm.$submitted && !$ctrl.vaccine.target_groups.length && !$ctrl.saving\">\n                        {{ 'vaccine-detail-form-error-required-target_groups' | translate }}\n                    </div>\n\n                </md-card>\n            </div>\n\n            <!-- form actions -->\n            <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n                <md-button page-back\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                    {{ 'common-cancel-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.handleDelete($ctrl.vaccine, $event)\"\n                           ng-if=\"$ctrl.id && !$ctrl.vaccine.is_super\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-warn md-raised\">\n                    {{ 'common-delete-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.clearForm(vaccineForm)\"\n                           ng-if=\"!$ctrl.id\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-raised\">\n                    {{ 'common-clear-button-text' | translate }}\n                </md-button>\n\n                <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-accent md-raised\">\n                    {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                </md-button>\n            </div>\n        </form>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var VaccineDetailController = function VaccineDetailController($filter, $mdDialog, $scope, $state, Target, Toast, Vaccine) {
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.vaccine;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete,
	    isIdInList: isIdInList,
	    toggleItemInList: toggleItemInList });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    loadDomainResources().
	    then(function (result) {
	      var targetGroups = result[0];
	      buildCheckboxSections(targetGroups);
	      loadResource($ctrl.id);
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function clearForm(form) {
	    $ctrl.vaccine = {
	      target_groups: [] };
	
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(vaccine, event) {
	    var confirmMessage = 'vaccine-detail-delete-confirm-text';
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')(confirmMessage)).
	    ariaLabel($filter('translate')(confirmMessage)).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Vaccine.
	      destroy(vaccine).
	      then(function (response) {
	        Toast.success($filter('translate')('vaccine-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('vaccine.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, vaccine) {
	    if (!form.$valid || !vaccine.target_groups.length) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    save(vaccine);
	  }
	
	  function isIdInList(list, id) {
	    return _.find(list, { id: id });
	  }
	
	  function toggleItemInList(list, item) {
	    if (_.find(list, { id: item.id })) {
	      _.remove(list, { id: item.id });
	    } else {
	      list.push(item);
	    }
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Vaccine.show(id).
	      then(function (response) {
	        $ctrl.vaccine = response;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	      $scope.$apply();
	    }
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Target.index({ limit: 1000000, parent_group_id: 'null' }));
	
	    return Promise.all(promises);
	  }
	
	  function buildCheckboxSections(topLevelGroups) {
	    _.forEach(topLevelGroups, function (topLevelGroup) {
	      var bottomLevelGroups = [];
	
	      _.forEach(topLevelGroup.sub_groups, function (subGroup) {
	        if (_.isEmpty(subGroup.sub_groups)) {
	          bottomLevelGroups.push(subGroup);
	        } else {
	          _.forEach(subGroup.sub_groups, function (bottomLevelGroup) {
	            bottomLevelGroup.name = bottomLevelGroup.name + ' (' + subGroup.name + ')';
	            bottomLevelGroups.push(bottomLevelGroup);
	          });
	        }
	      });
	
	      topLevelGroup.bottomLevelGroups = bottomLevelGroups;
	    });
	
	    $ctrl.topLevelGroups = topLevelGroups;
	  }
	
	  function save(vaccine) {
	    $ctrl.saving = true;
	
	    Vaccine.
	    save(vaccine).
	    then(function (response) {
	      Toast.success($filter('translate')('vaccine-detail-save-success'));
	      $ctrl.vaccine = response;
	      $state.go('vaccine.list');
	    }).
	    catch(function (err) {
	      var defaultErrMsg = $filter('translate')('common-server-error');
	      var fourONineMsg = $filter('translate')('vaccine-detail-409-error');
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error(message);
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	};
	
	VaccineDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Target', 'Toast', 'Vaccine'];exports.default =
	
	VaccineDetailController;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var VaccineService = function VaccineService(Restangular) {
	  var Service = Restangular.all('admin/vaccine');
	
	  var count = function count(query) {
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  var downloadReport = function downloadReport() {
	    return Restangular.one('vaccine/report').get();
	  };
	
	  var updatePosition = function updatePosition(id, data) {
	    return Service.customPATCH(data, 'position/' + id);
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy, downloadReport: downloadReport, updatePosition: updatePosition };
	};
	
	VaccineService.$inject = ['Restangular'];exports.default =
	
	VaccineService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _target = __webpack_require__(676);var _target2 = _interopRequireDefault(_target);
	var _targetList = __webpack_require__(681);var _targetList2 = _interopRequireDefault(_targetList);
	var _targetCategoryList = __webpack_require__(684);var _targetCategoryList2 = _interopRequireDefault(_targetCategoryList);
	var _target3 = __webpack_require__(685);var _target4 = _interopRequireDefault(_target3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var targetModule = _angular2.default.module('target', [
	_angularUiRouter2.default]).
	
	
	service('Target', _target4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/target');
	
	  $stateProvider.
	  state('target', {
	    component: 'target' }).
	
	  state('target.list', {
	    url: '/target',
	    component: 'targetList',
	    params: {
	      parent_group_id: 'null' } }).
	
	
	  state('target.category', {
	    url: '/target/category',
	    component: 'targetCategoryList' });
	
	}]).
	
	component('target', _target2.default).
	component('targetList', _targetList2.default).
	component('targetCategoryList', _targetCategoryList2.default).
	
	name;exports.default =
	
	targetModule;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _target = __webpack_require__(677);var _target2 = _interopRequireDefault(_target);
	var _target3 = __webpack_require__(678);var _target4 = _interopRequireDefault(_target3);
	__webpack_require__(679);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var targetComponent = {
	  bindings: {},
	  template: _target2.default,
	  controller: _target4.default };exports.default =
	
	
	targetComponent;

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var TargetController =
	function TargetController() {_classCallCheck(this, TargetController);
	  this.name = 'target';
	};exports.default =
	
	
	TargetController;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(680);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./target.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./target.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".target{color:red}tr.md-row:active td{background-color:#adadad}", ""]);
	
	// exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _targetList = __webpack_require__(682);var _targetList2 = _interopRequireDefault(_targetList);
	var _targetList3 = __webpack_require__(683);var _targetList4 = _interopRequireDefault(_targetList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var targetListComponent = {
	  bindings: {},
	  template: _targetList2.default,
	  controller: _targetList4.default };exports.default =
	
	
	targetListComponent;

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div layout=\"row\" layout-align=\"flex start\">\n    <md-button\n      class=\"md-raised md-accent\"\n      ng-click=\"$ctrl.showCreateDialog($event)\"\n    >\n      {{ 'common-new-masculine' | translate }}\n    </md-button>\n\n    <md-button\n      ng-if=\"!$ctrl.parentGroupId\"\n      ng-click=\"downloadReport()\"\n      class=\"md-raised md-accent\"\n      ng-disabled=\"$ctrl.activeSpin\"\n      ng-class=\"{'button-spin-active': $ctrl.activeSpinButton }\"\n    >\n      <span ng-show=\"!$ctrl.activeSpin\"\n        >{{ 'button-download-report' | translate }}</span\n      >\n      <span ng-show=\"$ctrl.activeSpin\">\n        {{ 'button-download-report-spin' | translate }}\n        <md-progress-circular\n          md-mode=\"indeterminate\"\n          class=\"md-accent md-hue-1 button-loader\"\n          md-diameter=\"20\"\n        ></md-progress-circular>\n      </span>\n    </md-button>\n\n    <md-card class=\"input-search\">\n      <div class=\"sb-table-search\">\n        <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n        </md-icon>\n\n        <input\n          ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n          ng-model-options=\"{ debounce: 1000 }\"\n          type=\"text\"\n          name=\"\"\n        />\n      </div>\n    </md-card>\n  </div>\n\n  <md-card\n    ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\"\n  >\n    <md-table-container>\n      <table md-table md-progress=\"$ctrl.promise\">\n        <thead md-head>\n          <tr md-row>\n            <th md-column md-order-by=\"name\" ng-click=\"$ctrl.orderList('name')\">\n              {{ 'target-list-table-header-name' | translate }}\n            </th>\n\n            <th\n              ng-if=\"!$ctrl.parentGroupId\"\n              md-column\n              md-order-by=\"parent_group.name\"\n              ng-click=\"$ctrl.orderList('parent_group.name')\"\n            >\n              {{ 'target-list-table-header-target-group' | translate }}\n            </th>\n\n            <th ng-if=\"!$ctrl.parentGroupId\" md-column>\n              {{ 'target-list-table-header-parent-group' | translate }}\n            </th>\n\n            <th\n              md-column\n              md-numeric\n              md-order-by=\"updated_At\"\n              ng-click=\"$ctrl.orderList('updated_At')\"\n            >\n              {{ 'common-updated-at' | translate }}\n            </th>\n\n            <th md-column md-numeric class=\"sb-table-column-xs\"></th>\n          </tr>\n        </thead>\n\n        <tbody md-body id=\"items\">\n          <tr\n            md-row\n            ng-repeat=\"resource in $ctrl.resources.data\"\n            ng-click=\"$ctrl.edit($event, resource)\"\n            data-id=\"{{resource.id}}\"\n          >\n            <td md-cell class=\"sb-table-truncate\">{{ resource.name }}</td>\n\n            <td ng-if=\"!$ctrl.parentGroupId\" md-cell class=\"sb-table-truncate\">\n              {{ resource.parent_group.parent_group ?\n              resource.parent_group.parent_group.name :\n              resource.parent_group.name }}\n            </td>\n\n            <td ng-if=\"!$ctrl.parentGroupId\" md-cell class=\"sb-table-truncate\">\n              {{ resource.parent_group.parent_group ? resource.parent_group.name\n              : 'common-none-feminine' | translate }}\n            </td>\n\n            <td md-cell>\n              {{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n            </td>\n\n            <td md-cell class=\"sb-table-column-xs\">\n              <md-button\n                aria-label=\"Toolbar menu\"\n                class=\"md-icon-button\"\n                ng-click=\"$ctrl.handleDelete(resource, $event)\"\n              >\n                <md-icon\n                  md-font-set=\"mdi\"\n                  md-font-icon=\"mdi-delete\"\n                  class=\"mdi-24px\"\n                >\n                </md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n\n    <md-table-pagination\n      md-limit-options=\"[10, 30, 50, 100, 200]\"\n      md-limit=\"$ctrl.$scope.tableConfig.limit\"\n      md-page=\"$ctrl.$scope.tableConfig.page\"\n      md-total=\"{{ $ctrl.resources.count }}\"\n      md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n      md-page-select\n    >\n    </md-table-pagination>\n  </md-card>\n\n  <div ng-show=\"$ctrl.uiState === 'EMPTY'\" class=\"sb-fill-parent\">\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n      </div>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\" class=\"sb-fill-parent\">\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-error-message\">{{ 'common-load-error' | translate}}</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _FileSaver = __webpack_require__(633);
	var _sortablejs = __webpack_require__(670);var _sortablejs2 = _interopRequireDefault(_sortablejs);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var TargetListController = function TargetListController(
	$filter,
	$mdDialog,
	$scope,
	$state,
	Target,
	Toast)
	{
	  DialogController.$inject = ["$scope", "$mdDialog"];
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit,
	    orderList: orderList,
	    showCreateDialog: showCreateDialog,
	    handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.parentGroupId = $state.params.parent_group_id;
	
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = "LOADING";
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: "updated_at DESC",
	      like_search: "",
	      like_search_fields: ["name"] };
	
	
	    if (!$ctrl.parentGroupId) {
	      $ctrl.$scope.tableConfig.like_search_fields.push("$parent_group.name$");
	    }
	
	    $ctrl.$scope.$watch(
	    "tableConfig",
	    function () {
	      loadData();
	    },
	    true);
	
	
	    createSortableList();
	  }
	
	  function createSortableList() {
	    var el = document.getElementById("items");
	    var sortable = _sortablejs2.default.create(el, { onUpdate: reorderListItems });
	  }
	
	  function reorderListItems(event) {var
	    oldIndex = event.oldIndex,newIndex = event.newIndex;
	    var listCopy = _angular2.default.copy($ctrl.resources.data);
	    var id = event.item.getAttribute("data-id");
	
	    Target.updatePosition(id, {
	      new_position: listCopy[newIndex].position,
	      old_position: listCopy[oldIndex].position }).
	
	    then(function (res) {
	      Toast.success($filter('translate')('table-list-new-order'));
	    }).
	    catch(function (_ref) {var data = _ref.data;
	      Toast.error(data.message);
	    }).
	    finally(function () {return loadData();});
	
	    var elementToMove = $ctrl.resources.data.splice(oldIndex, 1);
	    $ctrl.resources.data.splice(newIndex, 0, elementToMove[0]);
	  }
	
	  $scope.downloadReport = function () {
	    $ctrl.activeSpin = true;
	    $ctrl.activeSpinButton = true;
	    Target.downloadReport().
	    then(function (res) {
	      var file = new Blob([res], { type: "text/csv;charset=utf-8;" });
	      var messageSuccess = $filter("translate")("report-success");
	      $ctrl.activeSpin = false;
	      $ctrl.activeSpinButton = false;
	      Toast.success(messageSuccess);
	      (0, _FileSaver.saveAs)(file, "rel_analitico_categorias.csv");
	    }).
	    catch(function (err) {
	      console.log("err:", err);
	      var messageError = $filter("translate")("report-error");
	      $ctrl.activeSpin = false;
	      $ctrl.activeSpinButton = false;
	      Toast.error(messageError);
	    });
	  };
	
	  function edit(event, target) {
	    showCreateDialog(event, target);
	  }
	
	  function handleDelete(resource, event) {
	    event.stopPropagation();
	
	    var confirm = $mdDialog.
	    confirm().
	    textContent($filter("translate")("common-detail-delete-confirm-text")).
	    ariaLabel($filter("translate")("common-detail-delete-confirm-text")).
	    targetEvent(event).
	    ok($filter("translate")("common-yes")).
	    cancel($filter("translate")("common-cancel"));
	
	    $mdDialog.
	    show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Target.destroy(resource).
	      then(function (response) {
	        Toast.success($filter("translate")("common-detail-delete-success"));
	        $ctrl.deleting = false;
	        _.remove($ctrl.resources.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter("translate")("common-server-error"));
	        console.log("err:", err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {});
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(" ")[0];
	      var currentOrder = tableConfig.order.split(" ")[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === "DESC" ? "ASC" : "DESC";
	        tableConfig.order = currentField + " " + currentOrder;
	      } else {
	        tableConfig.order = field + " " + "ASC";
	      }
	    } else {
	      tableConfig.order = field + " " + " ASC";
	    }
	  }
	
	  function showCreateDialog(event, selectedTarget) {
	    $ctrl.selectedTarget = selectedTarget;
	
	    var contentText = $ctrl.parentGroupId ?
	    "'target-list-create-dialog-content'" :
	    "'target-list-create-category-dialog-content'";
	    var dialog = {
	      controller: DialogController,
	      targetEvent: event,
	      template:
	      '<md-dialog aria-label="List dialog">' +
	      '  <form name="targetGroupForm" ng-cloak ng-submit="saveResource(targetGroup)">' +
	      '  <md-dialog-content class="layout-padding">' +
	      '  <div class="md-dialog-content" >' +
	      "    <h2>{{ 'common-new-masculine' | translate }}</h2>" +
	      "" +
	      "    <p>{{" +
	      contentText +
	      "| translate }}</p>" +
	      "" +
	      '    <md-input-container class="md-block" flex>' +
	      "      <label>{{ 'target-list-create-dialog-name-input-label' | translate }}</label>" +
	      "" +
	      '      <input ng-model="targetGroup.name" required>' +
	      "    </md-input-container>",
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false };
	
	
	    if (!$ctrl.parentGroupId) {
	      dialog.template +=
	      "" +
	      '    <md-input-container class="md-block" flex>' +
	      "      <label>{{ 'target-list-create-dialog-target-select-label' | translate }}</label>" +
	      "" +
	      '      <md-select ng-model="targetGroup.topLevelId" required' +
	      '                 ng-change="loadCategories(targetGroup.topLevelId)">' +
	      '        <md-option ng-repeat="group in targetGroups" ' +
	      '                   ng-value="group.id">' +
	      "          {{ group.name }}" +
	      "        </md-option>" +
	      "      </md-select>" +
	      "    </md-input-container>" +
	      "" +
	      '    <md-input-container class="md-block" flex>' +
	      "      <label>{{ 'target-list-create-dialog-category-select-label' | translate }}</label>" +
	      "" +
	      '      <md-select ng-model="targetGroup.categoryId"' +
	      '                 ng-disabled="loading">' +
	      '        <md-option ng-value="null" >' +
	      "          {{ 'common-none-feminine' | translate }}" +
	      "        </md-option>" +
	      "        <md-option ng-repeat=\"category in parentCategories | filter:{ id: '!' + targetGroup.id}\"" +
	      '                 ng-value="category.id" >' +
	      "          {{ category.name }}" +
	      "        </md-option>" +
	      "      </md-select>" +
	      "" +
	      '      <div class="hint" ng-show="false">' +
	      "        {{ 'target-list-create-dialog-category-select-hint' | translate}}" +
	      "      </div>" +
	      "    </md-input-container>";
	    }
	
	    dialog.template +=
	    "" +
	    "    </div>" +
	    "    </md-dialog-content>" +
	    "  <md-dialog-actions>" +
	    '    <md-button ng-click="cancel()">' +
	    "      {{ 'common-cancel' | translate }}" +
	    "    </md-button>" +
	    "" +
	    '    <md-button type="submit"' +
	    '               ng-disabled="!targetGroupForm.$valid" class="md-accent">' +
	    "      {{ 'common-save-button-text' | translate }}" +
	    "    </md-button>" +
	    "  </md-dialog-actions>" +
	    "  </form>" +
	    "</md-dialog>";
	
	    $ctrl.promise = loadTargetGroups({
	      parent_group_id: "null" }).
	
	    then(function (targetGroups) {
	      $ctrl.targetGroups = targetGroups;
	
	      $mdDialog.show(dialog).then(
	      function (newTargetGroup) {
	        newTargetGroup.parent_group_id =
	        newTargetGroup.categoryId || newTargetGroup.topLevelId;
	        delete newTargetGroup.categoryId;
	        delete newTargetGroup.topLevelId;
	        save(newTargetGroup);
	      },
	      function () {});
	
	    }).
	    catch(function (err) {
	      console.log("err:", err);
	    });
	  }
	
	  function DialogController($scope, $mdDialog) {
	    "ngInject";
	
	    $scope.targetGroup = $ctrl.selectedTarget || {};
	
	    $scope.loadCategories = function (parentGroupId) {
	      $scope.loading = true;
	      $scope.parentCategories = [];
	      loadTargetGroups({
	        parent_group_id: parentGroupId }).
	
	      then(function (result) {
	        $scope.parentCategories = result;
	        $scope.loading = false;
	      }).
	      catch(function (err) {
	        console.log("err:", err);
	        $ctrl.uiState = "ERROR";
	        $scope.loading = false;
	      });
	    };
	
	    if (
	    _.isEmpty($scope.targetGroup && $scope.targetGroup.parent_group) === false)
	    {
	      var target = $scope.targetGroup;
	      $scope.targetGroup.topLevelId = target.parent_group.parent_group ?
	      target.parent_group.parent_group.id :
	      target.parent_group.id;
	
	      $scope.loadCategories($scope.targetGroup.topLevelId);
	
	      $scope.targetGroup.categoryId = target.parent_group.id;
	    }
	
	    $scope.targetGroups = $ctrl.targetGroups;
	    $scope.parentCategories = [];
	
	    $scope.hide = function () {
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      $mdDialog.cancel();
	    };
	
	    $scope.saveResource = function (targetGroup) {
	      $mdDialog.hide(targetGroup);
	    };
	  }
	
	  // Local functions
	
	  function loadTargetGroups(query) {
	    return Target.index(query);
	  }
	
	  function loadData() {
	    _angular2.default.extend($ctrl.$scope.tableConfig, $state.params);
	
	    $ctrl.promise = Target.load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? "COMPLETE" : "EMPTY";
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log("err:", err);
	      $ctrl.uiState = "ERROR";
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter("translate")("common-not-informed");
	      }
	    });
	  }
	
	  function save(target) {
	    $ctrl.promise = Target.save(target).
	    then(function (response) {
	      loadData();
	      Toast.success($filter("translate")("target-detail-save-success"));
	    }).
	    catch(function (err) {
	      loadData();
	      var defaultErrMsg = "common-server-error";
	      if (err.status == 409) {
	        var fourONineMsg = $ctrl.parentGroupId ?
	        $filter("translate")("target-detail-409-error") :
	        "A categoria já existe!";
	        $mdDialog.show(
	        $mdDialog.
	        alert().
	        clickOutsideToClose(true).
	        textContent(fourONineMsg).
	        ok("Ok"));
	
	      } else {
	        Toast.error($filter("translate")(defaultErrMsg));
	      }
	    });
	  }
	};
	
	TargetListController.$inject = [
	"$filter",
	"$mdDialog",
	"$scope",
	"$state",
	"Target",
	"Toast"];exports.default =
	
	
	TargetListController;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _targetList = __webpack_require__(682);var _targetList2 = _interopRequireDefault(_targetList);
	var _targetList3 = __webpack_require__(683);var _targetList4 = _interopRequireDefault(_targetList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var targetListComponent = {
	  bindings: {},
	  template: _targetList2.default,
	  controller: _targetList4.default };exports.default =
	
	
	targetListComponent;

/***/ }),
/* 685 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });
	var TargetService = function TargetService(Restangular) {
	  var Service = Restangular.all('admin/target_group');
	
	  var count = function count(query) {
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var updatePosition = function updatePosition(id, data) {
	    return Service.customPATCH(data, 'position/' + id);
	  };
	
	  var destroy = function destroy(_ref) {var id = _ref.id;
	    return Service.customDELETE(id);
	  };
	
	  var downloadReport = function downloadReport() {
	    return Restangular.one('target_group/report').get();
	  };
	
	  return { index: index, load: load, save: save, show: show, updatePosition: updatePosition, destroy: destroy, downloadReport: downloadReport };
	};
	
	TargetService.$inject = ['Restangular'];exports.default =
	
	TargetService;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _campaign = __webpack_require__(687);var _campaign2 = _interopRequireDefault(_campaign);
	var _campaignList = __webpack_require__(692);var _campaignList2 = _interopRequireDefault(_campaignList);
	var _campaignDetail = __webpack_require__(695);var _campaignDetail2 = _interopRequireDefault(_campaignDetail);
	var _campaign3 = __webpack_require__(698);var _campaign4 = _interopRequireDefault(_campaign3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var campaignModule = _angular2.default.module('campaign', [
	_angularUiRouter2.default]).
	
	
	service('Campaign', _campaign4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/campaign');
	
	  $stateProvider.
	  state('campaign', {
	    component: 'campaign' }).
	
	  state('campaign.list', {
	    url: '/campaign',
	    component: 'campaignList' }).
	
	  state('campaign.create', {
	    url: '/campaign/new',
	    component: 'campaignDetail',
	    params: {
	      id: "" } }).
	
	
	  state('campaign.edit', {
	    url: '/campaign/:id/edit',
	    component: 'campaignDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('campaign', _campaign2.default).
	component('campaignList', _campaignList2.default).
	component('campaignDetail', _campaignDetail2.default).
	
	name;exports.default =
	
	campaignModule;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _campaign = __webpack_require__(688);var _campaign2 = _interopRequireDefault(_campaign);
	var _campaign3 = __webpack_require__(689);var _campaign4 = _interopRequireDefault(_campaign3);
	__webpack_require__(690);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var campaignComponent = {
	  bindings: {},
	  template: _campaign2.default,
	  controller: _campaign4.default };exports.default =
	
	
	campaignComponent;

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 689 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var CampaignController =
	function CampaignController() {_classCallCheck(this, CampaignController);
	  this.name = 'campaign';
	};exports.default =
	
	
	CampaignController;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(691);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./campaign.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./campaign.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".sb-campaign .sb-page-section-title{margin-left:16px}.sb-campaign canvas{margin:0!important}.sb-campaign .sb-campaign-image-container img.sb-campaign-image{width:100%;height:auto}.sb-campaign .md-button{margin:6px 0}.sb-campaign .sb-form-actions{margin:8px}", ""]);
	
	// exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _campaignList = __webpack_require__(693);var _campaignList2 = _interopRequireDefault(_campaignList);
	var _campaignList3 = __webpack_require__(694);var _campaignList4 = _interopRequireDefault(_campaignList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var campaignListComponent = {
	  bindings: {},
	  template: _campaignList2.default,
	  controller: _campaignList4.default };exports.default =
	
	
	campaignListComponent;

/***/ }),
/* 693 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\" \n         ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n        <md-button class=\"md-raised md-accent\" ui-sref=\"campaign.create\">\n            {{ 'common-new-masculine' | translate }}\n        </md-button>\n\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\" \n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'campaign-list-table-header-name' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"start_date\"\n                        ng-click=\"$ctrl.orderList('start_date')\">\n                        {{ 'campaign-list-table-header-start_date' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"end_date\"\n                        ng-click=\"$ctrl.orderList('end_date')\">\n                        {{ 'campaign-list-table-header-end_date' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'common-updated-at-feminine' | translate }}\n                    </th>\n\n                    <th md-column md-numeric class=\"sb-table-column-xs\">\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit(resource.id)\">\n                    <td md-cell class=\"sb-table-truncate\">\n                    \t{{ resource.name }}\n                    </td>\n\n                    <td md-cell>\n                        {{ resource.start_date | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n\n                    <td md-cell>\n                        {{ resource.end_date | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n\n                    <td md-cell>\n                    \t{{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n\n                    <td md-cell>\n                        <md-button aria-label=\"Toolbar menu\"\n                                   class=\"md-icon-button\"\n                                   ng-click=\"$ctrl.handleDelete(resource, $event)\">\n                          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination \n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <img src=\"assets/empty_news.png\"/>\n\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'campaign-list-empty-state-line-1' | translate }}</p>\n                <p>{{ 'campaign-list-empty-state-line-2' | translate }}</p>\n            </div>\n\n            <md-button class=\"md-raised md-accent\" ui-sref=\"campaign.create\">\n                {{ 'campaign-list-create-campaign-button' | translate }}\n            </md-button>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var CampaignListController = function CampaignListController(Campaign, $filter, $scope, $state, $mdDialog, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name',
	      like_search: '',
	      like_search_fields: [
	      'name'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function edit(id) {
	    $state.go('campaign.edit', { id: id });
	  }
	
	  function handleDelete(resource, event) {
	    event.stopPropagation();
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Campaign.
	      destroy(resource).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        _.remove($ctrl.resources.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Campaign.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	CampaignListController.$inject = ['Campaign', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];exports.default =
	
	CampaignListController;

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _campaignDetail = __webpack_require__(696);var _campaignDetail2 = _interopRequireDefault(_campaignDetail);
	var _campaignDetail3 = __webpack_require__(697);var _campaignDetail4 = _interopRequireDefault(_campaignDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var campaignDetailComponent = {
	  bindings: {},
	  template: _campaignDetail2.default,
	  controller: _campaignDetail4.default };exports.default =
	
	
	campaignDetailComponent;

/***/ }),
/* 696 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-campaign\">\n        <div layout=\"row\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n            <div flex=\"60\" class=\"layout-padding\">\n                <h3 class=\"sb-page-section-title\">\n                    {{ 'campaign-create-page-title' | translate }}\n                </h3>\n\n                <form name=\"campaignForm\" ng-submit=\"$ctrl.handleSave(campaignForm, $ctrl.campaign)\"\n                      novalidate>\n                    <md-card class=\"layout-padding\">\n                        <!-- name -->\n                        <div layout=\"row\" flex>\n                            <md-input-container class=\"md-block\" flex>\n                                <label>{{ 'campaign-detail-form-news-name' | translate }}</label>\n\n                                <input ng-model=\"$ctrl.campaign.name\" name=\"name\" \n                                       md-maxlength=\"100\"\n                                       required>\n                                </input>\n\n                                <div ng-messages=\"campaignForm.name.$error\" multiple>\n                                    <div ng-message=\"required\">\n                                        {{ 'form-error-required-field' | translate}}\n                                    </div>\n\n                                    <div ng-message=\"md-maxlength\">\n                                        {{ 'campaign-detail-form-error-name-max-length' | translate}}\n                                    </div>\n                                </div>\n                            </md-input-container>\n                        </div>\n\n                        <p class=\"sb-hint lg\">\n                            {{ 'campaign-detail-form-dates-sub-header' | translate }}\n                        </p>\n\n                        <!-- start_date end_date -->\n                        <div layout=\"row\" flex>\n                            <md-input-container flex>\n                                <label>\n                                    {{'campaign-detail-form-start_date' | translate }}\n                                </label>\n\n                                <input time=\"false\" date=\"true\" mdc-datetime-picker=\"\" type=\"text\" id=\"date\" day-of-week-len=\"3\"\n                                    ng-change=\"$ctrl.onChangeStartDate(campaignForm)\" name=\"start_date\" required\n                                    placeholder=\"00/00/0000\" click-outside-to-close=\"true\" today-btn=\"false\" format=\"DD/MM/yyyy\"\n                                    ng-model=\"$ctrl.campaign.start_date\" min-date=\"$ctrl.minDate\" class=\"md-input ml-10\">\n\n                                <div ng-messages=\"campaignForm.start_date.$error\"\n                                     multiple>\n                                    <div ng-message=\"required\">\n                                        {{ 'form-error-required-field' | translate}}\n                                    </div>\n\n                                    <div ng-message=\"todayOrLater\">\n                                        {{ 'common-form-error-sb-today-or-later' | translate}}\n                                    </div>\n\n                                    <div ng-message=\"beforeDate\">\n                                        {{ 'common-form-error-sb-before-date' | translate}}\n                                    </div>\n                                </div>\n                            </md-input-container>\n\n                            <md-input-container flex>\n                                <label>\n                                    {{'campaign-detail-form-end_date' | translate }}\n                                </label>\n                                <input time=\"false\" date=\"true\" mdc-datetime-picker=\"\" type=\"text\" id=\"date\" day-of-week-len=\"3\"\n                                    ng-change=\"$ctrl.onChangeEndDate(campaignForm)\"  name=\"end_date\" required\n                                    placeholder=\"dd/mm/aaaa\" click-outside-to-close=\"true\" today-btn=\"false\" format=\"DD/MM/yyyy\"\n                                    ng-model=\"$ctrl.campaign.end_date\" min-date=\"$ctrl.campaign.start_date\" ng-disabled=\"!$ctrl.campaign.start_date\" class=\"md-input ml-10\">\n\n                                <div ng-messages=\"campaignForm.end_date.$error\"\n                                     multiple>\n                                    <div ng-message=\"required\">\n                                        {{ 'form-error-required-field' | translate}}\n                                    </div>\n\n                                    <div ng-message=\"todayOrLater\">\n                                        {{ 'common-form-error-sb-today-or-later' | translate}}\n                                    </div>\n\n                                    <div ng-message=\"afterDate\">\n                                        {{ 'common-form-error-sb-after-date' | translate}}\n                                    </div>\n                                </div>\n                            </md-input-container>\n                        </div>\n\n                        <p class=\"sb-hint lg\">\n                            {{ 'campaign-detail-form-news-item-sub-header' | translate }}\n                        </p>\n\n                        <md-autocomplete \n                            md-no-cache=\"true\"\n                            md-selected-item=\"$ctrl.selectedNewsItem\"\n                            md-selected-item-change=\"$ctrl.selectedNewsItemChange($ctrl.selectedNewsItem)\"\n                            md-items=\"newsItem in $ctrl.querySearch($ctrl.searchText)\"\n                            md-search-text=\"$ctrl.searchText\"\n                            md-item-text=\"newsItem.title\"\n                            md-menu-class=\"sb-autocomplete-custom-template\"\n                            placeholder=\"{{ 'campaign-detail-form-news-item-placeholder' | translate }}\">\n                            <md-item-template>\n                                <span class=\"item-title\">\n                                    <span>{{ newsItem.title }}</span>\n                                </span>\n\n                                <span class=\"item-metadata\">\n                                    <span>\n                                    {{ 'news-list-table-target-' + newsItem.user_profile_type | translate }}\n                                    </span>\n\n                                    <span> - </span>\n\n                                    <span>\n                                    {{'common-published-at-feminine' | translate }}  \n                                    </span>\n\n                                    <span>\n                                    {{ newsItem.published_at | momentFormat : 'DD/MM/YYYY' }}\n                                    </span>\n                                </span>\n                            </md-item-template>\n\n                            <md-not-found>\n                                {{ 'list-empty-search-state-line-1' | translate }}\n                            </md-not-found>\n                        </md-autocomplete>\n                    </md-card>\n\n                    <md-progress-linear ng-show=\"$ctrl.saving || $ctrl.deleting\"\n                                        md-mode=\"indeterminate\">\n                    </md-progress-linear>\n\n                    <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions\">\n                        <md-button page-back\n                                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                            {{ 'common-cancel-button-text' | translate }}\n                        </md-button>\n\n                        <md-button ng-click=\"$ctrl.handleDelete($ctrl.campaign, $event)\"\n                                   ng-if=\"$ctrl.id\"\n                                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                                   class=\"md-warn md-raised\">\n                            {{ 'common-delete-button-text' | translate }}\n                        </md-button>\n\n                        <md-button ng-click=\"$ctrl.clearForm(campaignForm)\"\n                                   ng-if=\"!$ctrl.id\"\n                                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                                   class=\"md-raised\">\n                            {{ 'common-clear-button-text' | translate }}\n                        </md-button>\n\n                        <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                                   class=\"md-accent md-raised\">\n                            {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                        </md-button>\n\n                    </div>\n                </form>\n            </div>\n\n            <div flex=\"40\" class=\"layout-padding\">\n                <h3 class=\"sb-page-section-title\">{{ 'common-image' | translate }}</h3>\n\n                <div>\n                    <input ng-show=\"false\" type=\"file\" id=\"fileInput\"/>\n                    \n                    <label for=\"fileInput\" class=\"md-button md-raised\">\n                        {{ 'common-choose-a-file' | translate }}\n                    </label>\n                </div>\n\n                <div class=\"sb-error-message\"\n                     ng-show=\"campaignForm.$submitted && (!$ctrl.myCroppedImage && !$ctrl.campaign.image_uri)\">\n                    {{ 'form-error-required-file' | translate}}\n                </div>\n\n                <div ng-show=\"$ctrl.fileName\">\n                    <span class=\"md-caption\">{{ $ctrl.fileName }}</span>\n                </div>\n\n                <div class=\"sb-hint\">\n                    {{ 'campaign-detail-form-image-hint' | translate }}\n                </div>\n\n                <div ng-show=\"$ctrl.myCroppedImage\"\n                     class=\"sb-campaign-image-container\">\n                    <img class=\"sb-campaign-image\" ng-src=\"{{ $ctrl.myCroppedImage }}\"/>\n                </div>\n\n                <div ng-show=\"$ctrl.campaign.image_uri && !$ctrl.myCroppedImage\"\n                     class=\"sb-campaign-image-container\">\n                    <img class=\"sb-campaign-image\" ng-src=\"{{ $ctrl.campaign.image_uri }}\"/>\n\n                    <md-progress-linear ng-show=\"$ctrl.loadingImage\" md-mode=\"indeterminate\">\n                    </md-progress-linear>\n                </div>\n            </div>\n        </div>\n\n        <div ng-show=\"$ctrl.uiState === 'LOADING'\"\n             class=\"sb-fill-parent\">\n            <div class=\"sb-absolute-center sb-empty-state\" \n                 layout=\"column\" layout-align=\"center center\">\n                <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n            </div>\n        </div>\n\n        <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n             class=\"sb-fill-parent\">\n            <div class=\"sb-absolute-center sb-empty-state\" \n                 layout=\"column\" layout-align=\"center center\">\n                <div class=\"sb-error-message\">\n                    {{ 'common-load-error' | translate}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var CampaignDetailController = function CampaignDetailController($filter, $mdDialog, $scope, $state, $timeout, Campaign, News, Toast) {
	  DialogController.$inject = ["$scope", "$mdDialog", "$filter"];
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete,
	    onChangeEndDate: onChangeEndDate,
	    onChangeStartDate: onChangeStartDate,
	    querySearch: querySearch,
	    selectedNewsItemChange: selectedNewsItemChange });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    _angular2.default.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
	
	    var id = $ctrl.id;
	
	    loadDomainResources().
	    then(function (result) {
	      $ctrl.newsItems = result[0];
	
	      loadResource($ctrl.id);
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function clearForm(form) {
	    $ctrl.campaign = {
	      start_date: moment(),
	      end_date: moment() };
	
	
	    $ctrl.myImage = '';
	    $ctrl.myCroppedImage = '';
	    $ctrl.fileName = undefined;
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	  $ctrl.minDate = new Date();
	
	  function handleDelete(campaign, event) {
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('campaign-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('campaign-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Campaign.
	      destroy(campaign).
	      then(function (response) {
	        Toast.success($filter('translate')('campaign-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('campaign.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, campaign) {
	    campaign.image_base64 = $ctrl.myCroppedImage;
	
	    if (!form.$valid || !campaign.image_base64 && !campaign.image_uri) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    $ctrl.saving = true;
	
	    Campaign.
	    save(campaign).
	    then(function (response) {
	      Toast.success($filter('translate')('campaign-detail-save-success'));
	      $state.go('campaign.list');
	    }).
	    catch(function (err) {
	      var defaultErrMsg = 'common-server-error';
	      var fourONineMsg = 'campaign-detail-409-error';
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter('translate')(message));
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	
	  function onChangeStartDate(form) {
	    $timeout(function () {
	      $ctrl.campaign.end_date = null;
	      form.end_date.$validate();
	    }, 100);
	  }
	
	  function onChangeEndDate(form) {
	    $timeout(function () {
	      form.start_date.$validate();
	    }, 100);
	  }
	
	  function querySearch(searchText) {
	    searchText = searchText.toLowerCase();
	
	    var results = _.filter($ctrl.newsItems, function (newsItem) {
	      return newsItem.title.toLowerCase().indexOf(searchText) > -1;
	    });
	
	    return results;
	  }
	
	  function selectedNewsItemChange(newsItem) {
	    $ctrl.campaign.news_item_id = newsItem ? newsItem.id : null;
	  }
	
	  // Local functions
	
	  function handleFileSelect(event) {
	    var file = event.currentTarget.files[0];
	
	    if (!file) {
	      console.log('no file added!');
	      return;
	    }
	
	    var reader = new FileReader();
	    reader.onload = function (event) {
	      $ctrl.myImage = event.target.result;
	      $scope.$apply();
	      $ctrl.fileName = file.name;
	      showCropDialog(event);
	    };
	
	    reader.readAsDataURL(file);
	  }
	
	  function showCropDialog(event) {
	    $mdDialog.show({
	      controller: DialogController,
	      targetEvent: event,
	      template:
	      '<md-dialog aria-label="Image cropper dialog" class="sb-ui-cropper-dialog">' +
	      '  <md-dialog-content>' +
	      '    <div layout="row" layout-align="center center" ng-show="!isDoneLoading">' +
	      '      <md-progress-linear md-mode="indeterminate"></md-progress-linear>' +
	      '    </div>' +
	      '' +
	      '    <ui-cropper' +
	      '      ng-show="isDoneLoading === true"' +
	      '      on-load-done="isDoneLoading = true"' +
	      '      image="myImage"' +
	      '      area-type="rectangle"' +
	      '      aspect-ratio="0.640449438"' +
	      '      init-max-area="true"' +
	      '      result-image-quality="0.5"' +
	      '      chargement="loadingText"' +
	      '      result-image-size="{w: 570, h: 890}"' +
	      '      result-image="myCroppedImage" canvas-scalemode="true">' +
	      '    </ui-cropper>' +
	      '  </md-dialog-content>' +
	      '  <md-dialog-actions' +
	      '     ng-show="isDoneLoading === true">' +
	      '    <md-button ng-click="cancel()">' +
	      '      Cancelar' +
	      '    </md-button>' +
	      '    <md-button ng-click="cropImage(myCroppedImage)" class="md-accent">' +
	      '      Feito' +
	      '    </md-button>' +
	      '  </md-dialog-actions>' +
	      '</md-dialog>',
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(function (myCroppedImage) {
	      $ctrl.myCroppedImage = myCroppedImage;
	      $ctrl.myImage = '';
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  }
	
	  function DialogController($scope, $mdDialog, $filter) {
	    "ngInject";
	    $scope.loadingText = $filter('translate')('common-loading');
	    $scope.myImage = $ctrl.myImage;
	    $scope.myCroppedImage = $ctrl.myCroppedImage;
	
	    $scope.hide = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.cancel();
	    };
	
	    $scope.cropImage = function (myCroppedImage) {
	      $mdDialog.hide(myCroppedImage);
	    };
	  }
	
	  function loadDomainResources() {
	    $ctrl.uiState = 'LOADING';
	
	    var promises = [];
	
	    promises.push(News.index({ limit: 10000000000, order: 'updated_at DESC' }));
	
	    return Promise.all(promises);
	  }
	
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Campaign.show(id).
	      then(function (response) {
	        if (response.news_item_id) {
	          $ctrl.selectedNewsItem = _.find($ctrl.newsItems, { id: response.news_item_id });
	        }
	        $ctrl.campaign = response;
	        $ctrl.campaign.start_date = new Date($ctrl.campaign.start_date);
	        $ctrl.campaign.end_date = new Date($ctrl.campaign.end_date);
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	      $scope.$apply();
	    }
	  }
	
	  function simulateImageLoadProgress() {
	    $ctrl.loadingImage = true;
	    $timeout(function () {
	      $ctrl.loadingImage = false;
	    }, 1000);
	  }
	};
	
	CampaignDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', '$timeout', 'Campaign', 'News', 'Toast'];exports.default =
	
	CampaignDetailController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var CampaignService = function CampaignService(Restangular) {
	  var Service = Restangular.all('admin/campaign');
	
	  var count = function count(query) {
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	CampaignService.$inject = ['Restangular'];exports.default =
	
	CampaignService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _client = __webpack_require__(700);var _client2 = _interopRequireDefault(_client);
	var _clientList = __webpack_require__(705);var _clientList2 = _interopRequireDefault(_clientList);
	var _clientDetail = __webpack_require__(708);var _clientDetail2 = _interopRequireDefault(_clientDetail);
	var _clientReport = __webpack_require__(711);var _clientReport2 = _interopRequireDefault(_clientReport);
	var _client3 = __webpack_require__(714);var _client4 = _interopRequireDefault(_client3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var clientModule = _angular2.default.module('client', [
	_angularUiRouter2.default]).
	
	
	service('Client', _client4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/client');
	
	  $stateProvider.
	  state('client', {
	    component: 'client' }).
	
	  state('client.list', {
	    url: '/client',
	    component: 'clientList' }).
	
	  state('client.create', {
	    url: '/client/new',
	    component: 'clientDetail',
	    params: {
	      id: "" } }).
	
	
	  state('client.edit', {
	    url: '/client/:id/edit',
	    component: 'clientDetail',
	    params: {
	      id: "" } }).
	
	
	  state('client.report', {
	    url: '/client/report',
	    component: 'clientReport' });
	
	}]).
	
	component('client', _client2.default).
	component('clientList', _clientList2.default).
	component('clientDetail', _clientDetail2.default).
	component('clientReport', _clientReport2.default).
	
	name;exports.default =
	
	clientModule;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _client = __webpack_require__(701);var _client2 = _interopRequireDefault(_client);
	var _client3 = __webpack_require__(702);var _client4 = _interopRequireDefault(_client3);
	__webpack_require__(703);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var clientComponent = {
	  bindings: {},
	  template: _client2.default,
	  controller: _client4.default };exports.default =
	
	
	clientComponent;

/***/ }),
/* 701 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 702 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var ClientController =
	function ClientController() {_classCallCheck(this, ClientController);
	  this.name = 'client';
	};exports.default =
	
	
	ClientController;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(704);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./client.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./client.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".sb-client .sb-health-insurance-img{width:100%}.input-search{margin-left:auto}.captions-group{margin-top:20px}.grid-captions{display:grid;grid-template-columns:1fr 1fr 1fr}.captions-group>div{font-size:14px;margin-top:4px}.grid-captions>div:last-child{grid-column-end:span 3}.chart-caption{width:12px;height:12px;margin-top:3px;margin-right:5px}.inputs-container{display:grid;grid-template-columns:repeat(4,1fr);gap:20px}.md-text:first-letter{text-transform:capitalize}", ""]);
	
	// exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _clientList = __webpack_require__(706);var _clientList2 = _interopRequireDefault(_clientList);
	var _clientList3 = __webpack_require__(707);var _clientList4 = _interopRequireDefault(_clientList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var clientListComponent = {
	  bindings: {},
	  template: _clientList2.default,
	  controller: _clientList4.default };exports.default =
	
	
	clientListComponent;

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"flex start\"\n         ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n\n         <md-button ng-click=\"downloadReport()\" class=\"md-raised md-accent\"\n         ng-disabled=\"$ctrl.activeSpin\"\n         ng-class=\"{'button-spin-active': $ctrl.activeSpinButton }\" >\n             <span ng-show=\"!$ctrl.activeSpin\">{{ 'button-download-report' | translate }}</span>\n             <span ng-show=\"$ctrl.activeSpin\">{{ 'button-download-report-spin' | translate }} <md-progress-circular md-mode=\"indeterminate\" class=\"md-accent md-hue-1 button-loader\" md-diameter=\"20\"></md-progress-circular></span>\n         </md-button>\n\n         <md-button ui-sref=\"client.report\" class=\"md-raised md-accent\"\n         ng-disabled=\"$ctrl.activeSpinSmall\"\n         ng-class=\"{'button-spin-active': $ctrl.activeSpinSmallButton }\" >\n             <span ng-show=\"!$ctrl.activeSpinSmall\">{{ 'button-download-report-small' | translate }}</span>\n             <span ng-show=\"$ctrl.activeSpinSmall\">{{ 'button-download-report-spin' | translate }} <md-progress-circular md-mode=\"indeterminate\" class=\"md-accent md-hue-1 button-loader\" md-diameter=\"20\"></md-progress-circular></span>\n         </md-button>\n\n         <md-card class=\"input-search\">\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"mobile_user.name\"\n                        ng-click=\"$ctrl.orderList('mobile_user.name')\">\n                        {{ 'common-name' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"email\"\n                        ng-click=\"$ctrl.orderList('email')\">\n                        {{ 'common-email' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"sabin_id\"\n                        ng-click=\"$ctrl.orderList('sabin_id')\">\n                        {{ 'common-sabin-id' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'common-updated-at' | translate }}\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit(resource.id)\">\n                    <td md-cell class=\"sb-table-truncate\">\n                        {{ resource.mobile_user.name }}\n                    </td>\n\n                    <td md-cell class=\"sb-table-truncate\">\n                        {{ resource.email }}\n                    </td>\n\n                    <td md-cell class=\"sb-table-truncate\">\n                        {{ resource.sabin_id }}\n                    </td>\n\n                    <td md-cell>\n                        {{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _FileSaver = __webpack_require__(633);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var ClientListController = function ClientListController(Client, $filter, $scope, $state, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'updated_at',
	      like_search: '',
	      like_search_fields: [
	      'email',
	      'sabin_id',
	      '$mobile_user.name$'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  $scope.downloadReport = function () {
	    $ctrl.activeSpin = true;
	    $ctrl.activeSpinButton = true;
	    Client.
	    downloadReport().
	    then(function (res) {
	      var messageSuccess = $filter('translate')('report-success');
	      $ctrl.activeSpin = false;
	      $ctrl.activeSpinButton = false;
	      Toast.success(messageSuccess);
	      window.location.href = res.url;
	    }).catch(function (err) {
	      console.log('err:', err);
	      var messageError = $filter('translate')('report-error');
	      $ctrl.activeSpin = false;
	      $ctrl.activeSpinButton = false;
	      Toast.error(messageError);
	    });
	  };
	
	  $scope.downloadReportSmall = function () {
	    $ctrl.activeSpinSmall = true;
	    $ctrl.activeSpinSmallButton = true;
	    Client.
	    downloadReportSmall().
	    then(function (res) {
	      var messageSuccess = $filter('translate')('report-success');
	      $ctrl.activeSpinSmall = false;
	      $ctrl.activeSpinSmallButton = false;
	      Toast.success(messageSuccess);
	      window.location.href = res.url;
	    }).catch(function (err) {
	      console.log('err:', err);
	      var messageError = $filter('translate')('report-error');
	      $ctrl.activeSpinSmall = false;
	      $ctrl.activeSpinSmallButton = false;
	      Toast.error(messageError);
	    });
	  };
	
	  function edit(id) {
	    $state.go('client.edit', { id: id });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Client.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      setPlaceHolderValues(response.data);
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.email === null || item.email === undefined) {
	        item.email = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	ClientListController.$inject = ['Client', '$filter', '$scope', '$state', 'Toast'];exports.default =
	
	ClientListController;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _clientDetail = __webpack_require__(709);var _clientDetail2 = _interopRequireDefault(_clientDetail);
	var _clientDetail3 = __webpack_require__(710);var _clientDetail4 = _interopRequireDefault(_clientDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var clientDetailComponent = {
	  bindings: {},
	  template: _clientDetail2.default,
	  controller: _clientDetail4.default };exports.default =
	
	
	clientDetailComponent;

/***/ }),
/* 709 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-client\" ng-if=\"$ctrl.uiState === 'COMPLETE'\">\n        <form name=\"clientForm\" ng-submit=\"$ctrl.handleSave(clientForm, $ctrl.client)\" \n              novalidate>\n            <!-- client -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">{{ 'client-detail-title' | translate }}</h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'client-detail-title-caption' | translate }}\n                </p>\n\n                <div layout=\"row\">\n                    <div layout=\"column\" layout-align=\"start center\" \n                         flex=\"15\"\n                         style=\"position: relative;\">\n                        <ng-avatar ng-if=\"!$ctrl.client.mobile_user.image_uri\"\n                                   string=\"{{ $ctrl.client.mobile_user.name | firstLastName | uppercase }}\"\n                                   max-length=2\n                                   round-shape=\"true\"\n                                   text-color=\"#fff\"\n                                   width=\"100\"\n                                   bg-color=\"#c1c1c1\">\n                        </ng-avatar>\n\n                        <div ng-if=\"$ctrl.client.mobile_user.image_uri\" class=\"sb-avatar-div\"\n                             style=\"background-image: url('{{ $ctrl.client.mobile_user.image_uri }}')\">\n                        </div>\n                    </div>\n\n                    <div flex=\"85\">\n                        <md-card>\n                            <!-- name email -->\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-name' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.client.mobile_user.name\" name=\"name\" \n                                           required>\n                                    </input>\n\n                                    <div ng-messages=\"clientForm.name.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'client-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-email' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.client.email\" name=\"email\"\n                                           type=\"email\" required>\n                                    </input>\n\n                                    <div ng-messages=\"clientForm.email.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"email\">\n                                            {{ 'form-error-email-invalid' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                            <!-- gender cpf -->\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-gender' | translate }}\n                                    </label>\n\n                                    <md-select ng-model=\"$ctrl.client.mobile_user.gender\"\n                                               name=\"gender\"\n                                               required>\n                                        <md-option ng-value=\"'MALE'\" >\n                                            {{ 'common-male' | translate }}\n                                        </md-option>\n\n                                        <md-option ng-value=\"'FEMALE'\" >\n                                            {{ 'common-female' | translate }}\n                                        </md-option>\n\n                                        <md-option ng-value=\"'OTHER'\" >\n                                            {{ 'common-other-gender' | translate }}\n                                        </md-option>\n                                    </md-select>\n\n                                    <div ng-messages=\"clientForm.gender.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-cpf' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.client.mobile_user.cpf\" name=\"cpf\" \n                                           ui-br-cpf-mask>\n                                    </input>\n\n                                    <div ng-messages=\"clientForm.cpf.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"cpf\">\n                                            {{ 'form-error-cpf-invalid' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                            <!-- phone_number birthdate -->\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-phone_number' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.client.phone_number\"\n                                           name=\"phone_number\" required>\n                                    </input>\n\n                                    <div ng-messages=\"clientForm.phone_number.$error\" \n                                         multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'client-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-birthdate' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.client.mobile_user.birthdate\"\n                                           name=\"birthdate\"\n                                           sb-today-or-before\n                                           ui-date-mask=\"DD/MM/YYYY\"\n                                           required>\n                                    </input>\n\n                                    <div ng-messages=\"clientForm.birthdate.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"date\">\n                                            {{ 'form-error-birthdate-invalid' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"todayOrBefore\">\n                                            {{ 'common-form-error-sb-today-or-before' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                            <!-- address_street address_number -->\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-address_street' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.client.address_street\"\n                                           name=\"address_street\" \n                                           required>\n                                    </input>\n\n                                    <div ng-messages=\"clientForm.address_street.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'client-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex=\"25\">\n                                    <label>\n                                        {{ 'client-detail-form-client-address_number' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.client.address_number\"\n                                           name=\"address_number\">\n                                    </input>\n\n                                    <div ng-messages=\"clientForm.address_number.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'client-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                            <!-- address_complement address_neighborhood -->\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-address_complement' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.client.address_complement\" name=\"address_complement\">\n                                    </input>\n\n                                    <div ng-messages=\"clientForm.address_complement.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'client-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-address_neighborhood' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.client.address_neighborhood\"\n                                           name=\"address_neighborhood\" \n                                           required>\n                                    </input>\n\n                                    <div ng-messages=\"clientForm.address_neighborhood.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'client-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                            <!-- address_postal_code state city -->\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-address_postal_code' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.client.address_postal_code\"\n                                           name=\"address_postal_code\"\n                                           ui-br-cep-mask\n                                           required>\n                                    </input>\n\n                                    <div ng-messages=\"clientForm.address_postal_code.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'client-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-state' | translate }}\n                                    </label>\n\n                                    <md-select ng-model=\"$ctrl.client.city.state_id\"\n                                               ng-change=\"$ctrl.onChangeState($ctrl.client.city.state_id)\"\n                                               name=\"state\"\n                                               required>\n                                        <md-option ng-repeat=\"state in $ctrl.states\"\n                                                   ng-value=\"state.id\" >\n                                            {{ state.name }}\n                                        </md-option>\n                                    </md-select>\n\n                                    <div ng-messages=\"clientForm.state.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'client-detail-form-client-city_id' | translate }}\n                                    </label>\n\n                                    <md-select ng-model=\"$ctrl.client.city_id\"\n                                               ng-disabled=\"!$ctrl.client.city.state_id || $ctrl.loadingCities\"\n                                               name=\"city\"\n                                               required>\n                                        <md-option ng-repeat=\"city in $ctrl.cities\"\n                                                   ng-value=\"city.id\" >\n                                            {{ city.name }}\n                                        </md-option>\n                                    </md-select>\n\n                                    <div ng-messages=\"clientForm.city.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n                        </md-card>\n\n                        <md-progress-linear ng-show=\"$ctrl.saving || $ctrl.deleting\"\n                                            md-mode=\"indeterminate\">\n                        </md-progress-linear>\n                    </div>\n                </div>\n            </div>\n\n            <!-- health_insurance -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">\n                    {{ 'client-detail-section-title-health_insurances' | translate }}\n                </h3>\n\n                <md-card>\n                    <div layout=\"column\" flex\n                         ng-repeat=\"healthInsurance in $ctrl.client.health_insurances\">\n                        <div layout=\"row\" flex>\n                            <md-input-container class=\"md-block\" flex>\n                                <label>\n                                    {{ 'client-detail-section-health_insurances-name' | translate }}\n                                </label>\n\n                                <input ng-model=\"healthInsurance.name\" name=\"healthInsurance\">\n                                </input>\n\n                                <div ng-messages=\"clientForm.healthInsurance.$error\" multiple>\n                                    <div ng-message=\"required\">\n                                        {{ 'form-error-required-field' | translate}}\n                                    </div>\n\n                                    <div ng-message=\"md-maxlength\">\n                                        {{ 'client-detail-form-error-title-max-length' | translate}}\n                                    </div>\n                                </div>\n                            </md-input-container>\n\n                            <div layout=\"row\" layout-align=\"end start\">\n                                <md-button class=\"md-accent\" \n                                           ng-click=\"$ctrl.removeFromList(healthInsurance, $ctrl.client.health_insurances)\">\n                                           {{ 'common-delete-button-text' | translate }}\n                                </md-button>\n                            </div>\n                        </div>\n\n                        <div layout=\"row\" class=\"layout-padding\" flex>\n                            <div flex=\"33\">\n                                <img ng-show=\"healthInsurance.front_image_uri\"\n                                     ng-src=\"{{ healthInsurance.front_image_uri }}\"\n                                     class=\"sb-health-insurance-img\"/>\n                            </div>\n\n                            <div flex=\"33\">\n                                <img ng-show=\"healthInsurance.rear_image_uri\"\n                                     ng-src=\"{{ healthInsurance.rear_image_uri }}\"\n                                     class=\"sb-health-insurance-img\"/>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div ng-if=\"!$ctrl.client.health_insurances || !$ctrl.client.health_insurances.length\" \n                         layout=\"column\" \n                         layout-align=\"center center\"\n                         class=\"sb-empty-state\">\n                        <div class=\"sb-empty-state-text\">\n                            <p>\n                                {{ 'client-detail-section-health_insurances-empty-state-line-1' | translate }}\n                            </p>\n                        </div>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- dependents -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">\n                    {{ 'client-detail-section-title-dependents' | translate }}\n                </h3>\n\n               <p class=\"sb-page-section-sub-title\">\n                    {{ 'client-detail-section-title-dependents-caption' | translate }}\n                </p>\n\n                <md-card>\n                    <md-list>\n                        <md-list-item class=\"secondary-button-padding\"\n                            ng-repeat=\"dependent in $ctrl.client.mobile_user.dependents\">\n                            <img ng-if=\"dependent.mobile_user.image_uri\"\n                                 alt=\"{{ dependent.mobile_user.name }}\"\n                                 ng-src=\"{{ dependent.mobile_user.image_uri }}\"\n                                 class=\"md-avatar\" />\n\n                            <ng-avatar ng-if=\"!dependent.mobile_user.image_uri\"\n                                       string=\"{{ dependent.mobile_user.name | firstLastName | uppercase }}\"\n                                       max-length=2\n                                       round-shape=\"true\"\n                                       text-color=\"#fff\"\n                                       width=\"40\"\n                                       bg-color=\"#c1c1c1\"\n                                       class=\"md-avatar\"></ng-avatar>\n\n                            <p>{{ dependent.mobile_user.name }}</p>\n\n                            <md-button class=\"md-accent\" \n                                       ng-click=\"$ctrl.removeFromList(dependent, $ctrl.client.mobile_user.dependents)\">\n                                       {{ 'client-detail-section-dependents-remove-button-text' | translate }}\n                            </md-button>\n                        </md-list-item>\n                    </md-list>\n\n                    <div ng-if=\"!$ctrl.client.mobile_user.dependents || !$ctrl.client.mobile_user.dependents.length\" \n                         layout=\"column\" \n                         layout-align=\"center center\"\n                         class=\"sb-empty-state\">\n                        <div class=\"sb-empty-state-text\">\n                            <p>\n                                {{ 'client-detail-section-dependents-empty-state-line-1' | translate }}\n                            </p>\n                        </div>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- sponsors -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">\n                    {{ 'client-detail-section-title-sponsors' | translate }}\n                </h3>\n\n               <p class=\"sb-page-section-sub-title\">\n                    {{ 'client-detail-section-title-sponsors-caption' | translate }}\n                </p>\n\n                <md-card>\n                    <md-list>\n                        <md-list-item class=\"secondary-button-padding\"\n                            ng-repeat=\"sponsor in $ctrl.client.sponsors\">\n                            <img ng-if=\"sponsor.image_uri\"\n                                 alt=\"{{ sponsor.name }}\"\n                                 ng-src=\"{{ sponsor.image_uri }}\"\n                                 class=\"md-avatar\" />\n\n                            <ng-avatar ng-if=\"!sponsor.image_uri\"\n                                       string=\"{{ sponsor.name | firstLastName | uppercase }}\"\n                                       max-length=2\n                                       round-shape=\"true\"\n                                       text-color=\"#fff\"\n                                       width=\"40\"\n                                       bg-color=\"#c1c1c1\"\n                                       class=\"md-avatar\"></ng-avatar>\n\n                            <p>{{ sponsor.name }}</p>\n\n                            <md-button class=\"md-accent\" \n                                       ng-click=\"$ctrl.removeFromList(sponsor, $ctrl.client.sponsors)\">\n                                       {{ 'client-detail-section-sponsors-remove-button-text' | translate }}\n                            </md-button>\n                        </md-list-item>\n                    </md-list>\n\n                    <div ng-if=\"!$ctrl.client.sponsors || !$ctrl.client.sponsors.length\" \n                         layout=\"column\" \n                         layout-align=\"center center\"\n                         class=\"sb-empty-state\">\n                        <div class=\"sb-empty-state-text\">\n                            <p>\n                                {{ 'client-detail-section-sponsors-empty-state-line-1' | translate }}\n                            </p>\n                        </div>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- form actions -->\n            <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n                <md-button page-back\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                    {{ 'common-cancel-button-text' | translate }}\n                </md-button>\n\n                <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-accent md-raised\">\n                    {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                </md-button>\n            </div>\n        </form>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var ClientDetailController = function ClientDetailController($filter, $mdDialog, $scope, $state, City, Client, State, Toast) {
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.client;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete,
	    onChangeState: onChangeState,
	    removeFromList: removeFromList });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    loadDomainResources().
	    then(function (result) {
	      $ctrl.states = result[0];
	
	      loadResource($ctrl.id);
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function clearForm(form) {
	    $ctrl.client = {};
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(client, event) {
	    var confirmMessage = 'client-detail-delete-confirm-text';
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')(confirmMessage)).
	    ariaLabel($filter('translate')(confirmMessage)).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Client.
	      destroy(client).
	      then(function (response) {
	        Toast.success($filter('translate')('client-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('client.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, client) {
	    if (!form.$valid) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    save(client);
	  }
	
	  function onChangeState(stateId) {
	    $ctrl.client.city_id = undefined;
	    $ctrl.loadingCities = true;
	
	    City.
	    index({
	      state_id: stateId,
	      limit: 10000 }).
	
	    then(function (cities) {
	      $ctrl.cities = cities;
	      $ctrl.loadingCities = false;
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.loadingCities = false;
	    });
	  }
	
	  function removeFromList(item, list) {
	    _.remove(list, { id: item.id });
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Client.show(id).
	      then(function (response) {
	        if (response.mobile_user.birthdate) {
	          response.mobile_user.birthdate = moment(response.mobile_user.birthdate).utc();
	        }
	
	        if (response.address_postal_code) {
	          response.address_postal_code = response.address_postal_code.replace(/\-/, '');
	        }
	
	        if (response.city) {
	          City.
	          index({
	            state_id: response.city.state_id,
	            limit: 10000 }).
	
	          then(function (cities) {
	            $ctrl.cities = cities;
	            $ctrl.client = response;
	            $ctrl.uiState = 'COMPLETE';
	          }).
	          catch(function (err) {
	            console.log('err:', err);
	            $ctrl.uiState = 'ERROR';
	          });
	        } else {
	          $ctrl.client = response;
	          $ctrl.uiState = 'COMPLETE';
	        }
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	    }
	  }
	
	  function loadDomainResources() {
	    $ctrl.uiState = 'LOADING';
	
	    var promises = [];
	
	    promises.push(State.index());
	
	    return Promise.all(promises);
	  }
	
	  function save(client) {
	    $ctrl.saving = true;
	
	    client.address_postal_code = client.address_postal_code.replace(/^(\d{5})(\d{3})$/, '$1-$2');
	
	    Client.
	    save(client).
	    then(function (response) {
	      Toast.success($filter('translate')('client-detail-save-success'));
	      $ctrl.client = response;
	      $ctrl.saving = false;
	      $state.go('client.list');
	    }).
	    catch(function (err) {
	      var defaultErrMsg = 'common-server-error';
	      var fourONineMsg = 'client-detail-409-error';
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter('translate')(message));
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	};
	
	ClientDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'City', 'Client', 'State', 'Toast'];exports.default =
	
	ClientDetailController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _clientReport = __webpack_require__(712);var _clientReport2 = _interopRequireDefault(_clientReport);
	var _clientReport3 = __webpack_require__(713);var _clientReport4 = _interopRequireDefault(_clientReport3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var clientReportComponent = {
	  bindings: {},
	  template: _clientReport2.default,
	  controller: _clientReport4.default };exports.default =
	
	
	clientReportComponent;

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container sb-page-section\">\n  <div ng-show=\"$ctrl.uiState === 'LOADING'\"\n       class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n    </div>\n  </div>\n  <md-card ng-show=\" $ctrl.uiState === 'COMPLETE'\" class=\"sb-page-section\">\n    <div layout=\"row\">\n\n      <div layout=\"column\" class=\"sb-page-section\">\n        <h3 class=\"sb-page-section-title\">{{ 'client-report-title-subtitle' | translate }}</h3>\n\n        <p class=\"sb-page-section-sub-title\">\n          {{ 'client-report-title-subtitle-caption' | translate }}\n        </p>\n\n      </div>\n    </div>\n    <div layout=\"row\">\n\n      <md-input-container class=\"md-block\" flex>\n        <label>Tipo de cliente</label>\n\n        <md-select name=\"receiver\"\n                   ng-model=\"$ctrl.filter.receiver\" ng-disabled=\"$ctrl.saving\"\n        >\n          <md-option ng-value=\"null\">\n            {{ 'common-general' | translate }}\n          </md-option>\n\n          <md-option ng-value=\"'CLIENT'\">\n            {{ 'common-clients' | translate }}\n          </md-option>\n\n          <md-option ng-value=\"'MEDIC'\">\n            {{ 'common-medics' | translate }}\n          </md-option>\n\n          <md-option ng-value=\"'DEPENDENT'\">\n            {{ 'common-dependents' | translate }}\n          </md-option>\n        </md-select>\n      </md-input-container>\n      <md-input-container class=\"md-block\" flex>\n        <label>\n          {{ 'common-state' | translate }}\n        </label>\n\n        <md-select ng-model=\"$ctrl.filter.state_id\" ng-disabled=\"$ctrl.saving\"\n                   ng-change=\"$ctrl.onChangeState($ctrl.filter.state_id)\"\n                   name=\"state\" multiple md-on-close=\"$ctrl.clearSearch()\"\n                   md-container-class=\"selectdemoSelectHeader\">\n          <md-select-header layout=\"column\" class=\"demo-select-header\">\n            <md-input-container class=\"md-block\" flex>\n              <input ng-model=\"$ctrl.searchState\" type=\"text\"\n                     ng-model-options=\"{debounce: {'default': 250, 'blur': 0}}\"\n                     class=\"demo-header-searchbox md-text input-search-state\" aria-label=\"state filter\"\n                     placeholder=\"Buscar estados\"/>\n            </md-input-container>\n          </md-select-header>\n\n          <md-optgroup label=\"state\">\n            <md-option ng-repeat=\"state in $ctrl.states | filter:$ctrl.searchState\"\n                       ng-value=\"state.id\">\n              {{ state.name }}\n            </md-option>\n          </md-optgroup>\n        </md-select>\n\n        <div ng-messages=\"notificationForm.state.$error\" multiple>\n          <div ng-message=\"required\">\n            {{ 'form-error-required-field' | translate}}\n          </div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block\" flex>\n        <label>\n          {{ $ctrl.filter.state_id.length > 1 ? 'Todas' : 'common-city' | translate }}\n        </label>\n\n        <md-select ng-model=\"$ctrl.filter.city_id\"\n                   ng-disabled=\"!$ctrl.filter.state_id || $ctrl.loadingCities || $ctrl.saving || ($ctrl.filter.state_id.length != 1)\"\n                   name=\"city\" multiple md-on-close=\"$ctrl.clearSearch()\"\n                   md-container-class=\"selectdemoSelectHeader\">\n          <md-select-header layout=\"column\" class=\"demo-select-header\">\n            <md-input-container class=\"md-block\" flex>\n              <input ng-model=\"$ctrl.search\" type=\"text\" ng-model-options=\"{debounce: {'default': 250, 'blur': 0}}\"\n                     class=\"demo-header-searchbox md-text input-search-city\" aria-label=\"city filter\"  placeholder=\"Buscar cidades\"/>\n            </md-input-container>\n\n          </md-select-header>\n          <md-optgroup label=\"city\">\n            <md-option ng-value=\"null\">\n              {{ 'common-all-masculine' | translate }}\n            </md-option>\n            <md-option ng-repeat=\"city in $ctrl.cities | filter:$ctrl.search\" \n              ng-selected=\"!$ctrl.filter.city_id.includes(null) && $ctrl.filter.city_id.includes(city.id.toString())\"\n              ng-disabled=\"$ctrl.filter.city_id.includes(null)\" ng-value=\"city.id.toString()\">{{ city.name }}\n            </md-option>\n          </md-optgroup>\n        </md-select>\n\n        <div ng-messages=\"notificationForm.city.$error\" multiple>\n          <div ng-message=\"required\">\n            {{ 'form-error-required-field' | translate}}\n          </div>\n        </div>\n      </md-input-container>\n\n      <md-input-container class=\"md-block\" flex>\n        <label>{{ 'common-gender' | translate}}</label>\n        <md-select name=\"gender\" ng-disabled=\"$ctrl.saving\"\n                   ng-model=\"$ctrl.filter.gender\"\n        >\n          <md-option ng-value=\"null\">\n            {{ 'common-all-masculine' | translate}}\n          </md-option>\n\n          <md-option ng-value=\"'MALE'\">\n            {{ 'common-male' | translate}}\n          </md-option>\n\n          <md-option ng-value=\"'FEMALE'\">\n            {{ 'common-female' | translate}}\n          </md-option>\n        </md-select>\n      </md-input-container>\n    </div>\n\n    <div class=\"inputs-container\">\n      <md-input-container>\n        <label> Período inicial</label>\n        <input ng-model='$ctrl.filter.specificationDate' type='month' name='specificationDate ' id='specificationDate' ng-change=\"setMaxYear()\" ng-disabled=\"$ctrl.saving\"/>\n      </md-input-container>\n\n      <md-input-container>\n        <label> Período final </label>\n        <input ng-model='$ctrl.filter.finalDate' type='month' name='finalDate' \n        id='finalDate' min=\"{{$ctrl.filter.specificationDate | date:'yyyy-MM'}}\" max=\"{{maxPeriod | date:'yyyy-MM'}}\" ng-disabled=\"!$ctrl.filter.specificationDate || $ctrl.saving\" />\n      </md-input-container>\n    </div>\n\n\n    <md-progress-linear ng-show=\"$ctrl.saving || $ctrl.deleting || $ctrl.generationChart\"\n                        md-mode=\"indeterminate\">\n    </md-progress-linear>\n\n    <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions\">\n\n      <md-button ng-click=\"generateChartReport()\" ng-disabled=\"$ctrl.generationChart || $ctrl.deleting\"\n                 class=\"md-accent md-raised\">\n        {{ $ctrl.generationChart ? 'client-report-graph-filtering' : 'client-report-graph-filter' | translate }}\n      </md-button>\n      <md-button ng-click=\"downloadReport()\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                 class=\"md-accent md-raised\">\n        {{ $ctrl.saving ? 'client-report-filtering' : 'client-report-filter' | translate }}\n      </md-button>\n    </div>\n\n  </md-card>\n  <md-card ng-show=\" $ctrl.graphCreated\" >\n    <div layout=\"row\" layout-align=\"flex start\">\n\n      <div layout=\"column\" class=\"sb-page-section\">\n        <h3 class=\"sb-page-section-title\">{{ 'client-report-title' | translate }}</h3>\n\n        <p class=\"sb-page-section-sub-title\">\n          {{ 'client-report-title-caption' | translate }}\n        </p>\n\n      </div>\n    </div>\n    <div layout=\"row\" >\n      <div layout=\"column\" class=\"sb-page-section\">\n        <p class=\"sb-page-section-sub-title\">\n          {{ 'client-report-chart-clients' | translate }}\n        </p>\n        <canvas id=\"pieCients\" class=\"chart chart-pie\"\n                chart-data=\"dataClients\" chart-labels=\"labelsClients\" chart-colors=\"colors\" chart-options=\"options\" legend=\"true\">\n        </canvas>\n        <div class=\"captions-group\">\n          <div layout=\"row\" layout-align=\"flex start\" ng-repeat=\"(index, label) in labelsClients\">\n            <div class=\"chart-caption\" ng-style=\"{'background-color': colors[index]}\"></div>\n            {{ label + \" - \" + dataClients[index] }}\n          </div>\n        </div>\n      </div>\n\n      <div layout=\"column\" class=\"sb-page-section\">\n        <p class=\"sb-page-section-sub-title\">\n          {{ 'client-report-chart-clients-gender' | translate }}\n        </p>\n        <canvas id=\"pieGender\" class=\"chart chart-pie\"\n                chart-data=\"dataClientsGender\" chart-labels=\"labelsClientsGender\" chart-colors=\"colors\" chart-options=\"options\" legend=\"true\">\n        </canvas>\n        <div class=\"captions-group\">\n          <div layout=\"row\" layout-align=\"flex start\" ng-repeat=\"(index, label) in labelsClientsGender\">\n            <div class=\"chart-caption\" ng-style=\"{'background-color': colors[index]}\"></div>\n            {{ label + \" - \" + dataClientsGender[index] }}\n          </div>\n        </div>\n      </div>\n      <div layout=\"column\" class=\"sb-page-section\" ng-if=\"labelsCities.length == 0\">\n        <p class=\"sb-page-section-sub-title\">\n          {{ 'client-report-chart-clients-states' | translate }}\n        </p>\n        <canvas id=\"pieStates\" class=\"chart chart-pie\"\n                chart-data=\"dataStates\" chart-labels=\"labelsStates\" chart-colors=\"colors\" chart-options=\"$ctrl.options\" legend=\"true\">\n        </canvas>\n        <div class=\"captions-group grid-captions\">\n          <div layout=\"row\" layout-align=\"flex start\" ng-repeat=\"(index, label) in labelsStates\">\n            <div class=\"chart-caption\" ng-style=\"{'background-color': colors[index]}\"></div>\n            {{ label + \" - \" + dataStates[index] }}\n          </div>\n        </div>\n      </div>\n\n      <div layout=\"column\" class=\"sb-page-section\" ng-if=\"labelsCities.length > 0\">\n        <p class=\"sb-page-section-sub-title\">\n          Total de clientes por cidades\n        </p>\n        <canvas id=\"pieCities\" class=\"chart chart-pie\"\n                chart-data=\"dataCities\" chart-labels=\"labelsCities\" chart-colors=\"colors\" chart-options=\"$ctrl.options\" legend=\"true\">\n        </canvas>\n        <div class=\"captions-group grid-captions\">\n          <div layout=\"row\" layout-align=\"flex start\" ng-repeat=\"(index, label) in labelsCities\">\n            <div class=\"chart-caption\" ng-style=\"{'background-color': colors[index]}\"></div>\n            {{ label + \" - \" + dataCities[index] }}\n          </div>\n        </div>\n      </div>\n    </div>\n  </md-card>\n\n</div>\n"

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _FileSaver = __webpack_require__(633);
	var _moment = __webpack_require__(421);var _moment2 = _interopRequireDefault(_moment);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var ClientReportController = function ClientReportController(Client, $filter, $scope, $state, Toast, State, City, $timeout) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	  $ctrl.search = '';
	  $ctrl.searchState = '';
	  $scope.colors = ['#8DC73D', '#F78022', '#2B3594', '#ED1B24', '#FDF106', '#2BC0B8', '#CA225F', '#262625',
	  '#00A652', '#8D62A9', '#F16029', '#6F2D8F', '#0C0352', '#03CEA4', '#9B1F05', '#F82D69', '#A05A65', '#15FF00',
	  '#455110', '#C8B382', '#4E1F24', '#45606E', '#00FF43', '#FF9393', '#606060', '#99AB52', '#E9FD78', '#7CB3B3'];
	  $ctrl.filter = {};
	  $ctrl.selectedDate = '';
	
	  $timeout(function () {
	    _angular2.default.element(document.querySelector('.input-search-state')).on('keydown', function (ev) {
	      ev.stopPropagation();
	    });
	  }, 500);
	
	  _angular2.default.extend($ctrl, {
	    onChangeState: onChangeState, edit: edit, clearSearch: clearSearch });
	
	
	
	  activate();
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	    $ctrl.uiState = 'LOADING';
	    loadData().
	    then(function (response) {
	      $ctrl.states = response[0];
	      $ctrl.uiState = 'COMPLETE';
	      $ctrl.$scope.$apply();
	    });
	  }
	
	  function clearSearch() {
	    $ctrl.search = '';
	  };
	
	  $scope.generateChartReport = function () {
	    $ctrl.activeSpinButton = true;
	    $ctrl.activeSpin = true;
	    $ctrl.generationChart = true;
	    Client.loadCharts({
	      receiver: $ctrl.filter.receiver,
	      state: $ctrl.filter.state_id,
	      gender: $ctrl.filter.gender,
	      city_id: $ctrl.filter.city_id,
	      specificationDate: formatDate($ctrl.filter.specificationDate),
	      finalDate: formatDate($ctrl.filter.finalDate) }).
	
	    then(function (response) {
	      setChartValues(response);
	      $ctrl.activeSpin = false;
	      $ctrl.graphCreated = true;
	      $ctrl.generationChart = false;
	      $ctrl.activeSpinButton = false;
	    });
	  };
	
	  $scope.downloadReport = function () {
	    $ctrl.activeSpin = true;
	    $ctrl.saving = true;
	    $ctrl.activeSpinButton = true;
	    Client.
	    getReportData({
	      receiver: $ctrl.filter.receiver,
	      state: $ctrl.filter.state_id,
	      gender: $ctrl.filter.gender,
	      city_id: $ctrl.filter.city_id,
	      specificationDate: formatDate($ctrl.filter.specificationDate),
	      finalDate: formatDate($ctrl.filter.finalDate) }).
	
	    then(function (res) {
	      $ctrl.activeSpin = false;
	      $ctrl.saving = false;
	      $ctrl.activeSpinButton = false;
	      var file = new Blob([res], { type: 'text/csv;charset=utf-8;' });
	      (0, _FileSaver.saveAs)(file, 'rel_analitico_clientes.csv');
	    }).catch(function (err) {
	      console.log('err:', err);
	      var messageError = $filter('translate')('report-error');
	      $ctrl.activeSpin = false;
	      $ctrl.saving = false;
	      $ctrl.activeSpinButton = false;
	      Toast.error(messageError);
	    });
	
	    // Client
	    // .getReportData()
	    // .then(function (res) {
	    //   let messageSuccess = $filter('translate')('report-success');
	    //   $ctrl.activeSpin = false;
	    //   $ctrl.activeSpinButton = false;
	    //   Toast.success(messageSuccess);
	    //   window.location.href = res.url;
	    // }).catch(err => {
	    //   console.log('err:' ,  err);
	    //   let messageError = $filter('translate')('report-error');
	    //   $ctrl.activeSpin = false;
	    //   $ctrl.activeSpinButton = false;
	    //   Toast.error(messageError);
	    // });
	  };
	
	  $scope.downloadReportSmall = function () {
	    $ctrl.activeSpinSmall = true;
	    $ctrl.activeSpinSmallButton = true;
	    Client.
	    downloadReportSmall().
	    then(function (res) {
	      var messageSuccess = $filter('translate')('report-success');
	      $ctrl.activeSpinSmall = false;
	      $ctrl.activeSpinSmallButton = false;
	      Toast.success(messageSuccess);
	      window.location.href = res.url;
	    }).catch(function (err) {
	      console.log('err:', err);
	      var messageError = $filter('translate')('report-error');
	      $ctrl.activeSpinSmall = false;
	      $ctrl.activeSpinSmallButton = false;
	      Toast.error(messageError);
	    });
	  };
	
	  function onChangeState(stateId) {
	    if (stateId && stateId.length === 1) {
	      // if(stateId && stateId.length > 1)
	      $ctrl.filter.city_id = null;
	      $ctrl.loadingCities = true;
	      City.
	      listCitiesWithClient({
	        state_id: stateId,
	        limit: 1000000 }).
	
	      then(function (cities) {
	        $ctrl.cities = cities;
	        $ctrl.loadingCities = false;
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.loadingCities = false;
	      }).finally(function () {
	        _angular2.default.element(document.querySelector('.input-search-city')).on('keydown', function (ev) {
	          ev.stopPropagation();
	        });
	      });
	    }
	
	    if (stateId && stateId.length > 1) {
	      $ctrl.search = '';
	      $ctrl.filter.city_id = null;
	      $ctrl.cities = [];
	    }
	  }
	
	  function edit(id) {
	    $state.go('client.edit', { id: id });
	  }
	
	  // Local functions
	  function loadData() {
	    var promises = [];
	    promises.push(State.listStatesWithClient());
	    return Promise.all(promises);
	  }
	
	  function setChartValues(json) {
	    $scope.labelsClients = ["Médicos", "Clientes", "Dependentes"];
	    $scope.dataClients = [json.type.countMedic, json.type.countClient, json.type.countDependents];
	    $scope.labelsClientsGender = ["Masculino", "Feminino", "Outros", "Não informado"];
	    $scope.dataClientsGender = [json.gender.countMale, json.gender.countFemale, json.gender.countOther, json.gender.countNull];
	    $scope.labelsDependents = ["Possui dependentes", "Não possui dependentes"];
	    $scope.dataDependents = [json.dependent.countWith, json.dependent.countWithout];
	    $scope.labelsStates = [];
	    $scope.dataStates = [];
	    json.states.forEach(function (state) {
	      $scope.labelsStates.push(state.uf);
	      $scope.dataStates.push(state.total);
	    });
	    $scope.labelsCities = [];
	    $scope.dataCities = [];
	    json.cities.forEach(function (city) {
	      $scope.labelsCities.push(city.name);
	      $scope.dataCities.push(city.total);
	    });
	  }
	
	  $scope.maxPeriod = new Date(new Date().getUTCFullYear() + 1);
	  $scope.setMaxYear = function () {
	    $ctrl.filter.finalDate = null;
	    $scope.maxPeriod = new Date($ctrl.filter.specificationDate.getUTCFullYear() + 1 + ' ' + ($ctrl.filter.specificationDate.getUTCMonth() + 1) + ' 1');
	  };
	
	  function formatDate(dt) {
	    return dt ? (0, _moment2.default)(dt).format("YYYY-MM-DD") : null;
	  }
	};
	
	ClientReportController.$inject = ['Client', '$filter', '$scope', '$state', 'Toast', 'State', 'City', '$timeout'];exports.default =
	ClientReportController;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var ClientService = function ClientService(Restangular) {
	  var Service = Restangular.all('admin/user_profile');
	
	  var count = function count(query) {
	    query = query || {};
	    query.type = 'CLIENT';
	    query.deleted_at = 'null';
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.type = 'CLIENT';
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var loadCharts = function loadCharts(params) {
	    return Service.customGET('report', params);
	  };
	
	  var getReportData = function getReportData(params) {
	    return Service.customGET('report-data', params);
	  };
	
	  var load = function load(query) {
	    query = query || {};
	    query.type = 'CLIENT';
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  var downloadReport = function downloadReport() {
	    return Restangular.one('user_profile/full_report').get();
	  };
	
	  var downloadReportSmall = function downloadReportSmall() {
	    return Restangular.one('user_profile/partial_report').get();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy, downloadReport: downloadReport, downloadReportSmall: downloadReportSmall, loadCharts: loadCharts, getReportData: getReportData };
	};
	
	ClientService.$inject = ['Restangular'];exports.default =
	
	ClientService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _card = __webpack_require__(716);var _card2 = _interopRequireDefault(_card);
	var _cardList = __webpack_require__(721);var _cardList2 = _interopRequireDefault(_cardList);
	var _cardDetail = __webpack_require__(724);var _cardDetail2 = _interopRequireDefault(_cardDetail);
	var _card3 = __webpack_require__(727);var _card4 = _interopRequireDefault(_card3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var cardModule = _angular2.default.module('card', [
	_angularUiRouter2.default]).
	
	
	service('Card', _card4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/card');
	
	  $stateProvider.
	  state('card', {
	    component: 'card' }).
	
	  state('card.list', {
	    url: '/card',
	    component: 'cardList' }).
	
	  state('card.create', {
	    url: '/card/new',
	    component: 'cardDetail',
	    params: {
	      id: "" } }).
	
	
	  state('card.edit', {
	    url: '/card/:id/edit',
	    component: 'cardDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('card', _card2.default).
	component('cardList', _cardList2.default).
	component('cardDetail', _cardDetail2.default).
	
	name;exports.default =
	
	cardModule;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _card = __webpack_require__(717);var _card2 = _interopRequireDefault(_card);
	var _card3 = __webpack_require__(718);var _card4 = _interopRequireDefault(_card3);
	__webpack_require__(719);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var cardComponent = {
	  bindings: {},
	  template: _card2.default,
	  controller: _card4.default };exports.default =
	
	
	cardComponent;

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var CardController =
	function CardController() {_classCallCheck(this, CardController);
	  this.name = 'card';
	};exports.default =
	
	
	CardController;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(720);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./card.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./card.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".card{color:red}.select-field[disabled] .md-select-icon,.select-field[disabled] .md-select-value{color:rgba(0,0,0,.54)}", ""]);
	
	// exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _cardList = __webpack_require__(722);var _cardList2 = _interopRequireDefault(_cardList);
	var _cardList3 = __webpack_require__(723);var _cardList4 = _interopRequireDefault(_cardList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var cardListComponent = {
	  bindings: {},
	  template: _cardList2.default,
	  controller: _cardList4.default };exports.default =
	
	
	cardListComponent;

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\"\n         ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n        <md-button class=\"md-raised md-accent\" ui-sref=\"card.create\">\n            {{ 'common-new-masculine' | translate }}\n        </md-button>\n\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\"\n                        ng-click=\"$ctrl.orderList('name')\">\n                        {{ 'common-name' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'common-updated-at' | translate }}\n                    </th>\n\n                    <th md-column md-numeric class=\"sb-table-column-xs\">\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit(resource.id)\">\n                    <td md-cell class=\"sb-table-truncate\">\n                    \t{{ resource.name }}\n                    </td>\n\n                    <td md-cell>\n                    \t{{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n\n                    <td md-cell>\n                        <md-button aria-label=\"Toolbar menu\"\n                                   class=\"md-icon-button\"\n                                   ng-click=\"$ctrl.handleDelete(resource, $event)\">\n                          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <img src=\"assets/vacines_empty.png\"/>\n\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'card-list-empty-state-line-1' | translate }}</p>\n                <p>{{ 'card-list-empty-state-line-2' | translate }}</p>\n            </div>\n\n            <md-button class=\"md-raised md-accent\" ui-sref=\"card.create\">\n                {{ 'card-list-create-card-button' | translate }}\n            </md-button>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var CardListController = function CardListController(Card, $filter, $scope, $state, $mdDialog, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name',
	      like_search: '',
	      like_search_fields: [
	      'name'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function edit(id) {
	    $state.go('card.edit', { id: id });
	  }
	
	  function handleDelete(resource, event) {
	    event.stopPropagation();
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Card.
	      destroy(resource).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        _.remove($ctrl.resources.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Card.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	CardListController.$inject = ['Card', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];exports.default =
	
	CardListController;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _cardDetail = __webpack_require__(725);var _cardDetail2 = _interopRequireDefault(_cardDetail);
	var _cardDetail3 = __webpack_require__(726);var _cardDetail4 = _interopRequireDefault(_cardDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var cardDetailComponent = {
	  bindings: {},
	  template: _cardDetail2.default,
	  controller: _cardDetail4.default };exports.default =
	
	
	cardDetailComponent;

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-card\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <form name=\"cardForm\" ng-submit=\"$ctrl.handleSave(cardForm, $ctrl.card)\"\n              novalidate>\n            <!-- card -->\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">{{ 'card-detail-title' | translate }}</h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'card-detail-title-caption' | translate }}\n                </p>\n\n                <md-card>\n                    <!-- name -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\" flex>\n                            <label>\n                                {{ 'common-name' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.card.name\" name=\"name\" required />\n\n                            <div ng-messages=\"cardForm.name.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"md-maxlength\">\n                                    {{ 'card-detail-form-error-title-max-length' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n\n                    <!-- doses interval_in_days -->\n                    <div layout=\"row\" flex>\n                        <md-input-container class=\"md-block\">\n                            <label>\n                                {{ 'card-detail-form-doses-label' | translate }}*\n                            </label>\n                            <md-select\n                              ng-model=\"$ctrl.card.doses\" style=\"width: 170px\"\n                              ng-change=\"$ctrl.onChangeDose($ctrl.card.doses)\"\n                              name=\"doses\"\n                              aria-required=\"true\">\n                                <md-option ng-value=\"\" aria-selected=\"true\"></md-option>\n                                <md-option ng-value=\"'Anual'\">Anual</md-option>\n                                <md-option ng-value=\"1\">1</md-option>\n                                <md-option ng-value=\"2\">2</md-option>\n                                <md-option ng-value=\"3\">3</md-option>\n                            </md-select>\n                        </md-input-container>\n\n                        <span flex=\"2\"></span>\n\n                        <md-input-container class=\"md-block\">\n                            <label>\n                                {{ 'card-detail-form-interval-value-label' | translate }}\n                            </label>\n\n                            <input ng-model=\"$ctrl.intervalValue\"\n                                   name=\"intervalValue\"\n                                   type=\"number\" min=\"1\"\n                                   ng-disabled=\"!$ctrl.card.doses || $ctrl.card.doses === 1\"\n                                   ng-required=\"$ctrl.card.doses > 1 || $ctrl.card.doses === 'Anual'\" />\n\n                            <div ng-messages=\"cardForm.intervalValue.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n\n                                <div ng-message=\"min\">\n                                    {{ 'card-detail-form-error-interval_in_days-min' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n\n                        <md-input-container class=\"md-block\">\n                            <md-select\n                              class=\"select-field\"\n                              ng-model=\"$ctrl.card.input_interval_unit\"\n                              name=\"input_interval_unit\"\n                              ng-disabled=\"!$ctrl.card.doses || $ctrl.card.doses === 1\"\n                              ng-required=\"$ctrl.card.doses > 1\">\n                                <md-option ng-value=\"'MONTHS'\" >\n                                    {{ 'common-months' | translate }}\n                                </md-option>\n                                <md-option ng-value=\"'YEARS'\" >\n                                    {{ 'common-years' | translate }}\n                                </md-option>\n                            </md-select>\n\n                            <div ng-messages=\"cardForm.input_interval_unit.$error\" multiple>\n                                <div ng-message=\"required\">\n                                    {{ 'form-error-required-field' | translate}}\n                                </div>\n                            </div>\n                        </md-input-container>\n                    </div>\n                </md-card>\n            </div>\n\n            <!-- form actions -->\n            <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n                <md-button page-back\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                    {{ 'common-cancel-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.handleDelete($ctrl.card, $event)\"\n                           ng-if=\"$ctrl.id && !$ctrl.card.is_super\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-warn md-raised\">\n                    {{ 'common-delete-button-text' | translate }}\n                </md-button>\n\n                <md-button ng-click=\"$ctrl.clearForm(cardForm)\"\n                           ng-if=\"!$ctrl.id\"\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-raised\">\n                    {{ 'common-clear-button-text' | translate }}\n                </md-button>\n\n                <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-accent md-raised\">\n                    {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                </md-button>\n            </div>\n        </form>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var CardDetailController = function CardDetailController($filter, $mdDialog, $scope, $state, Toast, Card) {
	  var $ctrl = this;
	
	  var daysPerYear = 365;
	  var monthsPerYear = 30.4167;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.card;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    loadResource($ctrl.id);
	  }
	
	  function clearForm(form) {
	    $ctrl.card = {
	      input_interval_unit: 'MONTHS' };
	
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(card, event) {
	    var confirmMessage = 'common-detail-delete-confirm-text';
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')(confirmMessage)).
	    ariaLabel($filter('translate')(confirmMessage)).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Card.
	      destroy(card).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('card.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, card) {
	    if (!form.$valid) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    var multiplier = card.input_interval_unit === 'MONTHS' ? monthsPerYear : daysPerYear;
	    card.interval_in_days = Math.round($ctrl.intervalValue * multiplier);
	
	    save(card);
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	
	      Card.show(id).
	      then(function (response) {
	        response.input_interval_unit = response.input_interval_unit || 'MONTHS';
	        var multiplier = response.input_interval_unit === 'MONTHS' ? monthsPerYear : daysPerYear;
	        $ctrl.intervalValue = Math.round(response.interval_in_days / multiplier);
	
	        $ctrl.card = response;
	        $ctrl.card.doses = response.doses === 0 ? 'Anual' : response.doses;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.uiState = 'ERROR';
	      });
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	    }
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Module.index());
	
	    return Promise.all(promises);
	  }
	
	  function save(card) {
	    $ctrl.saving = true;
	
	    Card.
	    save(card).
	    then(function (response) {
	      Toast.success($filter('translate')('card-detail-save-success'));
	      $ctrl.card = response;
	      $ctrl.saving = false;
	      $state.go('card.list');
	    }).
	    catch(function (err) {
	      var defaultErrMsg = 'common-server-error';
	      var fourONineMsg = 'card-detail-409-error';
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter('translate')(message));
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	};
	
	CardDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Card'];exports.default =
	
	CardDetailController;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var CardService = function CardService(Restangular) {
	  var Service = Restangular.all('admin/card_vaccine');
	
	  var count = function count(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.customDELETE();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	CardService.$inject = ['Restangular'];exports.default =
	
	CardService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _insurance = __webpack_require__(729);var _insurance2 = _interopRequireDefault(_insurance);
	var _insuranceList = __webpack_require__(734);var _insuranceList2 = _interopRequireDefault(_insuranceList);
	var _insuranceDetail = __webpack_require__(737);var _insuranceDetail2 = _interopRequireDefault(_insuranceDetail);
	var _insurance3 = __webpack_require__(740);var _insurance4 = _interopRequireDefault(_insurance3);
	var _insuranceStateList = __webpack_require__(741);var _insuranceStateList2 = _interopRequireDefault(_insuranceStateList);
	var _insuranceStateDetail = __webpack_require__(744);var _insuranceStateDetail2 = _interopRequireDefault(_insuranceStateDetail);
	var _insuranceCityDetail = __webpack_require__(747);var _insuranceCityDetail2 = _interopRequireDefault(_insuranceCityDetail);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var insuranceModule = _angular2.default.module('insurance', [
	_angularUiRouter2.default]).
	
	
	service('Insurance', _insurance4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/insurance');
	
	  $stateProvider.
	  state('insurance', {
	    component: 'insurance' }).
	
	  state('insurance.list', {
	    url: '/insurance',
	    component: 'insuranceList' }).
	
	  state('insurance.create', {
	    url: '/insurance/new',
	    component: 'insuranceDetail',
	    params: {
	      id: "" } }).
	
	
	  state('insurance.edit', {
	    url: '/insurance/:id/edit',
	    component: 'insuranceDetail',
	    params: {
	      id: "" } }).
	
	
	  state('insurance.state', {
	    url: '/insurance/states',
	    component: 'insuranceStateList' }).
	
	  state('insurance.screate', {
	    url: '/insurance/states/new',
	    component: 'insuranceStateDetail',
	    params: {
	      id: "" } }).
	
	
	  state('insurance.sedit', {
	    url: '/insurance/states/:id/edit',
	    component: 'insuranceStateDetail',
	    params: {
	      id: "" } }).
	
	
	  state('insurance.ccreate', {
	    url: '/insurance/city/:uf/new',
	    component: 'insuranceCityDetail',
	    params: {
	      uf: "" } }).
	
	
	  state('insurance.cedit', {
	    url: '/insurance/city/:uf/:id/edit',
	    component: 'insuranceCityDetail',
	    params: {
	      uf: "",
	      id: "" } });
	
	
	}]).
	
	component('insurance', _insurance2.default).
	component('insuranceList', _insuranceList2.default).
	component('insuranceStateList', _insuranceStateList2.default).
	component('insuranceDetail', _insuranceDetail2.default).
	component('insuranceStateDetail', _insuranceStateDetail2.default).
	component('insuranceCityDetail', _insuranceCityDetail2.default).
	
	name;exports.default =
	
	insuranceModule;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _insurance = __webpack_require__(730);var _insurance2 = _interopRequireDefault(_insurance);
	var _insurance3 = __webpack_require__(731);var _insurance4 = _interopRequireDefault(_insurance3);
	__webpack_require__(732);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var insuranceComponent = {
	  bindings: {},
	  template: _insurance2.default,
	  controller: _insurance4.default };exports.default =
	
	
	insuranceComponent;

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var InsuranceController =
	function InsuranceController() {_classCallCheck(this, InsuranceController);
	  this.name = 'insurance';
	};exports.default =
	
	
	InsuranceController;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(733);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./insurance.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./insurance.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".insurance{color:red}", ""]);
	
	// exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _insuranceList = __webpack_require__(735);var _insuranceList2 = _interopRequireDefault(_insuranceList);
	var _insuranceList3 = __webpack_require__(736);var _insuranceList4 = _interopRequireDefault(_insuranceList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var insuranceListComponent = {
	  bindings: {},
	  template: _insuranceList2.default,
	  controller: _insuranceList4.default };exports.default =
	
	
	insuranceListComponent;

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container unit-list\">\n  <div layout=\"row\" layout-align=\"space between\"\n       ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY')\">\n    <md-button class=\"md-raised md-accent\" ui-sref=\"insurance.create\">\n      {{ 'common-new-masculine' | translate }}\n    </md-button>\n\n    <md-input-container class=\"md-block\" flex>\n      <label>\n        {{ 'common-state' | translate }}\n      </label>\n\n      <md-select ng-model=\"$ctrl.state_id\"\n                 ng-change=\"$ctrl.onChangeState($ctrl.state_id)\"\n                 ng-disabled=\"$ctrl.isSent\"\n                 name=\"state\">\n        <md-option ng-repeat=\"state in $ctrl.states\"\n                   ng-value=\"state.sigla\">\n          {{ state.descricao }}\n        </md-option>\n      </md-select>\n    </md-input-container>\n\n\n    <md-input-container class=\"md-block\" flex>\n      <label>\n        {{ 'common-city' | translate }}\n      </label>\n\n      <md-select ng-model=\"$ctrl.city_id\"\n                 ng-change=\"$ctrl.onChangeCity($ctrl.city_id)\"\n                 ng-disabled=\"!$ctrl.state_id || $ctrl.loadingCities || $ctrl.isSent\"\n                 name=\"city\">\n\n        <md-option ng-repeat=\"city in $ctrl.cities\"\n                   ng-value=\"city.sigla\">\n          {{ city.descricao }}\n        </md-option>\n      </md-select>\n    </md-input-container>\n\n    <md-card>\n      <div class=\"sb-table-search\">\n        <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n        </md-icon>\n\n        <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n               ng-model-options=\"{ debounce: 1000 }\"\n               type=\"text\" name=\"\">\n      </div>\n    </md-card>\n  </div>\n\n  <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n    <md-table-container>\n      <table md-table md-progress=\"$ctrl.promise\">\n        <thead md-head>\n        <tr md-row>\n          <th md-column>\n            ID\n          </th>\n          <th md-column>\n            Descrição\n          </th>\n          <th md-column>\n            Cobre analises clinicas\n          </th>\n          <th md-column>\n            Cobre exames de imagem\n          </th>\n          <th md-column>\n            Cobre Vacinas\n          </th>\n          <th md-column></th>\n        </tr>\n        </thead>\n        <tbody md-body>\n        <tr md-row ng-repeat=\"resource in $ctrl.resources.data\">\n          <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.edit(resource)\">\n            {{ resource.id }}\n          </td>\n\n          <td md-cell ng-click=\"$ctrl.edit(resource)\">\n            {{ resource.descricao }}\n          </td>\n          <td md-cell ng-click=\"$ctrl.edit(resource)\">\n            {{ (resource.cobre_analises_clinicas == 1 ? 'Sim' : 'Não') }}\n          </td>\n          <td md-cell ng-click=\"$ctrl.edit(resource)\">\n            {{ (resource.cobre_exames_imagem == 1 ? 'Sim' : 'Não')  }}\n          </td>\n          <td md-cell ng-click=\"$ctrl.edit(resource)\">\n            {{ (resource.cobre_vacinas == 1 ? 'Sim' : 'Não') }}\n          </td>\n          <td md-cell>\n            <md-button aria-label=\"Toolbar menu\"\n                        class=\"md-icon-button\"\n                        ng-click=\"$ctrl.handleDelete(resource, $event)\">\n              <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n              </md-icon>\n            </md-button>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n\n  </md-card>\n\n  <div ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n       class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <img src=\"assets/vacines_empty.png\"/>\n\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n      </div>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n       class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n      </div>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n       class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <div class=\"sb-error-message\">\n        {{ 'common-load-error' | translate}}\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var InsuranceListController = function InsuranceListController(Insurance, $filter, $scope, $state, $mdDialog, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, handleDelete: handleDelete, onChangeState: onChangeState, onChangeCity: onChangeCity });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name',
	      like_search: '',
	      like_search_fields: [
	      'name'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      Insurance.listStates().then(function (states) {
	        $ctrl.state_id = states[0].sigla;
	        $ctrl.states = states;
	        Insurance.listCities($ctrl.state_id).then(function (cities) {
	          $ctrl.city_id = cities[0].sigla;
	          $ctrl.cities = cities;
	          loadData($ctrl.city_id);
	        });
	      });
	    }, true);
	  }
	
	  function onChangeCity(cityId) {
	    loadData($ctrl.city_id);
	  }
	  function onChangeState(stateId) {
	    $ctrl.city_id = undefined;
	    $ctrl.loadingCities = true;
	
	    Insurance.listCities($ctrl.state_id).
	    then(function (cities) {
	      $ctrl.cities = cities;
	      $ctrl.loadingCities = false;
	      $ctrl.resources = [];
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.loadingCities = false;
	    });
	  }
	  function edit(resource) {
	    resource.city_id = $ctrl.city_id;
	    var id = resource.id;
	    localStorage.setItem('insurance', JSON.stringify(resource));
	    $state.go('insurance.edit', { id: id });
	  }
	
	  function handleDelete(_ref, event) {var id = _ref.id;
	    event.stopPropagation();
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    var obj = {
	      id: id,
	      sigla_uf: $ctrl.state_id,
	      sigla_city: $ctrl.city_id };
	
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Insurance.
	      deleteCovenant(obj).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        loadData($ctrl.city_id);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData(sigla) {
	    $ctrl.promise = Insurance.
	    load(sigla, $ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	InsuranceListController.$inject = ['Insurance', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];exports.default =
	
	InsuranceListController;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _insuranceDetail = __webpack_require__(738);var _insuranceDetail2 = _interopRequireDefault(_insuranceDetail);
	var _insuranceDetail3 = __webpack_require__(739);var _insuranceDetail4 = _interopRequireDefault(_insuranceDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var insuranceDetailComponent = {
	  bindings: {},
	  template: _insuranceDetail2.default,
	  controller: _insuranceDetail4.default };exports.default =
	
	
	insuranceDetailComponent;

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div class=\"sb-content sb-card\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n    <form name=\"cardForm\" ng-submit=\"$ctrl.handleSave(cardForm, $ctrl.insurance)\"\n          novalidate>\n      <!-- card -->\n      <div layout=\"column\" class=\"sb-page-section\">\n        <h3 class=\"sb-page-section-title\">{{ 'insurance-detail-title' | translate }}</h3>\n\n        <md-card>\n          <!-- name -->\n          <div layout=\"row\" flex>\n            <md-input-container class=\"md-block\" flex>\n              <label>\n                {{ 'common-name' | translate }}\n              </label>\n\n              <input ng-model=\"$ctrl.insurance.descricao\" name=\"descricao\"\n                     required>\n              </input>\n\n              <div ng-messages=\"cardForm.descricao.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n\n                <div ng-message=\"md-maxlength\">\n                  {{ 'card-detail-form-error-title-max-length' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n\n          </div>\n          <div layout=\"row\" flex ng-if=\"!$ctrl.id\">\n            <md-input-container class=\"md-block\" flex>\n              <label>\n                {{ 'common-state' | translate }}\n              </label>\n\n              <md-select ng-model=\"$ctrl.state_id\"\n                         ng-change=\"$ctrl.onChangeState($ctrl.state_id)\"\n                         ng-disabled=\"$ctrl.isSent\"\n                         name=\"state\">\n                <md-option ng-repeat=\"state in $ctrl.states\"\n                           ng-value=\"state.sigla\">\n                  {{ state.descricao }}\n                </md-option>\n              </md-select>\n            </md-input-container>\n            <md-input-container class=\"md-block\" flex>\n              <label>\n                {{ 'common-city' | translate }}\n              </label>\n\n              <md-select ng-model=\"$ctrl.insurance.city\"\n                         ng-change=\"$ctrl.onChangeCity($ctrl.insurance.city)\"\n                         ng-disabled=\"!$ctrl.state_id || $ctrl.loadingCities || $ctrl.isSent\"\n                         name=\"city\">\n\n                <md-option ng-repeat=\"city in $ctrl.cities\"\n                           ng-value=\"city.sigla\">\n                  {{ city.descricao }}\n                </md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n          <!-- expire -->\n          <div layout=\"row\" flex ng-if=\"!$ctrl.id\">\n            <md-input-container class=\"md-block\">\n              <label>\n                {{ 'insurance-detail-form-expire-label' | translate }}\n              </label>\n\n              <input ng-model=\"$ctrl.insurance.validade\" name=\"validade\"\n                     type=\"number\" value=\"90\">\n\n              <div ng-messages=\"cardForm.doses.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n\n            <span flex=\"30\"></span>\n          </div>\n          Opçoes adicionais\n          <div layout=\"row\" flex>\n            <md-checkbox ng-model=\"$ctrl.insurance.cobre_analises_clinicas\"\n                         ng-checked=\"$ctrl.insurance.cobre_analises_clinicas\" aria-label=\"Analises clinicas\">\n              Cobre analises clinicas\n            </md-checkbox>\n            <md-checkbox ng-model=\"$ctrl.insurance.cobre_exames_imagem\" ng-checked=\"$ctrl.insurance.cobre_exames_imagem\"\n                         aria-label=\"Exames de imagem\">\n              Cobre exames de imagem\n            </md-checkbox>\n            <md-checkbox ng-model=\"$ctrl.insurance.cobre_vacinas\" ng-checked=\"$ctrl.insurance.cobre_vacinas\"\n                         aria-label=\"Cobre vacinas\">\n              Cobre Vacinas\n            </md-checkbox>\n          </div>\n        </md-card>\n      </div>\n\n      <!-- form actions -->\n      <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n        <md-button page-back\n                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n          {{ 'common-cancel-button-text' | translate }}\n        </md-button>\n\n        <md-button ng-click=\"$ctrl.clearForm(cardForm)\"\n                   ng-if=\"!$ctrl.id\"\n                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                   class=\"md-raised\">\n          {{ 'common-clear-button-text' | translate }}\n        </md-button>\n\n        <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                   class=\"md-accent md-raised\">\n          {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n        </md-button>\n      </div>\n    </form>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n       class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <div class=\"sb-error-message\">\n        {{ 'common-load-error' | translate}}\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var InsuranceDetailController = function InsuranceDetailController($filter, $mdDialog, $scope, $state, Toast, Insurance) {
	  var $ctrl = this;
	
	  var daysPerYear = 365;
	  var monthsPerYear = 30.4167;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.isEdit = false;
	  $ctrl.insurance;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete,
	    onChangeState: onChangeState });
	
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	    $ctrl.state_id = null;
	    Insurance.listStates().then(function (states) {
	      $ctrl.states = states;
	      loadResource($ctrl.id);
	    });
	  }
	
	  function onChangeState(stateId) {
	    $ctrl.city_id = undefined;
	    $ctrl.loadingCities = true;
	
	    Insurance.listCities($ctrl.state_id).
	    then(function (cities) {
	      $ctrl.cities = cities;
	      $ctrl.loadingCities = false;
	      $ctrl.resources = [];
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.loadingCities = false;
	    });
	  }
	
	  function clearForm(form) {
	    $ctrl.insurance = {
	      validade: 90 };
	
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(card, event) {
	    var confirmMessage = 'card-detail-delete-confirm-text';
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')(confirmMessage)).
	    ariaLabel($filter('translate')(confirmMessage)).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Insurance.
	      destroy(card).
	      then(function (response) {
	        Toast.success($filter('translate')('card-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('card.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, insurance) {
	    if (!form.$valid) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	    insurance.save = $ctrl.id != null && $ctrl.id !== '';
	    save(insurance);
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	      var resource = JSON.parse(localStorage.getItem('insurance'));
	      $ctrl.isEdit = true;
	      $ctrl.insurance = resource;
	      console.log($ctrl.insurance.resource);
	      $ctrl.uiState = 'COMPLETE';
	
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	    }
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Module.index());
	
	    return Promise.all(promises);
	  }
	
	  function save(card) {
	    $ctrl.saving = true;
	
	    Insurance.
	    save(card).
	    then(function (response) {
	      Toast.success($filter('translate')('insurance-detail-save-success'));
	      $ctrl.card = response;
	      $ctrl.saving = false;
	      $state.go('insurance.list');
	    }).
	    catch(function (err) {
	      if (typeof err.data == "string") {
	        Toast.error($filter('translate')(err.data));
	      } else {
	        var defaultErrMsg = 'common-server-error';
	        var fourONineMsg = 'card-detail-409-error';
	        var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	        Toast.error($filter('translate')(message));
	      }
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	};
	
	InsuranceDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Insurance'];exports.default =
	
	InsuranceDetailController;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {"use strict";Object.defineProperty(exports, "__esModule", { value: true });var InsuranceService = function InsuranceService(Restangular) {
	  var Service = Restangular.all('admin/insurance');
	
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return Service.customPUT({
	        "descricao": resource.descricao,
	        cobre_analises_clinicas: resource.cobre_analises_clinicas,
	        cobre_exames_imagem: resource.cobre_exames_imagem,
	        cobre_vacinas: resource.cobre_vacinas,
	        city_id: resource.city_id,
	        "id": resource.id },
	      "convenios");
	    } else {
	      return Service.customPOST({
	        "descricao": resource.descricao,
	        "cidade": resource.city,
	        cobre_analises_clinicas: resource.cobre_analises_clinicas,
	        cobre_exames_imagem: resource.cobre_exames_imagem,
	        cobre_vacinas: resource.cobre_vacinas,
	        "validade": resource.validade },
	      "convenios");
	    }
	  };
	
	  var saveState = function saveState(resource) {
	    if (resource.save) {
	      return Service.customPUT({
	        "description": resource.description,
	        "uf": resource.uf,
	        "id": resource.id },
	      "states");
	    } else {
	      return Service.customPOST({
	        "description": resource.description,
	        "uf": resource.uf,
	        "id": resource.id },
	      "states");
	    }
	  };
	  var saveCity = function saveCity(resource) {
	    if (resource.save) {
	      return Service.customPUT({
	        "description": resource.description,
	        "sigla": resource.sigla,
	        "uf": resource.uf,
	        "id": resource.id },
	      "cities");
	    } else {
	      return Service.customPOST({
	        "description": resource.description,
	        "uf": resource.uf,
	        "sigla": resource.sigla },
	      "cities");
	    }
	  };
	
	  var index = function index(SIGLA, query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return Service.customGET(SIGLA + "/convenios?like_search=" + query.like_search);
	  };
	
	  var load = function load(sigla, query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      var count = 10;
	      index(sigla, query).
	      then(function (data) {
	        resolve({ count: count, data: data });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var listStates = function listStates() {
	    return Service.customGET("states");
	  };
	  var listCities = function listCities(UF) {
	    return Service.customGET("states/" + UF + "/cities");
	  };
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var deleteCovenant = function deleteCovenant(resource) {
	    return Service.customDELETE("convenios/planos", {
	      "id": resource.id,
	      "sigla_city": resource.sigla_city,
	      "sigla_uf": resource.sigla_uf });
	
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy, listStates: listStates, listCities: listCities, saveState: saveState, saveCity: saveCity, deleteCovenant: deleteCovenant };
	};
	
	InsuranceService.$inject = ['Restangular'];exports.default =
	
	InsuranceService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _insuranceStateList = __webpack_require__(742);var _insuranceStateList2 = _interopRequireDefault(_insuranceStateList);
	var _insuranceStateList3 = __webpack_require__(743);var _insuranceStateList4 = _interopRequireDefault(_insuranceStateList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var insuranceStateListComponent = {
	  bindings: {},
	  template: _insuranceStateList2.default,
	  controller: _insuranceStateList4.default };exports.default =
	
	
	insuranceStateListComponent;

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container unit-list\">\n  <div layout=\"row\" layout-align=\"space between\"\n       ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n    <md-button class=\"md-raised md-accent\" ui-sref=\"insurance.screate\">\n      {{ 'common-new-masculine' | translate }}\n    </md-button>\n\n\n  </div>\n\n  <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n    <md-table-container>\n      <table md-table md-progress=\"$ctrl.promise\">\n        <thead md-head>\n        <tr md-row>\n          <th md-column>\n            Sigla\n          </th>\n          <th md-column>\n            Descrição\n          </th>\n\n        </tr>\n        </thead>\n        <tbody md-body>\n        <tr md-row ng-repeat=\"resource in $ctrl.resources\"\n            ng-click=\"$ctrl.edit(resource)\">\n          <td md-cell class=\"sb-table-truncate\">\n            {{ resource.sigla }}\n          </td>\n\n          <td md-cell>\n            {{ resource.descricao }}\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n\n  </md-card>\n\n  <div ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n       class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <img src=\"assets/vacines_empty.png\"/>\n\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'card-list-empty-state-line-1' | translate }}</p>\n        <p>{{ 'card-list-empty-state-line-2' | translate }}</p>\n      </div>\n\n      <md-button class=\"md-raised md-accent\" ui-sref=\"insurance.create\">\n        {{ 'card-list-create-card-button' | translate }}\n      </md-button>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n       class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n      </div>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n       class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <div class=\"sb-error-message\">\n        {{ 'common-load-error' | translate}}\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var InsuranceStateListController = function InsuranceStateListController(Insurance, $filter, $scope, $state, $mdDialog, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList, handleDelete: handleDelete, onChangeState: onChangeState, onChangeCity: onChangeCity });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'name',
	      like_search: '',
	      like_search_fields: [
	      'name'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      // Insurance.listStates().then(function (states) {
	      //   $ctrl.state_id = states[0].sigla
	      //   $ctrl.states = states;
	      // Insurance.listCities($ctrl.state_id).then(function (cities) {
	      //   $ctrl.city_id = cities[0].sigla
	      //   $ctrl.cities = cities;
	      loadData();
	      // })
	      // })
	    }, true);
	  }
	
	  function onChangeCity(cityId) {
	    loadData($ctrl.city_id);
	  }
	  function onChangeState(stateId) {
	    $ctrl.city_id = undefined;
	    $ctrl.loadingCities = true;
	
	    Insurance.listCities($ctrl.state_id).
	    then(function (cities) {
	      $ctrl.cities = cities;
	      $ctrl.loadingCities = false;
	      $ctrl.resources = [];
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.loadingCities = false;
	    });
	  }
	  function edit(resource) {
	    var id = resource.id;
	    localStorage.setItem('stateInsurance', JSON.stringify(resource));
	    $state.go('insurance.sedit', { id: id });
	  }
	
	  function handleDelete(resource, event) {
	    event.stopPropagation();
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')('common-detail-delete-confirm-text')).
	    ariaLabel($filter('translate')('common-detail-delete-confirm-text')).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Insurance.
	      destroy(resource).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.deleting = false;
	        _.remove($ctrl.resources.data, resource);
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	
	  function loadData(sigla) {
	    $ctrl.promise = Insurance.
	    listStates().
	    then(function (response) {
	      console.log("- response", response);
	      $ctrl.resources = response;
	      $ctrl.uiState = response.length ? 'COMPLETE' : 'EMPTY';
	      // $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	InsuranceStateListController.$inject = ['Insurance', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];exports.default =
	
	InsuranceStateListController;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _insuranceStateDetail = __webpack_require__(745);var _insuranceStateDetail2 = _interopRequireDefault(_insuranceStateDetail);
	var _insuranceStateDetail3 = __webpack_require__(746);var _insuranceStateDetail4 = _interopRequireDefault(_insuranceStateDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var insuranceStateDetailComponent = {
	  bindings: {},
	  template: _insuranceStateDetail2.default,
	  controller: _insuranceStateDetail4.default };exports.default =
	
	
	insuranceStateDetailComponent;

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div class=\"sb-content sb-card\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n    <form name=\"cardForm\" ng-submit=\"$ctrl.handleSave(cardForm, $ctrl.state)\"\n          novalidate>\n      <!-- card -->\n      <div layout=\"column\" class=\"sb-page-section\">\n        <h3 class=\"sb-page-section-title\">{{ 'insurance-state-detail-title' | translate }}</h3>\n\n        <md-card>\n          <!-- name -->\n          <div layout=\"row\" flex >\n\n          </div>\n          <!-- expire -->\n          <div layout=\"row\" flex >\n            <md-input-container class=\"md-block\">\n              <label>\n                Sigla\n              </label>\n\n              <input ng-model=\"$ctrl.state.uf\" name=\"uf\" ng-disabled=\"$ctrl.id\"\n                     type=\"text\" maxlength=\"2\">\n\n              <div ng-messages=\"cardForm.doses.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex>\n              <label>\n                Nome do Estado\n              </label>\n\n              <input ng-model=\"$ctrl.state.description\" name=\"description\"\n                     required>\n              </input>\n\n              <div ng-messages=\"cardForm.descricao.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n\n                <div ng-message=\"md-maxlength\">\n                  {{ 'card-detail-form-error-title-max-length' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n\n\n            <span flex=\"30\"></span>\n          </div>\n        </md-card>\n      </div>\n\n      <div layout=\"column\" class=\"sb-page-section\" ng-if=\"$ctrl.id\">\n\n          <h3 class=\"sb-page-section-title\">Cidades do Estado\n          <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.create( $ctrl.state)\" >\n            {{ 'common-new-feminine-city' | translate }}</h3>\n          </md-button>\n\n        <md-card>\n\n          <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n              <thead md-head>\n              <tr md-row>\n                <th md-column>\n                  Sigla\n                </th>\n                <th md-column>\n                  Descrição\n                </th>\n\n              </tr>\n              </thead>\n              <tbody md-body>\n              <tr md-row ng-repeat=\"resource in $ctrl.resources\"\n                  ng-click=\"$ctrl.edit(resource)\">\n                <td md-cell class=\"sb-table-truncate\">\n                  {{ resource.sigla }}\n                </td>\n\n                <td md-cell>\n                  {{ resource.descricao }}\n                </td>\n              </tr>\n              </tbody>\n            </table>\n          </md-table-container>\n        </md-card>\n      </div>\n      <!-- form actions -->\n      <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n        <md-button page-back\n                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n          {{ 'common-cancel-button-text' | translate }}\n        </md-button>\n\n        <md-button ng-click=\"$ctrl.clearForm(cardForm)\"\n                   ng-if=\"!$ctrl.id\"\n                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                   class=\"md-raised\">\n          {{ 'common-clear-button-text' | translate }}\n        </md-button>\n\n        <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                   class=\"md-accent md-raised\">\n          {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n        </md-button>\n      </div>\n    </form>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n       class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <div class=\"sb-error-message\">\n        {{ 'common-load-error' | translate}}\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var InsuranceStateDetailController = function InsuranceStateDetailController($filter, $mdDialog, $scope, $state, Toast, Insurance) {
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.isEdit = false;
	  $ctrl.state;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete,
	    edit: edit,
	    create: create });
	
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	    $ctrl.state_id = null;
	    loadResource($ctrl.id);
	  }
	
	  function clearForm(form) {
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function create(resource) {
	    console.log("create", resource);
	    var uf = resource.uf;
	    $state.go('insurance.ccreate', { uf: uf });
	  }
	  function edit(resource) {
	    console.log("resource", resource);
	    var uf = $ctrl.state.uf,id = resource.id;
	    localStorage.setItem('cityInsurance', JSON.stringify(resource));
	    $state.go('insurance.cedit', { uf: uf, id: id });
	  }
	  function handleDelete(card, event) {
	    var confirmMessage = 'card-detail-delete-confirm-text';
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')(confirmMessage)).
	    ariaLabel($filter('translate')(confirmMessage)).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Insurance.
	      destroy(card).
	      then(function (response) {
	        Toast.success($filter('translate')('card-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('card.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, state) {
	    if (!form.$valid) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	    state.save = $ctrl.id != null && $ctrl.id !== '';
	    save(state);
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	      var resource = JSON.parse(localStorage.getItem('stateInsurance'));
	      $ctrl.isEdit = true;
	      $ctrl.state = {
	        id: resource.id,
	        uf: resource.sigla,
	        description: resource.descricao };
	
	      Insurance.listCities(resource.sigla).
	      then(function (cities) {
	        $ctrl.resources = cities;
	        $ctrl.loadingCities = false;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.loadingCities = false;
	      });
	
	    } else {
	      $ctrl.uiState = 'COMPLETE';
	    }
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Module.index());
	
	    return Promise.all(promises);
	  }
	
	  function save(card) {
	    $ctrl.saving = true;
	
	    Insurance.
	    saveState(card).
	    then(function (response) {
	      Toast.success($filter('translate')('insurance-state-detail-save-success'));
	      $ctrl.card = response;
	      $ctrl.saving = false;
	      $state.go('insurance.state');
	    }).
	    catch(function (err) {
	      if (typeof err.data == "string") {
	        Toast.error($filter('translate')(err.data));
	      } else {
	        var defaultErrMsg = 'common-server-error';
	        var fourONineMsg = 'card-detail-409-error';
	        var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	        Toast.error($filter('translate')(message));
	      }
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	};
	
	InsuranceStateDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Insurance'];exports.default =
	
	InsuranceStateDetailController;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _insuranceCityDetail = __webpack_require__(748);var _insuranceCityDetail2 = _interopRequireDefault(_insuranceCityDetail);
	var _insuranceCityDetail3 = __webpack_require__(749);var _insuranceCityDetail4 = _interopRequireDefault(_insuranceCityDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var insuranceCityDetailComponent = {
	  bindings: {},
	  template: _insuranceCityDetail2.default,
	  controller: _insuranceCityDetail4.default };exports.default =
	
	
	insuranceCityDetailComponent;

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div class=\"sb-content sb-card\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n    <form name=\"cardForm\" ng-submit=\"$ctrl.handleSave(cardForm, $ctrl.city)\"\n          novalidate>\n      <!-- card -->\n      <div layout=\"column\" class=\"sb-page-section\">\n        <h3 class=\"sb-page-section-title\">{{ 'insurance-city-detail-title' | translate }}</h3>\n\n        <md-card>\n          <!-- name -->\n          <div layout=\"row\" flex >\n\n          </div>\n          <!-- expire -->\n          <div layout=\"row\" flex >\n            <md-input-container class=\"md-block\">\n              <label>\n                UF\n              </label>\n\n              <input ng-model=\"$ctrl.uf\" name=\"uf\" ng-disabled=\"true\"\n                     type=\"text\" maxlength=\"2\">\n\n              <div ng-messages=\"cardForm.doses.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\">\n              <label>\n                Sigla\n              </label>\n\n              <input ng-model=\"$ctrl.city.sigla\" name=\"sigla\" ng-disabled=\"$ctrl.city.id\"\n                     type=\"text\" maxlength=\"4\">\n\n              <div ng-messages=\"cardForm.doses.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex>\n              <label>\n                Nome da cidade\n              </label>\n\n              <input ng-model=\"$ctrl.city.description\" name=\"description\"\n                     required>\n              </input>\n\n              <div ng-messages=\"cardForm.descricao.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n\n                <div ng-message=\"md-maxlength\">\n                  {{ 'card-detail-form-error-title-max-length' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n\n\n            <span flex=\"30\"></span>\n          </div>\n        </md-card>\n      </div>\n\n      <!-- form actions -->\n      <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n        <md-button page-back\n                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n          {{ 'common-cancel-button-text' | translate }}\n        </md-button>\n\n        <md-button ng-click=\"$ctrl.clearForm(cardForm)\"\n                   ng-if=\"!$ctrl.id\"\n                   ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                   class=\"md-raised\">\n          {{ 'common-clear-button-text' | translate }}\n        </md-button>\n\n        <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                   class=\"md-accent md-raised\">\n          {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n        </md-button>\n      </div>\n    </form>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n       class=\"sb-fill-parent\">\n    <div class=\"sb-absolute-center sb-empty-state\"\n         layout=\"column\" layout-align=\"center center\">\n      <div class=\"sb-error-message\">\n        {{ 'common-load-error' | translate}}\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var InsuranceCityDetailController = function InsuranceCityDetailController($filter, $mdDialog, $scope, $state, Toast, Insurance) {
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.uf = $state.params.uf;
	  $ctrl.isEdit = false;
	  $ctrl.city;
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete });
	
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	    $ctrl.state_id = null;
	    loadResource($ctrl.id);
	  }
	
	  function clearForm(form) {
	
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(card, event) {
	    var confirmMessage = 'card-detail-delete-confirm-text';
	
	    var confirm = $mdDialog.confirm().
	    textContent($filter('translate')(confirmMessage)).
	    ariaLabel($filter('translate')(confirmMessage)).
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Insurance.
	      destroy(card).
	      then(function (response) {
	        Toast.success($filter('translate')('card-detail-delete-success'));
	        $ctrl.deleting = false;
	        $state.go('card.list');
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	        console.log('err:', err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {
	    });
	  }
	
	  function handleSave(form, state) {
	    if (!form.$valid) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	    state.save = $ctrl.city.id != null && $ctrl.city.id !== '';
	    save(state);
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = 'LOADING';
	      var resource = JSON.parse(localStorage.getItem('cityInsurance'));
	      console.log("resource,", resource);
	      $ctrl.isEdit = true;
	      $ctrl.city = {
	        id: resource.id,
	        sigla: resource.sigla,
	        uf: $ctrl.uf,
	        description: resource.descricao };
	
	      Insurance.listCities(resource.sigla).
	      then(function (cities) {
	        $ctrl.resources = cities;
	        $ctrl.loadingCities = false;
	        $ctrl.uiState = 'COMPLETE';
	      }).
	      catch(function (err) {
	        console.log('err:', err);
	        $ctrl.loadingCities = false;
	      });
	
	    } else {
	      $ctrl.city = {
	        uf: $ctrl.uf };
	
	      $ctrl.uiState = 'COMPLETE';
	    }
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Module.index());
	
	    return Promise.all(promises);
	  }
	
	  function save(card) {
	    $ctrl.saving = true;
	
	    Insurance.
	    saveCity(card).
	    then(function (response) {
	      Toast.success($filter('translate')('insurance-city-detail-save-success'));
	      $ctrl.card = response;
	      $ctrl.saving = false;
	      $state.go('insurance.state');
	    }).
	    catch(function (err) {
	      if (typeof err.data == "string") {
	        Toast.error($filter('translate')(err.data));
	      } else {
	        var defaultErrMsg = 'common-server-error';
	        var fourONineMsg = 'card-detail-409-error';
	        var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	        Toast.error($filter('translate')(message));
	      }
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	};
	
	InsuranceCityDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Insurance'];exports.default =
	
	InsuranceCityDetailController;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _notification = __webpack_require__(751);var _notification2 = _interopRequireDefault(_notification);
	var _notificationList = __webpack_require__(756);var _notificationList2 = _interopRequireDefault(_notificationList);
	var _notificationDetail = __webpack_require__(759);var _notificationDetail2 = _interopRequireDefault(_notificationDetail);
	var _notification3 = __webpack_require__(762);var _notification4 = _interopRequireDefault(_notification3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var notificationModule = _angular2.default.module('notification', [
	_angularUiRouter2.default]).
	
	
	service('Notification', _notification4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/notification');
	
	  $stateProvider.
	  state('notification', {
	    component: 'notification' }).
	
	  state('notification.list', {
	    url: '/notification',
	    component: 'notificationList' }).
	
	  state('notification.create', {
	    url: '/notification/new',
	    component: 'notificationDetail',
	    params: {
	      id: "" } }).
	
	
	  state('notification.detail', {
	    url: '/notification/:id/detail',
	    component: 'notificationDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('notification', _notification2.default).
	component('notificationList', _notificationList2.default).
	component('notificationDetail', _notificationDetail2.default).
	
	name;exports.default =
	
	notificationModule;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _notification = __webpack_require__(752);var _notification2 = _interopRequireDefault(_notification);
	var _notification3 = __webpack_require__(753);var _notification4 = _interopRequireDefault(_notification3);
	__webpack_require__(754);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var notificationComponent = {
	  bindings: {},
	  template: _notification2.default,
	  controller: _notification4.default };exports.default =
	
	
	notificationComponent;

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var NotificationController =
	function NotificationController() {_classCallCheck(this, NotificationController);
	  this.name = 'notification';
	};exports.default =
	
	
	NotificationController;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(755);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./notification.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./notification.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".notification{color:red}[disabled] md-input-container.md-default-theme .md-input,[disabled] md-input-container .md-input,md-input-container.md-default-theme .md-input[disabled],md-input-container .md-input[disabled],md-select.md-default-theme[disabled] .md-select-icon,md-select.md-default-theme[disabled] .md-select-value,md-select.md-default-theme[disabled] .md-select-value.md-select-placeholder,md-select[disabled] .md-select-icon,md-select[disabled] .md-select-value,md-select[disabled] .md-select-value.md-select-placeholder{color:#000000d1}.title-filter{padding:16px 0}notification table tbody tr td:nth-of-type(5){padding:0 56px 0 0!important;text-align:right!important}", ""]);
	
	// exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _notificationList = __webpack_require__(757);var _notificationList2 = _interopRequireDefault(_notificationList);
	var _notificationList3 = __webpack_require__(758);var _notificationList4 = _interopRequireDefault(_notificationList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var notificationListComponent = {
	  bindings: {},
	  template: _notificationList2.default,
	  controller: _notificationList4.default };exports.default =
	
	
	notificationListComponent;

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div\n    layout=\"row\"\n    layout-align=\"space between\"\n    ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\"\n  >\n    <md-button class=\"md-raised md-accent\" ui-sref=\"notification.create\">\n      {{ 'common-new-masculine' | translate }}\n    </md-button>\n\n    <md-card>\n      <div class=\"sb-table-search\">\n        <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n        </md-icon>\n\n        <input\n          ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n          ng-model-options=\"{ debounce: 1000 }\"\n          type=\"text\"\n          name=\"\"\n        />\n      </div>\n    </md-card>\n  </div>\n\n  <md-card\n    ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\"\n  >\n    <md-table-container>\n      <table md-table md-progress=\"$ctrl.promise\">\n        <thead md-head>\n          <tr md-row>\n            <th\n              md-column\n              md-order-by=\"title\"\n              ng-click=\"$ctrl.orderList('title')\"\n            >\n              {{ 'common-title' | translate }}\n            </th>\n\n            <th\n              md-column\n              md-order-by=\"title\"\n              ng-click=\"$ctrl.orderList('title')\"\n            >\n              {{ 'common-title-status' | translate }}\n            </th>\n\n            <th\n              md-column\n              md-order-by=\"created_at\"\n              md-order-by=\"created_at\"\n              ng-click=\"$ctrl.orderList('created_at')\"\n            >\n              {{ 'common-title-scheduled' | translate }}\n            </th>\n\n            <th\n              md-column\n              md-numeric\n              md-order-by=\"send_at\"\n              ng-click=\"$ctrl.orderList('send_at')\"\n            >\n              {{ 'common-sent-at' | translate }}\n            </th>\n\n            <th\n              md-column\n              md-numeric\n              md-order-by=\"updated_At\"\n              ng-click=\"$ctrl.orderList('updated_At')\"\n            >\n              {{ 'common-updated-at' | translate }}\n            </th>\n\n            <th md-column md-numeric class=\"sb-table-column-xs\"></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"resource in $ctrl.resources.data\">\n            <td\n              md-cell\n              class=\"sb-table-truncate\"\n              ng-click=\"$ctrl.detail(resource.id)\"\n            >\n              {{ resource.title }}\n            </td>\n\n            <td md-cell ng-click=\"$ctrl.detail(resource.id)\">\n              {{ $ctrl.formatStatus(resource.status) }}\n            </td>\n\n            <td md-cell ng-click=\"$ctrl.detail(resource.id)\">\n              <span ng-if=\"$ctrl.checkTime(resource.send_at)\">\n                {{ resource.send_at | momentFormat : 'DD/MM/YYYY' }}\n              </span>\n              <span ng-if=\"!$ctrl.checkTime(resource.send_at)\"> - </span>\n            </td>\n\n            <td md-cell ng-click=\"$ctrl.detail(resource.id)\">\n              {{ resource.send_at | momentFormat : 'DD/MM/YYYY' }}\n            </td>\n\n            <td md-cell ng-click=\"$ctrl.detail(resource.id)\">\n              {{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n            </td>\n\n            <td md-cell>\n              <md-button\n                ng-if=\"$ctrl.checkTime(resource.send_at)\"\n                aria-label=\"Toolbar menu\"\n                class=\"md-icon-button\"\n                ng-click=\"$ctrl.handleDelete(resource, $event)\"\n              >\n                <md-icon\n                  md-font-set=\"mdi\"\n                  md-font-icon=\"mdi-delete\"\n                  class=\"mdi-24px\"\n                >\n                </md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n\n    <md-table-pagination\n      md-limit=\"$ctrl.$scope.tableConfig.limit\"\n      md-page=\"$ctrl.$scope.tableConfig.page\"\n      md-total=\"{{ $ctrl.resources.count }}\"\n      md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n      md-page-select\n    >\n    </md-table-pagination>\n  </md-card>\n\n  <div\n    ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n    class=\"sb-fill-parent\"\n  >\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <img src=\"assets/empty_news.png\" />\n\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'notification-list-empty-state-line-1' | translate }}</p>\n        <p>{{ 'notification-list-empty-state-line-2' | translate }}</p>\n      </div>\n\n      <md-button class=\"md-raised md-accent\" ui-sref=\"notification.create\">\n        {{ 'notification-list-create-notification-button' | translate }}\n      </md-button>\n    </div>\n  </div>\n\n  <div\n    ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n    class=\"sb-fill-parent\"\n  >\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n      </div>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\" class=\"sb-fill-parent\">\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-error-message\">{{ 'common-load-error' | translate}}</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var NotificationListController = function NotificationListController(Notification, $filter, $scope, $state, $mdDialog, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    detail: detail,
	    orderList: orderList,
	    formatStatus: formatStatus,
	    checkTime: checkTime,
	    handleDelete: handleDelete });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'created_at DESC',
	      like_search: '',
	      like_search_fields: [
	      'title'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function detail(id) {
	    $state.go('notification.detail', { id: id });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  function formatStatus(status) {
	    if (status === 'SENDING') return 'Enviando';
	    if (status === 'SENT') return 'Enviado';
	    if (status === 'FAILED') return 'Falha no envio';
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Notification.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.description === null || item.description === undefined) {
	        item.description = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	
	  function handleDelete(notification, event) {
	    var confirmMessage = "notification-detail-delete-confirm-text";
	
	    var confirm = $mdDialog.
	    confirm().
	    textContent($filter("translate")(confirmMessage)).
	    ariaLabel($filter("translate")(confirmMessage)).
	    targetEvent(event).
	    ok($filter("translate")("common-yes")).
	    cancel($filter("translate")("common-cancel"));
	
	    $mdDialog.
	    show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Notification.destroy(notification).
	      then(function (response) {
	        Toast.success(
	        $filter("translate")("notification-detail-delete-success"));
	
	        $ctrl.deleting = false;
	        loadData();
	      }).
	      catch(function (err) {
	        Toast.error($filter("translate")("common-server-error"));
	        console.log("err:", err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {});
	  }
	
	  function checkTime(sendAt) {
	    var datetime = moment(sendAt);
	    return datetime.isAfter(moment());
	  }
	};
	
	NotificationListController.$inject = ['Notification', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];exports.default =
	
	NotificationListController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _notificationDetail = __webpack_require__(760);var _notificationDetail2 = _interopRequireDefault(_notificationDetail);
	var _notificationDetail3 = __webpack_require__(761);var _notificationDetail4 = _interopRequireDefault(_notificationDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var notificationDetailComponent = {
	  bindings: {},
	  template: _notificationDetail2.default,
	  controller: _notificationDetail4.default };exports.default =
	
	
	notificationDetailComponent;

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div\n    class=\"sb-content sb-notification\"\n    ng-show=\"$ctrl.uiState === 'COMPLETE'\"\n  >\n    <form\n      name=\"notificationForm\"\n      ng-submit=\"$ctrl.handleSave(notificationForm, $ctrl.notification)\"\n      novalidate\n    >\n      <!-- notification -->\n      <div layout=\"column\" class=\"sb-page-section\">\n        <h3 class=\"sb-page-section-title\">\n          {{ 'notification-detail-title' | translate }}\n        </h3>\n\n        <p class=\"sb-page-section-sub-title\">\n          {{ 'notification-detail-title-caption' | translate }}\n        </p>\n\n        <md-card>\n          <!-- title -->\n          <div layout=\"row\" flex>\n            <md-input-container class=\"md-block\" flex>\n              <label> {{ 'common-title' | translate }} </label>\n\n              <input\n                ng-model=\"$ctrl.notification.title\"\n                name=\"title\"\n                md-maxlength=\"20\"\n                ng-disabled=\"$ctrl.isSent\"\n                required\n              />\n\n              <div ng-messages=\"notificationForm.title.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n\n                <div ng-message=\"md-maxlength\">\n                  {{ 'notification-detail-form-error-title-max-length' |\n                  translate}}\n                </div>\n              </div>\n            </md-input-container>\n          </div>\n\n          <!-- message -->\n          <div layout=\"row\" flex>\n            <md-input-container class=\"md-block\" flex>\n              <label> {{ 'common-message' | translate }} </label>\n\n              <textarea\n                ng-model=\"$ctrl.notification.message\"\n                name=\"message\"\n                rows=\"2\"\n                md-maxlength=\"140\"\n                ng-disabled=\"$ctrl.isSent\"\n                required\n              >\n              </textarea>\n\n              <div ng-messages=\"notificationForm.message.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n\n                <div ng-message=\"md-maxlength\">\n                  {{ 'notification-detail-form-error-message-max-length' |\n                  translate}}\n                </div>\n              </div>\n            </md-input-container>\n          </div>\n\n          <!-- message -->\n          <div layout=\"row\" flex>\n            <md-input-container class=\"md-block\" flex>\n              <label>{{ 'notification-detail-type' | translate }}</label>\n\n              <md-select\n                name=\"receiver\"\n                ng-model=\"$ctrl.notification.receiver\"\n                ng-disabled=\"$ctrl.isSent\"\n                required\n              >\n                <md-option ng-value=\"'ALL'\">\n                  {{ 'common-general' | translate }}\n                </md-option>\n\n                <md-option ng-value=\"'CLIENT'\">\n                  {{ 'common-clients' | translate }}\n                </md-option>\n\n                <md-option ng-value=\"'MEDIC'\">\n                  {{ 'common-medics' | translate }}\n                </md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n\n          <!-- Filter by state, city or gender -->\n\n          <div class=\"title-filter\" layout=\"row\" flex>\n            <label style=\"font-weight: 500;\">{{ 'notification-detail-filer-public' | translate }}</label>\n          </div>\n          <div layout=\"row\">\n            <md-input-container class=\"md-block\" flex>\n              <label> {{ 'common-type-region' | translate }} </label>\n\n              <md-select\n                ng-model=\"$ctrl.notification.only_vaccine_regions\"\n                ng-change=\"$ctrl.onChangeRegionType()\"\n                name=\"typeRegion\"\n                md-on-close=\"$ctrl.clearSearch()\"\n                md-container-class=\"selectdemoSelectHeader\"\n                ng-disabled=\"$ctrl.isSent\"\n              >\n                <md-option\n                  ng-repeat=\"type in $ctrl.regionTypes\"\n                  ng-value=\"type.value\"\n                >\n                  {{ type.text }}\n                </md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n\n          <div layout=\"row\">\n            <md-input-container class=\"md-block\" flex>\n              <label>\n                {{ $ctrl.notification.only_vaccine_regions === null ?\n                ('common-state' | translate) : 'Não se aplica' }}\n              </label>\n\n              <md-select\n                ng-model=\"$ctrl.filter.state_id\"\n                ng-change=\"$ctrl.onChangeState($ctrl.filter.state_id)\"\n                name=\"state\"\n                multiple\n                md-on-close=\"$ctrl.clearSearch()\"\n                md-container-class=\"selectdemoSelectHeader\"\n                ng-disabled=\"$ctrl.isSent || $ctrl.disabledFilterStateCities\"\n              >\n                <md-select-header layout=\"column\" class=\"demo-select-header\">\n                  <md-input-container class=\"md-block\" flex>\n                    <input\n                      ng-model=\"$ctrl.searchState\"\n                      type=\"text\"\n                      ng-model-options=\"{debounce: {'default': 250, 'blur': 0}}\"\n                      ng-change=\"$ctrl.filterContent($ctrl.searchState, 'states')\"\n                      class=\"md-text input-search-state\"\n                      placeholder=\"Buscar estados\"\n                    />\n                  </md-input-container>\n                </md-select-header>\n\n                <md-optgroup label=\"state\">\n                  <md-option\n                    ng-value=\"null\"\n                    ng-click=\"$ctrl.setListContent(null, $ctrl.selectedStates)\"\n                  >\n                    {{ 'common-all-masculine' | translate }}\n                  </md-option>\n\n                  <md-option\n                    ng-selected=\"$ctrl.filter.state_id.includes(state.id.toString())\n                                  && !$ctrl.filter.state_id.includes(null)\"\n                    ng-click=\"$ctrl.setListContent(state.name, $ctrl.selectedStates)\"\n                    ng-disabled=\"$ctrl.filter.state_id.includes(null)\"\n                    ng-repeat=\"state in $ctrl.states\"\n                    ng-value=\"state.id.toString()\"\n                  >\n                    {{ state.name }}\n                  </md-option>\n                </md-optgroup>\n              </md-select>\n\n              <div ng-messages=\"notificationForm.state.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex>\n              <label>\n                {{ $ctrl.notification.only_vaccine_regions === null ?\n                ('common-city' | translate) : 'Não se aplica' }}\n              </label>\n\n              <md-select\n                ng-model=\"$ctrl.filter.city_id\"\n                name=\"city\"\n                multiple\n                md-on-close=\"$ctrl.clearSearch()\"\n                md-container-class=\"selectdemoSelectHeader\"\n                ng-disabled=\"$ctrl.isSent || $ctrl.disabledFilterStateCities\"\n              >\n                <md-select-header layout=\"column\" class=\"demo-select-header\">\n                  <md-input-container class=\"md-block\" flex>\n                    <input\n                      ng-model=\"$ctrl.search\"\n                      type=\"text\"\n                      ng-model-options=\"{debounce: {'default': 250, 'blur': 0}}\"\n                      class=\"demo-header-searchbox md-text input-search-city\"\n                      ng-change=\"$ctrl.filterContent($ctrl.search, 'cities')\"\n                      placeholder=\"Buscar cidades\"\n                    />\n                  </md-input-container>\n                </md-select-header>\n\n                <md-optgroup label=\"city\">\n                  <md-option\n                    ng-value=\"null\"\n                    ng-click=\"$ctrl.setListContent(null, $ctrl.selectedCities)\"\n                  >\n                    {{ 'common-all-masculine' | translate }}\n                  </md-option>\n\n                  <md-option\n                    ng-selected=\"$ctrl.filter.city_id.includes(city.id.toString()) \n                                  && !$ctrl.filter.city_id.includes(null)\"\n                    ng-disabled=\"$ctrl.filter.city_id.includes(null)\"\n                    ng-click=\"$ctrl.setListContent(city.name, $ctrl.selectedCities)\"\n                    ng-repeat=\"city in $ctrl.cities\"\n                    ng-value=\"city.id.toString()\"\n                    >{{ city.name }}\n                  </md-option>\n                </md-optgroup>\n              </md-select>\n\n              <div ng-messages=\"notificationForm.city.$error\" multiple>\n                <div ng-message=\"required\">\n                  {{ 'form-error-required-field' | translate}}\n                </div>\n              </div>\n            </md-input-container>\n\n            <md-input-container class=\"md-block\" flex>\n              <label>{{ 'common-gender' | translate}}</label>\n              <md-select\n                name=\"gender\"\n                ng-model=\"$ctrl.filter.gender\"\n                ng-disabled=\"$ctrl.isSent\"\n              >\n                <md-option ng-value=\"null\">\n                  {{ 'common-all-masculine' | translate}}\n                </md-option>\n\n                <md-option ng-value=\"'MALE'\">\n                  {{ 'common-male' | translate}}\n                </md-option>\n\n                <md-option ng-value=\"'FEMALE'\">\n                  {{ 'common-female' | translate}}\n                </md-option>\n              </md-select>\n            </md-input-container>\n          </div>\n\n          <!-- URL -->\n          <div layout=\"row\" flex>\n            <md-input-container class=\"md-block\" flex>\n              <label>{{ 'common-url' | translate }}</label>\n\n              <input\n                ng-model=\"$ctrl.notification.url\"\n                name=\"url\"\n                md-maxlength=\"255\"\n                ng-disabled=\"$ctrl.isSent\"\n              />\n\n              <div ng-messages=\"notificationForm.url.$error\" multiple>\n                <div ng-message=\"md-maxlength\">\n                  {{ 'notification-detail-form-error-url-max-length' |\n                  translate}}\n                </div>\n              </div>\n            </md-input-container>\n          </div>\n\n          <div\n            ng-if=\"$ctrl.selectedStates.length > 1 || $ctrl.selectedCities.length > 1\"\n          >\n            <p>\n              Total de Estados:\n              <strong>{{$ctrl.selectedStates.length}}</strong> <br />\n              <strong>{{$ctrl.selectedStates.join(\", \")}}</strong>\n            </p>\n            <p>\n              Total de Cidades:\n              <strong>{{$ctrl.selectedCities.length}}</strong> <br />\n              <strong>{{$ctrl.selectedCities.join(\", \")}}</strong>\n            </p>\n          </div>\n        </md-card>\n      </div>\n      <!-- isScheduled send_at -->\n      <div layout=\"column\" flex class=\"sb-conditional-section\">\n        <md-checkbox\n          ng-model=\"$ctrl.isScheduled\"\n          ng-disabled=\"$ctrl.isSent\"\n          aria-label=\"Checkbox 1\"\n        >\n          {{ 'notification-detail-schedule-checkbox' | translate }}\n        </md-checkbox>\n\n        <div layout=\"row\" flex ng-if=\"$ctrl.isScheduled\">\n          <md-input-container class=\"md-block\" flex>\n            <label> {{ 'common-date' | translate }} </label>\n            <input\n              time=\"false\"\n              date=\"true\"\n              mdc-datetime-picker=\"\"\n              type=\"text\"\n              id=\"date\"\n              day-of-week-len=\"3\"\n              placeholder=\"DD/MM/YYYY\"\n              ng-disabled=\"!$ctrl.isScheduled || $ctrl.isSent\"\n              click-outside-to-close=\"true\"\n              today-btn=\"false\"\n              format=\"DD/MM/yyyy\"\n              ng-model=\"$ctrl.notification.send_at\"\n              min-date=\"$ctrl.minDate\"\n              max-date=\"$ctrl.maxDate\"\n              class=\"md-input\"\n            />\n\n            <div ng-messages=\"notificationForm.send_at.$error\" multiple>\n              <div ng-message=\"required\">\n                {{ 'form-error-required-field' | translate}}\n              </div>\n\n              <div ng-message=\"todayOrLater\">\n                {{ 'common-form-error-sb-today-or-later' | translate}}\n              </div>\n            </div>\n          </md-input-container>\n\n          <md-input-container class=\"md-block\" flex>\n            <label> {{ 'common-time' | translate }} </label>\n\n            <input\n              ng-model=\"$ctrl.sendAtTime\"\n              name=\"sendAtTime\"\n              ui-time-mask=\"short\"\n              placeholder=\"hh:mm\"\n              sb-time-field-now-or-later\n              sb-date=\"{{ $ctrl.notification.send_at }}\"\n              ng-disabled=\"!$ctrl.isScheduled || $ctrl.isSent\"\n              ng-required=\"$ctrl.isScheduled\"\n            />\n\n            <div ng-messages=\"notificationForm.sendAtTime.$error\" multiple>\n              <div ng-message=\"required\">\n                {{ 'form-error-required-field' | translate}}\n              </div>\n\n              <div ng-message=\"todayOrLater\">\n                {{ 'common-form-error-sb-today-or-later' | translate}}\n              </div>\n\n              <div ng-message=\"beforeDate\">\n                {{ 'common-form-error-sb-before-date' | translate}}\n              </div>\n            </div>\n          </md-input-container>\n        </div>\n      </div>\n\n      <!-- hasNewsItem type_id -->\n      <div layout=\"column\" flex class=\"sb-conditional-section\">\n        <md-checkbox\n          ng-model=\"$ctrl.hasNewsItem\"\n          ng-disabled=\"$ctrl.isSent\"\n          aria-label=\"Checkbox 1\"\n        >\n          {{ 'notification-detail-has-news-item-checkbox' | translate }}\n        </md-checkbox>\n\n        <md-autocomplete\n          md-no-cache=\"true\"\n          md-selected-item=\"$ctrl.selectedNewsItem\"\n          md-selected-item-change=\"$ctrl.selectedNewsItemChange($ctrl.selectedNewsItem)\"\n          md-items=\"newsItem in $ctrl.querySearch($ctrl.searchText)\"\n          md-search-text=\"$ctrl.searchText\"\n          md-item-text=\"newsItem.title\"\n          md-menu-class=\"sb-autocomplete-custom-template\"\n          placeholder=\"{{ 'campaign-detail-form-news-item-placeholder' | translate }}\"\n          ng-required=\"$ctrl.hasNewsItem\"\n          ng-disabled=\"!$ctrl.hasNewsItem || $ctrl.isSent\"\n        >\n          <md-item-template>\n            <span class=\"item-title\">\n              <span>{{ newsItem.title }}</span>\n            </span>\n\n            <span class=\"item-metadata\">\n              <span>\n                {{ 'news-list-table-target-' + newsItem.user_profile_type |\n                translate }}\n              </span>\n\n              <span> - </span>\n\n              <span> {{'common-published-at-feminine' | translate }} </span>\n\n              <span>\n                {{ newsItem.published_at | momentFormat : 'DD/MM/YYYY' }}\n              </span>\n            </span>\n          </md-item-template>\n\n          <md-not-found>\n            {{ 'list-empty-search-state-line-1' | translate }}\n          </md-not-found>\n        </md-autocomplete>\n\n        <div\n          class=\"sb-error-message\"\n          ng-show=\"notificationForm.$submitted && ($ctrl.hasNewsItem && !$ctrl.selectedNewsItem)\"\n        >\n          {{ 'form-error-required-field' | translate}}\n        </div>\n      </div>\n\n      <!-- form actions -->\n      <div\n        layout=\"row\"\n        layout-align=\"end center\"\n        flex\n        class=\"sb-form-actions after-card\"\n        ng-if=\"$ctrl.isSent\"\n      >\n        <md-button page-back ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n          {{ 'common-go-back-button-text' | translate }}\n        </md-button>\n      </div>\n\n      <div\n        layout=\"row\"\n        layout-align=\"end center\"\n        flex\n        class=\"sb-form-actions after-card\"\n        ng-if=\"!$ctrl.isSent\"\n      >\n        <md-button page-back ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n          {{ 'common-cancel-button-text' | translate }}\n        </md-button>\n\n        <md-button\n          ng-click=\"$ctrl.handleDelete($ctrl.notification, $event)\"\n          ng-if=\"$ctrl.id && !$ctrl.notification.is_super\"\n          ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n          class=\"md-warn md-raised\"\n        >\n          {{ 'common-delete-button-text' | translate }}\n        </md-button>\n\n        <md-button\n          ng-click=\"$ctrl.clearForm(notificationForm)\"\n          ng-if=\"!$ctrl.id\"\n          ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n          class=\"md-raised\"\n        >\n          {{ 'common-clear-button-text' | translate }}\n        </md-button>\n\n        <md-button\n          type=\"submit\"\n          ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n          class=\"md-accent md-raised\"\n        >\n          {{ $ctrl.saving ? 'common-save-button-loading-text' :\n          'common-save-button-text' | translate }}\n        </md-button>\n      </div>\n    </form>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\" class=\"sb-fill-parent\">\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-error-message\">{{ 'common-load-error' | translate}}</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var NotificationDetailController = function NotificationDetailController(
	$filter,
	$mdDialog,
	$scope,
	$state,
	$timeout,
	City,
	News,
	Notification,
	State,
	Toast)
	{
	  var $ctrl = this;
	
	  $ctrl.id = $state.params.id;
	  $ctrl.notification = {
	    only_vaccine_regions: null };
	
	  $ctrl.disabledFilterStateCities = false;
	  $ctrl.regionTypes = [
	  { text: "Todas", value: null },
	  { text: "Com vacinas", value: true },
	  { text: "Não possuem vacinas", value: false }];
	
	  $ctrl.filter = {};
	  $ctrl.search = "";
	  $ctrl.searchState = "";
	  $ctrl.selectedCities = [];
	  $ctrl.selectedStates = [];
	  $ctrl.disabledInputs = false;
	  $ctrl.minDate = new Date();
	  $ctrl.maxDate = new Date(
	  $ctrl.minDate.getFullYear() + 5 + "-" + (
	  $ctrl.minDate.getUTCMonth() + 1) + "-" +
	  $ctrl.minDate.getUTCDate());
	
	  $ctrl.original = {
	    states: [],
	    cities: [] };
	
	
	  _angular2.default.extend($ctrl, {
	    clearForm: clearForm,
	    handleSave: handleSave,
	    handleDelete: handleDelete,
	    onChangeDate: onChangeDate,
	    onChangeState: onChangeState,
	    querySearch: querySearch,
	    selectedNewsItemChange: selectedNewsItemChange,
	    setListContent: setListContent,
	    filterContent: filterContent,
	    onChangeRegionType: onChangeRegionType });
	
	
	  $timeout(function () {
	    _angular2.default.
	    element(document.querySelector(".input-search-state")).
	    on("keydown", function (ev) {
	      ev.stopPropagation();
	    });
	  }, 500);
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    loadDomainResources().
	    then(function (result) {
	      $ctrl.newsItems = result[0];
	      $ctrl.states = result[1];
	      $ctrl.original.states = result[1];
	
	      loadResource($ctrl.id);
	    }).
	    catch(function (err) {
	      console.log("err:", err);
	      $ctrl.uiState = "ERROR";
	    });
	  }
	
	  function clearForm(form) {
	    $ctrl.notification = {
	      receiver: "ALL",
	      only_vaccine_regions: null,
	      send_at: moment().add(1, "days") };
	
	    $ctrl.filter = {};
	    if (form) {
	      form.$setPristine();
	      form.$setUntouched();
	    }
	  }
	
	  function handleDelete(notification, event) {
	    var confirmMessage = "notification-detail-delete-confirm-text";
	
	    var confirm = $mdDialog.
	    confirm().
	    textContent($filter("translate")(confirmMessage)).
	    ariaLabel($filter("translate")(confirmMessage)).
	    targetEvent(event).
	    ok($filter("translate")("common-yes")).
	    cancel($filter("translate")("common-cancel"));
	
	    $mdDialog.
	    show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      Notification.destroy(notification).
	      then(function (response) {
	        Toast.success(
	        $filter("translate")("notification-detail-delete-success"));
	
	        $ctrl.deleting = false;
	        $state.go("notification.list");
	      }).
	      catch(function (err) {
	        Toast.error($filter("translate")("common-server-error"));
	        console.log("err:", err);
	        $ctrl.deleting = false;
	      });
	    }).
	    catch(function () {});
	  }
	
	  function handleSave(form, notification) {
	    if (!form.$valid) {
	      Toast.error($filter("translate")("common-form-incomplete"));
	      return;
	    }
	
	    if ($ctrl.hasNewsItem) {
	      notification.type = "NEWS_ITEM";
	    } else if ($ctrl.notification.url) {
	      notification.type = "REDIRECT_NOTIFICATION";
	      delete notification.type_id;
	    } else {
	      notification.type = "GENERAL";
	      delete notification.type_id;
	    }
	
	    if ($ctrl.filter.state_id || $ctrl.filter.gender) {
	      notification.filter = {
	        gender: $ctrl.filter.gender,
	        state_id:
	        $ctrl.filter.state_id[0] === null ? null : $ctrl.filter.state_id,
	        city_id:
	        $ctrl.filter.city_id && $ctrl.filter.city_id[0] === null ?
	        null :
	        $ctrl.filter.city_id };
	
	    }
	
	    var deleteFilter = Object.values(notification.filter).every(function (value) {
	      if (value === null) return true;
	      return false;
	    });
	    if (deleteFilter) delete notification.filter;
	
	    if ($ctrl.isScheduled) {
	      var sendAt = moment($ctrl.notification.send_at);
	      var datetimeText = sendAt.format("YYYY-MM-DD") + " " + $ctrl.sendAtTime;
	      notification.send_at = moment(datetimeText);
	      save(notification);
	    } else {
	      var confirmMessage = "notification-detail-send-now-confirm-text";
	
	      var confirm = $mdDialog.
	      confirm().
	      textContent($filter("translate")(confirmMessage)).
	      ariaLabel($filter("translate")(confirmMessage)).
	      targetEvent(event).
	      ok($filter("translate")("common-ok")).
	      cancel($filter("translate")("common-cancel"));
	
	      $mdDialog.
	      show(confirm).
	      then(function () {
	        notification.send_at = null;
	        save(notification);
	      }).
	      catch(function () {});
	    }
	  }
	
	  function onChangeDate(form) {
	    $timeout(function () {
	      form.sendAtTime.$validate();
	    }, 100);
	  }
	
	  function onChangeState(stateIdArr) {
	    if (stateIdArr.length !== 0) {
	      $ctrl.filter.city_id = null;
	      $ctrl.loadingCities = true;
	      City.index({
	        state_id: stateIdArr,
	        limit: 1000000 }).
	
	      then(function (cities) {
	        $ctrl.cities = cities;
	        $ctrl.original.cities = cities;
	        $ctrl.selectedCities = [];
	        $ctrl.loadingCities = false;
	      }).
	      catch(function (err) {
	        console.log("err:", err);
	        $ctrl.loadingCities = false;
	      }).
	      finally(function () {
	        _angular2.default.
	        element(document.querySelector(".input-search-city")).
	        on("keydown", function (ev) {
	          ev.stopPropagation();
	        });
	      });
	    }
	
	    if (stateIdArr && stateIdArr.length > 1) {
	      $ctrl.search = "";
	      $ctrl.filter.city_id = null;
	      $ctrl.cities = [];
	    }
	  }
	
	  function onChangeRegionType() {
	    $ctrl.filter.state_id = [];
	    $ctrl.selectedStates = [];
	    $ctrl.selectedCities = [];
	    $ctrl.filter.city_id = [];
	    $ctrl.disabledFilterStateCities =
	    $ctrl.notification.only_vaccine_regions !== null;
	  }
	
	  function querySearch(searchText) {
	    searchText = searchText.toLowerCase();
	    var newsTypeToExclude =
	    $ctrl.notification.type === "MEDIC" ? "SBRUBBLES" : "MEDIC";
	
	    var results = _.filter($ctrl.newsItems, function (newsItem) {
	      return (
	        newsItem.title.toLowerCase().indexOf(searchText) > -1 &&
	        newsItem.user_profile_type != newsTypeToExclude);
	
	    });
	
	    return results;
	  }
	
	  function selectedNewsItemChange(newsItem) {
	    $ctrl.notification.type_id = newsItem ? newsItem.id : null;
	  }
	
	  // Local functions
	  function loadResource(id) {
	    if (id) {
	      $ctrl.uiState = "LOADING";
	
	      Notification.show(id).
	      then(function (response) {
	        $ctrl.notification = response;
	        $ctrl.notification.send_at = new Date($ctrl.notification.send_at);
	        $ctrl.notification.only_vaccine_regions =
	        response.only_vaccine_regions === undefined ?
	        null :
	        response.only_vaccine_regions;
	        if (response.state_id) {
	          onChangeState(response.state_id);
	        }
	        $ctrl.filter = {
	          gender: response.gender,
	          state_id: response.state_id === null ? [null] : response.state_id,
	          city_id: response.city_id === null ? [null] : response.city_id };
	
	        if (response.send_at) {
	          $ctrl.isScheduled = true;
	          setTime(response.send_at);
	        } else {
	          $ctrl.isSent = true;
	        }
	
	        if (response.type === "NEWS_ITEM" && response.type_id) {
	          $ctrl.hasNewsItem = true;
	          $ctrl.selectedNewsItem = _.find($ctrl.newsItems, {
	            id: response.type_id });
	
	        }
	
	        $ctrl.uiState = "COMPLETE";
	      }).
	      catch(function (err) {
	        console.log("err:", err);
	        $ctrl.uiState = "ERROR";
	      });
	    } else {
	      $ctrl.uiState = "COMPLETE";
	      $scope.$apply();
	    }
	  }
	
	  function loadDomainResources() {
	    $ctrl.uiState = "LOADING";
	
	    var promises = [];
	
	    promises.push(News.index({ limit: 10000000000, order: "updated_at DESC" }));
	    promises.push(State.index({ limit: 10000000000 }));
	
	    return Promise.all(promises);
	  }
	
	  function save(notification) {
	    notification.is_public = true;
	
	    $ctrl.saving = true;
	
	    Notification.save(notification).
	    then(function (response) {
	      Toast.success($filter("translate")("notification-detail-save-success"));
	      $ctrl.notification = response;
	      $ctrl.saving = false;
	      $state.go("notification.list");
	    }).
	    catch(function (err) {
	      var defaultErrMsg = "common-server-error";
	      var fourONineMsg = "notification-detail-409-error";
	      var message = err.status == 409 ? fourONineMsg : defaultErrMsg;
	      Toast.error($filter("translate")(message));
	      console.log("err:", err);
	      $ctrl.saving = false;
	    });
	  }
	
	  function setTime(sendAt) {
	    var datetime = moment(sendAt);
	    $ctrl.isSent = datetime.isSameOrBefore(moment());
	    var timeText = datetime.format("HH:mm");
	    $ctrl.sendAtTime = timeText;
	  }
	
	  function setListContent(name, list) {
	    if (name) {
	      var idx = list.findIndex(function (city) {
	        return name === city;
	      });
	
	      if (idx >= 0) {
	        list.splice(idx, 1);
	      } else {
	        list.push(name);
	      }
	    } else {
	      list.length = 0;
	    }
	  }
	
	  function filterContent(query, type) {
	    var filtered = [];
	
	    if (query) {
	      filtered = $ctrl.original[type].filter(function (_ref) {var name = _ref.name;
	        name = name.toLowerCase();
	        return (
	          name.includes(query) ||
	          name.
	          normalize("NFD").
	          replace(/[\u0300-\u036f]/g, "").
	          includes(query));
	
	      });
	    }
	
	    $ctrl[type] = query ? filtered : $ctrl.original[type];
	  }
	};
	
	NotificationDetailController.$inject = [
	"$filter",
	"$mdDialog",
	"$scope",
	"$state",
	"$timeout",
	"City",
	"News",
	"Notification",
	"State",
	"Toast"];exports.default =
	
	
	NotificationDetailController;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {"use strict";Object.defineProperty(exports, "__esModule", { value: true });var NotificationService = function NotificationService(Restangular) {
	  var Service = Restangular.all("admin/notification");
	
	  var count = function count(query) {
	    query = query || {};
	    query.deleted_at = "null";
	    query.is_public = 1;
	    return Service.customGET("count", query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      var id = resource.id;
	      delete resource.id;
	      return Service.customPOST(resource, "" + id);
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = "null";
	    query.is_public = 1;
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query = query || {};
	    query.deleted_at = "null";
	    query.is_public = 1;
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return Service.customDELETE(resource.id);
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	NotificationService.$inject = ["Restangular"];exports.default =
	
	NotificationService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _me = __webpack_require__(764);var _me2 = _interopRequireDefault(_me);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var meModule = _angular2.default.module('me', [
	_angularUiRouter2.default]).
	
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $stateProvider.
	  state('me', {
	    url: '/me',
	    component: 'me' });
	
	}]).
	
	component('me', _me2.default).
	
	name;exports.default =
	
	meModule;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _meDetail = __webpack_require__(765);var _meDetail2 = _interopRequireDefault(_meDetail);
	var _me = __webpack_require__(766);var _me2 = _interopRequireDefault(_me);
	__webpack_require__(767);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var meComponent = {
	  bindings: {},
	  template: _meDetail2.default,
	  controller: _me2.default };exports.default =
	
	
	meComponent;

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-me\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <form name=\"meForm\" ng-submit=\"$ctrl.handleSave(meForm, $ctrl.me)\" \n              novalidate>\n            <div layout=\"column\" class=\"sb-page-section\">\n                <h3 class=\"sb-page-section-title\">\n                    {{ 'me-detail-title' | translate }}\n                </h3>\n\n                <p class=\"sb-page-section-sub-title\">\n                    {{ 'me-detail-title-caption' | translate }}\n                </p>\n\n                <div layout=\"row\">\n                    <div layout=\"column\" layout-align=\"start center\" flex=\"25\"\n                         style=\"position: relative;\">\n                        <div>\n                            <input ng-show=\"false\" type=\"file\" id=\"fileInput\"/>\n                            \n                            <label for=\"fileInput\">\n                                <div ng-show=\"!$ctrl.myCroppedImage && !$ctrl.me.image_uri\" \n                                     class=\"sb-avatar-input\">\n                                </div>\n\n                                <img class=\"sb-avatar-image\"\n                                     ng-show=\"$ctrl.me.image_uri || $ctrl.myCroppedImage\"\n                                     ng-src=\"{{ $ctrl.myCroppedImage || $ctrl.me.image_uri }}\"/>\n                            </label>\n                        </div>\n\n                        <div class=\"sb-hint sb-text-align-center\"\n                             ng-show=\"!$ctrl.myCroppedImage\">\n                            {{ 'admin-detail-form-image-hint' | translate }}\n                        </div>\n\n                        <md-button ng-click=\"$ctrl.clearImage()\"\n                                   ng-show=\"$ctrl.myCroppedImage || $ctrl.me.image_uri\"\n                                   class=\"md-icon-button md-warn\"\n                                   style=\"position: absolute; top: 0px; right: 0px\">\n                            <md-icon md-font-set=\"mdi\" \n                                     md-font-icon=\"mdi-close\"\n                                     class=\"mdi-24px\">\n                            </md-icon>\n                        </md-button>\n                    </div>\n\n                    <div flex=\"75\">\n                        <md-card>\n                            <!-- name sector -->\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'admin-detail-form-admin-name' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.me.name\" name=\"name\" \n                                           required>\n                                    </input>\n\n                                    <div ng-messages=\"meForm.name.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'me-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'admin-detail-form-admin-sector' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.me.sector\" name=\"sector\"\n                                           ng-disabled=\"true\">\n                                    </input>\n\n                                    <div ng-messages=\"meForm.sector.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"md-maxlength\">\n                                            {{ 'me-detail-form-error-title-max-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                            <!-- email access-group -->\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'admin-detail-form-admin-email' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.me.email\" name=\"email\" \n                                           type=\"email\" \n                                           required>\n                                    </input>\n\n                                    <div ng-messages=\"meForm.email.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"email\">\n                                            {{ 'form-error-email-invalid' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n\n                                <md-input-container class=\"md-block\" flex>\n                                    <label>\n                                        {{ 'admin-detail-form-admin-access-group' | translate }}\n                                    </label>\n\n                                    <md-select ng-model=\"$ctrl.me.access_group_id\"\n                                               name=\"access_group\"\n                                               ng-disabled=\"true\">\n                                        <md-option ng-repeat=\"access_group in $ctrl.access_groups\"\n                                                   ng-value=\"access_group.id\" >\n                                            {{ access_group.name }}\n                                        </md-option>\n                                    </md-select>\n\n                                    <div ng-messages=\"meForm.access_group.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                            <!-- password -->\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"sb-password-container md-block\" flex>\n                                    <label>\n                                        {{ 'me-detail-form-new-password' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.me.password\" name=\"password\"\n                                           type=\"{{ $ctrl.isPasswordVisible ? 'text' : 'password'}}\"\n                                           minlength=\"6\">\n                                    </input>\n\n                                    <md-icon ng-click=\"$ctrl.isPasswordVisible = !$ctrl.isPasswordVisible;\"\n                                             md-font-set=\"mdi\" \n                                             md-font-icon=\"{{ $ctrl.isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye'}}\"\n                                             class=\"mdi-24px\">\n                                    </md-icon>\n\n                                    <div ng-messages=\"meForm.password.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'form-error-required-field' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"minlength\">\n                                            {{ 'admin-detail-form-error-password-min-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n\n                            <!-- current_password -->\n                            <div layout=\"row\" flex>\n                                <md-input-container class=\"sb-current_password-container md-block\" flex>\n                                    <label>\n                                        {{ 'admin-detail-form-current_password' | translate }}\n                                    </label>\n\n                                    <input ng-model=\"$ctrl.me.current_password\" name=\"current_password\"\n                                           type=\"{{ $ctrl.isCurrentPasswordVisible ? 'text' : 'password'}}\"\n                                           required>\n                                    </input>\n\n                                    <md-icon ng-click=\"$ctrl.isCurrentPasswordVisible = !$ctrl.isCurrentPasswordVisible;\"\n                                             md-font-set=\"mdi\" \n                                             md-font-icon=\"{{ $ctrl.isCurrentPasswordVisible ? 'mdi-eye-off' : 'mdi-eye'}}\"\n                                             class=\"mdi-24px\">\n                                    </md-icon>\n\n                                    <div ng-messages=\"meForm.current_password.$error\" multiple>\n                                        <div ng-message=\"required\">\n                                            {{ 'me-detail-form-error-current_password-required' | translate}}\n                                        </div>\n\n                                        <div ng-message=\"minlength\">\n                                            {{ 'me-detail-form-error-current_password-min-length' | translate}}\n                                        </div>\n                                    </div>\n                                </md-input-container>\n                            </div>\n                        </md-card>\n\n                        <md-progress-linear ng-show=\"$ctrl.saving || $ctrl.deleting\"\n                                            md-mode=\"indeterminate\">\n                        </md-progress-linear>\n                    </div>\n                </div>\n                \n            </div>\n\n            <!-- form actions -->\n            <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n                <md-button page-back\n                           ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                    {{ 'common-cancel-button-text' | translate }}\n                </md-button>\n\n                <md-button type=\"submit\" ng-disabled=\"$ctrl.saving || $ctrl.deleting\"\n                           class=\"md-accent md-raised\">\n                    {{ $ctrl.saving ? 'common-save-button-loading-text' : 'common-save-button-text' | translate }}\n                </md-button>\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var MeDetailController = function MeDetailController($filter, $mdDialog, $scope, $state, Restangular, Toast, Group) {
	  DialogController.$inject = ["$scope", "$mdDialog"];
	  var $ctrl = this;
	
	  $ctrl.me;
	  $ctrl.isPasswordVisible = false;
	  $ctrl.isCurrentPasswordVisible = false;
	  $ctrl.currentPassword;
	
	  _angular2.default.extend($ctrl, {
	    clearImage: clearImage,
	    clearForm: clearForm,
	    handleSave: handleSave });
	
	
	  activate();
	
	  function activate() {
	    clearForm();
	
	    _angular2.default.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
	
	    $ctrl.uiState = 'LOADING';
	
	    loadDomainResources().
	    then(function (result) {
	      $ctrl.access_groups = result[0];
	
	      loadResource();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function clearImage() {
	    _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	    $ctrl.myImage = '';
	    $ctrl.myCroppedImage = '';
	    $ctrl.fileName = undefined;
	    $ctrl.me.image_uri = null;
	  }
	
	  function clearForm(form) {
	    $ctrl.me = {};
	
	    if (form) {
	      form.email.$$element[0].value = '';
	      form.$setPristine();
	      form.$setUntouched();
	    }
	
	    $ctrl.myImage = '';
	    $ctrl.myCroppedImage = '';
	    $ctrl.fileName = undefined;
	  }
	
	  function handleSave(form, me) {
	    if (!form.$valid) {
	      Toast.error($filter('translate')('common-form-incomplete'));
	      return;
	    }
	
	    me.image_base64 = $ctrl.myCroppedImage;
	
	    $ctrl.currentPassword = me.current_password;
	
	    $ctrl.saving = true;
	
	    me.save().
	    then(function (response) {
	      Toast.success($filter('translate')('me-detail-save-success'));
	      response.current_password = $ctrl.currentPassword;
	      $ctrl.me = response;
	      $ctrl.saving = false;
	      window.history.back();
	    }).
	    catch(function (err) {
	      var defaultErrMsg = $filter('translate')('common-server-error');
	      var fourOThreeMsg = $filter('translate')('me-detail-403-error');
	      var message = err.status == 403 ? fourOThreeMsg : defaultErrMsg;
	      Toast.error(message);
	      console.log('err:', err);
	      $ctrl.saving = false;
	    });
	  }
	
	  // Local functions
	  function handleFileSelect(event) {
	    var file = event.currentTarget.files[0];
	
	    if (!file) {
	      return;
	    }
	
	    var reader = new FileReader();
	    reader.onload = function (event) {
	      $ctrl.myImage = event.target.result;
	      $scope.$apply();
	      $ctrl.fileName = file.name;
	      showCropDialog(event);
	    };
	
	    reader.readAsDataURL(file);
	  }
	
	  function showCropDialog(event) {
	    $mdDialog.show({
	      controller: DialogController,
	      targetEvent: event,
	      template:
	      '<md-dialog aria-label="List dialog">' +
	      '  <md-dialog-content>' +
	      '    <ui-cropper' +
	      '      image="myImage"' +
	      '      area-type="circle"' +
	      '      chargement="loadingText"' +
	      '      result-image-size="{w: 200,h: 200}"' +
	      '      result-image="myCroppedImage" canvas-scalemode="true">' +
	      '    </ui-cropper>' +
	      '  </md-dialog-content>' +
	      '  <md-dialog-actions>' +
	      '    <md-button ng-click="cancel()">' +
	      '      Cancelar' +
	      '    </md-button>' +
	      '    <md-button ng-click="cropImage(myCroppedImage)" class="md-accent">' +
	      '      Feito' +
	      '    </md-button>' +
	      '  </md-dialog-actions>' +
	      '</md-dialog>',
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(function (myCroppedImage) {
	      $ctrl.myCroppedImage = myCroppedImage;
	      $ctrl.myImage = '';
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  }
	
	  function DialogController($scope, $mdDialog) {
	    "ngInject";
	    $scope.loadingText = 'Carregando';
	    $scope.myImage = $ctrl.myImage;
	    $scope.myCroppedImage = $ctrl.myCroppedImage;
	
	    $scope.hide = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.cancel();
	    };
	
	    $scope.cropImage = function (myCroppedImage) {
	      $mdDialog.hide(myCroppedImage);
	    };
	  }
	
	  function loadResource(id) {
	    Restangular.service('me').
	    one().
	    get().
	    then(function (me) {
	      console.log('me:', me);
	      $ctrl.me = me;
	      $ctrl.uiState = 'COMPLETE';
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function loadDomainResources() {
	    var promises = [];
	
	    promises.push(Group.index());
	
	    return Promise.all(promises);
	  }
	
	};
	
	MeDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Restangular', 'Toast', 'Group'];exports.default =
	
	MeDetailController;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(768);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./me.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./me.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _apiaccesslog = __webpack_require__(770);var _apiaccesslog2 = _interopRequireDefault(_apiaccesslog);
	var _apiaccesslogList = __webpack_require__(775);var _apiaccesslogList2 = _interopRequireDefault(_apiaccesslogList);
	var _apiaccesslogDetail = __webpack_require__(778);var _apiaccesslogDetail2 = _interopRequireDefault(_apiaccesslogDetail);
	var _apiaccesslog3 = __webpack_require__(781);var _apiaccesslog4 = _interopRequireDefault(_apiaccesslog3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var apiaccesslogModule = _angular2.default.module('apiaccesslog', [
	_angularUiRouter2.default]).
	
	
	service('Apiaccesslog', _apiaccesslog4.default).
	
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/notification');
	
	  $stateProvider.
	  state('apiaccesslog', {
	    component: 'apiaccesslog' }).
	
	  state('apiaccesslog.list', {
	    url: '/apiaccesslog',
	    component: 'apiaccesslogList' }).
	
	  state('apiaccesslog.create', {
	    url: '/apiaccesslog/new',
	    component: 'apiaccesslogDetail',
	    params: {
	      id: "" } }).
	
	
	  state('apiaccesslog.edit', {
	    url: '/apiaccesslog/edit',
	    component: 'apiaccesslogDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	
	component('apiaccesslog', _apiaccesslog2.default).
	component('apiaccesslogList', _apiaccesslogList2.default).
	component('apiaccesslogDetail', _apiaccesslogDetail2.default).
	
	name;exports.default =
	
	apiaccesslogModule;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _apiaccesslog = __webpack_require__(771);var _apiaccesslog2 = _interopRequireDefault(_apiaccesslog);
	var _apiaccesslog3 = __webpack_require__(772);var _apiaccesslog4 = _interopRequireDefault(_apiaccesslog3);
	__webpack_require__(773);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var apiaccesslogComponent = {
	  bindings: {},
	  template: _apiaccesslog2.default,
	  controller: _apiaccesslog4.default };exports.default =
	
	
	apiaccesslogComponent;

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var ApiaccesslogController =
	function ApiaccesslogController() {_classCallCheck(this, ApiaccesslogController);
	  this.name = 'apiaccesslog';
	};exports.default =
	
	
	ApiaccesslogController;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(774);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./apiaccesslog.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./apiaccesslog.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".apiaccesslog{color:red}.text-detail{margin-top:30px}", ""]);
	
	// exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _apiaccesslogList = __webpack_require__(776);var _apiaccesslogList2 = _interopRequireDefault(_apiaccesslogList);
	var _apiaccesslogList3 = __webpack_require__(777);var _apiaccesslogList4 = _interopRequireDefault(_apiaccesslogList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var apiaccesslogListComponent = {
	  bindings: {},
	  template: _apiaccesslogList2.default,
	  controller: _apiaccesslogList4.default };exports.default =
	
	
	apiaccesslogListComponent;

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div layout=\"row\" layout-align=\"space between\"\n         ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search)\">\n\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.$scope.tableConfig.like_search\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"title\"\n                        ng-click=\"$ctrl.orderList('title')\">\n                        {{ 'apiaccesslog-list-username' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"send_at\"\n                        ng-click=\"$ctrl.orderList('send_at')\">\n                        {{ 'apiaccesslog-list-type' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\"\n                        ng-click=\"$ctrl.orderList('updated_At')\">\n                        {{ 'apiaccesslog-list-creat_at' | translate }}\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\"\n                      ng-click=\"$ctrl.edit(resource)\">\n                    <td md-cell class=\"sb-table-truncate\">\n                    \t{{ resource.username }}\n                    </td>\n\n                    <td md-cell class=\"sb-table-truncate\">\n                    \t{{ resource.type }}\n                    </td>\n\n                    <td md-cell>\n                        {{ resource.created_at | momentFormat : 'DD/MM/YYYY HH:MM:SS' }}\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <img src=\"assets/empty_news.png\"/>\n\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'apiaccesslog-list-empty-state-line-1' | translate }}</p>\n                <p>{{ 'apiaccesslog-list-empty-state-line-2' | translate }}</p>\n            </div>\n\n            <md-button class=\"md-raised md-accent\" ui-sref=\"apiaccesslog.create\">\n                {{ 'apiaccesslog-list-create-apiaccesslog-button' | translate }}\n            </md-button>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var ApiaccesslogListController = function ApiaccesslogListController(Apiaccesslog, $filter, $scope, $state) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	
	  _angular2.default.extend($ctrl, {
	    edit: edit, orderList: orderList });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'updated_at DESC',
	      like_search: '',
	      like_search_fields: [
	      'username',
	      'created_at',
	      'type'] };
	
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function edit(item) {
	    $state.go('apiaccesslog.edit', { id: item });
	  }
	
	  function orderList(field) {
	    var tableConfig = $ctrl.$scope.tableConfig;
	    if (tableConfig.order) {
	      var currentField = tableConfig.order.split(' ')[0];
	      var currentOrder = tableConfig.order.split(' ')[1];
	
	      if (currentField === field) {
	        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
	        tableConfig.order = currentField + ' ' + currentOrder;
	      } else {
	        tableConfig.order = field + ' ' + 'ASC';
	      }
	    } else {
	      tableConfig.order = field + ' ' + ' ASC';
	    }
	  }
	
	  // Local functions
	  function loadData() {
	    $ctrl.promise = Apiaccesslog.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	};
	
	ApiaccesslogListController.$inject = ['Apiaccesslog', '$filter', '$scope', '$state'];exports.default =
	
	ApiaccesslogListController;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _apiaccesslogDetail = __webpack_require__(779);var _apiaccesslogDetail2 = _interopRequireDefault(_apiaccesslogDetail);
	var _apiaccesslogDetail3 = __webpack_require__(780);var _apiaccesslogDetail4 = _interopRequireDefault(_apiaccesslogDetail3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var apiaccesslogDetailComponent = {
	  bindings: {},
	  template: _apiaccesslogDetail2.default,
	  controller: _apiaccesslogDetail4.default };exports.default =
	
	
	apiaccesslogDetailComponent;

/***/ }),
/* 779 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div class=\"sb-content sb-apiaccesslog\" ng-show=\"$ctrl.uiState === 'COMPLETE'\">\n        <!-- apiaccesslog -->\n        <div layout=\"column\" class=\"sb-page-section\">\n            <h3 class=\"sb-page-section-title\">{{ 'apiaccesslog-detail-title' | translate }}</h3>\n\n            <p class=\"sb-page-section-sub-title\">\n                {{ 'apiaccesslog-detail-title-caption' | translate }}\n            </p>\n\n            <md-card>\n                <!-- username and type-->\n                <div layout=\"row\" flex>\n                    <md-input-container class=\"md-block\" flex>\n                        <label>\n                            {{ 'apiaccesslog-detail-username' | translate }}\n                        </label>\n                        <p class=\"text-detail\">\n                            {{ $ctrl.apiaccesslog.username }}\n                        </p>\n                    </md-input-container>\n                    <md-input-container class=\"md-block\" flex>\n                        <label>\n                            {{ 'apiaccesslog-detail-type' | translate }}\n                        </label>\n                        <p class=\"text-detail\">\n                            {{ $ctrl.apiaccesslog.type }}\n                        </p>\n                    </md-input-container>\n                </div>\n\n                <!-- created_at -->\n                <div layout=\"row\" flex>\n                    <md-input-container class=\"md-block\" flex>\n                        <label>\n                            {{ 'apiaccesslog-detail-date' | translate }}\n                        </label>\n                        <p class=\"text-detail\">\n                            {{ $ctrl.apiaccesslog.created_at | momentFormat : 'DD/MM/YYYY HH:MM:SS' }}\n                        </p>\n                    </md-input-container>\n                </div>\n\n                <!-- header -->\n                <div layout=\"row\" flex>\n                    <md-input-container class=\"md-block\" flex>\n                        <label>\n                            {{ 'apiaccesslog-detail-header' | translate }}\n                        </label>\n                        <p class=\"text-detail\">\n                            {{ $ctrl.apiaccesslog.header }}\n                        </p>\n                    </md-input-container>\n                </div>\n            </md-card>\n        </div>\n\n        <!-- form actions -->\n        <div layout=\"row\" layout-align=\"end center\" flex class=\"sb-form-actions after-card\">\n            <md-button page-back\n                        ng-disabled=\"$ctrl.saving || $ctrl.deleting\">\n                {{ 'common-go-back-button-text' | translate }}\n            </md-button>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'LOADING'\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\" \n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var ApiaccesslogDetailController = function ApiaccesslogDetailController($filter, $mdDialog, $scope, $state, $timeout, City, News, Apiaccesslog, State, Toast) {
	  var $ctrl = this;
	
	  $ctrl.apiaccesslog = $state.params.id;
	
	  _angular2.default.extend($ctrl, {
	    onChangeDate: onChangeDate,
	    onChangeState: onChangeState,
	    querySearch: querySearch,
	    selectedNewsItemChange: selectedNewsItemChange });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.uiState = 'LOADING';
	    if (!$ctrl.apiaccesslog) $state.go('apiaccesslog.list');else
	    {
	      $ctrl.uiState = 'COMPLETE';
	    }
	  }
	
	  function onChangeDate(form) {
	    $timeout(function () {
	      form.sendAtTime.$validate();
	    }, 100);
	  }
	
	  function onChangeState(stateId) {
	    $ctrl.apiaccesslog.city_id = undefined;
	    $ctrl.loadingCities = true;
	
	    City.
	    index({
	      state_id: stateId,
	      limit: 1000000 }).
	
	    then(function (cities) {
	      $ctrl.cities = cities;
	      $ctrl.loadingCities = false;
	    }).
	    catch(function (err) {
	      console.log('err:', err);
	      $ctrl.loadingCities = false;
	    });
	  }
	
	  function querySearch(searchText) {
	    searchText = searchText.toLowerCase();
	    var newsTypeToExclude = $ctrl.apiaccesslog.type === 'MEDIC' ? 'SBRUBBLES' : 'MEDIC';
	
	    var results = _.filter($ctrl.newsItems, function (newsItem) {
	      return newsItem.title.toLowerCase().indexOf(searchText) > -1 && newsItem.user_profile_type != newsTypeToExclude;
	    });
	
	    return results;
	  }
	
	  function selectedNewsItemChange(newsItem) {
	    $ctrl.apiaccesslog.type_id = newsItem ? newsItem.id : null;
	  }
	};
	
	ApiaccesslogDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', '$timeout', 'City', 'News', 'Apiaccesslog', 'State', 'Toast'];exports.default =
	
	ApiaccesslogDetailController;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var ApiaccesslogService = function ApiaccesslogService(Restangular) {
	  var Service = Restangular.all('admin/log');
	
	  var count = function count(query) {
	    query = query || {};
	    return Service.customGET('count', query);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Service.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    return Service.getList(query);
	  };
	
	  var load = function load(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return new Promise(function (resolve, reject) {
	      count(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  var show = function show(id) {
	    return Service.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy, count: count };
	};
	
	ApiaccesslogService.$inject = ['Restangular'];exports.default =
	
	ApiaccesslogService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _version = __webpack_require__(783);var _version2 = _interopRequireDefault(_version);
	var _versionList = __webpack_require__(788);var _versionList2 = _interopRequireDefault(_versionList);
	var _version3 = __webpack_require__(791);var _version4 = _interopRequireDefault(_version3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var versionModule = _angular2.default.module('appVersion', [
	_angularUiRouter2.default]).
	
	service('Version', _version4.default).
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/app-version');
	
	  $stateProvider.
	  state('app-version', {
	    component: 'version' }).
	
	  state('app-version.list', {
	    url: '/app-version',
	    component: 'versionList' });
	
	}]).
	component('version', _version2.default).
	component('versionList', _versionList2.default).
	name;exports.default =
	
	versionModule;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _version = __webpack_require__(784);var _version2 = _interopRequireDefault(_version);
	var _version3 = __webpack_require__(785);var _version4 = _interopRequireDefault(_version3);
	__webpack_require__(786);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var versionComponent = {
	  bindings: {},
	  template: _version2.default,
	  controller: _version4.default };exports.default =
	
	
	versionComponent;

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var VersionController =
	function VersionController() {_classCallCheck(this, VersionController);
	  this.name = 'app-version';
	};exports.default =
	
	
	VersionController;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(787);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./version.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./version.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".version-form{display:flex;gap:20px;margin-top:22px}", ""]);
	
	// exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _versionList = __webpack_require__(789);var _versionList2 = _interopRequireDefault(_versionList);
	var _versionList3 = __webpack_require__(790);var _versionList4 = _interopRequireDefault(_versionList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var versionListComponent = {
	  bindings: {},
	  template: _versionList2.default,
	  controller: _versionList4.default };exports.default =
	
	
	versionListComponent;

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div style=\"margin: 8px;\">\n        <h3><strong>NOTIFICAÇÃO DA VERSÃO</strong></h3>\n        <p>\n            As informações serão utilizadas para notificar os usuários da nova versão do aplicativo, sempre que estiverem em uma versão inferior a configurada.\n        </p>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column md-order-by=\"name\">\n                        {{ 'version-list-table-header-version' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"short_name\">\n                        {{ 'version-list-table-header-os' | translate }}\n                    </th>\n\n                    <th md-column md-order-by=\"short_name\">\n                        {{ 'version-list-table-header-forced' | translate }}\n                    </th>\n\n                    <th md-column md-numeric md-order-by=\"updated_At\">\n                        {{ 'version-list-table-header-configured' | translate }}\n                    </th>\n\n                    <th md-column md-numeric class=\"sb-table-column-xs\">\n                    </th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\">\n                    <td md-cell class=\"sb-table-truncate\">\n                    \t{{ resource.version }}\n                    </td>\n\n                    <td md-cell class=\"sb-table-truncate\">\n                        {{ resource.platform }}\n                    </td>\n                    \n                    <td md-cell class=\"sb-table-truncate\">\n                        <md-checkbox ng-checked=\"resource.isForced\" ng-disabled=\"true\">\n                        </md-checkbox>\n                    </td>\n\n                    <td md-cell>\n                    \t{{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}\n                    </td>\n\n                    <td md-cell>\n                        <md-button aria-label=\"Toolbar menu\" title=\"Editar\" type=\"button\"\n                                   class=\"md-icon-button\"\n                                   ng-click=\"$ctrl.edit(resource, $event)\">\n                          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-pencil\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _FileSaver = __webpack_require__(633);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var VersionListController = function VersionListController(Version, $mdDialog, $filter, $scope, $state, Toast) {
	  DialogController.$inject = ["$scope", "$mdDialog"];
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	  _angular2.default.extend($ctrl, {
	    edit: edit });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	    $ctrl.notification = {
	      version: null,
	      platform: '',
	      isForced: false };
	
	
	    $ctrl.versionList = [];
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'updated_at' };
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	
	  function edit(resource) {
	    $ctrl.notification = {
	      version: resource.version,
	      platform: resource.platform,
	      isForced: resource.isForced };
	
	    $mdDialog.show({
	      controller: DialogController,
	      template:
	      '<md-dialog aria-label="Version dialog" style="max-width: 600px; padding: 24px;">' +
	      '  <md-dialog-content>' +
	      '     <h4><strong>EDITAR VERSÃO</strong></h4>' +
	      '     <div> Preencha os dados sobre a versão conforme os campos abaixo.' +
	      '       Essas informações serão utilizadas para notificar os usuários da nova versão do aplicativo, sempre que estiverem em uma versão inferior a configurada.' +
	      '     </div>' +
	      '     <div class="version-form">' +
	      '       <md-input-container class="md-block" flex>' +
	      '       <label>Versão disponível</label>' +
	      '       <input ng-model="notification.version" name="title">' +
	      '      </md-input-container>' +
	      '       <md-input-container class="md-block" flex>' +
	      '         <label>Plataforma</label>' +
	      '         <md-select ng-model="notification.platform" disabled>' +
	      '          <md-option ng-value="\'ANDROID\'">Android</md-option>' +
	      '          <md-option ng-value="\'IOS\'">iOS</md-option>' +
	      '         </md-select>' +
	      '       </md-input-container>' +
	      '       <md-input-container class="md-block">' +
	      '       <md-checkbox aria-label="Atualização obrigatória" ng-checked="notification.isForced" ng-model="notification.isForced" >Atualização obrigatória</md-checkbox>' +
	      '       </md-input-container>' +
	      '     </div>' +
	      '     <div>' +
	      '     Caso deseje que os usuários não sejam notificados sobre a nova versão disponível, preencha o campo "Versão disponível" com o número 0' +
	      '     </div>' +
	      '</md-dialog-content>' +
	      '<md-dialog-actions>' +
	      '  <md-button ng-click="cancel()">Cancelar</md-button>' +
	      '  <md-button ng-click="save(notification)" class="md-accent">Salvar</md-button>' +
	      '  </md-dialog-actions>' +
	      '</md-dialog>',
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(function (resource) {
	      saveData(resource);
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  }
	
	  function DialogController($scope, $mdDialog) {
	    "ngInject";
	    $scope.loadingText = 'Carregando';
	    $scope.notification = {
	      version: $ctrl.notification.version,
	      platform: $ctrl.notification.platform,
	      isForced: $ctrl.notification.isForced };
	
	
	    $scope.hide = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      _angular2.default.element(document.querySelector('#fileInput')).val(undefined);
	      $mdDialog.cancel();
	    };
	
	    $scope.save = function (resource) {
	      $mdDialog.hide(resource);
	    };
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Version.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      setPlaceHolderValues(response.data);
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.email === null || item.email === undefined) {
	        item.email = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	
	  function saveData(resource) {
	    $ctrl.promise = Version.
	    save(resource).
	    then(function (response) {
	      loadData();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = 'ERROR';
	    }).finally(function () {
	      $ctrl.notification = {
	        version: null,
	        plataform: '',
	        isForced: false };
	
	    });
	  }
	};
	
	VersionListController.$inject = ['Version', '$mdDialog', '$filter', '$scope', '$state', 'Toast'];exports.default =
	
	VersionListController;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var VersionService = function VersionService(Restangular) {
	  var ServiceAPI = Restangular.all('app_version');
	
	  var getVersionsList = function getVersionsList() {
	    return ServiceAPI.customGET();
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return ServiceAPI.post(resource);
	    }
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return ServiceAPI.getList(query);
	  };
	
	  var load = function load(query) {
	    return new Promise(function (resolve, reject) {
	      getVersionsList(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  load(null);
	
	  var show = function show(id) {
	    return ServiceAPI.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, show: show, destroy: destroy };
	};
	
	VersionService.$inject = ['Restangular'];exports.default =
	
	VersionService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _faq = __webpack_require__(793);var _faq2 = _interopRequireDefault(_faq);
	var _faqList = __webpack_require__(796);var _faqList2 = _interopRequireDefault(_faqList);
	var _categoriesList = __webpack_require__(802);var _categoriesList2 = _interopRequireDefault(_categoriesList);
	var _faq3 = __webpack_require__(807);var _faq4 = _interopRequireDefault(_faq3);
	var _logList = __webpack_require__(808);var _logList2 = _interopRequireDefault(_logList);
	var _logDetailList = __webpack_require__(811);var _logDetailList2 = _interopRequireDefault(_logDetailList);
	var _categories = __webpack_require__(814);var _categories2 = _interopRequireDefault(_categories);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var faqModule = _angular2.default.module('appfaq', [
	_angularUiRouter2.default]).
	
	service('Faq', _faq4.default).
	service('Categorie', _categories2.default).
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/faq');
	
	  $stateProvider.
	  state('faq', {
	    component: 'faq' }).
	
	  state('faq.list', {
	    url: '/faq',
	    component: 'faqList' }).
	
	  state('faq.categories.list', {
	    url: '/faq/categories',
	    component: 'faqCategoryList' }).
	
	  state('faq.log-list', {
	    url: '/faq/log',
	    component: 'logList' }).
	
	  state('faq.log-detail', {
	    url: '/faq/log/:id',
	    component: 'logDetailList',
	    params: {
	      id: "" } });
	
	
	}]).
	component('faq', _faq2.default).
	component('faqList', _faqList2.default).
	component('faqCategoryList', _categoriesList2.default).
	component('logList', _logList2.default).
	component('logDetailList', _logDetailList2.default).
	name;exports.default =
	
	faqModule;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _faq = __webpack_require__(794);var _faq2 = _interopRequireDefault(_faq);
	var _faq3 = __webpack_require__(795);var _faq4 = _interopRequireDefault(_faq3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var faqComponent = {
	  bindings: {},
	  template: _faq2.default,
	  controller: _faq4.default };exports.default =
	
	
	faqComponent;

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var FaqController =
	function FaqController() {_classCallCheck(this, FaqController);
	  this.name = 'faq';
	};exports.default =
	
	
	FaqController;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _faqList = __webpack_require__(797);var _faqList2 = _interopRequireDefault(_faqList);
	var _faqList3 = __webpack_require__(798);var _faqList4 = _interopRequireDefault(_faqList3);
	__webpack_require__(800);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var faqListComponent = {
	  bindings: {},
	  template: _faqList2.default,
	  controller: _faqList4.default };exports.default =
	
	
	faqListComponent;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div style=\"margin: 8px\">\n    <h3><strong>PERGUNTAS FREQUENTES</strong></h3>\n  </div>\n  <div layout=\"row\" layout-align=\"flex start\">\n    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.edit()\"\n      >NOVA</md-button\n    >\n    <md-button class=\"md-raised md-accent\" ui-sref=\"faq.log-list\"\n      >LOGS</md-button\n    >\n  </div>\n\n  <md-card\n    ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\"\n  >\n    <md-table-container>\n      <table md-progress=\"$ctrl.promise\" md-table>\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Perguntas</th>\n            <th md-column>Categoria</th>\n            <th md-column>Subcategoria</th>\n            <th md-column>App</th>\n            <th md-column>Loja</th>\n            <th md-column>Site</th>\n            <th md-column></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"resource in $ctrl.resources.data\">\n            <td\n              class=\"sb-table-truncate\"\n              md-cell\n              ng-click=\"$ctrl.edit(resource, $event)\"\n            >\n              {{ resource.question }}\n            </td>\n            <td\n              class=\"sb-table-truncate\"\n              md-cell\n              ng-click=\"$ctrl.edit(resource, $event)\"\n            >\n              {{ resource.categorie.name }}\n            </td>\n            <td\n              class=\"sb-table-truncate\"\n              md-cell\n              ng-click=\"$ctrl.edit(resource, $event)\"\n            >\n              {{ resource.subcategorie.name }}\n            </td>\n\n            <td\n              class=\"sb-table-truncate\"\n              md-cell\n              ng-click=\"$ctrl.edit(resource, $event)\"\n            >\n              <div ng-switch on=\"resource.is_visible_app\">\n                <md-icon\n                  class=\"mdi-24px\"\n                  md-font-icon=\"mdi-close-circle\"\n                  md-font-set=\"mdi\"\n                  ng-switch-when=\"false\"\n                >\n                </md-icon>\n                <md-icon\n                  class=\"mdi-24px\"\n                  md-font-icon=\"mdi-checkbox-marked-circle\"\n                  md-font-set=\"mdi\"\n                  ng-switch-when=\"true\"\n                >\n                </md-icon>\n              </div>\n            </td>\n            <td\n              class=\"sb-table-truncate\"\n              md-cell\n              ng-click=\"$ctrl.edit(resource, $event)\"\n            >\n              <div ng-switch on=\"resource.is_visible_shop\">\n                <md-icon\n                  class=\"mdi-24px\"\n                  md-font-icon=\"mdi-close-circle\"\n                  md-font-set=\"mdi\"\n                  ng-switch-when=\"false\"\n                >\n                </md-icon>\n                <md-icon\n                  class=\"mdi-24px\"\n                  md-font-icon=\"mdi-checkbox-marked-circle\"\n                  md-font-set=\"mdi\"\n                  ng-switch-when=\"true\"\n                >\n                </md-icon>\n              </div>\n            </td>\n            <td\n              class=\"sb-table-truncate\"\n              md-cell\n              ng-click=\"$ctrl.edit(resource, $event)\"\n            >\n              <div ng-switch on=\"resource.is_visible_website\">\n                <md-icon\n                  class=\"mdi-24px\"\n                  md-font-icon=\"mdi-close-circle\"\n                  md-font-set=\"mdi\"\n                  ng-switch-when=\"false\"\n                >\n                </md-icon>\n                <md-icon\n                  class=\"mdi-24px\"\n                  md-font-icon=\"mdi-checkbox-marked-circle\"\n                  md-font-set=\"mdi\"\n                  ng-switch-when=\"true\"\n                >\n                </md-icon>\n              </div>\n            </td>\n            <td md-cell>\n              <md-button\n                aria-label=\"Toolbar menu\"\n                class=\"md-icon-button\"\n                ng-click=\"$ctrl.deleteDialog(resource, $event)\"\n                title=\"Excluir\"\n                type=\"button\"\n              >\n                <md-icon\n                  class=\"mdi-24px\"\n                  md-font-icon=\"mdi-delete\"\n                  md-font-set=\"mdi\"\n                ></md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n  </md-card>\n\n  <div\n    class=\"sb-fill-parent\"\n    ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n  >\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"sb-fill-parent\" ng-show=\"$ctrl.uiState === 'ERROR'\">\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-error-message\">{{ 'common-load-error' | translate}}</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _addAsk = __webpack_require__(799);var _addAsk2 = _interopRequireDefault(_addAsk);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var FaqListController = function FaqListController(Faq, Categorie, $mdDialog, $filter, $scope, $state, Toast) {
	  DialogController.$inject = ["$scope", "$mdDialog"];
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	  _angular2.default.extend($ctrl, {
	    edit: edit,
	    deleteDialog: deleteDialog });
	
	
	  var formatCategory = function formatCategory(el) {
	    return {
	      id: el.id,
	      name: el.name,
	      subcategories: el.subcategories };
	
	  };
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.categories = [];
	
	    $ctrl.uiState = 'LOADING';
	    $ctrl.category = {
	      name: '' };
	
	
	    $ctrl.versionList = [];
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      order: 'updated_at' };
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	      loadCategories();
	    }, true);
	  }
	
	  function edit(resource) {
	    $mdDialog.show({
	      template: _addAsk2.default,
	      controller: ["$scope", "$mdDialog", function controller($scope, $mdDialog) {
	        "ngInject";
	        $scope.loadingText = 'Carregando';
	        $scope.categories = $ctrl.categories.map(formatCategory);
	        $scope.isEditing = resource && resource.id;
	
	        $scope.faq = _angular2.default.copy(resource) || {
	          question: '',
	          response: '',
	          categorie: { id: null, name: null },
	          subcategorie: { id: null, name: null },
	          is_visible_app: 0,
	          is_visible_shop: 0,
	          is_visible_webchat: 0 };
	
	
	        $scope.handleChange = function (id) {
	          $scope.subCategories = $scope.categories.find(function (el) {return el.id === id;}).subcategories;
	        };
	
	        if (resource && resource.categorie && resource.subcategorie) {
	          $scope.handleChange(resource.categorie.id);
	        } else {
	          $scope.subCategories = [];
	        }
	
	        $scope.hide = function () {
	          $mdDialog.hide();
	        };
	
	        $scope.cancel = function () {
	          $mdDialog.cancel();
	        };
	
	        $scope.save = function (resource) {
	          $mdDialog.hide(resource);
	        };
	      }],
	      bindToController: true,
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(function (resource) {
	      resource.id ? update(resource) : saveData(resource);
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  }
	
	  function deleteDialog(resource) {
	    $mdDialog.show({
	      template: '<md-dialog aria-label="Version dialog" style="max-width: 550px; padding: 24px;">' +
	      '  <md-dialog-content>' +
	      '  <h4><strong>EXCLUIR VERSÃO</strong></h4>' +
	      '  <div>Deseja realmente excluir a versão selecionada?</div>' +
	      '  </md-dialog-content>' +
	      '  <md-dialog-actions>' +
	      '    <md-button ng-click="cancel()">Cancelar</md-button>' +
	      '    <md-button ng-click="save()" class="md-accent">Excluir</md-button>' +
	      '  </md-dialog-actions>' +
	      '</md-dialog>',
	      controller: DialogController,
	      bindToController: true,
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(function () {
	      deleteData(resource.id);
	    }, function () {
	      $scope.status = 'You cancelled the dialog.';
	    });
	  }
	
	  function DialogController($scope, $mdDialog) {
	    "ngInject";
	    $scope.loadingText = 'Carregando';
	    $scope.categories = $ctrl.categories;
	    $scope.subCategories = [];
	
	    $scope.handleChange = function (resource) {
	      $scope.subCategories = $scope.categories.find(function (el) {return el.id === resource.id;}).subcategories;
	    };
	
	    $scope.hide = function () {
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      $mdDialog.cancel();
	    };
	
	    $scope.save = function (resource) {
	      $mdDialog.hide(resource);
	    };
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Faq.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      setPlaceHolderValues(response.data);
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function loadCategories() {
	    $ctrl.promise = Categorie.index().
	    then(function (response) {
	      $ctrl.categories = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.email === null || item.email === undefined) {
	        item.email = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	
	  function saveData(resource) {
	    var category = $ctrl.categories.find(function (el) {return el.id === resource.categorie.id;});
	
	    resource.categorie_id = category ? category.id : null;
	    resource.subcategorie_id = resource.subcategorie.id ?
	    category.subcategories.find(function (el) {return el.id === resource.subcategorie.id;}).
	    id :
	    null;
	
	    delete resource.categorie;
	    delete resource.subcategorie;
	
	    $ctrl.promise = Faq.
	    save(resource).
	    then(function (response) {
	      loadData();
	    }).
	    catch(function (err) {
	      if (err.status === 400) {
	        $mdDialog.show(
	        $mdDialog.alert().
	        clickOutsideToClose(true).
	        textContent("A pergunta já existe, necessário criar uma pergunta diferente!").
	        ok("Ok"));
	
	      } else
	      {
	        $ctrl.uiState = 'ERROR';
	      }
	    }).finally(function () {
	      $ctrl.notification = {
	        version: null,
	        plataform: '' };
	
	    });
	  }
	
	  function update(resource) {
	    var updatedResponse = {
	      question: resource.question,
	      title: resource.question,
	      categorie_id: resource.categorie ? resource.categorie.id : null,
	      subcategorie_id: resource.subcategorie ? resource.subcategorie.id : null,
	      is_visible_app: resource.is_visible_app,
	      is_visible_shop: resource.is_visible_shop,
	      is_visible_website: resource.is_visible_website,
	      response: resource.response };
	
	
	    $ctrl.promise = Faq.
	    update(resource.id, updatedResponse).
	    then(function (response) {
	      loadData();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = 'ERROR';
	    }).finally(function () {
	      $ctrl.notification = {
	        version: null,
	        plataform: '' };
	
	    });
	  }
	
	  function deleteData(id) {
	    $ctrl.promise = Faq.
	    deleteData(id).
	    then(function (response) {
	      loadData();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = 'ERROR';
	    }).finally(function () {
	      $ctrl.notification = {
	        version: null,
	        plataform: '' };
	
	    });
	  }
	};
	
	FaqListController.$inject = ['Faq', 'Categorie', '$mdDialog', '$filter', '$scope', '$state', 'Toast'];exports.default =
	
	FaqListController;

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog\n  aria-label=\"Nova Pergunta dialog\"\n  style=\"max-width: 550px; padding: 24px\"\n>\n  <md-dialog-content>\n    <h3 class=\"sb-page-section-title\">{{ 'faq-detail-title' | translate }}</h3>\n    <div class=\"faq-form\">\n      <form name=\"faqForm\" novalidate>\n        <div class=\"sb-page-section\" layout=\"column\">\n          <md-card>\n            <div flex layout=\"row\">\n              <md-input-container class=\"md-block\" flex>\n                <label> {{ 'faq-detail-input-title' | translate }} </label>\n\n                <input name=\"question\" ng-model=\"faq.question\" required />\n\n                <div multiple ng-messages=\"faqForm.question.$error\">\n                  <div ng-message=\"required\">\n                    {{ 'form-error-required-field' | translate}}\n                  </div>\n\n                  <div ng-message=\"md-maxlength\">\n                    {{ 'region-detail-form-error-title-max-length' | translate}}\n                  </div>\n                </div>\n              </md-input-container>\n            </div>\n\n            <div class=\"categories-box\">\n              <div flex layout=\"row\">\n                <md-input-container class=\"md-block\" flex>\n                  <label>{{ 'common-category' | translate }}</label>\n                  <md-select\n                    ng-change=\"handleChange(faq.categorie.id)\"\n                    ng-model=\"faq.categorie.id\"\n                  >\n                    <md-option\n                      ng-repeat=\"categorie in categories\"\n                      ng-value=\"categorie.id\"\n                      >{{ categorie.name }}</md-option\n                    >\n                  </md-select>\n                </md-input-container>\n              </div>\n\n              <div flex layout=\"row\">\n                <md-input-container class=\"md-block\" flex>\n                  <label>{{ 'common-subcategory' | translate }}</label>\n                  <md-select ng-model=\"faq.subcategorie.id\">\n                    <md-option\n                      ng-repeat=\"subCategorie in subCategories\"\n                      ng-value=\"subCategorie.id\"\n                      >{{ subCategorie.name }}</md-option\n                    >\n                  </md-select>\n                </md-input-container>\n              </div>\n            </div>\n\n            <h3 class=\"section-title\">\n              {{ 'faq-detail-title-response' | translate }}\n            </h3>\n            <div\n              class=\"sb-ta-container\"\n              ng-class=\"{'sb-input-invalid': (faqForm.response.$touched || faqForm.$submitted) && (!faq.response || faq.response.trim().length < 12) }\"\n            >\n              <text-angular name=\"response\" ng-model=\"faq.response\">\n              </text-angular>\n            </div>\n\n            <h3 class=\"section-title\">\n              {{ 'faq-detail-title-platforms' | translate }}\n            </h3>\n            <div flex layout=\"row\">\n              <md-checkbox\n                aria-label=\"Site\"\n                ng-checked=\"faq.is_visible_website\"\n                ng-model=\"faq.is_visible_website\"\n                >Site\n              </md-checkbox>\n\n              <md-checkbox\n                aria-label=\"Loja Virtual\"\n                ng-checked=\"faq.is_visible_shop\"\n                ng-model=\"faq.is_visible_shop\"\n                >Loja Virtual\n              </md-checkbox>\n\n              <md-checkbox\n                aria-label=\"App\"\n                ng-checked=\"faq.is_visible_app\"\n                ng-model=\"faq.is_visible_app\"\n              >\n                App\n              </md-checkbox>\n            </div>\n          </md-card>\n        </div>\n      </form>\n    </div>\n  </md-dialog-content>\n  <md-dialog-actions>\n    <md-button ng-click=\"cancel()\">Cancelar</md-button>\n    <md-button class=\"md-accent\" ng-click=\"save(faq)\">Salvar</md-button>\n  </md-dialog-actions>\n</md-dialog>\n"

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(801);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./faq-list.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./faq-list.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, "table tbody tr td:nth-of-type(6){display:table-cell}.categories-box{display:flex;flex-wrap:wrap;gap:20px}.section-title{font-weight:600;text-transform:uppercase;color:rgba(0,0,0,.72);font-size:14px}", ""]);
	
	// exports


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _categoriesList = __webpack_require__(803);var _categoriesList2 = _interopRequireDefault(_categoriesList);
	var _categoriesList3 = __webpack_require__(804);var _categoriesList4 = _interopRequireDefault(_categoriesList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var categoriesListComponent = {
	  bindings: {},
	  template: _categoriesList2.default,
	  controller: _categoriesList4.default };exports.default =
	
	
	categoriesListComponent;

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div style=\"margin: 8px;\">\n        <h3><strong>Categorias</strong></h3>\n    </div>\n    <div layout=\"row\" layout-align=\"flex start\" >\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.newCategory()\">NOVA</md-button>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column>Nome da Categoria</th>\n                    <th md-column></th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\">\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.newCategory(resource, $event)\">{{ resource.name }}</td>\n                    <td md-cell>\n                        <md-button aria-label=\"Toolbar menu\" title=\"Excluir\" type=\"button\"\n                                   class=\"md-icon-button\" ng-click=\"$ctrl.deleteDialog(resource, $event)\">\n                          <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n                          </md-icon>\n                        </md-button>\n                    </td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _addCategory = __webpack_require__(805);var _addCategory2 = _interopRequireDefault(_addCategory);
	var _addSubcategory = __webpack_require__(806);var _addSubcategory2 = _interopRequireDefault(_addSubcategory);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _asyncToGenerator(fn) {return function () {var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {function step(key, arg) {try {var info = gen[key](arg);var value = info.value;} catch (error) {reject(error);return;}if (info.done) {resolve(value);} else {return Promise.resolve(value).then(function (value) {step("next", value);}, function (err) {step("throw", err);});}}return step("next");});};}
	
	var CategoriesListController = function CategoriesListController(CategoriesService, $mdDialog, $filter, $scope, $state, Toast) {
	                CategoryDialogController.$inject = ["$scope", "$mdDialog"];
	                SubcategoryDialogController.$inject = ["$scope", "$mdDialog"];var resolveSubCategory = function () {var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	    function _callee(resource) {var categoryIndex, subCategoryIndex, newSub, _subCategoryIndex;return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
	              categoryIndex = $ctrl.resources.data.findIndex(
	              function (el) {return el.id === resource.categoryId;});if (!(
	
	
	              resource.action === 'SAVE')) {_context.next = 12;break;}if (!
	              resource.subCategory.id) {_context.next = 8;break;}
	              updateSubCategory(resource);
	
	              subCategoryIndex = $ctrl.resources.data[
	              categoryIndex].
	              subcategories.findIndex(function (el) {return el.id === resource.subCategory.id;});
	
	              $ctrl.resources.data[categoryIndex].subcategories[
	              subCategoryIndex].
	              name = resource.subCategory.name;_context.next = 12;break;case 8:_context.next = 10;return (
	
	                saveSubCategory(resource));case 10:newSub = _context.sent;
	              $ctrl.resources.data[categoryIndex].subcategories.push(newSub);case 12:
	
	
	
	              if (resource.action === 'DELETE') {
	                deleteSubCategory(resource.subCategory.id);
	
	                _subCategoryIndex = $ctrl.resources.data[
	                categoryIndex].
	                subcategories.findIndex(function (el) {return el.id === resource.subCategory.id;});
	
	                $ctrl.resources.data[categoryIndex].subcategories.splice(
	                _subCategoryIndex,
	                1);
	
	              }case 13:case 'end':return _context.stop();}}}, _callee, this);}));return function resolveSubCategory(_x) {return _ref.apply(this, arguments);};}();var saveSubCategory = function () {var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(
	
	
	    function _callee2(resource) {return regeneratorRuntime.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:_context2.next = 2;return (
	                CategoriesService.
	                saveSubCategory(resource.categoryId, resource.subCategory.name).
	                then(function (response) {
	                  loadData();
	                  return response;
	                }).
	                catch(function (err) {
	                  $ctrl.uiState = 'ERROR';
	                }).finally(function () {
	                  $ctrl.notification = {
	                    version: null,
	                    plataform: '' };
	
	                }));case 2:return _context2.abrupt('return', _context2.sent);case 3:case 'end':return _context2.stop();}}}, _callee2, this);}));return function saveSubCategory(_x2) {return _ref2.apply(this, arguments);};}();var $ctrl = this;$ctrl.$scope = $scope;_angular2.default.extend($ctrl, { newCategory: newCategory, deleteDialog: deleteDialog });activate();function activate() {$ctrl.resources = { count: 0, data: [] };$ctrl.uiState = 'LOADING';$ctrl.category = { name: '' };$ctrl.versionList = [];$ctrl.promise;$ctrl.$scope.tableConfig = { page: 1, limit: 10, order: 'updated_at' };$ctrl.$scope.$watch('tableConfig', function () {loadData();}, true);}function newCategory(resource) {console.log(resource);$mdDialog.show({ template: _addCategory2.default, bindToController: true, parent: _angular2.default.element(document.body), clickOutsideToClose: true, fullscreen: false, controller: CategoryDialogController, controllerAs: 'ctrl', locals: { title: resource ? 'common-edit' : 'common-create', category: resource } }).then(function (resource) {saveCategory(resource);}, function () {$scope.status = 'You cancelled the dialog.';});}function newSubCategory(categoryId, subCategory) {$mdDialog.show({ template: _addSubcategory2.default, bindToController: true, parent: _angular2.default.element(document.body), clickOutsideToClose: false, escapeToClose: false, fullscreen: false, controller: SubcategoryDialogController, controllerAs: 'ctrl', locals: { title: subCategory ? 'common-edit' : 'common-create', categoryId: categoryId, subCategory: subCategory } }).then(function (resource) {resolveSubCategory(resource);}, function () {$scope.status = 'You cancelled the dialog.';}).finally(function () {newCategory($ctrl.resources.data.find(function (el) {return el.id === categoryId;}));});}function deleteDialog(resource) {$mdDialog.show({ template: '<md-dialog aria-label="Version dialog" style="max-width: 550px; padding: 24px;">' + '  <md-dialog-content>' + '  <h4><strong>EXCLUIR CATEGORIA</strong></h4>' + '  <div>Deseja realmente excluir a categoria selecionada?</div>' + '  </md-dialog-content>' + '  <md-dialog-actions>' + '    <md-button ng-click="cancel()">Cancelar</md-button>' + '    <md-button ng-click="save()" class="md-accent">Excluir</md-button>' + '  </md-dialog-actions>' + '</md-dialog>', controller: CategoryDialogController, bindToController: true, clickOutsideToClose: true, fullscreen: false }).then(function () {deleteCategory(resource.id);}, function () {$scope.status = 'You cancelled the dialog.';});}function CategoryDialogController($scope, $mdDialog) {"ngInject";$scope.hide = function () {$mdDialog.hide();};$scope.cancel = function () {$mdDialog.cancel();};$scope.save = function (resource) {$mdDialog.hide(resource);};$scope.editSubCategory = function (categoryId, subCategory) {newSubCategory(categoryId, subCategory);};}function SubcategoryDialogController($scope, $mdDialog) {"ngInject";$scope.hide = function () {$mdDialog.hide();};$scope.cancel = function (categoryId, subCategory) {$mdDialog.cancel({ categoryId: categoryId, subCategory: subCategory });};$scope.save = function (categoryId, subCategory) {$mdDialog.hide({ action: 'SAVE', categoryId: categoryId, subCategory: subCategory });};$scope.delete = function (categoryId, subCategory) {$mdDialog.hide({ action: 'DELETE', categoryId: categoryId, subCategory: subCategory });};} // Local functions
	  function loadData() {$ctrl.promise = CategoriesService.load($ctrl.$scope.tableConfig).then(function (response) {setPlaceHolderValues(response.data);$ctrl.resources = response;$ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';$ctrl.$scope.$apply();}).catch(function (err) {$ctrl.uiState = 'ERROR';});}function setPlaceHolderValues(arr) {_.forEach(arr, function (item) {if (item.email === null || item.email === undefined) {item.email = $filter('translate')('common-not-informed');}});}function saveCategory(resource) {$ctrl.promise = CategoriesService.save(resource).then(function (response) {loadData();}).catch(function (err) {if (err.status === 409) {$mdDialog.show($mdDialog.alert().clickOutsideToClose(true).textContent("A categoria já existe!").ok("Ok"));} else {$ctrl.uiState = 'ERROR';}}).finally(function () {$ctrl.notification = { version: null, plataform: '' };});}function deleteCategory(id) {$ctrl.promise = CategoriesService.deleteCategory(id).then(function (response) {loadData();}).catch(function (err) {$ctrl.uiState = 'ERROR';}).finally(function () {$ctrl.notification = { version: null, plataform: '' };});}
	
	  function updateSubCategory(resource) {
	    $ctrl.promise = CategoriesService.
	    updateSubCategory(resource.subCategory.id, resource.subCategory.name).
	    then(function (response) {
	      loadData();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = 'ERROR';
	    }).finally(function () {
	      $ctrl.notification = {
	        version: null,
	        plataform: '' };
	
	    });
	  }
	
	  function deleteSubCategory(id) {
	    $ctrl.promise = CategoriesService.
	    deleteSubCategory(id).
	    then(function (response) {
	      loadData();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = 'ERROR';
	    }).finally(function () {
	      $ctrl.notification = {
	        version: null,
	        plataform: '' };
	
	    });
	  }
	};
	
	CategoriesListController.$inject = ['CategoriesService', '$mdDialog', '$filter', '$scope', '$state', 'Toast'];exports.default =
	
	CategoriesListController;

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Category dialog\" style=\"width: 550px; padding: 24px\">\n  <md-dialog-content>\n    <h4>\n      <strong\n        >{{ ctrl.title | translate }} {{ 'common-category' | translate\n        }}</strong\n      >\n    </h4>\n\n    <div class=\"\">\n      <div class=\"sb-page-section\">\n        <div layout=\"row\" flex>\n          <md-input-container class=\"md-block\" flex>\n            <label style=\"width: auto\">Nome da categoria</label>\n            <input ng-model=\"ctrl.category.name\" name=\"title\" required />\n          </md-input-container>\n        </div>\n\n        <div ng-if=\"ctrl.category.subcategories.length > 0\" flex>\n          <h4><strong>{{ 'common-subcategory' | translate }}</strong></h4>\n\n          <div ng-repeat=\"(key, subCat) in ctrl.category.subcategories\">\n            <input\n              type=\"radio\"\n              id=\"{{ subCat.id }}\"\n              name=\"subcategory\"\n              value=\"{{ subCat.name }}\"\n            />\n            <label\n              for=\"{{ subCat.id }}\"\n              ng-click=\"editSubCategory(ctrl.category.id, subCat)\"\n            >\n              <span> {{ subCat.name }} </span>\n\n              <md-button title=\"Editar\" type=\"button\" class=\"md-icon-button\">\n                <md-icon\n                  md-font-set=\"mdi\"\n                  md-font-icon=\"mdi-pencil\"\n                  class=\"mdi-24px\"\n                /> </md-button\n            ></label>\n          </div>\n        </div>\n\n        <md-button\n          ng-if=\"ctrl.category.id\"\n          class=\"md-raised\"\n          ng-click=\"editSubCategory(ctrl.category.id, subCat)\"\n          >{{ 'common-add-subcategory' | translate }}</md-button\n        >\n      </div>\n    </div>\n  </md-dialog-content>\n\n  <md-dialog-actions>\n    <md-button ng-click=\"cancel()\">Cancelar</md-button>\n    <md-button\n      ng-disabled=\"!ctrl.category.name\"\n      ng-click=\"save(ctrl.category)\"\n      class=\"md-accent\"\n      >Salvar</md-button\n    >\n  </md-dialog-actions>\n</md-dialog>\n"

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	module.exports = "<md-dialog aria-label=\"Faq dialog\" style=\"width: 550px; padding: 24px\">\n  <md-dialog-content>\n    <h4><strong>{{ 'common-subcategory' | translate }}</strong></h4>\n    <div class=\"version-form\">\n      <md-input-container class=\"md-block\" flex>\n        <label for='subcategory' style=\"width: auto\">Nome da Subcategoria</label>\n        <input id='subcategory' name=\"subcategory\" ng-model=\"ctrl.subCategory.name\" required/>\n      </md-input-container>\n    </div>\n  </md-dialog-content>\n\n  <md-dialog-actions>\n    <md-button\n      ng-click=\"delete(ctrl.categoryId, ctrl.subCategory)\"\n      ng-if=\"ctrl.subCategory.id\"\n      >Remover</md-button\n    >\n    <md-button ng-click=\"cancel(ctrl.categoryId, ctrl.subCategory)\"\n      >Cancelar</md-button\n    >\n    <md-button\n      class=\"md-accent\"\n      ng-click=\"save(ctrl.categoryId, ctrl.subCategory)\"\n      ng-disabled=\"!ctrl.subCategory.name\"\n      >Salvar</md-button\n    >\n  </md-dialog-actions>\n</md-dialog>\n"

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });
	var FaqService = function FaqService(Restangular) {
	  var ServiceAPI = Restangular.all('common_questions');
	
	  var getFaqList = function getFaqList() {
	    return ServiceAPI.customGET();
	  };
	
	  var getLogDetails = function getLogDetails(id) {
	    return Restangular.all('admin/common_questions_logs').customGET(id);
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return resource.save();
	    } else {
	      return Restangular.all('admin/common_questions').post(resource);
	    }
	  };
	
	  var update = function update(id, response) {
	    return Restangular.all('admin/common_questions').customPUT(response, id);
	  };
	
	  var deleteData = function deleteData(id) {
	    return Restangular.all('admin/common_questions').customDELETE(id);
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return ServiceAPI.getList(query);
	  };
	
	  var load = function load(query) {
	    return new Promise(function (resolve, reject) {
	      getFaqList(query).
	      then(function (response) {
	        var count = response.length;
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  load(null);
	
	  var show = function show(id) {
	    return ServiceAPI.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, update: update, deleteData: deleteData, show: show, destroy: destroy, getLogDetails: getLogDetails };
	};
	
	FaqService.$inject = ['Restangular'];exports.default =
	
	FaqService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _logList = __webpack_require__(809);var _logList2 = _interopRequireDefault(_logList);
	var _logList3 = __webpack_require__(810);var _logList4 = _interopRequireDefault(_logList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var logListComponent = {
	  bindings: {},
	  template: _logList2.default,
	  controller: _logList4.default };exports.default =
	
	
	logListComponent;

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div style=\"margin: 8px;\">\n        <h3>\n            <strong>DETALHES DO LOG</strong>\n        </h3>\n    </div>\n    <div layout=\"row\" layout-align=\"flex start\">\n        <md-button class=\"md-raised md-accent\" page-back>Voltar</md-button>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column>Perguntas</th>\n                    <th md-column>Categoria</th>\n                    <th md-column>Criada por</th>\n                    <th md-column>Data de criação</th>\n                    <th md-column>Editada por</th>\n                    <th md-column>Data de edição</th>\n                  </tr>\n                </thead>\n\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\">\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.showDetail(resource, $event)\">{{ resource.question }}</td>\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.showDetail(resource, $event)\">{{ resource.categorie.name }}</td>\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.showDetail(resource, $event)\">{{ resource.author.name }}</td>\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.showDetail(resource, $event)\">{{ $ctrl.formatDate(resource.created_at) }}</td>\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.showDetail(resource, $event)\">{{ resource.updated_to.name }}</td>\n                    <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.showDetail(resource, $event)\">{{ $ctrl.formatDate(resource.updated_at) }}</td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n        <md-table-pagination\n            md-limit=\"$ctrl.$scope.tableConfig.limit\"\n            md-page=\"$ctrl.$scope.tableConfig.page\"\n            md-total=\"{{ $ctrl.resources.count }}\"\n            md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n            md-page-select>\n        </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var LogListController = function LogListController(Faq, $mdDialog, $filter, $scope, $state, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	  _angular2.default.extend($ctrl, {
	    goBack: goBack,
	    showDetail: showDetail,
	    formatDate: formatDate });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	    $ctrl.category = {
	      name: '' };
	
	
	    $ctrl.versionList = [];
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'updated_at' };
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function goBack() {
	    window.history.back();
	  }
	
	  function showDetail(resource) {
	    $state.go('faq.log-detail', { id: resource.id });
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Faq.
	    load($ctrl.$scope.tableConfig).
	    then(function (response) {
	      setPlaceHolderValues(response.data);
	      $ctrl.resources = response;
	      $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
	      $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.email === null || item.email === undefined) {
	        item.email = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	
	  function formatDate(date) {
	    return new Intl.DateTimeFormat(navigator.language).format(new Date(date));
	  }
	};
	
	LogListController.$inject = ['Faq', '$mdDialog', '$filter', '$scope', '$state', 'Toast'];exports.default =
	
	LogListController;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _logDetailList = __webpack_require__(812);var _logDetailList2 = _interopRequireDefault(_logDetailList);
	var _logDetailList3 = __webpack_require__(813);var _logDetailList4 = _interopRequireDefault(_logDetailList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var logDetailListComponent = {
	  bindings: {},
	  template: _logDetailList2.default,
	  controller: _logDetailList4.default };exports.default =
	
	
	logDetailListComponent;

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n    <div style=\"margin: 8px;\">\n        <h3><strong>DETALHES DO LOG</strong></h3>\n    </div>\n    <div layout=\"row\" layout-align=\"flex start\">\n        <md-button class=\"md-raised md-accent\" page-back>Voltar</md-button>\n    </div>\n\n    <md-card ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\">\n        <md-table-container>\n            <table md-table md-progress=\"$ctrl.promise\">\n                <thead md-head>\n                  <tr md-row>\n                    <th md-column>Perguntas</th>\n                    <th md-column>Categoria</th>\n                    <th md-column>Criada por</th>\n                    <th md-column>Data de criação</th>\n                    <th md-column>Ediata por</th>\n                    <th md-column>Data de edição</th>\n                  </tr>\n                </thead>\n                <tbody md-body>\n                  <tr md-row ng-repeat=\"resource in $ctrl.resources.data\">\n                    <td md-cell class=\"sb-table-truncate\">{{ resource.question }}</td>\n                    <td md-cell class=\"sb-table-truncate\">{{ resource.categorie.name }}</td>\n                    <td md-cell class=\"sb-table-truncate\">{{ resource.author.name }}</td>\n                    <td md-cell class=\"sb-table-truncate\">{{ resource.created_at | momentFormat : 'DD/MM/YYYY' }}</td>\n                    <td md-cell class=\"sb-table-truncate\">{{ resource.updated_to.name }}</td>\n                    <td md-cell class=\"sb-table-truncate\">{{ resource.updated_at | momentFormat : 'DD/MM/YYYY' }}</td>\n                  </tr>\n                </tbody>\n            </table>\n        </md-table-container>\n\n      <md-table-pagination\n        md-limit=\"$ctrl.$scope.tableConfig.limit\"\n        md-page=\"$ctrl.$scope.tableConfig.page\"\n        md-total=\"{{ $ctrl.resources.count }}\"\n        md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n        md-page-select>\n      </md-table-pagination>\n    </md-card>\n\n    <div ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-empty-state-text\">\n                <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n            </div>\n        </div>\n    </div>\n\n    <div ng-show=\"$ctrl.uiState === 'ERROR'\"\n         class=\"sb-fill-parent\">\n        <div class=\"sb-absolute-center sb-empty-state\"\n             layout=\"column\" layout-align=\"center center\">\n            <div class=\"sb-error-message\">\n                {{ 'common-load-error' | translate}}\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var LogDetailListController = function LogDetailListController(Faq, $mdDialog, $filter, $scope, $state, Toast) {
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	  $ctrl.id = $state.params.id;
	
	  _angular2.default.extend($ctrl, {
	    goBack: goBack });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.resources = {
	      count: 0,
	      data: [] };
	
	
	    $ctrl.uiState = 'LOADING';
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: 'updated_at' };
	
	
	    $ctrl.$scope.$watch('tableConfig', function () {
	      loadData();
	    }, true);
	  }
	
	  function goBack() {
	    window.history.back();
	  }
	
	  // Local functions
	
	  function loadData() {
	    $ctrl.promise = Faq.
	    getLogDetails($ctrl.id).
	    then(function (response) {
	      setPlaceHolderValues(response);
	      $ctrl.resources = { count: response.length, data: response };
	      $ctrl.uiState = response.length ? 'COMPLETE' : 'EMPTY';
	      // $ctrl.$scope.$apply();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = 'ERROR';
	    });
	  }
	
	  function setPlaceHolderValues(arr) {
	    _.forEach(arr, function (item) {
	      if (item.email === null || item.email === undefined) {
	        item.email = $filter('translate')('common-not-informed');
	      }
	    });
	  }
	};
	
	LogDetailListController.$inject = ['Faq', '$mdDialog', '$filter', '$scope', '$state', 'Toast'];exports.default =
	
	LogDetailListController;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });
	var FaqCategoryService = function FaqCategoryService(Restangular) {
	  var ServiceAPI = Restangular.all('categories');
	
	  var getFaqList = function getFaqList() {
	    return ServiceAPI.customGET();
	  };
	
	  var save = function save(resource) {
	    if (resource.save) {
	      return Restangular.all('admin/categories').customPUT({ name: resource.name }, resource.id);
	    } else {
	      return Restangular.all('admin/categories').post(resource);
	    }
	  };
	
	  var saveSubCategory = function saveSubCategory(categoryId, subCategoryName) {
	    return Restangular.all('admin/categories').customPOST({ name: subCategoryName }, categoryId + '/sub');
	  };
	
	  var updateSubCategory = function updateSubCategory(subCategoryId, subCategoryName) {
	    return Restangular.all('admin/categories').customPUT({ name: subCategoryName }, subCategoryId + '/sub');
	  };
	
	  var deleteCategory = function deleteCategory(id) {
	    return Restangular.all('admin/categories').customDELETE(id);
	  };
	
	  var deleteSubCategory = function deleteSubCategory(id) {
	    return Restangular.all('admin/categories').customDELETE(id + '/sub');
	  };
	
	  var index = function index(query) {
	    query = query || {};
	    query.deleted_at = 'null';
	    return ServiceAPI.getList(query);
	  };
	
	  var load = function load(query) {
	    return new Promise(function (resolve, reject) {
	      getFaqList(query).
	      then(function (response) {
	        var count = response[0];
	        index(query).
	        then(function (data) {
	          resolve({ count: count, data: data });
	        }).
	        catch(function (err) {
	          reject(err);
	        });
	      }).
	      catch(function (err) {
	        reject(err);
	      });
	    });
	  };
	
	  load(null);
	
	  var show = function show(id) {
	    return ServiceAPI.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    resource.deleted_at = moment();
	    return resource.save();
	  };
	
	  return { index: index, load: load, save: save, deleteCategory: deleteCategory, show: show, destroy: destroy, saveSubCategory: saveSubCategory, updateSubCategory: updateSubCategory, deleteSubCategory: deleteSubCategory };
	};
	
	FaqCategoryService.$inject = ['Restangular'];exports.default =
	
	FaqCategoryService;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _categories = __webpack_require__(816);var _categories2 = _interopRequireDefault(_categories);
	var _categoriesList = __webpack_require__(802);var _categoriesList2 = _interopRequireDefault(_categoriesList);
	var _categories3 = __webpack_require__(814);var _categories4 = _interopRequireDefault(_categories3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var categoriesModule = _angular2.default.module('categories', [
	_angularUiRouter2.default]).
	
	service('CategoriesService', _categories4.default).
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/categories');
	
	  $stateProvider.
	  state('categories', {
	    component: 'categories' }).
	
	  state('categories.list', {
	    url: '/categories',
	    component: 'categoriesList' });
	
	}]).
	component('categories', _categories2.default).
	component('categoriesList', _categoriesList2.default).
	name;exports.default =
	
	categoriesModule;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _categories = __webpack_require__(817);var _categories2 = _interopRequireDefault(_categories);
	var _categories3 = __webpack_require__(818);var _categories4 = _interopRequireDefault(_categories3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var categoriesComponent = {
	  bindings: {},
	  template: _categories2.default,
	  controller: _categories4.default };exports.default =
	
	
	categoriesComponent;

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var CategoriesController =
	function CategoriesController() {_classCallCheck(this, CategoriesController);
	  this.name = 'categories';
	};exports.default =
	
	
	CategoriesController;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _popUp = __webpack_require__(820);var _popUp2 = _interopRequireDefault(_popUp);
	var _popUpList = __webpack_require__(825);var _popUpList2 = _interopRequireDefault(_popUpList);
	var _popUpDetail = __webpack_require__(828);var _popUpDetail2 = _interopRequireDefault(_popUpDetail);
	var _popUp3 = __webpack_require__(833);var _popUp4 = _interopRequireDefault(_popUp3);
	var _notification = __webpack_require__(762);var _notification2 = _interopRequireDefault(_notification);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var popUpModule = _angular2.default.module('popUp', [
	_angularUiRouter2.default]).
	
	service('PopUp', _popUp4.default).
	service('NotificationService', _notification2.default).
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/pop-up');
	
	  $stateProvider.
	  state('pop-up', {
	    component: 'popUp' }).
	
	  state('pop-up.list', {
	    url: '/pop-up',
	    component: 'popUpList' }).
	
	  state('pop-up.create', {
	    url: '/pop-up/new',
	    component: 'popUpDetail' }).
	
	  state('pop-up.detail', {
	    url: '/pop-up/:id/detail',
	    component: 'popUpDetail',
	    params: {
	      id: "" } });
	
	
	}]).
	component('popUp', _popUp2.default).
	component('popUpList', _popUpList2.default).
	component('popUpDetail', _popUpDetail2.default).
	name;exports.default =
	
	popUpModule;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _popUp = __webpack_require__(821);var _popUp2 = _interopRequireDefault(_popUp);
	var _popUp3 = __webpack_require__(822);var _popUp4 = _interopRequireDefault(_popUp3);
	__webpack_require__(823);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var popUpComponent = {
	  bindings: {},
	  template: _popUp2.default,
	  controller: _popUp4.default };exports.default =
	
	
	popUpComponent;

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var PopUpController =
	function PopUpController() {_classCallCheck(this, PopUpController);
	  this.name = 'pop-up';
	};exports.default =
	
	
	PopUpController;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(824);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./pop-up.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./pop-up.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".version-form{display:flex;gap:20px;margin-top:22px}.content-regions{max-width:400px;width:100%;text-wrap:nowrap;text-overflow:ellipsis;overflow:hidden}.m-0{margin:0}.mr-68{margin-right:68px!important}.md-select-value.md-select-placeholder{height:34px}md-input-container>md-select{width:165px}", ""]);
	
	// exports


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _popUpList = __webpack_require__(826);var _popUpList2 = _interopRequireDefault(_popUpList);
	var _popUpList3 = __webpack_require__(827);var _popUpList4 = _interopRequireDefault(_popUpList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var popUpListComponent = {
	  bindings: {},
	  template: _popUpList2.default,
	  controller: _popUpList4.default };exports.default =
	
	
	popUpListComponent;

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div layout=\"row\" layout-align=\"space between\">\n        <div layout=\"row\">\n          <md-button class=\"md-raised md-accent mr-68\" ui-sref=\"pop-up.create\">\n              {{ 'common-new-pop-up' | translate }}\n          </md-button>\n\n          <md-input-container class=\"md-block m-0\" flex>\n            <label>\n              {{ 'common-state' | translate }}\n            </label>\n    \n            <md-select ng-model=\"$ctrl.filter.state_id\" ng-disabled=\"$ctrl.saving\"\n                       ng-change=\"$ctrl.onChangeFilter()\"\n                       name=\"state\" multiple md-on-close=\"$ctrl.clearSearch()\"\n                       md-container-class=\"selectdemoSelectHeader\">    \n              <md-option ng-repeat=\"state in $ctrl.states | filter:$ctrl.filterName\"\n                          ng-value=\"state.id\">\n                {{ state.name }}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-block m-0\" flex>\n            <label>\n              {{ 'common-city' | translate }}\n            </label>\n    \n            <md-select ng-model=\"$ctrl.filter.city_id\" ng-disabled=\"$ctrl.saving\"\n                       ng-change=\"$ctrl.onChangeCityFilter()\"\n                       name=\"state\" multiple md-on-close=\"$ctrl.clearSearch()\"\n                       md-container-class=\"selectdemoSelectHeader\">    \n              <md-option ng-repeat=\"city in $ctrl.cities | filter:$ctrl.filterCityName\"\n                          ng-value=\"city.id\">\n                {{ city.name }}\n              </md-option>\n            </md-select>\n          </md-input-container>\n\n          <md-input-container class=\"md-block m-0\" flex>\n            <label>\n              {{ 'common-status' | translate }}\n            </label>\n    \n            <md-select ng-model=\"$ctrl.filter.status\" ng-disabled=\"$ctrl.saving\"\n                       ng-change=\"$ctrl.onChangeFilter()\"\n                       name=\"region\" md-on-close=\"$ctrl.clearSearch()\"\n                       md-container-class=\"selectdemoSelectHeader\">\n                <md-option ng-value=\"true\">Habilitado</md-option>\n                <md-option ng-value=\"false\">Desabilitado</md-option>\n                <md-option ng-value=\"null\">Todos</md-option>\n            </md-select>\n          </md-input-container>\n        </div>\n\n        <md-card>\n            <div class=\"sb-table-search\">\n                <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n                </md-icon>\n\n                <input ng-model=\"$ctrl.filter.title\"\n                ng-change=\"$ctrl.onChangeFilter()\"\n                    ng-model-options=\"{ debounce: 1000 }\"\n                    type=\"text\" name=\"\">\n            </div>\n        </md-card>\n    </div>\n\n  <md-card\n    ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\"\n  >\n    <md-table-container>\n      <table md-table md-progress=\"$ctrl.promise\">\n        <thead md-head>\n          <tr md-row>\n            <th md-column>Título</th>\n            <th md-column>Status</th>\n            <th md-column>URL da imagem</th>\n            <th md-column>Regiões</th>\n            <th md-column class=\"sb-table-column-xs\"></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"item in $ctrl.resources.data\">\n            <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.detail(item.id)\">{{ item.title }}</td>\n\n            <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.detail(item.id)\">{{ item.status ? 'Habilitado' : 'Desabilitado' }}</td>\n\n            <td md-cell class=\"sb-table-truncate\" ng-click=\"$ctrl.detail(item.id)\">\n                {{ item.image_url }}\n            </td>\n\n            <td md-cell ng-click=\"$ctrl.detail(item.id)\">\n                <div class=\"content-regions\">\n                    {{ item.regions.join(\", \") }}\n                </div>\n            </td>\n\n            <td md-cell>\n              <md-button\n                aria-label=\"Toolbar menu\"\n                title=\"Editar\"\n                type=\"button\"\n                class=\"md-icon-button\"\n                ng-click=\"$ctrl.deletePopUp(item)\"\n              >\n              <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-delete\" class=\"mdi-24px\">\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n    <md-table-pagination \n        md-limit=\"10\"\n        md-page=\"$ctrl.filter.page\"\n        md-total=\"{{ $ctrl.filter.total }}\"\n        md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n        md-on-paginate=\"$ctrl.loadData\"\n        >\n    </md-table-pagination>\n  </md-card>\n\n  <div ng-show=\"$ctrl.uiState === 'EMPTY'\" class=\"sb-fill-parent\">\n    <div class=\"sb-empty-state sb-empty-state-text\" layout-align=\"center center\">\n      <p style=\"text-align: center;\">Não foram encontrados resultados.</p>\n    </div>\n  </div>\n\n  <div\n    ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.$scope.tableConfig.like_search\"\n    class=\"sb-fill-parent\"\n  >\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n      </div>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\" class=\"sb-fill-parent\">\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-error-message\">{{ 'common-load-error' | translate}}</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var PopUpListController = function PopUpListController(
	PopUp,
	$mdDialog,
	$filter,
	$scope,
	$state,
	State,
	City,
	Toast)
	{
	  DialogController.$inject = ["$scope", "$mdDialog"];
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	  _angular2.default.extend($ctrl, {
	    getRegionsListName: getRegionsListName,
	    onChangeFilter: onChangeFilter,
	    onChangeState: onChangeState });
	
	
	  activate();
	
	  function activate() {
	    State.index({ limit: 10000000000 }).then(function (result) {
	      $ctrl.states = result;
	    });
	
	    $ctrl.states = [];
	    $ctrl.cities = [];
	    $ctrl.filterName = "";
	    $ctrl.filterCityName = "";
	    $ctrl.selectedRegion = "";
	    $ctrl.filter = {
	      status: null,
	      state_id: [],
	      city_id: [],
	      title: "",
	      page: 1,
	      total: 0 };
	
	    $ctrl.statusList = [
	    {
	      value: true,
	      label: 'Habilitado' }];
	
	
	    $ctrl.uiState = "LOADING";
	
	    $ctrl.promise;
	
	    $ctrl.$scope.tableConfig = {
	      page: 1,
	      limit: 10,
	      order: "updated_at" };
	
	
	    $ctrl.$scope.$watch(
	    "tableConfig",
	    function () {
	      $ctrl.loadData();
	    },
	    true);
	
	  }
	
	  function getRegionsListName(group) {
	    var newList = [];
	    group.forEach(function (item) {
	      item.regions.forEach(function (region) {
	        newList.push(region.name + " - " + item.state);
	      });
	    });
	
	    return newList.join(", ");
	  }
	
	  function onChangeFilter() {
	    $ctrl.loadData();
	    onChangeState($ctrl.filter.state_id);
	  }
	
	  function onChangeCityFilter() {
	    $ctrl.loadData();
	  }
	
	  function onChangeState(stateIdArr) {
	    if (stateIdArr.length !== 0) {
	      $ctrl.filter.city_id = [];
	      City.index({
	        state_id: stateIdArr,
	        limit: 1000000 }).
	
	      then(function (cities) {
	        $ctrl.cities = cities;
	      }).
	      catch(function (err) {
	        console.log("err:", err);
	        $ctrl.loadingCities = false;
	      }).
	      finally(function () {
	        _angular2.default.
	        element(document.querySelector(".input-search-city")).
	        on("keydown", function (ev) {
	          ev.stopPropagation();
	        });
	      });
	    }
	  }
	
	  function DialogController($scope, $mdDialog) {
	    "ngInject";
	    $scope.loadingText = "Carregando";
	    $scope.notification = {
	      version: $ctrl.notification.version,
	      platform: $ctrl.notification.platform,
	      isForced: $ctrl.notification.isForced };
	
	
	    $scope.hide = function () {
	      _angular2.default.element(document.querySelector("#fileInput")).val(undefined);
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      _angular2.default.element(document.querySelector("#fileInput")).val(undefined);
	      $mdDialog.cancel();
	    };
	
	    $scope.save = function (resource) {
	      $mdDialog.hide(resource);
	    };
	  }
	
	  // Local functions
	
	  $ctrl.loadData = function () {
	    $ctrl.promise = PopUp.getpopUpsList($ctrl.filter).
	    then(function (response) {
	      $ctrl.resources = _angular2.default.copy(response);
	      $ctrl.filter.page = response.page;
	      $ctrl.filter.total = response.total;
	      $ctrl.uiState = response.data.length ? "COMPLETE" : "EMPTY";
	    }).
	    catch(function (err) {
	      $ctrl.uiState = "ERROR";
	    });
	  };
	
	  function getRegionsList() {
	    $ctrl.uiState = "LOADING";
	    $ctrl.promise = PopUp.getRegionsList().
	    then(function (response) {
	      response.forEach(function (item) {
	        item.regions.forEach(function (region) {
	          $ctrl.regionsList.push({ name: region.name + " - " + item.state, id: region.id });
	        });
	        $ctrl.uiState = response.data.length ? "COMPLETE" : "EMPTY";
	      });
	    }).
	    catch(function (err) {
	      $ctrl.uiState = "ERROR";
	    });
	  }
	
	  function saveData(resource) {
	    $ctrl.promise = PopUp.save(resource).
	    then(function (response) {
	      $ctrl.loadData();
	    }).
	    catch(function (err) {
	      $ctrl.uiState = "ERROR";
	    }).
	    finally(function () {
	      $ctrl.notification = {
	        version: null,
	        plataform: "",
	        isForced: false };
	
	    });
	  }
	
	  $ctrl.deletePopUp = function (popUp) {
	    var confirm = $mdDialog.confirm().
	    textContent("Remover pop-up \"" + popUp.title + "\"").
	    ariaLabel("Remover pop-up \"" + popUp.title + "\"").
	    targetEvent(event).
	    ok($filter('translate')('common-yes')).
	    cancel($filter('translate')('common-cancel'));
	
	    $mdDialog.show(confirm).
	    then(function () {
	      PopUp.
	      destroy(popUp).
	      then(function (response) {
	        Toast.success($filter('translate')('common-detail-delete-success'));
	        $ctrl.loadData();
	      }).
	      catch(function (err) {
	        Toast.error($filter('translate')('common-server-error'));
	      });
	    }).
	    catch(function () {
	    });
	  };
	
	  $ctrl.detail = function (id) {
	    $state.go('pop-up.detail', { id: id });
	  };
	};
	
	PopUpListController.$inject = [
	"PopUp",
	"$mdDialog",
	"$filter",
	"$scope",
	"$state",
	"State",
	"City",
	"Toast"];exports.default =
	
	
	PopUpListController;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _popUpDetail = __webpack_require__(829);var _popUpDetail2 = _interopRequireDefault(_popUpDetail);
	var _popUpDetail3 = __webpack_require__(830);var _popUpDetail4 = _interopRequireDefault(_popUpDetail3);
	__webpack_require__(831);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var popUpDetailComponent = {
	  bindings: {},
	  template: _popUpDetail2.default,
	  controller: _popUpDetail4.default };exports.default =
	
	
	popUpDetailComponent;

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div class=\"sb-content sb-news\">\n    <div layout=\"row\">\n      <div flex=\"100\" class=\"layout-padding\">\n        <span class=\"sb-page-section-title\">\n            Detalhes do pop-up\n        </span>\n        <p class=\"sb-page-section-sub-title\">\n            Preencha os dados conforme os campos abaixo\n        </p>\n        <md-input-container class=\"md-block\" flex>\n            <label>Título do pop-up</label>\n            <input ng-model=\"$ctrl.campaignPopUp.title\" name=\"title\"\n                    required>\n            </input>\n        </md-input-container>\n\n        <div>\n            <div>Status do pop-up</div>\n            <md-switch ng-model=\"$ctrl.campaignPopUp.status\" aria-label=\"Status\">\n                Status\n              </md-switch>\n        </div>\n\n        <md-input-container class=\"md-block\" flex>\n            <label>URL da imagem do pop-up</label>\n            <input ng-model=\"$ctrl.campaignPopUp.image_url\" name=\"title\"\n                   required>\n            </input>\n        </md-input-container>\n\n        <div class=\"title-filter\" layout=\"row\" flex>\n          <label style=\"font-weight: 500;\">{{ 'notification-detail-filer-public' | translate }}</label>\n        </div>\n        <div layout=\"row\">\n          <md-input-container class=\"md-block\" flex>\n            <label> {{ 'common-type-region' | translate }} </label>\n\n            <md-select\n              ng-model=\"$ctrl.campaignPopUp.only_vaccine_regions\"\n              ng-change=\"$ctrl.onChangeRegionType()\"\n              name=\"typeRegion\"\n              md-on-close=\"$ctrl.clearSearch()\"\n              md-container-class=\"selectdemoSelectHeader\"\n              ng-disabled=\"$ctrl.disableSelect()\"\n            >\n              <md-option\n                ng-repeat=\"type in $ctrl.regionTypes\"\n                ng-value=\"type.value\"\n              >\n                {{ type.text }}\n              </md-option>\n            </md-select>\n          </md-input-container>\n        </div>\n        <div layout=\"row\">\n          <md-input-container class=\"md-block\" flex>\n            <label> {{ $ctrl.campaignPopUp.only_vaccine_regions === null ? ('common-state' | translate) : 'Não se aplica' }} </label>\n            <md-select\n              ng-model=\"$ctrl.filter.state_id\"\n              ng-change=\"$ctrl.onChangeState($ctrl.filter.state_id, true)\"\n              name=\"state\"\n              multiple\n              md-on-close=\"$ctrl.clearSearch()\"\n              md-container-class=\"selectdemoSelectHeader\"\n              ng-disabled=\"$ctrl.disableSelect() || $ctrl.disabledFilterStateCities\"\n            >\n              <md-select-header layout=\"column\" class=\"demo-select-header\">\n                <md-input-container class=\"md-block\" flex>\n                  <input\n                    ng-model=\"$ctrl.searchState\"\n                    type=\"text\"\n                    ng-model-options=\"{debounce: {'default': 250, 'blur': 0}}\"\n                    ng-change=\"$ctrl.filterContent($ctrl.searchState, 'states')\"\n                    class=\"md-text input-search-state\"\n                    placeholder=\"Buscar estados\"\n                  />\n                </md-input-container>\n              </md-select-header>\n\n              <md-optgroup label=\"state\">\n                <md-option\n                  ng-value=\"null\"\n                  ng-click=\"$ctrl.setListContent(null, $ctrl.selectedStates)\"\n                >\n                  {{ 'common-all-masculine' | translate }}\n                </md-option>\n\n                <md-option\n                  ng-selected=\"$ctrl.filter.state_id.includes(state.id.toString())\n                                && !$ctrl.filter.state_id.includes(null)\"\n                  ng-click=\"$ctrl.setListContent(state.name, $ctrl.selectedStates)\"\n                  ng-disabled=\"$ctrl.filter.state_id.includes(null)\"\n                  ng-repeat=\"state in $ctrl.states\"\n                  ng-value=\"state.id.toString()\"\n                >\n                  {{ state.name }}\n                </md-option>\n              </md-optgroup>\n            </md-select>\n\n            <div ng-messages=\"notificationForm.state.$error\" multiple>\n              <div ng-message=\"required\">\n                {{ 'form-error-required-field' | translate}}\n              </div>\n            </div>\n          </md-input-container>\n          <md-input-container class=\"md-block\" flex>\n            <label>{{ $ctrl.campaignPopUp.only_vaccine_regions === null ? ('common-city' | translate) : 'Não se aplica' }} </label>\n\n            <md-select\n              ng-model=\"$ctrl.filter.city_id\"\n              name=\"city\"\n              multiple\n              md-on-close=\"$ctrl.clearSearch()\"\n              md-container-class=\"selectdemoSelectHeader\"\n              ng-disabled=\"$ctrl.disabledFilterStateCities\"\n            >\n              <md-select-header layout=\"column\" class=\"demo-select-header\">\n                <md-input-container class=\"md-block\" flex>\n                  <input\n                    ng-model=\"$ctrl.search\"\n                    type=\"text\"\n                    ng-model-options=\"{debounce: {'default': 250, 'blur': 0}}\"\n                    class=\"demo-header-searchbox md-text input-search-city\"\n                    ng-change=\"$ctrl.filterContent($ctrl.search, 'cities')\"\n                    placeholder=\"Buscar cidades\"\n                  />\n                </md-input-container>\n              </md-select-header>\n\n              <md-optgroup label=\"city\">\n                <md-option\n                  ng-value=\"null\"\n                  ng-click=\"$ctrl.setListContent(null, $ctrl.selectedCities)\"\n                >\n                  {{ 'common-all-masculine' | translate }}\n                </md-option>\n\n                <md-option\n                  ng-selected=\"$ctrl.filter.city_id.includes(city.id.toString()) \n                                && !$ctrl.filter.city_id.includes(null)\"\n                  ng-disabled=\"$ctrl.filter.city_id.includes(null)\"\n                  ng-click=\"$ctrl.setListContent(city.name, $ctrl.selectedCities)\"\n                  ng-repeat=\"city in $ctrl.cities\"\n                  ng-value=\"city.id.toString()\"\n                  >{{ city.name }}\n                </md-option>\n              </md-optgroup>\n            </md-select>\n\n            <div ng-messages=\"notificationForm.city.$error\" multiple>\n              <div ng-message=\"required\">\n                {{ 'form-error-required-field' | translate}}\n              </div>\n            </div>\n          </md-input-container>\n        </div>\n\n        <div ng-if=\"$ctrl.filter.state_id.length\">\n          <div>Total de Estados: <span><strong>{{ $ctrl.filter.state_id.includes(null) ? \"Todos\" : $ctrl.filter.state_id.length }}</strong></span></div>\n          <div ng-if=\"!$ctrl.filter.state_id.includes(null)\"><strong>{{ $ctrl.getStateNames() }}</strong></div>\n        </div>\n\n        <div ng-if=\"$ctrl.filter.city_id.length\">\n          <div>Total de Cidades: <span><strong>{{$ctrl.filter.city_id.includes(null) ? \"Todas\" : $ctrl.filter.city_id.length }}</strong></span></div>\n          <div ng-if=\"!$ctrl.filter.city_id.includes(null)\"><strong>{{ $ctrl.getCitiesNames() }}</strong></div>\n        </div>\n\n        <div>\n        <md-input-container class=\"md-block\" flex>\n            <label>URL de destino ao tocar no pop-up</label>\n            <input ng-model=\"$ctrl.campaignPopUp.url_campaign\" name=\"title\"\n                   required>\n            </input>\n        </md-input-container>\n      </div>\n      <div\n      layout=\"row\"\n      layout-align=\"end center\"\n      flex\n      class=\"sb-form-actions after-card\"\n    >\n      <md-button page-back>\n        {{ 'common-cancel-button-text' | translate }}\n      </md-button>\n  \n      <md-button\n        ng-if=\"$ctrl.id\"\n        ng-click=\"$ctrl.deletePopUp()\"\n        class=\"md-warn md-raised\"\n      >\n        {{ 'common-delete-button-text' | translate }}\n      </md-button>\n  \n      <md-button\n          ng-click=\"$ctrl.saveData()\"\n        class=\"md-accent md-raised\"\n      >\n        {{ 'common-save-button-text' | translate }}\n      </md-button>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var PopUpListController = function PopUpListController(
	PopUp,
	NotificationService,
	$mdDialog,
	$filter,
	$scope,
	$state,
	State,
	City,
	Toast)
	{
	  var $ctrl = this;
	  _angular2.default.extend($ctrl, {
	    onChangeRegionType: onChangeRegionType,
	    onChangeState: onChangeState,
	    filterContent: filterContent,
	    setListContent: setListContent });
	
	
	  $ctrl.states = [];
	  $ctrl.cities = [];
	  $ctrl.filter = {};
	  $ctrl.allSelected = false;
	  $ctrl.original = {
	    states: [],
	    cities: [] };
	
	  $ctrl.regionTypes = [
	  { text: "Todas", value: null },
	  { text: "Com vacinas", value: true },
	  { text: "Não possuem vacinas", value: false }];
	
	
	  function filterContent(query, type) {
	    var filtered = [];
	
	    if (query) {
	      filtered = $ctrl.original[type].filter(function (_ref) {var name = _ref.name;
	        name = name.toLowerCase();
	        return (
	          name.includes(query) ||
	          name.
	          normalize("NFD").
	          replace(/[\u0300-\u036f]/g, "").
	          includes(query));
	
	      });
	    }
	
	    $ctrl[type] = query ? filtered : $ctrl.original[type];
	  }
	
	  function onChangeRegionType() {
	    $ctrl.filter.state_id = [];
	    $ctrl.selectedStates = [];
	    $ctrl.selectedCities = [];
	    $ctrl.filter.city_id = [];
	    $ctrl.disabledFilterStateCities =
	    $ctrl.campaignPopUp.only_vaccine_regions !== null;
	  }
	
	  function loadDomainResources() {
	    $ctrl.uiState = "LOADING";
	
	    var promises = [];
	    promises.push(State.index({ limit: 10000000000 }));
	
	    return Promise.all(promises);
	  }
	
	  activate();
	
	  function loadResource() {
	    $ctrl.id = $state.params.id;
	
	    loadDomainResources().
	    then(function (result) {
	      $ctrl.states = result[0];
	      if ($ctrl.id) {
	        $ctrl.uiState = "LOADING";
	        PopUp.show($ctrl.id).
	        then(function (response) {
	          $ctrl.campaignPopUp = _angular2.default.copy(response);
	          if (response.state_id) {
	            onChangeState(response.state_id);
	          }
	          $ctrl.filter = {
	            state_id: response.state_id === null ? null : response.state_id,
	            city_id: response.city_id === null ? null : response.city_id };
	
	          if (response.city_id.length) {
	            $ctrl.filter.city_id = response.city_id.map(function (id) {return (
	                id.toString());});
	
	          }
	
	          if (response.state_id.length)
	          $ctrl.campaignPopUp.only_vaccine_regions = null;
	          $ctrl.uiState = "COMPLETE";
	        }).
	        catch(function (err) {
	          $ctrl.uiState = "ERROR";
	        });
	      } else {
	        $ctrl.campaignPopUp = {
	          title: "",
	          status: true,
	          image_url: "",
	          url_campaign: "",
	          only_vaccine_regions: null };
	
	      }
	    }).
	    catch(function (err) {
	      console.log("err:", err);
	      $ctrl.uiState = "ERROR";
	    });
	  }
	
	  function onChangeState(stateIdArr) {var clearCities = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    if (stateIdArr.length !== 0) {
	      var lastPosition = stateIdArr.length - 1;
	      if (
	      stateIdArr.includes(null) &&
	      stateIdArr[lastPosition] === null &&
	      lastPosition !== 0)
	      {
	        $ctrl.filter.state_id = [null];
	        $ctrl.filter.city_id = [null];
	        return;
	      } else if (stateIdArr[0] === null && stateIdArr.length > 1) {
	        stateIdArr.split(0, 1);
	      }
	      $ctrl.loadingCities = true;
	      City.index({
	        state_id: stateIdArr,
	        limit: 1000000 }).
	
	      then(function (cities) {
	        $ctrl.cities = cities;
	        $ctrl.original.cities = cities;
	        $ctrl.selectedCities = [];
	        $ctrl.loadingCities = false;
	      }).
	      catch(function (err) {
	        console.log("err:", err);
	        $ctrl.loadingCities = false;
	      }).
	      finally(function () {
	        _angular2.default.
	        element(document.querySelector(".input-search-city")).
	        on("keydown", function (ev) {
	          ev.stopPropagation();
	        });
	      });
	    }
	
	    if (clearCities) {
	      $ctrl.search = "";
	      $ctrl.filter.city_id = null;
	      $ctrl.cities = [];
	    }
	  }
	
	  function setListContent(name, list) {
	    if (name) {
	      var idx = list.findIndex(function (city) {
	        return name === city;
	      });
	
	      if (idx >= 0) {
	        list.splice(idx, 1);
	      } else {
	        list.push(name);
	      }
	    } else {
	      list.length = 0;
	    }
	  }
	
	  function activate() {
	    loadResource();
	    $ctrl.promise;
	  }
	
	  $ctrl.saveData = function () {
	    var data = _angular2.default.extend($ctrl.campaignPopUp, $ctrl.filter);
	    if (data.only_vaccine_regions === null) delete data.only_vaccine_regions;
	    if (data.state_id && data.state_id.length && data.state_id.includes(null)) {
	      data.state_id = null;
	    }
	
	    if (data.city_id && data.city_id.length) {
	      if (data.city_id.includes(null)) data.city_id = null;else
	      {
	        var listId = data.city_id.map(function (id) {
	          return Number(id);
	        });
	        data.city_id = listId;
	      }
	    }
	    $ctrl.promise = PopUp.save(data).
	    then(function (response) {
	      $state.go("pop-up.list");
	    }).
	    catch(function (err) {
	      if (err.status === 400) {
	        var complement = "";
	        Toast.error("J\xE1 existe um banner ativo para " + complement);
	      }
	    });
	  };
	
	  $ctrl.deletePopUp = function () {
	    var confirm = $mdDialog.
	    confirm().
	    textContent("Remover pop-up \"" + $ctrl.campaignPopUp.title + "\"").
	    ariaLabel("Remover pop-up \"" + $ctrl.campaignPopUp.title + "\"").
	    targetEvent(event).
	    ok($filter("translate")("common-yes")).
	    cancel($filter("translate")("common-cancel"));
	
	    $mdDialog.
	    show(confirm).
	    then(function () {
	      $ctrl.deleting = true;
	      PopUp.destroy($ctrl.campaignPopUp).
	      then(function (response) {
	        Toast.success($filter("translate")("common-detail-delete-success"));
	        $state.go("pop-up.list");
	      }).
	      catch(function (err) {
	        Toast.error($filter("translate")("common-server-error"));
	      });
	    }).
	    catch(function () {});
	  };
	
	  $ctrl.getStateNames = function () {
	    var map = $ctrl.filter.state_id.map(function (_id) {
	      var idx = $ctrl.states.findIndex(function (_ref2) {var id = _ref2.id;return _id.toString() === id.toString();});
	      if (idx > -1) return $ctrl.states[idx].name;else
	      return "";
	    });
	    return map.join(", ");
	  };
	
	
	  $ctrl.getCitiesNames = function () {
	    var map = $ctrl.filter.city_id.map(function (_id) {
	      var idx = $ctrl.cities.findIndex(function (_ref3) {var id = _ref3.id;return _id.toString() === id.toString();});
	      if (idx > -1) return $ctrl.cities[idx].name;else
	      return "";
	    });
	    return map.join(", ");
	  };
	
	
	  $ctrl.toggle = function (id) {
	    var idx = $ctrl.campaignPopUp.regions.indexOf(id);
	    if (idx > -1) {
	      $ctrl.campaignPopUp.regions.splice(idx, 1);
	    } else {
	      $ctrl.campaignPopUp.regions.push(id);
	    }
	  };
	
	  $ctrl.exists = function (id) {
	    return $ctrl.campaignPopUp.regions.indexOf(id) > -1;
	  };
	
	  $ctrl.allRegions = function () {
	    $ctrl.allSelected = !$ctrl.allSelected;
	    $ctrl.campaignPopUp.regions = [];
	  };
	};
	PopUpListController.$inject = [
	"PopUp",
	"NotificationService",
	"$mdDialog",
	"$filter",
	"$scope",
	"$state",
	"State",
	"City",
	"Toast"];exports.default =
	
	
	PopUpListController;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(832);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./pop-up-detail.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./pop-up-detail.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".regions-content{margin-top:30px;max-width:279px;width:100%;border:1px solid #000;padding:13px 18px;overflow-y:auto;height:100%;max-height:259px}.region-item{padding:10px 0}.md-input-has-value{margin-top:8px!important}", ""]);
	
	// exports


/***/ }),
/* 833 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var PopUpService = function PopUpService(Restangular) {
	  var ServiceAPI = Restangular.all('v2/admin/campaign_popups');
	
	  var getpopUpsList = function getpopUpsList(query) {
	    return ServiceAPI.customGET("", query);
	  };
	
	  var getRegionsList = function getRegionsList() {
	    return ServiceAPI.customGET('regions');
	  };
	
	  var save = function save(resource) {
	    if (resource.id) {
	      var copyData = angular.copy(resource);
	      delete copyData.id;
	      return ServiceAPI.customPUT(copyData, resource.id);
	    } else {
	      return ServiceAPI.post(resource);
	    }
	  };
	
	  var show = function show(id) {
	    return ServiceAPI.get(id);
	  };
	
	  var destroy = function destroy(resource) {
	    return ServiceAPI.customDELETE(resource.id);
	  };
	
	  return { getpopUpsList: getpopUpsList, getRegionsList: getRegionsList, save: save, show: show, destroy: destroy };
	};
	
	PopUpService.$inject = ['Restangular'];exports.default =
	
	PopUpService;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);
	var _angularUiRouter = __webpack_require__(341);var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	var _timeTitle = __webpack_require__(835);var _timeTitle2 = _interopRequireDefault(_timeTitle);
	var _timeTitleList = __webpack_require__(840);var _timeTitleList2 = _interopRequireDefault(_timeTitleList);
	var _timeTitle3 = __webpack_require__(647);var _timeTitle4 = _interopRequireDefault(_timeTitle3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var titleModule = _angular2.default.
	module("time-title", [_angularUiRouter2.default]).
	
	service("TimeTitleService", _timeTitle4.default).
	config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise("/login");
	  $stateProvider.
	  state("time-title", {
	    component: "timeTitle" }).
	
	  state("time-title.list", {
	    url: "/time-title",
	    component: "timeTitleList" });
	
	}]).
	
	component("timeTitle", _timeTitle2.default).
	component("timeTitleList", _timeTitleList2.default).
	name;exports.default =
	
	titleModule;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _timeTitle = __webpack_require__(836);var _timeTitle2 = _interopRequireDefault(_timeTitle);
	var _timeTitle3 = __webpack_require__(837);var _timeTitle4 = _interopRequireDefault(_timeTitle3);
	__webpack_require__(838);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var titleComponent = {
	  bindings: {},
	  template: _timeTitle2.default,
	  controller: _timeTitle4.default };exports.default =
	
	
	titleComponent;

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	module.exports = "<ui-view></ui-view>"

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var TimeTitleController =
	function TimeTitleController() {_classCallCheck(this, TimeTitleController);
	  this.name = 'time-title';
	};exports.default =
	
	
	TimeTitleController;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(839);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./time-title.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./time-title.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	
	
	// module
	exports.push([module.id, ".title-name{color:#ff3b30;font-size:16px;font-weight:700;padding-top:13px}h4{margin-bottom:0}.subtitle{font-size:14px;color:#9b9b9b}", ""]);
	
	// exports


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _timeTitleList = __webpack_require__(841);var _timeTitleList2 = _interopRequireDefault(_timeTitleList);
	var _timeTitleList3 = __webpack_require__(842);var _timeTitleList4 = _interopRequireDefault(_timeTitleList3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var timeTitleListComponent = {
	  bindings: {},
	  template: _timeTitleList2.default,
	  controller: _timeTitleList4.default };exports.default =
	
	
	timeTitleListComponent;

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"sb-content-container\">\n  <div\n    layout=\"row\"\n    layout-align=\"space between\"\n    ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE' || ($ctrl.uiState === 'EMPTY' && $ctrl.tableConfig.like_search)\"\n  >\n    <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.modalTitle()\">\n      Novo Título\n    </md-button>\n\n    <md-card>\n      <div class=\"sb-table-search\">\n        <md-icon md-font-set=\"mdi\" md-font-icon=\"mdi-magnify\" class=\"mdi-24px\">\n        </md-icon>\n\n        <input\n          ng-model=\"$ctrl.filter.title\"\n          ng-model-options=\"{ debounce: 500 }\"\n          type=\"text\"\n          ng-change=\"$ctrl.getTimeTitleList()\"\n        />\n      </div>\n    </md-card>\n  </div>\n\n  <md-card\n    ng-show=\"$ctrl.uiState === 'LOADING' || $ctrl.uiState === 'COMPLETE'\"\n  >\n    <md-table-container>\n      <table md-table md-progress=\"$ctrl.promise\">\n        <thead md-head>\n          <tr md-row>\n            <th\n              md-column\n              md-order-by=\"title\"\n              ng-click=\"$ctrl.orderList('title')\"\n            >\n              {{ 'common-title' | translate }}\n            </th>\n            <th style=\"width: 135px\"></th>\n          </tr>\n        </thead>\n        <tbody md-body>\n          <tr md-row ng-repeat=\"item in $ctrl.timeTitles\">\n            <td md-cell class=\"sb-table-truncate\">{{ item.title }}</td>\n\n            <td md-cell>\n              <md-button\n                title=\"Editar\"\n                type=\"button\"\n                class=\"md-icon-button\"\n                ng-click=\"$ctrl.modalTitle(item)\"\n              >\n                <md-icon\n                  md-font-set=\"mdi\"\n                  md-font-icon=\"mdi-pencil\"\n                  class=\"mdi-24px\"\n                />\n              </md-button>\n              <md-button\n                title=\"Excluir\"\n                type=\"button\"\n                class=\"md-icon-button\"\n                ng-click=\"$ctrl.removeTitle(item)\"\n              >\n                <md-icon\n                  md-font-set=\"mdi\"\n                  md-font-icon=\"mdi-delete\"\n                  class=\"mdi-24px\"\n                >\n                </md-icon>\n              </md-button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </md-table-container>\n\n    <md-table-pagination\n      md-limit=\"$ctrl.filter.limit\"\n      md-page=\"$ctrl.filter.page\"\n      md-total=\"{{ $ctrl.totalItems }}\"\n      md-label=\"{{ {of: 'de', page: 'Página', rowsPerPage: 'Linhas por página'} }}\"\n      md-on-paginate=\"$ctrl.getTimeTitleList\"\n    >\n    </md-table-pagination>\n  </md-card>\n\n  <div\n    ng-show=\"$ctrl.uiState === 'EMPTY' && !$ctrl.tableConfig.like_search\"\n    class=\"sb-fill-parent\"\n  >\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <img src=\"assets/empty_news.png\" />\n\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'notification-list-empty-state-line-1' | translate }}</p>\n        <p>{{ 'notification-list-empty-state-line-2' | translate }}</p>\n      </div>\n\n      <md-button class=\"md-raised md-accent\" ui-sref=\"notification.create\">\n        {{ 'notification-list-create-notification-button' | translate }}\n      </md-button>\n    </div>\n  </div>\n\n  <div\n    ng-show=\"$ctrl.uiState === 'EMPTY' && $ctrl.filter.title\"\n    class=\"sb-fill-parent\"\n  >\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-empty-state-text\">\n        <p>{{ 'list-empty-search-state-line-1' | translate }}</p>\n      </div>\n    </div>\n  </div>\n\n  <div ng-show=\"$ctrl.uiState === 'ERROR'\" class=\"sb-fill-parent\">\n    <div\n      class=\"sb-absolute-center sb-empty-state\"\n      layout=\"column\"\n      layout-align=\"center center\"\n    >\n      <div class=\"sb-error-message\">{{ 'common-load-error' | translate}}</div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports, "__esModule", { value: true });var _angular = __webpack_require__(333);var _angular2 = _interopRequireDefault(_angular);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var TimeTitleListController = function TimeTitleListController(
	TimeTitleService,
	$mdDialog,
	$filter,
	$scope,
	$state,
	Toast)
	{
	  DialogController.$inject = ["$scope", "$mdDialog", "data"];
	  var $ctrl = this;
	  $ctrl.$scope = $scope;
	  _angular2.default.extend($ctrl, {
	    getTimeTitleList: getTimeTitleList,
	    modalTitle: modalTitle,
	    removeTitle: removeTitle });
	
	
	  activate();
	
	  function activate() {
	    $ctrl.promise;
	    $ctrl.timeTitles = [];
	    $ctrl.totalItems = 0;
	    $ctrl.filter = {
	      limit: 10,
	      page: 1,
	      title: "" };
	
	    getTimeTitleList();
	  }
	
	  function getTimeTitleList() {
	    var filter = _angular2.default.copy($ctrl.filter);
	    if (!$ctrl.filter.title) delete filter.title;
	    $ctrl.uiState = "LOADING";
	    $ctrl.promise = TimeTitleService.getTimeTitleList(filter).
	    then(function (response) {
	      $ctrl.timeTitles = _angular2.default.copy(response.data);
	      $ctrl.totalItems = response.total;
	    }).
	    catch(function (err) {}).
	    finally(function () {
	      $ctrl.uiState = "COMPLETE";
	    });
	  }
	
	  function modalTitle() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    $mdDialog.
	    show({
	      controller: DialogController,
	      template:
	      '<md-dialog aria-label="Version dialog" style="width: 400px; padding: 24px;">' +
	      "  <md-dialog-content>" +
	      "     <h4><strong>Título de horário de funcionamento</strong></h4>" +
	      "     <div>Insira o título do horário de funcionamento</div>" +
	      '     <div style="padding-top: 24px;">' +
	      '       <md-input-container class="md-block" flex style="width: 99%;">' +
	      "       <label>Título do horário*</label>" +
	      '       <input ng-model="data.title" name="title">' +
	      "      </md-input-container>" +
	      "     </div>" +
	      "     <div> </div>" +
	      "</md-dialog-content>" +
	      "<md-dialog-actions>" +
	      '  <md-button ng-click="cancel()">Cancelar</md-button>' +
	      '  <md-button ng-click="save()" ng-disabled="!data.title || loading" class="md-raised md-accent">Salvar</md-button>' +
	      "  </md-dialog-actions>" +
	      "</md-dialog>",
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      locals: { data: data },
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(
	    function () {
	      getTimeTitleList();
	    },
	    function () {});
	
	  }
	
	  function removeTitle(data) {
	    $mdDialog.
	    show({
	      controller: DialogController,
	      template:
	      '<md-dialog aria-label="Version dialog" style="width: 400px; padding: 24px;">' +
	      "  <md-dialog-content>" +
	      "     <h4><strong>Excluir título de horário de funcionamento</strong></h4>" +
	      "     <div class='subtitle'>Tem certeza que deseja excluir este título?</div>" +
	      '     <div class="title-name">{{data.title}}</div' +
	      "</md-dialog-content>" +
	      "<md-dialog-actions>" +
	      '  <md-button ng-click="cancel()">Cancelar</md-button>' +
	      '  <md-button ng-click="delete()" ng-disabled="!data.title || loading" class="md-raised md-accent">Excluir</md-button>' +
	      "  </md-dialog-actions>" +
	      "</md-dialog>",
	      bindToController: true,
	      parent: _angular2.default.element(document.body),
	      locals: { data: data },
	      clickOutsideToClose: true,
	      fullscreen: false }).
	
	    then(
	    function () {
	      getTimeTitleList();
	    },
	    function () {});
	
	  }
	
	  function DialogController($scope, $mdDialog, data) {
	    "ngInject";
	    $scope.data = {
	      title: "" };
	
	    if (data) {
	      $scope.data = _angular2.default.copy(data);
	    }
	    $scope.loading = false;
	
	    $scope.hide = function () {
	      $mdDialog.hide();
	    };
	
	    $scope.cancel = function () {
	      $mdDialog.cancel();
	    };
	
	    $scope.delete = function () {
	      $scope.loading = true;
	      $ctrl.promise = TimeTitleService.destroy($scope.data).
	      then(function () {
	        $mdDialog.hide();
	      }).
	      catch(function (err) {}).
	      finally(function () {
	        $scope.loading = false;
	      });
	    };
	
	    $scope.save = function () {
	      $scope.loading = true;
	      $ctrl.promise = TimeTitleService.save($scope.data).
	      then(function (response) {
	        $mdDialog.hide();
	      }).
	      catch(function (err) {}).
	      finally(function () {
	        $scope.loading = false;
	      });
	    };
	  }
	};
	
	TimeTitleListController.$inject = [
	"TimeTitleService",
	"$mdDialog",
	"$filter",
	"$scope",
	"$state",
	"Toast"];exports.default =
	
	
	TimeTitleListController;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _app = __webpack_require__(844);var _app2 = _interopRequireDefault(_app);
	__webpack_require__(845);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var appComponent = {
	  template: _app2.default };exports.default =
	
	
	appComponent;

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\">\n  <shell></shell>\n</div>\n"

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(846);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(446)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(445)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);
	
	// module
	exports.push([module.id, "body{height:100%}h1,h2,h3,h4,h5,h6{font-weight:400}.sb-fill-height,div[ui-view]{height:100%}.sb-fill-parent{position:relative;width:100%;height:100%}.sb-absolute-center{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.sb-no-margin{margin:0}.sb-content-container{max-width:1200px;height:100%;margin:auto}md-toast.md-success-toast-theme .md-toast-content{background-color:#43a047}md-toast.md-error-toast-theme .md-toast-content{background-color:#f44336}[ng-click]:hover{cursor:pointer}*{outline:none}table.md-table th.md-column.md-active md-icon.md-sort-icon,table.md-table th.md-column:hover md-icon.md-sort-icon{height:12px;min-height:12px}.sb-empty-state .sb-empty-state-text{text-align:center;margin:16px 0 24px}.sb-empty-state .sb-empty-state-text p{margin:2px 0;font-size:14px;color:rgba(0,0,0,.4)}.sb-empty-state .md-button{padding:0 16px}.sb-page-section{margin-bottom:32px}.sb-page-section .sb-page-section-sub-title,.sb-page-section .sb-page-section-title{margin-left:16px}.sb-page-section md-card{padding:16px}.sb-page-section-title{margin-top:0;margin-bottom:8px;font-weight:600;text-transform:uppercase;color:rgba(0,0,0,.72);font-size:14px}.sb-page-section-sub-title{font-size:14px;color:rgba(0,0,0,.48);margin:0 0 16px}tr:not([sb-disabled=true])[ng-click]:hover,tr[ng-click]:hover{cursor:pointer;background:rgba(0,0,0,.12);transition:background .5s linear}.sb-checkboxes .sb-section-title{color:rgba(0,0,0,.56);font-weight:600;margin:32px 0 0}.sb-checkboxes md-checkbox{margin:0;padding:16px;width:280px;flex:0 0 auto;font-size:14px}.sb-table-search{padding:4px 8px 0}.sb-table-search input{border:0;font-size:14px;color:rgba(0,0,0,.64)}label[for=fileInput] div.sb-avatar-input{height:200px;width:200px;border:1px solid rgba(0,0,0,.12);background-color:rgba(0,0,0,.12);border-radius:50%;cursor:pointer}.sb-avatar-image{border-radius:50%;cursor:pointer}.sb-avatar-div{max-width:75%;width:75%;height:auto;display:block;padding-top:75%;border-radius:50%;background-position-y:center;background-position-x:center;background-repeat:no-repeat;background-size:cover;margin:0 auto;top:0;left:0;right:0;bottom:0}.sb-text-align-center{text-align:center}form md-card{margin-bottom:0}.sb-title{font-weight:600;font-size:14px;margin:16px 0 0;color:rgba(0,0,0,.8)}.sb-body-2{margin-top:8px;font-size:14px;font-weight:500;letter-spacing:.01em;line-height:24px}.sb-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sb-datepicker-input-container{padding:16px 0}.sb-datepicker-input-container>label{margin-bottom:8px;color:rgba(0,0,0,.4)}.sb-hint{color:grey;font-size:12px;line-height:14px;overflow:hidden;opacity:1;margin-top:0;padding-top:5px}.sb-hint.lg{color:rgba(0,0,0,.4);font-size:16px;padding-top:32px;padding-left:12px;padding-bottom:8px}.sb-autocomplete-custom-template li{border-bottom:1px solid #ccc;height:56px!important;padding-top:8px!important;padding-bottom:8px!important;white-space:normal}.sb-autocomplete-custom-template li:last-child{border-bottom-width:0}.sb-autocomplete-custom-template .item-title{display:block;line-height:2}.sb-autocomplete-custom-template .item-metadata{display:block;line-height:2;font-size:12px;color:grey}.sb-conditional-section>md-checkbox{margin-top:32px}.sb-table-column-xs{width:25px}md-card.sb-input-invalid{box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px #d50000}.sb-error-message{color:#d50000;font-size:12px;line-height:14px;overflow:hidden;opacity:1;margin-top:0;padding-top:5px}.sb-form-actions .md-button{margin:8px 0 8px 16px}.sb-form-actions.after-card{padding-right:8px}md-input-container .hint{position:absolute;left:2px;right:auto;bottom:7px;font-size:12px;line-height:14px;transition:all .3s cubic-bezier(.55,0,.55,.2);color:grey}md-input-container .hint.ng-enter,md-input-container .hint.ng-hide,md-input-container .hint.ng-leave.ng-leave-active{bottom:26px;opacity:0}md-input-container .hint.ng-enter.ng-enter-active,md-input-container .hint.ng-leave{bottom:7px;opacity:1}md-input-container.md-icon-right.sb-password-container{padding-left:0;padding-right:0;margin-right:8px}md-dialog-content md-input-container .hint{left:6px;bottom:-18px}.unit-list div md-input-container{margin-top:5px;margin-bottom:5px}.unit-list div md-input-container:last-of-type{margin-right:10px}text-angular .sb-ta-toolbar{padding:0 8px;background-color:rgba(0,0,0,.08)}text-angular .sb-ta-toolbar .sb-ta-button-group{position:relative;display:inline-block}text-angular .sb-ta-toolbar .sb-ta-button-group .md-button{margin:0;min-width:0}text-angular .sb-ta-toolbar .sb-ta-button-group .md-button.active{background-color:rgba(0,0,0,.24)}md-card.sb-ta-container{margin:0}.sb-table-truncate{overflow:hidden;max-width:300px;text-overflow:ellipsis;white-space:nowrap}.app{height:100%}.dtp div.dtp-month-btn{font-size:12px;line-height:24px;cursor:pointer}.dtp div.dtp-actual-num{font-size:18px;line-height:24px}.dtp div.dtp-date{background-color:#f44336;display:flex;justify-content:space-between}.dtp div.dtp-actual-month,.dtp div.dtp-actual-year{font-size:18px;cursor:pointer;color:#fff}.dtp div.dtp-year-btn{color:#fff;font-size:12px;line-height:24px}.dtp>.dtp-content>.dtp-date-view>header.dtp-header,.dtp table.dtp-picker-days tr>td>a.selected{background:#f44336}.dtp-date>.layout-row>.flex{min-width:60px}.md-input{order:2;display:block;margin-top:0;background:none;padding:2px 2px 1px 0;border-width:0 0 1px;line-height:26px;height:30px;-ms-flex-preferred-size:26px;border-radius:0;border-style:solid;transition:border-color .4s cubic-bezier(.25,.8,.25,1);width:100%;box-sizing:border-box;float:left}.ml-10{margin-left:10px}", ""]);
	
	// exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var config = function config($httpProvider, $locationProvider, $mdIconProvider) {
		$httpProvider.interceptors.push('HttpInterceptor');
		// @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
		// #how-to-configure-your-server-to-work-with-html5mode
		$locationProvider.html5Mode(true).hashPrefix('!');
		$mdIconProvider.fontSet('material-design-icons', 'mdi');
		moment.locale('pt');
	};
	
	config.$inject = ['$httpProvider', '$locationProvider', '$mdIconProvider'];exports.default =
	
	config;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {'use strict';Object.defineProperty(exports, "__esModule", { value: true });var config = function config($mdDateLocaleProvider) {
		$mdDateLocaleProvider.formatDate = function (date) {
			return moment(date).format('DD/MM/YYYY');
		};
	
		$mdDateLocaleProvider.months = [
		'Janeiro',
		'Fevereiro',
		'Março',
		'Abril',
		'Maio',
		'Junho',
		'Julho',
		'Agosto',
		'Setembro',
		'Outubro',
		'Novembro',
		'Dezembro'];
	
	
		$mdDateLocaleProvider.shortMonths = [
		'Jan',
		'Fev',
		'Mar',
		'Abr',
		'Mai',
		'Jun',
		'Jul',
		'Ago',
		'Sep',
		'Out',
		'Nov',
		'Dez'];
	
	
		$mdDateLocaleProvider.days = [
		'Domingo',
		'Segunda-feria',
		'Terça-feria',
		'Quart-feria',
		'Quinta-feria',
		'Sexta-feira',
		'Sábado'];
	
	
		$mdDateLocaleProvider.shortDays = [
		'Dom',
		'Seg',
		'Ter',
		'Qua',
		'Qui',
		'Sex',
		'Sáb'];
	
	
		$mdDateLocaleProvider.firstDayOfWeek = 1;
	
		$mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
			return 'Semana ' + weekNumber;
		};
	
		$mdDateLocaleProvider.msgCalendar = 'Calendário';
		$mdDateLocaleProvider.msgOpenCalendar = 'Abrir calendário';
	};
	
	config.$inject = ['$mdDateLocaleProvider'];exports.default =
	
	config;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(421)))

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var config = function config($mdThemingProvider) {
	  var sabinRed = $mdThemingProvider.extendPalette('red', {
	    '900': 'b90a00' });
	
	
	  var sabinWarn = $mdThemingProvider.extendPalette('red', {
	    '500': '9e9e9e' });
	
	
	  $mdThemingProvider.definePalette('sabinRed', sabinRed);
	  $mdThemingProvider.definePalette('sabinWarn', sabinWarn);
	
	  $mdThemingProvider.
	  theme('default').
	  primaryPalette('blue').
	  accentPalette('sabinRed', {
	    'default': '900' }).
	
	  warnPalette('sabinWarn').
	  backgroundPalette('grey');
	
	  $mdThemingProvider.theme('success-toast');
	  $mdThemingProvider.theme('error-toast');
	};
	
	config.$inject = ['$mdThemingProvider'];exports.default =
	
	config;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _pt = __webpack_require__(851);var _pt2 = _interopRequireDefault(_pt);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var config = function config($translateProvider) {
		$translateProvider.translations('pt', _pt2.default);
		$translateProvider.preferredLanguage('pt');
		$translateProvider.useSanitizeValueStrategy('escape');
	};
	
	config.$inject = ['$translateProvider'];exports.default =
	
	config;

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _dictionary;function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}var dictionary = (_dictionary = {
	    'admin-detail-409-error': 'Já existe um usuário com este e-mail',
	    'admin-detail-delete-confirm-text': 'Remover usuário?',
	    'admin-detail-delete-success': 'Usuário removido',
	    'admin-detail-form-admin-access-group': 'Grupo de acesso',
	    'admin-detail-form-admin-email': 'E-mail',
	    'admin-detail-form-admin-name': 'Nome',
	    'admin-detail-form-admin-new-password': 'Nova senha',
	    'admin-detail-form-admin-password': 'Senha',
	    'admin-detail-form-admin-sector': 'Setor',
	    'admin-detail-form-current_password': 'Senha atual',
	    'admin-detail-form-desactivate-switch': 'Ativar/desativar usuário do sistema',
	    'admin-detail-form-error-password-min-length': 'Mínimo de 6 caractéres',
	    'admin-detail-form-image-hint': 'Enviar foto',
	    'admin-detail-save-success': 'Usuário salvo',
	    'admin-detail-title': 'Detalhes do usuário',
	    'admin-detail-title-caption': 'Preencha os dados do usuário conforme os campos abaixo',
	    'admin-list-create-admin-button': 'Criar usuário',
	    'admin-list-empty-state-line-1': 'Nenhum usuário',
	    'admin-list-empty-state-line-2': 'Crie seu primeiro usuário',
	    'admin-list-table-access-group-null': 'Sem grupo',
	    'admin-list-table-header-access-group': 'Grupo de acesso',
	    'admin-list-table-header-created-at': 'Criado em',
	    'admin-list-table-header-email': 'E-mail',
	    'admin-list-table-header-name': 'Nome',
	    'attendance-list-active-success': 'Pré-atendimento atualizado',
	    'attendance-list-active-error': 'Não foi possível completar esta ação',
	    'attendance-detail-city': 'Cidade',
	    'attendance-detail-finished': 'Status do pré-agendamento',
	    'attendance-detail-medical-request-title': 'Pedido Médico',
	    'attendance-detail-health-insurance-front_image': 'Frente da carteirinha',
	    'attendance-detail-health-insurance-rear_image': 'Verso da carteirinha',
	    'attendance-detail-place': 'Local do atendimento',
	    'attendance-detail-service': 'Nome do serviço',
	    'attendance-detail-state': 'Estado',
	    'attendance-detail-title': 'Detalhe do pré-atendimento',
	    'attendance-detail-title-caption': 'Leia abaixo maiores informações sobre o pré-agendamento',
	    'attendance-detail-type': 'Tipo',
	    'attendance-detail-reference-user-birthdate': 'Data de nascimento',
	    'attendance-detail-reference-user-document': 'CPF',
	    'attendance-detail-reference-user-email': 'E-mail',
	    'attendance-detail-reference-user-name': 'Nome',
	    'attendance-detail-reference-user-title': 'Usuário solicitante',
	    'attendance-detail-reference-user-phone': 'Telefone',
	    'attendance-detail-reference-user-title-caption': 'Dados do usuário solicitante',
	    'attendance-detail-unit-address': 'Endereço',
	    'attendance-detail-unit-name': 'Unidade',
	    'attendance-info-HOME': 'Domiciliar',
	    'attendance-info-PRE_SCHEDULING': 'Pré-agendamento',
	    'attendance-info-BUDGET': 'Orçamento',
	    'attendance-info-EXAM': 'Exame laboratorial',
	    'attendance-info-CHECKUP': 'Check-up',
	    'attendance-info-IMAGE': 'Exame de imagem',
	    'attendance-info-UNIT': 'Unidade Sabin',
	    'attendance-info-VACCINE': 'Vacina',
	    'attendance-list-table-header-city': 'Cidade',
	    'attendance-list-table-header-finished': 'Atendido',
	    'attendance-list-table-header-name': 'Nome',
	    'attendance-list-table-header-place': 'Local',
	    'attendance-list-table-header-service': 'Serviço',
	    'attendance-list-table-header-state': 'Estado',
	    'attendance-list-table-header-type': 'Tipo',
	    'attendance-list-table-header-unit': 'Unidade',
	    'button-download-report': 'Baixar relatório analítico',
	    'button-download-report-small': 'Visualizar relatório sintético',
	    'button-download-report-spin': 'Gerando relatório',
	    'auth-service-forbid-access-dialog-text': 'Entre em contato com o administrador do sistema.',
	    'auth-service-forbid-access-dialog-title': '403 - Acesso proibido',
	    'campaign-create-page-title': 'Detalhe da campanha',
	    'campaign-detail-409-error': 'Já existe uma campanha neste período',
	    'campaign-detail-delete-confirm-text': 'Remover campanha?',
	    'campaign-detail-delete-success': 'Campanha removida',
	    'campaign-detail-form-dates-sub-header': 'Informe as datas de início de fim da campanha *',
	    'campaign-detail-form-end_date': 'Finaliza em',
	    'campaign-detail-form-image-hint': 'A imagem será salva no tamanho 570 x 890 px.',
	    'campaign-detail-form-news-item': 'Notícia vinculada',
	    'campaign-detail-form-news-item-placeholder': 'Pesquise por uma notícia',
	    'campaign-detail-form-news-item-sub-header': 'Vincule uma notícia a esta campanha',
	    'campaign-detail-form-news-name': 'Nome da campanha',
	    'campaign-detail-form-start_date': 'Inicia em',
	    'campaign-detail-save-success': 'Campanha salva',
	    'campaign-detail-title-caption': 'Preencha os dados da campanha conforme os campos abaixo',
	    'campaign-image-title-caption': 'Escolha uma imagem para a campanha',
	    'campaign-list-create-campaign-button': 'Nova campanha',
	    'campaign-list-empty-state-line-1': 'Nenhuma campanha',
	    'campaign-list-empty-state-line-2': 'Crie sua primeira campanha',
	    'campaign-list-table-header-end_date': 'Finaliza em',
	    'campaign-list-table-header-name': 'Nome da campanha',
	    'campaign-list-table-header-start_date': 'Inicia em',
	    'card-detail-409-error': 'Já existe uma vacina com esse nome',
	    'card-detail-form-doses-label': 'Quantidade de doses',
	    'card-detail-form-error-doses-max': 'A quantidade de doses deve ser no máximo 3',
	    'card-detail-form-error-doses-min': 'A quantidade de doses deve ser no mínimo 1',
	    'card-detail-form-error-interval_in_days-min': 'O intervalo deve ser no mínimo 1 dia',
	    'card-detail-form-interval-value-label': 'Intervalo entre as doses',
	    'card-detail-form-time-unit': 'Unidade de tempo',
	    'card-detail-save-success': 'Vacina salva',
	    'card-detail-title': 'Detalhes da vacinação',
	    'card-detail-title-caption': 'Preencha os dados da vacinação conforme os campos abaixo',
	    'card-list-create-card-button': 'Criar vacina',
	    'card-list-empty-state-line-1': 'Nenuma vacina cadastrada',
	    'card-list-empty-state-line-2': 'Crie sua primeira vacina',
	    'insurance-state-detail-title': 'Detalhes do Estado',
	    'insurance-city-detail-title': 'Detalhes da Cidade',
	    'insurance-detail-title': 'Detalhes do Convênio',
	    'insurance-detail-form-expire-label': 'Validade do pedido (dias)',
	    'insurance-detail-save-success': 'Convênio salvo',
	    'insurance-state-detail-save-success': 'Estado salvo',
	    'insurance-city-detail-save-success': 'Cidade salva',
	    'client-detail-form-client-address_complement': 'Complemento',
	    'client-detail-form-client-address_neighborhood': 'Bairro',
	    'client-detail-form-client-address_number': 'Número',
	    'client-detail-form-client-address_postal_code': 'CEP',
	    'client-detail-form-client-address_street': 'Endereço',
	    'client-detail-form-client-birthdate': 'Data de nascimento',
	    'client-detail-form-client-city_id': 'Cidade',
	    'client-detail-form-client-cpf': 'CPF',
	    'client-detail-form-client-email': 'E-mail',
	    'client-detail-form-client-gender': 'Gênero',
	    'client-detail-form-client-name': 'Nome completo',
	    'client-detail-form-client-phone_number': 'Telefone',
	    'client-detail-form-client-state': 'Estado',
	    'client-detail-form-client-period': 'Período',
	    'client-detail-remove-association-confirm-text': 'Remover vínculo',
	    'client-detail-save-success': 'Cliente salvo',
	    'client-detail-section-dependents-empty-state-line-1': 'Este cliente não tem dependentes',
	    'client-detail-section-dependents-remove-button-text': 'Remover vínculo',
	    'client-detail-section-health_insurances-empty-state-line-1': 'Nenhum convênio cadastrado',
	    'client-detail-section-health_insurances-name': 'Convênio',
	    'client-detail-section-sponsors-empty-state-line-1': 'Este cliente não é dependente de nenhum usuário',
	    'client-detail-section-sponsors-remove-button-text': 'Remover vínculo',
	    'client-detail-section-title-dependents': 'Dependentes vinculados',
	    'client-detail-section-title-dependents-caption': 'Remova vínculos deste cliente',
	    'client-detail-section-title-health_insurances': 'Detalhes do convênio',
	    'client-detail-section-title-sponsors': 'Responsáveis',
	    'client-detail-section-title-sponsors-caption': 'Remova vínculos deste cliente',
	    'client-detail-title': 'Detalhes do cliente',
	    'client-detail-title-caption': 'Edite as informações abaixo conforme necessário',
	    'client-report-title': 'Relatório sintético',
	    'client-report-title-caption': 'Dashboard gráfico de clientes',
	    'client-report-chart-clients': 'Total de clientes',
	    'client-report-chart-clients-gender': 'Total de clientes por gênero',
	    'client-report-chart-clients-dependents': 'Total de clientes por dependentes',
	    'client-report-chart-clients-states': 'Total de clientes por estados',
	    'client-report-title-subtitle': 'Relatório analítico',
	    'client-report-title-subtitle-caption': 'Selecione as opções de filtragem para gerar o relatório',
	    'client-report-filter': 'Gerar relatório analítico',
	    'client-report-filtering': 'Gerando relatório analítico',
	    'client-report-graph-filter': 'Gerar gráfico analítico',
	    'client-report-graph-filtering': 'Gerando gráfico analítico',
	    'common-about-text': 'Sobre',
	    'common-actions': 'Ações',
	    'common-all-rights-reserved-text': 'Todos os direitos reservados.',
	    'common-campaign': 'Campanha',
	    'common-communicate': 'Comunicado',
	    'common-cancel': 'Cancelar',
	    'common-cancel-button-text': 'Cancelar',
	    'common-category': 'Categoria',
	    'common-subcategory': 'Subcategoria',
	    'common-add-subcategory': 'Adicionar Subcategoria',
	    'common-choose-a-file': 'Escolher um arquivo',
	    'common-city': 'Cidade',
	    'common-clear-button-text': 'Limpar',
	    'common-clients': 'Clientes',
	    'common-create': 'Criar',
	    'common-create-button-text': 'Criar',
	    'common-created-at-feminine': 'Criada em',
	    'common-date': 'Data',
	    'common-delete': 'Remover',
	    'common-delete-button-text': 'Remover',
	    'common-detail-delete-confirm-text': 'Remover este item?',
	    'common-detail-delete-success': 'Item removido',
	    'common-edit': 'Editar',
	    'common-email': 'E-mail',
	    'common-female': 'Feminino',
	    'common-form-error-sb-after-date': 'A data final não pode ser antes da data inicial',
	    'common-form-error-sb-before-date': 'A data inicial não pode ser depois da data final',
	    'common-form-error-sb-today-or-before': 'Data de nascimento inválida',
	    'common-form-error-sb-today-or-later': 'A data não pode ser antes de hoje',
	    'common-form-incomplete': 'Formulário incompleto',
	    'common-general': 'Geral',
	    'common-go-back-button-text': 'Voltar',
	    'common-help-text': 'Ajuda',
	    'common-hours': 'horas',
	    'common-image': 'Imagem',
	    'common-load-error': 'Houve um erro os carregar os dados',
	    'common-loading': 'Carregando',
	    'common-male': 'Masculino',
	    'common-medics': 'Médicos',
	    'common-dependents': 'Dependentes',
	    'common-message': 'Mensagem',
	    'common-name': 'Nome',
	    'common-gender': 'Sexo',
	    'common-new-feminine': 'Nova',
	    'common-new-feminine-city': 'Nova cidade',
	    'common-new-masculine': 'Novo',
	    'common-new-pop-up': 'Novo Pop-up',
	    'common-new-video': 'Novo Banner',
	    'common-all-feminine': 'Todas',
	    'common-all-masculine': 'Todos',
	    'common-none-feminine': 'Nenhuma',
	    'common-none-masculine': 'Nenhum',
	    'common-not-informed': 'Não informado',
	    'common-ok': 'OK',
	    'common-other-gender': 'Outro',
	    'common-password': 'Senha',
	    'common-phone-number': 'Telefone',
	    'common-please-wait': 'Por favor aguarde',
	    'common-published-at-feminine': 'Publicada em',
	    'common-remove': 'Remover',
	    'common-sabin': 'Sabin',
	    'common-sabin-id': 'Código Shift',
	    'common-save-button-loading-text': 'Salvando...',
	    'common-save-button-text': 'Salvar',
	    'common-save-error': 'Houve um erro ao salvar este item',
	    'common-sent-at': 'Enviada em',
	    'common-server-error': 'Não foi possível completar esta ação',
	    'common-sicence-and-research': 'Pesquisa e ciência',
	    'common-sign-out': 'Sair',
	    'common-state': 'Estado',
	    'common-time': 'Hora',
	    'common-title': 'Título',
	    'common-title-scheduled': 'Agendada para',
	    'common-title-status': 'Status',
	    'common-region': 'Região',
	    'common-status': 'Status',
	    'common-type-region': 'Tipo de região',
	    'common-updated-at': 'Atualizado em',
	    'common-pre-attendance': 'Pré-atendimento',
	    'common-accept-pre-attendance': 'Aceita pré-atendimento',
	    'common-no-accept-pre-attendance': 'Não aceita pré-atendimento',
	    'common-updated-at-feminine': 'Atualizada em',
	    'common-updated-active': 'Ativo',
	    'common-user': 'Usuário',
	    'common-yes': 'Sim',
	    'common-unit': 'Unidade',
	    'common-days': 'Días',
	    'common-months': 'Meses',
	    'common-years': 'Anos',
	    'common-url': 'Inserir URL',
	    'differential-detail-409-error': 'Já existe uma diferencial com esse nome',
	    'differential-detail-save-success': 'Differencial salva',
	    'differential-list-create-dialog-content': 'Dê um nome para o diferencial.',
	    'faq-detail-title': 'Nova Pergunta',
	    'faq-detail-title-response': 'Resposta',
	    'faq-detail-title-platforms': 'Plataformas digitais',
	    'faq-detail-input-title': 'Pergunta',
	    'form-error-birthdate-invalid': 'Data inválida',
	    'form-permission-checkbox-field': 'Permissões',
	    'form-error-email-invalid': 'Este e-mail não é válido',
	    'form-error-required-field': 'Campo obrigatório',
	    'form-error-required-file': 'Arquivo obrigatório',
	    'form-error-sb-time-field-now-or-later': 'A hora não pode ser antes de agora',
	    'form-error-time-invalid': 'A hora deve ser no formato "hh:mm"',
	    'group-detail-409-error': 'Já existe um grupo com este nome',
	    'group-detail-delete-confirm-text': 'Remover grupo?',
	    'group-detail-delete-success': 'Grupo removido',
	    'group-detail-delete-with-users-confirm-text': 'Os usuários deste grupo perderão acesso à plataforma. Deseja remover?',
	    'group-detail-form-group-name': 'Nome do grupo',
	    'group-detail-no-access-confirm-text': 'Este grupo não tem acesso a nenhum módulo. Deseja salvar?',
	    'group-detail-save-success': 'Grupo salvo',
	    'group-detail-section-title-admin-modules': 'Módulos',
	    'group-detail-section-title-admin-modules-caption': 'Selecione abaixo os módulos accesíveis por este grupo',
	    'group-detail-section-title-admin-modules-caption-super': 'O acesso a módulos deste grupo não pode ser editado',
	    'group-detail-title': 'Detalhes do grupo',
	    'group-detail-title-caption': 'Preencha os dados do grupo conforme os campos abaixo',
	    'group-list-create-group-button': 'Criar grupo de acesso',
	    'group-list-empty-state-line-1': 'Nenhum grupo',
	    'group-list-empty-state-line-2': 'Crie seu primeiro grupo',
	    'group-list-table-all-modules-text': 'Todos',
	    'group-list-table-header-modules': 'Módulos',
	    'group-list-table-header-name': 'Grupo',
	    'group-list-table-no-modules-text': 'Sem acesso',
	    'list-empty-search-state-line-1': 'Nenhum resultado encontrado',
	    'login-button-loading-text': 'Entrando...',
	    'login-button-text': 'Entrar',
	    'login-forgot-password-text': 'Esqueci minha senha',
	    'login-remember-me-checkbox-text': 'Lembrar-me',
	    'me-detail-403-error': 'Senha inválida',
	    'me-detail-form-error-current_password-required': 'É necessário informar a senha atual para atualizar seu perfil',
	    'me-detail-form-new-password': 'Nova senha',
	    'me-detail-save-success': 'Suas informações foram salvas',
	    'me-detail-title': 'Minha conta',
	    'me-detail-title-caption': 'Atualize suas informações conforme necessário',
	    'news-create-page-title': 'Nova notícia',
	    'news-detail-delete-confirm-text': 'Remover notícia?',
	    'news-detail-delete-success': 'Notícia removida',
	    'news-detail-form-error-content-min-length': 'A nóticia deve ter no máximo 5 caractéres',
	    'news-detail-form-error-title-max-length': 'Título deve ter no máximo 100 caractéres',
	    'news-detail-form-image-hint': 'A imagem será salva no tamanho 720 x 430 px.',
	    'news-detail-form-send-push-checkbox': 'Enviar push notification para os usuários',
	    'news-detail-form-filter-checkbox': 'Filtrar publico alvo',
	    'news-detail-save-success': 'Notícia salva',
	    'news-list-create-news-button': 'Nova Notícia',
	    'news-list-empty-state-line-1': 'Nenhuma notícia a ser exibida.',
	    'news-list-empty-state-line-2': 'Crie sua primeira notícia!',
	    'news-list-table-header-published-at': 'Publicada em',
	    'news-list-table-header-target': 'Categoria',
	    'news-list-table-header-title': 'Título',
	    'news-list-table-header-updated-at': 'Atualizado em',
	    'news-list-table-target-ALL': 'Geral',
	    'news-list-table-target-CAMPAIGN': 'Campanha',
	    'news-list-table-target-COMMUNICATE': 'Comunicado',
	    'news-list-table-target-CLIENT': 'Geral',
	    'news-list-table-target-MEDIC': 'Pesquisa e ciência',
	    'news-list-table-target-GENERAL': 'Geral',
	    'news-list-table-target-SCIENCE': 'Pesquisa e ciência',
	    'news-list-table-target-null': 'Geral',
	    'notification-detail-delete-confirm-text': 'Remover notificação?',
	    'notification-detail-delete-success': 'Notificação removida',
	    'notification-detail-form-error-message-max-length': 'A mensagem deve ter no máxmo 140 caractéres',
	    'notification-detail-form-error-title-max-length': 'O título deve ter no máxmo 20 caractéres',
	    'notification-detail-form-error-url-max-length': 'A URL deve ter no máxmo 255 caractéres',
	    'notification-detail-geo-limited-checkbox': 'Limitar esta notificação a um estado ou a uma cidade específica',
	    'notification-detail-has-news-item-checkbox': 'Vincular uma notícia a uma notificação push.',
	    'notification-detail-save-success': 'Notificação salva',
	    'notification-detail-schedule-checkbox': 'Agendar esta notificação push para uma data futura.',
	    'notification-detail-send-now-confirm-text': 'Esta notificação push será enviada imediatamente.',
	    'notification-detail-title': 'Nova notificação',
	    'notification-detail-title-caption': 'Preencha os dados da notificação conforme os campos abaixo',
	    'notification-detail-type': 'Público alvo',
	    'notification-detail-filer-public': 'Filtrar publico alvo',
	    'notification-list-create-notification-button': 'Criar notificação',
	    'notification-list-empty-state-line-1': 'Nehuma notificação push',
	    'notification-list-empty-state-line-2': 'Envie sua primeira notificação push',
	    'apiaccesslog-list-username': 'Usúario',
	    'apiaccesslog-list-type': 'Resultado de conexão',
	    'apiaccesslog-list-creat_at': 'Data',
	    'apiaccesslog-detail-delete-confirm-text': 'Remover log?',
	    'apiaccesslog-detail-delete-success': 'Log removido',
	    'apiaccesslog-detail-form-error-message-max-length': 'A mensagem deve ter no máxmo 140 caractéres',
	    'apiaccesslog-detail-form-error-title-max-length': 'O título deve ter no máxmo 20 caractéres',
	    'apiaccesslog-detail-geo-limited-checkbox': 'Limitar esta log a um estado ou a uma cidade específica',
	    'apiaccesslog-detail-save-success': 'Log salva',
	    'apiaccesslog-detail-title': 'Detalhes do Log',
	    'apiaccesslog-detail-title-caption': 'Dados de tentativas de utilização',
	    'apiaccesslog-detail-type': 'Público alvo',
	    'apiaccesslog-list-create-apiaccesslog-button': 'Criar log',
	    'apiaccesslog-list-empty-state-line-1': 'Nehum log até o momento',
	    'apiaccesslog-list-empty-state-line-2': 'Verifique novamente mais tarde',
	    'apiaccesslog-detail-username': 'Nome de Usúario' }, _defineProperty(_dictionary, 'apiaccesslog-detail-type',
	'Resultado de conexão'), _defineProperty(_dictionary,
	'apiaccesslog-detail-date', 'Data'), _defineProperty(_dictionary,
	'apiaccesslog-detail-header', 'Header de conexão'), _defineProperty(_dictionary,
	'page-detail-form-error-content-min-length', 'A página deve ter no máximo 5 caractéres'), _defineProperty(_dictionary,
	'page-detail-save-success', 'Página salva'), _defineProperty(_dictionary,
	'page-edit-page-title', 'Editar página'), _defineProperty(_dictionary,
	'procedure-list-active-success', 'Exame atualizado'), _defineProperty(_dictionary,
	'procedure-list-active-error', 'Não foi possível completar esta ação'), _defineProperty(_dictionary,
	'procedure-detail-client_info', 'Informações ao cliente'), _defineProperty(_dictionary,
	'procedure-detail-collection_info', 'Informações de coleta'), _defineProperty(_dictionary,
	'procedure-detail-collection_material', 'Material'), _defineProperty(_dictionary,
	'procedure-detail-description', 'Mnemônico'), _defineProperty(_dictionary,
	'procedure-detail-fasting_hours', 'Jejum'), _defineProperty(_dictionary,
	'procedure-detail-methodology', 'Metodologia'), _defineProperty(_dictionary,
	'procedure-detail-name', 'Nome do exame'), _defineProperty(_dictionary,
	'procedure-detail-reference-value-description', 'Valor'), _defineProperty(_dictionary,
	'procedure-detail-reference-value-value', 'Nome da amostra'), _defineProperty(_dictionary,
	'procedure-detail-reference-values-title', 'Valores de referência'), _defineProperty(_dictionary,
	'procedure-detail-reference-values-title-caption', 'Veja os valores de referência de acordo com as amostras do exame'), _defineProperty(_dictionary,
	'procedure-detail-result_time', 'Prazo'), _defineProperty(_dictionary,
	'procedure-detail-title', 'Detalhe do exame'), _defineProperty(_dictionary,
	'procedure-detail-title-caption', 'Leia abaixo maiores informações sobre o exame'), _defineProperty(_dictionary,
	'procedure-list-table-header-description', 'Mnemônico'), _defineProperty(_dictionary,
	'procedure-list-table-header-name', 'Nome'), _defineProperty(_dictionary,
	'region-detail-delete-confirm-text', 'Remover praça?'), _defineProperty(_dictionary,
	'region-detail-delete-success', 'Praça removida'), _defineProperty(_dictionary,
	'region-detail-save-success', 'Praça salva'), _defineProperty(_dictionary,
	'region-detail-title', 'Detalhe da praça'), _defineProperty(_dictionary,
	'region-detail-title-caption', 'Preencha os dados da praça conforme os campos abaixo'), _defineProperty(_dictionary,
	'service-detail-409-error', 'Já existe um serviço com esse nome'), _defineProperty(_dictionary,
	'service-detail-save-success', 'Serviço salvo'), _defineProperty(_dictionary,
	'service-list-create-dialog-content', 'Dê um nome para o serviço.'), _defineProperty(_dictionary,
	'shell-admin', 'Usuários do sistema'), _defineProperty(_dictionary,
	'shell-admin.create', 'Usuários do sistema'), _defineProperty(_dictionary,
	'shell-admin.edit', 'Usuários do sistema'), _defineProperty(_dictionary,
	'shell-admin.list', 'Usuários do sistema'), _defineProperty(_dictionary,
	'shell-app-version.list', 'Notificação de versão'), _defineProperty(_dictionary,
	'shell-attendance', 'Pré-Atendimento'), _defineProperty(_dictionary,
	'shell-attendance.list', 'Pré-Atendimento'), _defineProperty(_dictionary,
	'shell-attendance.show', 'Pré-Atendimento'), _defineProperty(_dictionary,
	'shell-attendance-list', 'Lista de pré-atendimentos'), _defineProperty(_dictionary,
	'shell-email', 'Configuração de e-mails'), _defineProperty(_dictionary,
	'shell-email.list', 'Configuração de e-mails'), _defineProperty(_dictionary,
	'shell-email.create', 'Configuração de e-mails'), _defineProperty(_dictionary,
	'shell-email.edit', 'Configuração de e-mails'), _defineProperty(_dictionary,
	'shell-campaign', 'Campanhas'), _defineProperty(_dictionary,
	'shell-campaign.create', 'Campanhas'), _defineProperty(_dictionary,
	'shell-campaign.edit', 'Campanhas'), _defineProperty(_dictionary,
	'shell-campaign.list', 'Campanhas'), _defineProperty(_dictionary,
	'shell-card', 'Cartela de vacinação'), _defineProperty(_dictionary,
	'shell-card.create', 'Cartela de vacinação'), _defineProperty(_dictionary,
	'shell-card.edit', 'Cartela de vacinação'), _defineProperty(_dictionary,
	'shell-card.list', 'Cartela de vacinação'), _defineProperty(_dictionary,
	'shell-faq-categories', 'Cadastrar Categorias'), _defineProperty(_dictionary,
	'shell-categories.list', 'Cadastrar Categorias'), _defineProperty(_dictionary,
	'shell-insurance', 'Convênios'), _defineProperty(_dictionary,
	'shell-insurance.create', 'Convênios'), _defineProperty(_dictionary,
	'shell-insurance.edit', 'Convênios'), _defineProperty(_dictionary,
	'shell-insurance.list', 'Convênios'), _defineProperty(_dictionary,
	'shell-insurance.ccreate', 'Cidade do convênio'), _defineProperty(_dictionary,
	'shell-insurance.cedit', 'Cidade do convênio'), _defineProperty(_dictionary,
	'shell-insurance.screate', 'Estados do convênio'), _defineProperty(_dictionary,
	'shell-insurance.sedit', 'Estados do convênio'), _defineProperty(_dictionary,
	'shell-insurance.state', 'Estados/Cidades'), _defineProperty(_dictionary,
	'shell-insurance-states', 'Estados/Cidades'), _defineProperty(_dictionary,
	'shell-states', 'Estados'), _defineProperty(_dictionary,
	'shell-cities', 'Cidades'), _defineProperty(_dictionary,
	'shell-client', 'Clientes'), _defineProperty(_dictionary,
	'shell-client.edit', 'Clientes'), _defineProperty(_dictionary,
	'shell-client.list', 'Clientes'), _defineProperty(_dictionary,
	'shell-client.report', 'Relatório de Clientes'), _defineProperty(_dictionary,
	'shell-custom-page', 'Páginas customizadas'), _defineProperty(_dictionary,
	'shell-custom-home-page', 'Tela inicial do aplicativo'), _defineProperty(_dictionary,
	'shell-differential', 'Diferenciais'), _defineProperty(_dictionary,
	'shell-differential.list', 'Diferenciais'), _defineProperty(_dictionary,
	'shell-faq', 'Perguntas Frequentes'), _defineProperty(_dictionary,
	'shell-faq.list', 'Adicionar Perguntas'), _defineProperty(_dictionary,
	'shell-faq.log.list', 'Perguntas Frequentes'), _defineProperty(_dictionary,
	'shell-faq.log-list', 'Perguntas Frequentes'), _defineProperty(_dictionary,
	'shell-faq.log.detail', 'Detalhes do Log'), _defineProperty(_dictionary,
	'shell-general-records', 'Cadastros gerais'), _defineProperty(_dictionary,
	'shell-group', 'Grupos de acesso'), _defineProperty(_dictionary,
	'shell-group.create', 'Grupos de acesso'), _defineProperty(_dictionary,
	'shell-group.edit', 'Grupos de acesso'), _defineProperty(_dictionary,
	'shell-group.list', 'Grupos de acesso'), _defineProperty(_dictionary,
	'shell-home', 'Home'), _defineProperty(_dictionary,
	'shell-me', 'Minha conta'), _defineProperty(_dictionary,
	'shell-news', 'Notícias'), _defineProperty(_dictionary,
	'shell-news.create', 'Notícias'), _defineProperty(_dictionary,
	'shell-news.edit', 'Notícias'), _defineProperty(_dictionary,
	'shell-news.list', 'Notícias'), _defineProperty(_dictionary,
	'shell-notification', 'Notificações push'), _defineProperty(_dictionary,
	'shell-notification.create', 'Notificações push'), _defineProperty(_dictionary,
	'shell-notification.edit', 'Notificações push'), _defineProperty(_dictionary,
	'shell-notification.list', 'Notificações push'), _defineProperty(_dictionary,
	'shell-notification.detail', 'Detalhes da notificação'), _defineProperty(_dictionary,
	'shell-apiaccesslog', 'Log de acesso a API'), _defineProperty(_dictionary,
	'shell-apiaccesslog.create', 'Acesso a API'), _defineProperty(_dictionary,
	'shell-apiaccesslog.edit', 'Acesso a API'), _defineProperty(_dictionary,
	'shell-apiaccesslog.list', 'Acesso a API'), _defineProperty(_dictionary,
	'shell-page-about', 'Sobre'), _defineProperty(_dictionary,
	'shell-page-cid', 'Aviso legal'), _defineProperty(_dictionary,
	'shell-page-privacy', 'Política de privacidade'), _defineProperty(_dictionary,
	'shell-page.about', 'Páginas customizadas'), _defineProperty(_dictionary,
	'shell-page.home-app', 'Tela inicial do aplicativo'), _defineProperty(_dictionary,
	'shell-page-video-home', 'Banners - Home do aplicativo'), _defineProperty(_dictionary,
	'shell-page.new-video-home', 'Banners - Home do aplicativo'), _defineProperty(_dictionary,
	'shell-page.view-video-home', 'Banners - Home do aplicativo'), _defineProperty(_dictionary,
	'shell-page.video-home', 'Banners - Home do aplicativo'), _defineProperty(_dictionary,
	'shell-page.cid', 'Páginas customizadas'), _defineProperty(_dictionary,
	'shell-page.privacy', 'Páginas customizadas'), _defineProperty(_dictionary,
	'shell-pop-up', 'Pop-ups'), _defineProperty(_dictionary,
	'shell-pop-up.detail', 'Pop-up'), _defineProperty(_dictionary,
	'shell-pop-up.create', 'Pop-up'), _defineProperty(_dictionary,
	'shell-pop-up.list', 'Pop-ups'), _defineProperty(_dictionary,
	'shell-pre_attendance', 'Pré-Atendimento'), _defineProperty(_dictionary,
	'shell-procedure', 'Informações de exames'), _defineProperty(_dictionary,
	'shell-procedure.list', 'Informações de exames'), _defineProperty(_dictionary,
	'shell-procedure.show', 'Informações de exames'), _defineProperty(_dictionary,
	'shell-region', 'Praças'), _defineProperty(_dictionary,
	'shell-region.create', 'Praças'), _defineProperty(_dictionary,
	'shell-region.edit', 'Praças'), _defineProperty(_dictionary,
	'shell-region.list', 'Praças'), _defineProperty(_dictionary,
	'shell-service', 'Serviços'), _defineProperty(_dictionary,
	'shell-service.list', 'Serviços'), _defineProperty(_dictionary,
	'shell-target', 'Público alvo'), _defineProperty(_dictionary,
	'shell-target-category', 'Categorias'), _defineProperty(_dictionary,
	'shell-target.category', 'Categorias'), _defineProperty(_dictionary,
	'shell-target.list', 'Público alvo'), _defineProperty(_dictionary,
	'shell-unit', 'Unidades'), _defineProperty(_dictionary,
	'shell-unit-list', 'Lista de unidades'), _defineProperty(_dictionary,
	'shell-unit.create', 'Unidades'), _defineProperty(_dictionary,
	'shell-unit.edit', 'Unidades'), _defineProperty(_dictionary,
	'shell-unit.list', 'Unidades'), _defineProperty(_dictionary,
	'shell-unit.authentication', 'Unidades'), _defineProperty(_dictionary,
	'shell-users-and-groups', 'Usuários e grupos'), _defineProperty(_dictionary,
	'shell-time-title', 'Títulos de horários'), _defineProperty(_dictionary,
	'shell-time-title.list', 'Títulos de horários'), _defineProperty(_dictionary,
	'shell-vaccine', 'Informações de vacinas'), _defineProperty(_dictionary,
	'shell-vaccine-vaccine', 'Vacinas'), _defineProperty(_dictionary,
	'shell-vaccine.create', 'Informações de vacinas'), _defineProperty(_dictionary,
	'shell-vaccine.edit', 'Informações de vacinas'), _defineProperty(_dictionary,
	'shell-vaccine.list', 'Informações de vacinas'), _defineProperty(_dictionary,
	'target-category-detail-409-error', 'Já existe um categoria com este nome neste público alvo'), _defineProperty(_dictionary,
	'target-detail-409-error', 'Já existe um público alvo com este nome'), _defineProperty(_dictionary,
	'target-detail-save-success', 'Público alvo salvo'), _defineProperty(_dictionary,
	'target-list-create-category-dialog-content', 'Dê um nome para a nova categoria'), _defineProperty(_dictionary,
	'target-list-create-dialog-category-select-hint', 'Opicional'), _defineProperty(_dictionary,
	'target-list-create-dialog-category-select-label', 'Categoria pai'), _defineProperty(_dictionary,
	'target-list-create-dialog-content', 'Dê um nome para o novo público alvo.'), _defineProperty(_dictionary,
	'target-list-create-dialog-name-input-label', 'Nome'), _defineProperty(_dictionary,
	'target-list-create-dialog-target-select-label', 'Público alvo'), _defineProperty(_dictionary,
	'target-list-table-header-name', 'Nome'), _defineProperty(_dictionary,
	'target-list-table-header-parent-group', 'Categoria pai'), _defineProperty(_dictionary,
	'target-list-table-header-target-group', 'Público alvo'), _defineProperty(_dictionary,
	'unit-detail-pending-requests', '*Há solicitações pendentes de mudanças de horário!'), _defineProperty(_dictionary,
	'unit-detail-link-google-unit', 'Vincular uma unidade do Google My Business'), _defineProperty(_dictionary,
	'unit-is-visible', 'Exibir Unidade'), _defineProperty(_dictionary,
	'unit-detail-sync-gmb', 'Sincronizar com o Google My Business'), _defineProperty(_dictionary,
	'unit-detail-add-special-hours', 'Adicionar horários especiais'), _defineProperty(_dictionary,
	'unit-detail-default-unit-opening-hour-text', 'Horário de funcionamento'), _defineProperty(_dictionary,
	'unit-detail-delete-confirm-text', 'Remover unidade?'), _defineProperty(_dictionary,
	'unit-detail-delete-success', 'Unidade removida'), _defineProperty(_dictionary,
	'unit-detail-form-opening-hour-add-button', 'Adicionar novo horário'), _defineProperty(_dictionary,
	'unit-detail-form-opening-hour-name', 'Título do horário'), _defineProperty(_dictionary,
	'unit-detail-form-opening-hour-remove-button', 'Remover'), _defineProperty(_dictionary,
	'unit-detail-form-opening-hour-value', 'Informe aqui os dias e horários específicos'), _defineProperty(_dictionary,
	'unit-detail-form-unit-address_complement', 'Complemento'), _defineProperty(_dictionary,
	'unit-detail-form-unit-address_neighborhood', 'Bairro'), _defineProperty(_dictionary,
	'unit-detail-form-unit-address_number', 'Número'), _defineProperty(_dictionary,
	'unit-detail-form-unit-address_postal_code', 'CEP'), _defineProperty(_dictionary,
	'unit-detail-form-unit-address_street', 'Endereço'), _defineProperty(_dictionary,
	'unit-detail-form-unit-city_id', 'Cidade'), _defineProperty(_dictionary,
	'unit-detail-form-unit-is-schedule-available', 'Disponível para pré-agendamento'), _defineProperty(_dictionary,
	'unit-detail-form-unit-latitude', 'Latitude'), _defineProperty(_dictionary,
	'unit-detail-form-unit-latitude-hint', 'Observe no mapa abaixo a localizaçao da unidade de acordo com as coordenadas'), _defineProperty(_dictionary,
	'unit-detail-form-unit-longitude', 'Longitude'), _defineProperty(_dictionary,
	'unit-detail-form-unit-name', 'Nome da unidade'), _defineProperty(_dictionary,
	'unit-detail-form-unit-observation', 'Observação'), _defineProperty(_dictionary,
	'unit-detail-form-unit-phone_number', 'Telefone de contato'), _defineProperty(_dictionary,
	'unit-detail-form-unit-region_id', 'Praça'), _defineProperty(_dictionary,
	'unit-detail-form-unit-state', 'Estado'), _defineProperty(_dictionary,
	'unit-detail-remove-opening-hour-confirm-text', 'Remover horário?'), _defineProperty(_dictionary,
	'unit-detail-remove-opening-hour-deny-text', 'A unidade precisa ter um horário de funcionamento'), _defineProperty(_dictionary,
	'unit-detail-save-success', 'Unidade salva'), _defineProperty(_dictionary,
	'unit-detail-section-title-differentials', 'Diferenciais'), _defineProperty(_dictionary,
	'unit-detail-section-title-differentials-caption', 'Selecione abaixo os Diferenciais disponíveis nesta unidade'), _defineProperty(_dictionary,
	'unit-detail-section-title-opening-hours', 'Horários'), _defineProperty(_dictionary,
	'unit-detail-section-title-opening-hours-caption', 'Informe abaixo os horários da unidade'), _defineProperty(_dictionary,
	'unit-detail-section-title-services', 'Serviços'), _defineProperty(_dictionary,
	'unit-detail-section-title-services-caption', 'Selecione abaixo os serviços disponíveis nesta unidade'), _defineProperty(_dictionary, 'unit-detail-section-title-opening-hours',
	'Horário de Funcionamento'), _defineProperty(_dictionary, 'unit-detail-section-title-opening-hours-caption',
	'Informe abaixo os horários da unidade que irão aparecer no Google'), _defineProperty(_dictionary,
	'unit-detail-title', 'Detalhe na unidade'), _defineProperty(_dictionary,
	'unit-detail-title-caption', 'Preencha os dados da unidade conforme os campos abaixo'), _defineProperty(_dictionary,
	'unit-list-create-unit-button', 'Criar unidade'), _defineProperty(_dictionary,
	'unit-list-empty-state-line-1', 'Nenhuma unidade'), _defineProperty(_dictionary,
	'unit-list-empty-state-line-2', 'Crie sua primeira unidade'), _defineProperty(_dictionary,
	'unit-list-table-header-address-street', 'Endereço'), _defineProperty(_dictionary,
	'unit-list-table-header-city', 'Cidade'), _defineProperty(_dictionary,
	'unit-list-table-header-name', 'Unidade'), _defineProperty(_dictionary,
	'unit-list-table-header-phone-number', 'Telefone'), _defineProperty(_dictionary,
	'unit-list-table-header-uf', 'UF'), _defineProperty(_dictionary,
	'vaccine-detail-delete-confirm-text', 'Remover vacina?'), _defineProperty(_dictionary,
	'vaccine-detail-delete-success', 'Vacina removida'), _defineProperty(_dictionary,
	'vaccine-detail-form-error-required-target_groups', 'A vacina deve pertencer ao pelo menos uma categoria'), _defineProperty(_dictionary,
	'vaccine-detail-form-error-title-max-length', 'O nome curto deve ter no máximo 20 caractéres'), _defineProperty(_dictionary,
	'vaccine-detail-form-vaccine-comment', 'Comentários'), _defineProperty(_dictionary,
	'vaccine-detail-form-vaccine-name', 'Nome da vacina'), _defineProperty(_dictionary,
	'vaccine-detail-form-vaccine-recommendations', 'Recomendações'), _defineProperty(_dictionary,
	'vaccine-detail-form-vaccine-schema', 'Esquema'), _defineProperty(_dictionary,
	'vaccine-detail-form-vaccine-short_name', 'Nome curto'), _defineProperty(_dictionary,
	'vaccine-detail-form-vaccine-short_name-hint-text', 'Este nome aparecerá no card de detalhe da vacina'), _defineProperty(_dictionary,
	'vaccine-detail-save-success', 'Vacina salva'), _defineProperty(_dictionary,
	'vaccine-detail-section-title-target_groups', 'Categorias'), _defineProperty(_dictionary,
	'vaccine-detail-section-title-target_groups-caption', 'Selecione as categorias em que essa vacina deve aparecer'), _defineProperty(_dictionary,
	'vaccine-detail-title', 'Detalhe da vacina'), _defineProperty(_dictionary,
	'vaccine-detail-title-caption', 'Preencha os dados da vacina conforme os campos abaixo'), _defineProperty(_dictionary,
	'vaccine-list-create-vaccine-button', 'Criar vacina'), _defineProperty(_dictionary,
	'vaccine-list-empty-state-line-1', 'Nenhuma vacina'), _defineProperty(_dictionary,
	'vaccine-list-empty-state-line-2', 'Crie sua primeira vacina'), _defineProperty(_dictionary,
	'vaccine-list-table-header-name', 'Nome'), _defineProperty(_dictionary,
	'vaccine-list-table-header-short_name', 'Nome comercial'), _defineProperty(_dictionary,
	'vaccine-list-table-header-version', 'Nome curto'), _defineProperty(_dictionary,
	'table-list-new-order', 'Ordenação alterada com sucesso!'), _defineProperty(_dictionary,
	'version-list-table-header-version', 'Versão'), _defineProperty(_dictionary,
	'version-list-table-header-forced', 'Atualização forçada'), _defineProperty(_dictionary,
	'version-list-table-header-os', 'Sistema Operacional'), _defineProperty(_dictionary,
	'version-list-table-header-configured', 'Configurado em'), _defineProperty(_dictionary,
	'region-list-empty-state-line-1', 'Nenhuma praça'), _defineProperty(_dictionary,
	'region-list-empty-state-line-2', 'Crie sua primeira praça'), _defineProperty(_dictionary,
	'region-list-create-region-button', 'Criar praça'), _defineProperty(_dictionary,
	'report-success', 'Relatório gerado com sucesso'), _defineProperty(_dictionary,
	'report-error', 'Não foi possível completar esta ação'), _defineProperty(_dictionary,
	'open', 'Aberto'), _defineProperty(_dictionary,
	'closed', 'Fechado'), _defineProperty(_dictionary,
	'toast-success-hours-sync', 'Horários sincronizados com sucesso!'), _defineProperty(_dictionary,
	'toast-error-houts-sync', 'Ocorreu algum erro ao sincronizar os horários!'), _defineProperty(_dictionary,
	'toast-success-approval-attendance-hour', 'Horários aprovados com sucesso!'), _defineProperty(_dictionary,
	'toast-error-approval-attendance-hour', 'Ocorreu algum erro ao aprovar os horários!'), _defineProperty(_dictionary,
	'toast-success-approved-special-hours', 'Horários especiais aprovados com sucesso!'), _defineProperty(_dictionary,
	'toast-error-approved-special-hours', 'Ocorreu algum erro ao aprovar os horários especiais!'), _defineProperty(_dictionary,
	'toast-success-remove-special-hours', 'Horário especial removido com sucesso!'), _defineProperty(_dictionary,
	'toast-error-remove-special-hours', 'Ocorreu algum erro ao remover o horário especial!'), _defineProperty(_dictionary,
	'toast-success-sync-special-hours', 'Horários especiais sincronizados com sucesso!'), _defineProperty(_dictionary,
	'toast-error-sync-special-hours', 'Ocorreu algum erro ao sincronizar os horários especiais!'), _defineProperty(_dictionary,
	'toast-success-reject-attendance-hour', 'Horários rejeitados com sucesso!'), _defineProperty(_dictionary,
	'toast-error-reject-attendance-hour', 'Ocorreu algum erro ao rejeitar os horários!'), _defineProperty(_dictionary,
	'toast-success-reject-special-hours', 'Horários especiais rejeitados com sucesso!'), _defineProperty(_dictionary,
	'toast-error-reject-special-hours', 'Ocorreu algum erro ao rejeitar os horários especiais!'), _defineProperty(_dictionary,
	'toast-success-request-new-special-hours', 'Horários especiais enviados para aprovação do gestor!'), _defineProperty(_dictionary,
	'toast-error-request-new-special-hours', 'Ocorreu algum erro ao enviar os horários especiais para aprovação!'), _defineProperty(_dictionary,
	'toast-success-request-change-schedule', 'Horários enviados para aprovação do gestor!'), _defineProperty(_dictionary,
	'toast-error-request-change-schedule', 'Ocorreu algum erro ao enviar os horários para aprovação!'), _dictionary);exports.default =
	
	
	dictionary;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _uri = __webpack_require__(853);var _uri2 = _interopRequireDefault(_uri);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
	
	var config = function config(RestangularProvider) {
		RestangularProvider.setBaseUrl(_uri2.default);
		// RestangularProvider.setBaseUrl('https://api.sabin.com.br/admin');
		//RestangularProvider.setBaseUrl('https://dev.api.sabin.aisdigital.com.br/admin');
		//RestangularProvider.setBaseUrl('http://localhost:3000/admin');
	};
	
	config.$inject = ['RestangularProvider'];exports.default =
	
	config;

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var uriProduction = 'https://api.sabin.com.br';
	var uriDeveloper = 'https://apidev.cloudsabin.com';
	var uriStaging = 'https://api-staging.cloudsabin.com';
	var uriLocalhost = uriDeveloper;
	
	var urls = [
	{ 'localhost:4200': uriLocalhost },
	{ 'localhost:8080': uriLocalhost },
	{ 'backofficedev.cloudsabin.com': uriDeveloper },
	{ 'backoffice-staging.cloudsabin.com': uriStaging },
	{ 'backoffice.sabin.com.br': uriProduction }];
	
	
	var urlFilter = urls.find(function (elem) {
	  return elem[window.location.host];
	});
	
	var uri = urlFilter[window.location.host];
	if (uri === undefined) {
	  console.info('Not found environment key for host: ' + window.location.host + '\n, using ' + uriDeveloper);
	  uri = uriDeveloper;
	}exports.default =
	
	uri;

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	'use strict';Object.defineProperty(exports, "__esModule", { value: true });var config = function config($provide) {
		$provide.decorator('taOptions', ['$delegate', function (taOptions) {
			// $delegate is the taOptions we are decorating
			// here we override the default toolbars and classes specified in taOptions.
			taOptions.forceTextAngularSanitize = true; // set false to allow the textAngular-sanitize provider to be replaced
			taOptions.keyMappings = []; // allow customizable keyMappings for specialized key boards or languages
			taOptions.toolbar = [
			['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'quote'],
			['bold', 'italics', 'underline', 'ul', 'ol'],
			['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'insertLink'],
			['redo', 'undo', 'clear']];
	
	
			taOptions.classes = {
				focussed: 'focussed',
				toolbar: 'sb-ta-toolbar',
				toolbarGroup: 'sb-ta-button-group',
				toolbarButton: 'md-button',
				toolbarButtonActive: 'active',
				disabled: 'disabled',
				textEditor: 'form-control',
				htmlEditor: 'form-control' };
	
			return taOptions; // whatever you return will be the taOptions
		}]);
	};
	
	config.$inject = ['$provide'];exports.default =
	
	config;

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js